(function() {
  'use strict';

  angular
    .module('app', ['ngAnimate',
                    'ngSanitize',
                    'ngMessages',
                    'ui.router',
                    'toastr',
                    'md.data.table',
                    'formlyMaterial',
                    'satellizer',
                    'ngMaterial',
                    'ngFileUpload',
                    'leaflet-directive',
                    'blockUI',
                    'lfNgMdFileInput',
                    'ui.knob',
                    'ngFileSaver']);

})();

(function () {
    'use strict';
    /*eslint-disable*/
    Simditor.locale = 'en-US';
    Simditor.i18n['en-US'] = {
        'bold': 'Negrita',
        'italic': 'Itálica',
        'ol': 'Lista ordenada',
        'ul': 'Lista desordenada',
        'table': 'Tabla',
        'deleteRow': 'Eliminar fila',
        'insertRowAbove': 'Insertar fila arriba',
        'insertRowBelow': 'Insertar fila abajo',
        'deleteColumn': 'Eliminar columna',
        'insertColumnLeft': 'Insertar columna a la izquierda',
        'insertColumnRight': 'Insertar columna a la derecha',
        'deleteTable': 'Eliminar tabla',
        'underline': 'Subrayar',
        'strikethrough': 'Tachar'
    };
    /*eslint-enable*/
    angular
            .module('app')
            .controller('SedesDetalleController', SedesDetalleController);

    /** @ngInject */

    function SedesDetalleController(restUrl, Modal, DataService, Util, Message, $stateParams, $window) {
        var vm = this;
//        var params = $stateParams;
        vm.id_sedes = 0;
        if ($window.sessionStorage.id_sedes == 'null' || $window.sessionStorage.id_sedes == 'undefined' || angular.isUndefined($window.sessionStorage.id_sedes)) {
            vm.id_sedes = "0";
        } else {
            vm.id_sedes = $window.sessionStorage.id_sedes;
        }
        /*eslint-disable*/
        var editorInvitacion = new Simditor({
            textarea: $('#editorMsj'),
            toolbar: [
                'bold', 'italic', 'underline', 'strikethrough',
                'color', 'ol', 'ul', 'blockquote', 'table', 'link', 'image',  'indent', 'outdent', 'alignment'
            ],
            allowedTags:['table','tr','td','b','p','div','spam','strong'],
            allowedAttributes: {table: ['bgcolor', 'width', 'border', 'cellspacing', 'cellpadding', 'style'],
            td:['style'] ,
            p:['align', 'dir'],
            div:['style'],
            spam: ['style'],
            strong: ['style']
            },
            allowedStyles : {table: ['min-width', 'max-width', 'border', 'border-bottom', 'border-top-left-radius', 'border-top-right-radius'],
                td:['font-family','font-size','color','line-height','padding-top','padding-left', 'padding-bottom', 'padding'],
                div:['text-align','background-color', 'padding', 'border'],
                spam:['text-align', 'font-size'],
                strong: ['text-align', 'font-size', 'font-weight']
            }
        });
        /*eslint-enable*/

        $window.sessionStorage.id_sedes = 'undefined';
        vm.permission = Util.getMenuProcess();
        vm.title = 'Configuración SEDES';
        vm.url = restUrl + 'rotaciones/sedes/';
        vm.urlImagenes = restUrl + 'rotaciones/sedesImagenes/';
        vm.urlRequisitos = restUrl + 'parametros/par_archivo/';
        vm.urlDatosSedes = restUrl + 'parametros/par_sedes/';
        vm.urlTiposRequisitos = restUrl + 'parametros/tipos_requisitos/par_archivo';
        vm.mostrarEditor = false;

        vm.obtenerRequisitos = obtenerRequisitos;
        vm.obtenerDatosSedes = obtenerDatosSedes;
        vm.obtenerSedes = obtenerSedes;
        vm.obtenerTiposRequisitos = obtenerTiposRequisitos;
        vm.editarRequisito = editarRequisito;
        vm.agregarRequisito = agregarRequisito;
        vm.activarRequisito = activarRequisito;
        vm.editarDatosSedes = editarDatosSedes;
        vm.agregarDatosSedes = agregarDatosSedes;
        vm.editarImagenes = editarImagenes;
        vm.editarCorreo = editarCorreo;
        vm.editarCite = editarCite;
        vm.editarInvitacion = editarInvitacion;
        vm.guardarInvitacion = guardarInvitacion;
        vm.cancelarEdicion = cancelarEdicion;

        vm.fieldsSedesImagenes = [
            'id_sedes',
            'logo',
            'escudo',
            'fondo',
            'fondo_resolucion'
        ];

        vm.fieldsSedesCorreo = [
            'id_sedes',
            // 'correo_host',
            // 'correo_puerto',
            'correo',
            'tipo',
            'deposito',
            'cantidad_promedios',
            'gestion_inicio'
                    // 'correo_contrasena'
        ];

        vm.fieldsSedesCite = [
            'id_sedes',
            'cite'
        ];

        vm.fieldsSedesInvitacion = [
            'id_sedes',
            'invitacion'
        ];

        vm.fieldsDatosSedes = [
            'id_par_sedes',
            'cargo_tecnico',
            'nombre_tecnico',
            'cargo_asesor',
            'nombre_asesor',
            'cargo_director',
            'nombre_director'
        ];

        vm.formlySedesImagenes = [
            {
                'key': 'id_sedes',
                'templateOptions': {
                    'label': 'ID',
                    required: false
                }
            },
            {
                'key': 'correo_contrasena',
                'templateOptions': {
                    'type': 'password'
                }
            },
            {
                'key': 'logo',
                'hideExpression': 'true',
                'templateOptions': {
                    required: false
                }
            },
            {
                'key': 'escudo',
                'hideExpression': 'true',
                'templateOptions': {
                    required: false
                }
            },
            {
                'key': 'fondo',
                'hideExpression': 'true',
                'templateOptions': {
                    required: false
                }
            },
            {
                'key': 'fondo_resolucion',
                'hideExpression': 'true',
                'templateOptions': {
                    required: false
                }
            },
            {
                'key': 'tipo',
                'templateOptions': {
                    required: false,
                    'label': 'Habilitar nota para Universidades'
                }
            },
            {
                'key': 'deposito',
                'templateOptions': {
                    required: false,
                    'label': 'Habilitar Depósito para Universidades'
                }
            },
            {
                'key': 'gestion_inicio',
                'defaultValue': 2017
            }
        ];
        vm.formlyDatosSedes = [
            {
                'key': 'id_par_sedes',
                'templateOptions': {
                    'label': 'ID',
                    required: false
                }
            }
        ];

        vm.archivos = [
            {
                key: 'logo',
                label: 'Logo'
            },
            {
                key: 'escudo',
                label: 'Escudo'
            },
            {
                key: 'fondo',
                label: 'Fondo'
            },
            {
                key: 'fondo_resolucion',
                label: 'Fondo Resolución'
            }
        ];

        activate();

        function activate() {
            obtenerSedes();
            obtenerRequisitos();
            obtenerDatosSedes();
            obtenerTiposRequisitos();

            getFormlySedesImagenes();
            getFormlySedesCorreo();
            getFormlySedesCite();
            getFormlySedesInvitacion();
            getFormlyDatosSedes();
        }

        function obtenerSedes() {
            DataService.get(vm.urlImagenes, vm.id_sedes)
                    .then(function (response) {
                        if (response && response.datos) {
                            vm.sedes = response.datos;
                            vm.id_sedes = response.datos.id_sedes;
                            // console.log(vm.id_sedes);
                        } else {
                            Message.warning("No se encuentra la información solicitada.");
                        }
                    });
        }

        function obtenerRequisitos() {
            DataService.get(vm.urlRequisitos + 'sedes/', vm.id_sedes)
                    .then(function (response) {
                        if (response && response.datos) {
                            vm.requisitos = response.datos;
                        } else {
                            Message.warning("No se encontraro registro de requisitos.");
                        }
                    });
        }

        function obtenerDatosSedes() {
            DataService.get(vm.urlDatosSedes + 'sedes/', vm.id_sedes)
                    .then(function (response) {
                        if (response && response.datos) {
                            vm.datosSedes = response.datos;
                        } else {
                            Message.warning("No se encuentraron tipos de requisitos.");
                        }
                    });
        }

        function obtenerTiposRequisitos() {
            DataService.get(vm.urlTiposRequisitos)
                    .then(function (response) {
                        if (response && response.datos) {
                            vm.tiposRequisitos = response.datos;
                        } else {
                            Message.warning("No se encuentra la información solicitada.");
                        }
                    });
        }

        function agregarRequisito(event) {
            vm.requisito = {fid_sedes: vm.id_sedes};
            Modal.show({
                event: event,
                data: vm,
                title: 'Agregar requisito',
                dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogRequisitoController],
                templateUrl: 'app/modules/rotaciones/sedes/sedesDetalle/editRequisito.dialog.html'
            });
        }

        function editarRequisito(event, id_par_archivo) {
            DataService.get(vm.urlRequisitos + id_par_archivo)
                    .then(function (response) {
                        var item = response.datos;
                        vm.requisito = item;
                        Modal.show({
                            event: event,
                            data: vm,
                            title: 'Editar requisito',
                            dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogRequisitoController],
                            templateUrl: 'app/modules/rotaciones/sedes/sedesDetalle/editRequisito.dialog.html'
                        });
                    });
        }

        function activarRequisito(event, _id_par_archivo, estado, fid_sedes) {
            var data = {id_par_archivo: _id_par_archivo}
            data.estado = estado;
            data.fid_sedes = fid_sedes;
            DataService.put(vm.urlRequisitos + _id_par_archivo, data)
                    .then(function (response) {
                        Message.success(response.mensaje);
                        vm.obtenerRequisitos();
                    })
                    .catch(function () {
                        Message.error();
                    });
        }

        function DialogRequisitoController($scope, $mdDialog, data, restUrl, DataService, Message) {
            var vm = $scope;
            vm.requisito = data.requisito;
            vm.tiposRequisitos = data.tiposRequisitos;

            function actualizar(response) {
                if (response && response.datos) {
                    Message.success(response.mensaje);
                    data.obtenerRequisitos();
                    $mdDialog.cancel();
                }
            }
            vm.guardarRequisito = function () {
                if (vm.requisito.id_par_archivo) {
                    DataService.put(data.urlRequisitos + vm.requisito.id_par_archivo, vm.requisito)
                            .then(function (response) {
                                actualizar(response);
                            });
                } else {
                    DataService.save(data.urlRequisitos, vm.requisito)
                            .then(function (response) {
                                actualizar(response);
                            });
                }
            }
            vm.close = function () {
                $mdDialog.cancel();
            }
        }


        function getFormlyDatosSedes() {
            DataService.fields(vm.urlDatosSedes)
                    .then(function (response) {
                        if (response) {
                            vm.fieldsDatosSedes = Util.filterFields(response, vm.fieldsDatosSedes);
                            vm.fieldsDatosSedes = Util.addPropertiesFormly(vm.fieldsDatosSedes, vm.formlyDatosSedes);
                            DataService.setFormly(vm.fieldsDatosSedes);
                        }
                    });
        }

        function agregarDatosSedes(event) {
            var data = {};
            data.datos = {fid_sedes: vm.id_sedes};
            Modal.show({
                event: event,
                data: data.datos,
                title: 'Agregar parámetros',
                fields: vm.fieldsDatosSedes,
                templateUrl: 'app/components/crudTable/dialog.crudTable.html',
                done: function (answer, $mdDialog) {
                    if (answer == 'save') {
                        DataService.save(vm.urlDatosSedes, data.datos)
                                .then(function (response) {
                                    if (response && response.datos) {
                                        Message.success(response.mensaje);
                                        vm.obtenerDatosSedes();
                                        $mdDialog.cancel();
                                    }
                                });
                    }
                }
            });
        }

        function editarDatosSedes(event, id_par_sedes) {
            DataService.get(vm.urlDatosSedes + id_par_sedes)
                    .then(function (data) {
                        if (data && data.datos) {
                            Modal.show({
                                event: event,
                                data: data.datos,
                                title: 'Editar parámetros',
                                fields: vm.fieldsDatosSedes,
                                templateUrl: 'app/components/crudTable/dialog.crudTable.html',
                                done: function (answer, $mdDialog) {
                                    if (answer == 'save') {
                                        DataService.put(vm.urlDatosSedes + data.datos.id_par_sedes, data.datos)
                                                .then(function (response) {
                                                    if (response && response.datos) {
                                                        Message.success(response.mensaje);
                                                        vm.obtenerDatosSedes();
                                                        $mdDialog.cancel();
                                                    }
                                                });
                                    }
                                }
                            });
                        }
                    });
        }



        function editarImagenes(event, id_sedes) {
            DataService.get(vm.url + id_sedes).then(function (data) {
                if (data && data.datos) {
                    data.datos.archivos = vm.archivos;
                    Modal.show({
                        event: event,
                        data: data.datos,
                        title: 'Imágenes SEDES',
                        fields: vm.fieldsSedesImagenes,
                        templateUrl: 'app/components/crudTable/dialog.crudTable.html',
                        done: function (answer, $mdDialog) {
                            if (answer == 'save') {
                                if (vm.archivos && vm.archivos.length > 0) {
                                    loadFiles(0, data.datos, $mdDialog);
                                } else {
                                    guardarItem(data.datos, $mdDialog);
                                }
                            }
                        }
                    });
                } else if (data && data.mensaje) {
                    Message.info("Aún no se han registrado los datos de SEDES.");
                }
            });

            function loadFiles(i, item, $mdDialog) {
                if (i < vm.archivos.length) {
                    if (vm.archivos[i].files && vm.archivos[i].files.length > 0) {
                        var archivo = vm.archivos[i].files[0].lfFile;
                        var reader = new FileReader();
                        reader.onload = function (readerEvt) {
                            var binaryString = readerEvt.target.result;
                            var imgData = 'data:' + archivo.type + ';base64,' + btoa(binaryString);
                            item[vm.archivos[i].key] = imgData;
                            loadFiles(i + 1, item, $mdDialog);
                        };
                        reader.readAsBinaryString(archivo);
                    } else {
                        loadFiles(i + 1, item, $mdDialog);
                    }
                } else {
                    guardarItem(item, $mdDialog);
                }
            }

            function guardarItem(item, $mdDialog) {
                DataService.put(vm.url + item.id_sedes, item)
                        .then(function (response) {
                            Message.success(response.mensaje);
                            vm.obtenerSedes();
                            $mdDialog.cancel();
                        });
            }
        }

        function getFormlySedesImagenes() {
            DataService.fields(vm.url)
                    .then(function (response) {
                        if (response) {
                            vm.fieldsSedesImagenes = Util.filterFields(response, vm.fieldsSedesImagenes);
                            vm.fieldsSedesImagenes = Util.addPropertiesFormly(vm.fieldsSedesImagenes, vm.formlySedesImagenes);
                            DataService.setFormly(vm.fieldsSedesImagenes);
                        }
                    });
        }


        function getFormlySedesCorreo() {
            DataService.fields(vm.url)
                    .then(function (response) {
                        if (response) {
                            vm.fieldsSedesCorreo = Util.filterFields(response, vm.fieldsSedesCorreo);
                            vm.fieldsSedesCorreo = Util.addPropertiesFormly(vm.fieldsSedesCorreo, vm.formlySedesImagenes);
                            DataService.setFormly(vm.fieldsSedesCorreo);
                        }
                    });
        }

        function getFormlySedesCite() {
            DataService.fields(vm.url)
                    .then(function (response) {
                        if (response) {
                            vm.fieldsSedesCite = Util.filterFields(response, vm.fieldsSedesCite);
                            vm.fieldsSedesCite = Util.addPropertiesFormly(vm.fieldsSedesCite, vm.formlySedesImagenes);
                            DataService.setFormly(vm.fieldsSedesCite);
                        }
                    });
        }

        function getFormlySedesInvitacion() {
            DataService.fields(vm.url)
                    .then(function (response) {
                        if (response) {
                            vm.fieldsSedesInvitacion = Util.filterFields(response, vm.fieldsSedesInvitacion);
                            vm.fieldsSedesInvitacion = Util.addPropertiesFormly(vm.fieldsSedesInvitacion, vm.formlySedesImagenes);
                            DataService.setFormly(vm.fieldsSedesInvitacion);
                        }
                    });
        }

        function editarCorreo(event, id_sedes) {
            DataService.get(vm.url + id_sedes)
                    .then(function (data) {
                        if (data && data.datos) {
                            Modal.show({
                                event: event,
                                data: data.datos,
                                title: 'Datos SEDES',
                                fields: vm.fieldsSedesCorreo,
                                templateUrl: 'app/components/crudTable/dialog.crudTable.html',
                                done: function (answer, $mdDialog) {
                                    if (answer == 'save') {
                                        if (vm.archivos && vm.archivos.length > 0) {
                                            loadFiles(0, data.datos, $mdDialog);
                                        } else {
                                            guardarItem(data.datos, $mdDialog);
                                        }
                                    }
                                }
                            });
                        } else if (data && data.mensaje) {
                            Message.info("Aún no se han registrado los datos de SEDES.");
                        }
                    });

            function loadFiles(i, item, $mdDialog) {
                if (i < vm.archivos.length) {
                    if (vm.archivos[i].files && vm.archivos[i].files.length > 0) {
                        var archivo = vm.archivos[i].files[0].lfFile;
                        var reader = new FileReader();
                        reader.onload = function (readerEvt) {
                            var binaryString = readerEvt.target.result;
                            var imgData = 'data:' + archivo.type + ';base64,' + btoa(binaryString);
                            item[vm.archivos[i].key] = imgData;
                            loadFiles(i + 1, item, $mdDialog);
                        };
                        reader.readAsBinaryString(archivo);
                    } else {
                        loadFiles(i + 1, item, $mdDialog);
                    }
                } else {
                    guardarItem(item, $mdDialog);
                }
            }

            function guardarItem(item, $mdDialog) {
                DataService.put(vm.url + item.id_sedes, item)
                        .then(function (response) {
                            Message.success(response.mensaje);
                            vm.obtenerSedes();
                            $mdDialog.cancel();
                        });
            }
        }

        function editarCite(event, id_sedes) {
            DataService.get(vm.url + id_sedes)
                    .then(function (data) {
                        if (data && data.datos) {
                            Modal.show({
                                event: event,
                                data: data.datos,
                                title: 'Datos cite',
                                fields: vm.fieldsSedesCite,
                                templateUrl: 'app/components/crudTable/dialog.crudTable.html',
                                done: function (answer, $mdDialog) {
                                    if (answer == 'save') {
                                        guardarItem(data.datos, $mdDialog);
                                    }
                                }
                            });
                        } else if (data && data.mensaje) {
                            Message.info("Aún no se han registrado los datos de SEDES.");
                        }
                    });

            function guardarItem(item, $mdDialog) {
                DataService.put(vm.url + item.id_sedes, item)
                        .then(function (response) {
                            Message.success(response.mensaje);
                            vm.obtenerSedes();
                            $mdDialog.cancel();
                        });
            }
        }

        function editarInvitacion(event, id_sedes) {
            vm.mostrarEditor = true;
            DataService.get(vm.url + id_sedes)
                    .then(function (data) {
                        if (data && data.datos) {
//                            console.log(data.datos.invitacion);
                            editorInvitacion.setValue(data.datos.invitacion);
                            editorInvitacion.sync();
                        } else if (data && data.mensaje) {
                            Message.info("Aún no se han registrado los datos de SEDES.");
                        }
                    });
        }

        function guardarInvitacion(event, id_sedes) {
            vm.mostrarEditor = false;
            var obj = {'invitacion': editorInvitacion.getValue()};
            DataService.put(vm.url + id_sedes, obj)
                    .then(function (response) {
                        Message.success(response.mensaje);
                        vm.obtenerSedes();
                    });
        }

        function cancelarEdicion() {
            vm.mostrarEditor = false;
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('VerificacionResolucionController', VerificacionResolucionController);

  /** @ngInject */
  function VerificacionResolucionController(Modal, DataService, Message, $location, $stateParams, $sce, verificarResolucion) {
    var vm = this;
    var params = $stateParams;
    vm.title = 'Datos del estudiante';
    vm.urlHabilitacion = verificarResolucion + params.codigo;

    vm.formatearUrl = formatearUrl;

    activate();

    function activate() {
      angular.element('body').addClass('no-login');
      DataService.get(vm.urlHabilitacion, params.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          vm.habilitacion = response.datos;
          if (vm.habilitacion.resolucion !== false) {
            //vm.habilitacion.resolucion = 'data:application/pdf;base64,' + vm.habilitacion.resolucion;
            vm.habilitacion.resolucion = vm.habilitacion.resolucion;
          }
        } else {
          Message.warning("No se encontraron los datos solicitados.");
        }
      })
    }

    function formatearUrl(url) {
      return $sce.trustAsResourceUrl(url);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('RequisitosResolucionesController', RequisitosResolucionesController);

  /** @ngInject */
  function RequisitosResolucionesController($scope, restUrl, Modal, DataService, Util, Message, $location, $stateParams, moment, Upload, $sce, $window, ConsultasService) {
    var vm = this;
    var params = $stateParams;
    vm.idHabilitacion = params.idHabilitacion;
    vm.permission = Util.getMenuProcess();
    vm.title = 'Registro de documentos para la resolución';
    vm.url = restUrl + 'rotaciones/habilitacion/';
    vm.urlTiposFaltas = restUrl + 'parametros/parametro/tipo_falta/';
    vm.urlFaltas = restUrl + 'rotaciones/habilitacion/faltas/';
    vm.urlObservaciones = restUrl + 'rotaciones/observacion/';
    vm.urlFaltasCrud = restUrl + "rotaciones/falta/";
    vm.urlArchivos = restUrl + 'rotaciones/habilitacion_archivo/';
    vm.urlInforme = restUrl + 'rotaciones/habilitacion_informe/';
    vm.urlCrearArchivos = restUrl + 'rotaciones/archivo/subir/';
    vm.urlMostrarInforme = restUrl + 'rotaciones/informe/';
    vm.urlGenerarInforme = restUrl + 'rotaciones/habilitacion_generar_informe/';
    vm.urlSubsanar = restUrl + 'rotaciones/observacion/subsanado/';
    vm.urlBuscar = restUrl + 'rotaciones/estudiante/documento/';
    vm.urlRequisito = restUrl + 'rotaciones/archivo/bin/';

    vm.obtenerHabilitacion = obtenerHabilitacion;
    vm.abrirRequisito = abrirRequisito;
    vm.enviarAsesor = enviarAsesor;
    vm.mostrarInformeTecnico = mostrarInformeTecnico;
    vm.mostrarInformeTecnicoGenerado = mostrarInformeTecnicoGenerado;
    vm.observarTramite = observarTramite;
    vm.volverResolucion = volverResolucion;
    vm.subsanarObservacion = subsanarObservacion;
    vm.volverBuscar = volverBuscar;
    vm.buscar = buscar;
    vm.registrarApoderado = registrarApoderado;
    vm.mostrarPoder = mostrarPoder;
    vm.verDetalleInscripcion = verDetalleInscripcion;
    vm.listarObservaciones = listarObservaciones;
    vm.mostrarObservarTramite = mostrarObservarTramite;
    vm.eliminarNota = eliminarNota;

    vm.tipo = 100;
    vm.tipos = [
      {
        value: 100,
        name: 'CI'
      },
      {
        value: 110,
        name: 'CI EXTRANJERO'
      },
      {
        value: 105,
        name: 'PASAPORTE'
      }
    ]

    activate();

    function activate() {
      var documento = $window.sessionStorage.getItem("documento_identidad_buscado");
      if (documento) {
        documento = angular.fromJson(documento);
        if (documento.documentoIdentidad) {
          vm.documentoIdentidad = documento.documentoIdentidad;
          vm.tipo = documento.tipo;
          // vm.buscar();
        }
      }
      obtenerHabilitacion();
    }

    function mostrarObservarTramite(habilitacion) {
      if (ConsultasService.verificarCredencialFirmada(habilitacion)) {
        return true;
      } else {
        return false;
      }
    }

    function obtenerFaltas() {
      DataService.list(vm.urlFaltas + vm.idHabilitacion)
        .then(function(response) {
          if (response && response.datos) {
            vm.faltas = response.datos;
            for (var f in vm.faltas) {
              if (vm.faltas[f].fecha_fin_bloqueo) {
                vm.habilitacion.fecha_fin_bloqueo = vm.faltas[f].fecha_fin_bloqueo;
              }
            }
          } else {
            vm.faltas = [];
          }
        });
    }

    function obtenerHabilitacion() {
      if (vm.idHabilitacion) {
        obtenerFaltas();
        DataService.get(vm.url, params.idHabilitacion)
        .then(function(response) {
          if (response && response.datos) {
            vm.habilitacion = response.datos;
            var inicio = moment(vm.habilitacion.fecha_inicio);
            var fin = moment(vm.habilitacion.fecha_fin);
            var ahora = moment(new Date());

            vm.barra = {
              min: 0,
              max: Number(fin.diff(inicio, 'days')),
              valor: Number(ahora.diff(inicio, 'days'))
            }
            if (vm.barra.valor > vm.barra.max) {
              vm.barra.valor = vm.barra.max;
            }
          } else {
            Message.warning("No se encuentra la información solicitada.");
          }
        });
        obtenerArchivos();
        listarObservaciones();
      }
    }

    function listarObservaciones() {
      DataService.get(vm.urlObservaciones + 'habilitacion/' + vm.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          vm.notas = response.datos;
        }
      });
    }

    function eliminarNota(id) {
      Modal.confirm('¿Desea eliminar la observación?' , function() {
        DataService.delete(vm.urlObservaciones, id)
        .then(function() {
          vm.listarObservaciones();
        });
      });
    }

    $scope.$on('archivoCargado', obtenerArchivos);
    function obtenerArchivos(){
      DataService.get(vm.urlArchivos, vm.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          vm.archivos = response.datos;
        } else {
          Message.warning("No se encontraron archivos registrados.");
        }
      });
    }

    function abrirRequisito(event, archivo) {
      // var parametros = {
      //   id: archivo.archivo[0].id_archivo
      // }
      DataService.get(restUrl + 'rotaciones/archivo/base/' + archivo.archivo[0].id_archivo)
      .then(function(response) {
        if (response && response.datos) {
          var respuestaArchivo = response.datos;
          var dialog;
          if (respuestaArchivo.type.startsWith('image')) {
            dialog = 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.req.html';
            Modal.show({
              event: event,
              data: respuestaArchivo.base64,
              title: archivo.nombre,
              templateUrl: dialog,
              controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
            });
          } else {
            ConsultasService.mostrarRequisitoPdfBase64(event, respuestaArchivo.base64, archivo.nombre)
          }
        } else {
          Message.error("No se encontraron los datos solicitados.");
        }
      });
    }

    function enviarAsesor(event) {
      Modal.confirm('El Informe Técnico Legal será enviado al Asesor Legal por lo que ya no podrá modificarlo. ¿Desea continuar?' , function() {
        var parametros = {
          ids_habilitacion: [vm.idHabilitacion],
          cite: vm.cite
        }
        DataService.post(vm.urlGenerarInforme, parametros)
        .then(function(response) {
          if (response && response.datos) {
            obtenerHabilitacion();
            Message.success(response.mensaje);
          } else {
            Message.warning("La solicitud no se procesó correctamente.");
          }
        });
      }, null, event);
    }

    function mostrarInformeTecnico(event) {
      var parametros = {
        id_habilitacion: vm.idHabilitacion
      }
      DataService.pdf2(vm.urlMostrarInforme, parametros)
        .then(function(response) {
          ConsultasService.mostrarPdf(event, [response.data], 'Informe Técnico Legal');
        });

    }

    function mostrarInformeTecnicoGenerado(event) {
      ConsultasService.mostrarPdfBase64(event,
                                        ConsultasService.urlMostrarInforme,
                                        { id_habilitacion: vm.idHabilitacion },
                                        "Informe Técnico Legal",
                                        "El informe técnico legal no se recuperó correctamente.");
    }

    function observarTramite(event, anterior) {
      vm.anterior = anterior;
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'DataService', 'restUrl', 'Message', DialogObservacionController],
        templateUrl: 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.observacion.crud.html'
      });
    }

    function volverResolucion() {
      $location.path("/rotaciones/resoluciones");
    }

    function PdfController($scope, $mdDialog, data, title) {
      var vm = $scope;

      vm.formatearUrl = function(url) {
        //return $sce.trustAsResourceUrl('data:image;base64,' + url);
        return $sce.trustAsResourceUrl(url);
      }

      vm.formatearUrlPdf = function(url) {
        return $sce.trustAsResourceUrl('data:application/pdf;base64,' + url);
      }

      vm.title = title;
      vm.data = data;
      vm.hide = $mdDialog.hide;
      vm.cancel = $mdDialog.cancel;
    }

    function subsanarObservacion(event) {
      Modal.confirm('Si subsana la observación, asegurese de tener aprobada la conclusión del SSSRO del estudiante, luego debe enviarla al Asesor Legal ingresando a la bandeja de Resoluciones Administrativas buscar por C.I. y enviar el informe técnico al Asesor Legal. El trámite será enviado al Asesor Legal para que se firme el Informe Técnico Legal y continúe el flujo normal del proceso. ¿Desea continuar?' , function() {
        DataService.put(vm.urlSubsanar + vm.habilitacion.observacion.id_observacion, {})
          .then(function(response) {
            if (response.mensaje) {
              enviarAsesorObservacion();
              Message.success(response.mensaje);
            }
          });
      }, null, event);
    }

    function enviarAsesorObservacion() {
      DataService.post(vm.urlGenerarInforme, {
          ids_habilitacion: vm.habilitacion.id_habilitacion,
          rezagado: vm.habilitacion.rezagado
        })
        .then(function(response) {
          if (response && response.datos) {
            obtenerHabilitacion();
            Message.success(response.mensaje);
          } else {
            Message.warning("La solicitud no se procesó correctamente.");
          }
        });
    }

    function buscar() {
      DataService.get(vm.urlBuscar + vm.documentoIdentidad + '?tipo=' + vm.tipo)
      .then(function(response) {
        if (response && response.datos) {
          vm.encontrados = response.datos;
          $window.sessionStorage.setItem("documento_identidad_buscado", angular.toJson({documentoIdentidad: vm.documentoIdentidad, tipo: vm.tipo}));
          if (vm.encontrados.length == 1 && vm.encontrados[0].habilitacion && vm.encontrados[0].habilitacion.length == 1) {
            $location.path("/rotaciones/requisitosResoluciones/" + vm.encontrados[0].habilitacion[0].id_habilitacion);
          }
        } else {
          Message.warning("No se encuentra el estudiante con el documento introducido.");
        }
      });
    }

    function verDetalleInscripcion(id_habilitacion) {
      $location.path("/rotaciones/requisitosResoluciones/" + id_habilitacion);
    }

    function volverBuscar() {
      $location.path("/rotaciones/requisitosResoluciones/");
    }

    function registrarApoderado(event) {
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', 'Upload', '$mdDialog', 'data', 'DataService', 'restUrl', 'Message', DialogApoderadoController],
        // templateUrl: 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.monitoreo.crud.html'
        templateUrl: 'app/modules/rotaciones/monitoreo/detalleMonitoreo/create.dialog.html'
      });
    }

    function mostrarPoder(event, id_apoderado) {
      DataService.get(restUrl + 'rotaciones/apoderado/base/' + id_apoderado)
      .then(function(response) {
        if (response && response.datos) {
          var respuestaArchivo = response.datos;
          var dialog;
          if (respuestaArchivo.type.startsWith('image')) {
            dialog = 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.req.html';
            Modal.show({
              event: event,
              data: respuestaArchivo.base64,
              title: "Documento",
              templateUrl: dialog,
              controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
            });
          } else {
            ConsultasService.mostrarRequisitoPdfBase64(event, respuestaArchivo.base64, "Documento")
          }
        } else {
          Message.error("No se encontraron los datos solicitados.");
        }
      });
    }

  }

  function DialogObservacionController($scope, $mdDialog, data, DataService, restUrl, Message) {
    var vm = $scope;
    vm.anterior = data.anterior;
    vm.url = restUrl + "rotaciones/observacion/";

    vm.observacion = {
      fid_habilitacion: data.idHabilitacion
    }
    vm.guardarObservacion = function() {
      if (vm.observacion.definitiva) {
        vm.observacion.estado_observacion = 'NOSUBSANABLE';
      } else {
        vm.observacion.estado_observacion = 'PENDIENTE';
      }
      if (vm.anterior) {
        vm.observacion.estado_observacion = 'NOTA';
      }
      DataService.save(vm.url, vm.observacion)
      .then(function(response) {
        if (response && response.datos) {
          data.obtenerHabilitacion();
          $mdDialog.hide();
          Message.success(response.mensaje);
        } else {
          Message.error("Ocurrió un error al tratar de guardar la observación.");
        }
      });
    }
    vm.close = function() {
      $mdDialog.hide();
    }
  }

  function DialogApoderadoController($scope, Upload, $mdDialog, data, DataService, restUrl, Message) {
    var vm = $scope;

    vm.url = restUrl + "rotaciones/apoderado";

    vm.apoderado = {
      fid_habilitacion: data.idHabilitacion
    }
    vm.guardarApoderado = function() {
      vm.apoderado.fid_persona = vm.apoderado.persona.id_persona;

      var debounceUpdate = function(newVal) {
        if (newVal != undefined) {
          var validarArchivo = newVal.lfFile;
          if (validarArchivo.type.indexOf('image/') >= 0 || validarArchivo.name.indexOf('.pdf', validarArchivo.name.length - 4) >= 0) {
            Upload.upload({
              url: vm.url,
              fields: vm.apoderado,
              // data: {file: newVal.lfFile, fields: vm.apoderado}
              file: newVal.lfFile
            }).progress(function(event) {
              var progressPercentage = parseInt(100.0 * event.loaded / event.total);
              vm.progreso = progressPercentage;
            }).success(function(response) {
              if (response && response.mensaje) {
                data.obtenerHabilitacion();
                $mdDialog.hide();
                Message.success(response.mensaje);
              }
              vm.mostrarProgreso = false;
            }).catch(function(error) {
              if (error && error.data && error.data.mensaje) {
                Message.error(error.data.mensaje);
              } else {
                Message.error("Ocurrió un error al procesar el archivo. Favor revisar si el formato es el correcto.");
              }
            });
          } else {
            Message.error("Sólo se permiten imágenes y archivos PDF.");
          }
        }
      };
      $scope.$watch('archivo[0]', debounceUpdate);
    }

    vm.close = function() {
      $mdDialog.hide();
    }
  }

  angular.module('app')
    .controller('ArchivosFilaController', function($scope, $timeout, Upload, DataService, Message, restUrl, $stateParams) {
      var vm = $scope;
      var params = $stateParams;
      vm.idHabilitacion = params.idHabilitacion;
      vm.urlCrearArchivos = restUrl + 'rotaciones/archivo/subir/';
      var debounceUpdate = function(newVal) {
        if (newVal != undefined) {
          var validarArchivo = newVal.lfFile;
          if (validarArchivo.type.indexOf('image/') >= 0 || validarArchivo.name.indexOf('.pdf', validarArchivo.name.length - 4) >= 0) {
            Upload.upload({
              url: vm.urlCrearArchivos + vm.idHabilitacion + '/' + vm.archivo.id_par_archivo,
              fields: {},
              file: newVal.lfFile
            }).progress(function(event) {
              var progressPercentage = parseInt(100.0 * event.loaded / event.total);
              vm.progreso = progressPercentage;
            }).success(function(response) {
              if (response && response.mensaje) {
                Message.success(response.mensaje);
                $scope.$emit('archivoCargado');
              }
              vm.mostrarProgreso = false;
            }).catch(function(error) {
              if (error && error.data && error.data.mensaje) {
                Message.error(error.data.mensaje);
              } else {
                Message.error("Ocurrió un error al procesar el archivo. Favor revisar si el formato es el correcto.");
              }
            });
          } else {
            Message.error("Sólo se permiten imágenes y archivos PDF.");
          }
        }
      };
      $scope.$watch('archivo.files[0]', debounceUpdate);

      var timeout = null;
      var actualizarRequisito = function(newVal, oldVal) {
        if (newVal != undefined) {
          if (newVal != oldVal) {
            if (timeout) {
              $timeout.cancel(timeout)
            }
            timeout = $timeout(guardarRequisito, 1000);
          }
        }
      };
      $scope.$watch('archivo.archivoTexto', actualizarRequisito);

      function guardarRequisito() {
        DataService.post(vm.urlCrearArchivos + vm.idHabilitacion + '/' + vm.archivo.id_par_archivo, {archivoTexto: vm.archivo.archivoTexto})
          .then(function(response) {
            if (response && response.datos) {
              if (response && response.mensaje) {
                Message.success(response.mensaje);
                $scope.$emit('archivoCargado');
              }
              vm.mostrarProgreso = false;
            } else {
              Message.warning("Ocurrió un error al guardar el valor del requisito. Por favor verifique sus datos.");
            }
          });
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('DetalleResolucionesController', DetalleResolucionesController);

  /** @ngInject */
  function DetalleResolucionesController(restUrl, Modal, DataService, Util, Message, $location, $stateParams, moment, Upload, $sce, DemofiService, $window,ConsultasService) {
    var vm = this;
//    var params = $stateParams;
//    vm.idHabilitacion = params.idHabilitacion;
    vm.idHabilitacion = $window.sessionStorage.id_habilitacion;
    vm.permission = Util.getMenuProcess();
    vm.title = 'Datos del estudiante';
    vm.url = restUrl + 'rotaciones/habilitacion/';
    vm.urlFaltas = restUrl + 'rotaciones/habilitacion/faltas/';
    vm.urlArchivos = restUrl + 'rotaciones/habilitacion_archivo/';
    vm.urlInforme = restUrl + 'rotaciones/habilitacion_informe/';
    vm.urlMostrarResolucion = restUrl + 'rotaciones/resolucion/';
    vm.urlResolucion = restUrl + 'rotaciones/habilitacion_resolucion/';
    vm.urlCrearArchivos = restUrl + 'rotaciones/archivo/subir/';
    vm.urlObtenerCredenciales = restUrl + 'rotaciones/habilitacion_credencial/';

    vm.listarFaltas = listarFaltas;
    vm.obtenerHabilitacion = obtenerHabilitacion;
    vm.guardarArchivos = guardarArchivos;
    vm.abrirRequisito = abrirRequisito;
    vm.mostrarInformeTecnicoGenerado = mostrarInformeTecnicoGenerado;
    vm.mostrarResolucion = mostrarResolucion;
    vm.observarTramite = observarTramite;
    vm.mostrarCredencial = mostrarCredencial;
    vm.verificarMostrarInforme = function(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'INFORME_GENERADO' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }
    vm.verificarMostrarResolucion = function(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }

    activate();

    function activate() {
      obtenerHabilitacion();
    }

    function obtenerHabilitacion() {
//      DataService.get(vm.url, params.idHabilitacion)
      DataService.get(vm.url, vm.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          vm.habilitacion = response.datos;
        } else {
          Message.warning("No se encuentra la información solicitada.");
        }
      });
      obtenerFaltas();
      obtenerArchivos();
    }

    function obtenerArchivos(){
      DataService.get(vm.urlArchivos, vm.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          vm.archivos = response.datos;
        } else {
          Message.warning("No se encontraron archivos registrados.");
        }
      });
    }

    function guardarArchivos() {
      var contador = 0;
      for (var i in vm.archivos) {
        if (vm.archivos[i].files.length == 1) {
          contador++;
          Upload.upload({
            url: vm.urlCrearArchivos + vm.idHabilitacion + '/' + vm.archivos[i].id_par_archivo,
            fields: {},
            file: vm.archivos[i].files[0].lfFile
          }).progress(function(event) {
            var progressPercentage = parseInt(100.0 * event.loaded / event.total);
            vm.progreso = progressPercentage;
          }).success(function(response) {
            if (response && response.mensaje) {
              Message.success(response.mensaje);
              obtenerHabilitacion();
            }
            vm.mostrarProgreso = false;
          }).catch(function(error) {
            if (error && error.data && error.data.error) {
              Message.error(error.data.error);
            }
            Message.error("Ocurrió un error al procesar el archivo. Favor revisar si el formato es el correcto.");
          });
        }
      }
      if (contador == 0) {
        Message.warning("No seleccionó ningún archivo para ser guardado.");
      }
    }

    function abrirRequisito(event, archivo) {
      DataService.get(restUrl + 'rotaciones/archivo/base/' + archivo.archivo[0].id_archivo)
      .then(function(response) {
        if (response && response.datos) {
          var respuestaArchivo = response.datos;
          var dialog;
          if (respuestaArchivo.type.startsWith('image')) {
            dialog = 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.req.html';
            Modal.show({
              event: event,
              data: respuestaArchivo.base64,
              title: archivo.nombre,
              templateUrl: dialog,
              controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
            });
          } else {
            ConsultasService.mostrarRequisitoPdfBase64(event, respuestaArchivo.base64, archivo.nombre)
          }
        } else {
          Message.error("No se encontraron los datos solicitados.");
        }
      });
    }

    // ------------- DOCUMENTOS GENERADOS

    function mostrarCredencial(event) {
      ConsultasService.mostrarPdfFirmas(event,
                                        ConsultasService.urlMostrarCredencial,
                                        {id_habilitacion: [vm.idHabilitacion]},
                                        "Credencial",
                                        "La credencial no se recuperó correctamente.");
    }

    function mostrarInformeTecnicoGenerado(event) {
      ConsultasService.mostrarPdfFirmas(event,
                                        ConsultasService.urlMostrarInforme,
                                        {id_habilitacion: [vm.idHabilitacion]},
                                        "Informe Técnico Legal",
                                        "El informe técnico legal no se recuperó correctamente.");
    }

    function mostrarResolucion(event) {
      ConsultasService.mostrarPdfFirmas(event,
                                        ConsultasService.urlMostrarResolucion,
                                        { id_habilitacion: [vm.idHabilitacion] },
                                        "Resolución Administrativa",
                                        "La resolución administrativa no se recuperó correctamente.");
    }

    // ------------------ FALTAS

    function listarFaltas(event) {
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'DataService', 'restUrl', 'Message', DialogMonitoreoController],
        templateUrl: 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.monitoreo.lista.html'
      });
    }

    function obtenerFaltas() {
      DataService.list(vm.urlFaltas + vm.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          var faltas = response.datos;
          vm.faltas = response.datos;
          for (var f in faltas) {
            if (faltas[f].fecha_fin_bloqueo) {
              vm.habilitacion.fecha_fin_bloqueo = faltas[f].fecha_fin_bloqueo;
            }
          }
        }
      });
    }

    function observarTramite(event) {
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'DataService', 'restUrl', 'Message', DialogObservacionController],
        templateUrl: 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.observacion.crud.html'
      });
    }

    function PdfController($scope, $mdDialog, data, title) {
      var vm = $scope;

      vm.formatearUrl = function(url) {
        //return $sce.trustAsResourceUrl('data:image;base64,' + url);
        return $sce.trustAsResourceUrl(url);
      }

      vm.formatearUrlPdf = function(url) {
        return $sce.trustAsResourceUrl('data:application/pdf;base64,' + url);
      }

      vm.formatearHtml = function(texto) {
        var res = texto.replace(/\n/g, "<br>");
        return $sce.trustAsHtml(res);
      }

      vm.title = title;
      vm.data = data;
      vm.hide = $mdDialog.hide;
      vm.cancel = $mdDialog.cancel;
    }

  }

  function DialogMonitoreoController($scope, $mdDialog, data) {
    var vm = $scope;
    vm.faltas = data.faltas;

    vm.close = function() {
      $mdDialog.hide();
    }
  }

  function DialogObservacionController($scope, $mdDialog, data, DataService, restUrl, Message) {
    var vm = $scope;

    vm.url = restUrl + "rotaciones/observacion/";

    vm.observacion = {
      fid_habilitacion: data.idHabilitacion
    }
    vm.guardarObservacion = function() {
      if (vm.observacion.definitiva) {
        vm.observacion.estado_observacion = 'NOSUBSANABLE';
      } else {
         vm.observacion.estado_observacion = 'PENDIENTE';
      }
      DataService.save(vm.url, vm.observacion)
      .then(function(response) {
        if (response && response.datos) {
          data.obtenerHabilitacion();
          $mdDialog.hide();
          Message.success(response.mensaje);
        } else {
          Message.error("Ocurrió un error al tratar de guardar la observación.");
        }
      });
    }
    vm.close = function() {
      $mdDialog.hide();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ReporteEstudiantesController', ReporteEstudiantesController);

  /** @ngInject */
  function ReporteEstudiantesController(restUrl, DataService, Message, FileSaver) {
    var vm = this;
    vm.urlGestiones = restUrl + 'rotaciones/periodo/gestion';
    vm.urlMunicipios = restUrl + 'rotaciones/municipio';
    vm.urlSedes = restUrl + 'rotaciones/sedes';
    vm.urlRed = restUrl + 'rotaciones/red';
    vm.urlEstablecimientos = restUrl + 'rotaciones/establecimientos';
    vm.urlUniversidad = restUrl + 'rotaciones/reportes/universidad';
    vm.urlTipoCarrera = restUrl + 'rotaciones/tipo_carrera/';
    vm.urlEstudiantes = restUrl + 'rotaciones/reporte/estudiantes';
    vm.urlPeriodos = restUrl + 'rotaciones/periodo/periodo/';
    vm.reporte = reporte;

    vm.cambiandoMunicipio = cambiandoMunicipio;
    vm.cambiandoGestion = cambiandoGestion;
    vm.listarPeriodos = listarPeriodos;
    vm.cambiandoPeriodo = cambiandoPeriodo;
    vm.cambiandoRed = cambiandoRed;
    vm.cambiandoSedes = cambiandoSedes;
    vm.cambiandoPeriodoGenerico = cambiandoPeriodoGenerico;

    vm.periodo = 0;
    vm.cod_area = 0;
    vm.cod_muni = 0;
    vm.id_establecimiento_salud = 0;
    vm.id_universidad = 0;
    vm.id_tipo_carrera = 0;
    vm.id_sedes = 0;
    vm.gestion = 0;
    vm.estado_habilitacion = '';
    vm.casos_especiales = false;

    vm.periodosGenericos = [{
      id_periodo: -1,
      numero: 1
    },{
      id_periodo: -1,
      numero: 2
    },{
      id_periodo: -1,
      numero: 3
    },{
      id_periodo: -1,
      numero: 4
    }];
    var actual = new Date().getFullYear();

    listarSedes();
    listarCarreras();

    reiniciar();

    function reiniciar() {
      vm.periodo = 0;
      vm.cod_area = 0;
      vm.cod_muni = 0;
      vm.id_establecimiento_salud = 0;
      vm.id_universidad = 0;
    }

    function listarSedes() {
      vm.sedes = [];
      DataService.get(vm.urlSedes)
      .then(function(sedes) {
        if (sedes && sedes.datos) {
          vm.sedes = sedes.datos;
          if (vm.sedes && vm.sedes.length > 0) {
            vm.id_sedes = vm.sedes[0].id_sedes;
          }
          cargarEstados();
        }
        cambiandoSedes();
      });
    }

    function cargarEstados() {
      vm.estados = ['HABILITADO', 'APROBADO', 'REPROBADO', 'RECHAZADO', 'OBSERVADO', 'PREASIGNADO', 'ASIGNADO', 'SUSPENDIDA', 'CREDENCIAL_GENERADA',
                    'CREDENCIAL_FIRMADA', 'INFORME_GENERADO', 'RESOLUCION_GENERADA', 'RESOLUCION_FIRMADA_ASESOR', 'RESOLUCION_FIRMADA_DIRECTOR', 'RESO_GENERADA_AP_CASADA', 'RESO_AP_CASADA_FIRMA_ASESOR'];
      if (vm.sedes && vm.sedes.length == 1) {
        vm.estados = ['HABILITADO', 'OBSERVADO', 'PREASIGNADO', 'ASIGNADO', 'SUSPENDIDA',
                      'CREDENCIAL_FIRMADA', 'RESOLUCION_FIRMADA_ASESOR', 'RESOLUCION_FIRMADA_DIRECTOR', 'RESO_AP_CASADA_FIRMA_ASESOR'];
      } else if (vm.sedes && vm.sedes.length > 0) {
        vm.estados = ['HABILITADO', 'OBSERVADO', 'SUSPENDIDA', 'CREDENCIAL_FIRMADA', 'RESOLUCION_FIRMADA_DIRECTOR' , 'RESO_AP_CASADA_FIRMA_ASESOR'];
      }
    }

    function listarGestiones() {
      var query = {
        id_sedes: vm.id_sedes
      };
      vm.gestiones = [];
      vm.gestion = 0;
      DataService.list(vm.urlGestiones, query)
        .then(function(gestiones) {
          if (gestiones && gestiones.datos) {
            vm.gestiones = gestiones.datos;
            if (vm.gestiones && vm.gestiones.length > 0) {
              vm.gestion = vm.gestiones[0].gestion;
              for (var i in vm.gestiones) {
                if (actual == vm.gestiones[i].gestion) {
                  vm.gestion = vm.gestiones[i].gestion;
                  break;
                }
              }
              if (vm.gestion == 0) {
                vm.gestion = vm.gestiones[0].gestion;
              }
            }
          } else {
            Message.warning("El SEDES aún no ha generado períodos para ninguna gestión.");
          }
          cambiandoGestion();
      });
    }

    function listarPeriodos() {
      var query = {
        id_sedes: vm.id_sedes
      };
      vm.periodos = [];
      DataService.list(vm.urlPeriodos + vm.gestion, query)
        .then(function(periodos) {
          if (periodos && periodos.datos) {
            vm.periodos = periodos.datos;
          }
          cambiandoPeriodo();
        });
    }

    function listarRedes() {
      var query = {
        gestion: vm.gestion,
        periodo: vm.periodo == 0 ? vm.periodo : vm.periodo.id_periodo,
        id_sedes: vm.id_sedes
      };
      vm.redes = [];
      DataService.list(vm.urlRed, query)
        .then(function(redes) {
          if (redes && redes.datos) {
            vm.redes = redes.datos;
          }
          cambiandoRed();
      });
    }

    function listarMunicipios(id) {
      var query = {
        gestion: vm.gestion,
        periodo: vm.periodo == 0 ? vm.periodo : vm.periodo.id_periodo,
        id_sedes: vm.id_sedes
      };
      vm.municipios = [];
      DataService.list(vm.urlMunicipios + '/' + id, query)
        .then(function(municipios) {
          if (municipios && municipios.datos) {
            vm.municipios = municipios.datos;
          }
          cambiandoMunicipio();
      });
    }

    function listarEstablecimientos(id) {
      var query = {
        gestion: vm.gestion,
        periodo: vm.periodo == 0 ? vm.periodo : vm.periodo.id_periodo,
        cod_area: vm.cod_area,
        id_sedes: vm.id_sedes
      };
      vm.establecimientos = [];
      DataService.list(vm.urlEstablecimientos + '/' + id, query)
        .then(function(establecimientos) {
          if (establecimientos && establecimientos.datos) {
            vm.establecimientos = establecimientos.datos;
          }
      });
    }

    function listarUniversidad() {
      var query = {
        gestion: vm.gestion,
        periodo: vm.periodo == 0 ? vm.periodo : vm.periodo.id_periodo,
        id_sedes: vm.id_sedes
      };
      DataService.list(vm.urlUniversidad, query)
      .then(function(universidad) {
        vm.universidades = [];
        if (universidad && universidad.datos) {
          vm.universidades = universidad.datos;
        }
      });
    }

    function listarCarreras() {
      DataService.get(vm.urlTipoCarrera)
        .then(function(carreras) {
          if (carreras && carreras.datos) {
            vm.carreras = carreras.datos;
          }
      });
    }

    function cambiandoSedes() {
      listarGestiones();
    }

    function cambiandoGestion() {
      listarPeriodos();
      vm.periodo = 0;
    }
    function cambiandoPeriodo() {
      listarRedes();
      vm.cod_area = 0;
      listarUniversidad();
      vm.id_universidad = 0;
    }

    function cambiandoPeriodoGenerico() {
      listarUniversidad();
      vm.id_universidad = 0;
    }

    function cambiandoRed() {
      listarMunicipios(vm.cod_area);
      vm.cod_muni = 0;
    }

    function cambiandoMunicipio() {
      listarEstablecimientos(vm.cod_muni);
      vm.id_establecimiento_salud = 0;
    }

    function reporte() {
      DataService.pdf2(vm.urlEstudiantes, {
        cod_muni: vm.cod_muni,
        id_establecimiento_salud: vm.id_establecimiento_salud,
        cod_area: vm.cod_area,
        id_universidad: vm.id_universidad,
        id_tipo_carrera: vm.id_tipo_carrera,
        gestion: vm.gestion,
        periodo: vm.periodo.numero,
        estado_habilitacion: vm.estado_habilitacion,
        casos_especiales: vm.casos_especiales,
        id_sedes: vm.id_sedes
      })
      .then(function(data) {
        // data = new Blob([data.data], {type: 'application/vnd.oasis.opendocument.spreadsheet'});
        data = new Blob([data.data], {type: 'text/csv'});
        FileSaver.saveAs(data, 'estudiantes.csv');
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ReporteCuposController', ReporteCuposController);

  /** @ngInject */
  function ReporteCuposController(restUrl, DataService, Message, FileSaver) {
    var vm = this;
    vm.urlGestiones = restUrl + 'rotaciones/periodo/gestion';
    vm.urlMunicipios = restUrl + 'rotaciones/todos/municipio';
    vm.urlSedes = restUrl + 'rotaciones/sedes';
    vm.urlRed = restUrl + 'rotaciones/todos/red';
    vm.urlCupos = restUrl + 'rotaciones/reporte/cupos';
    vm.urlPeriodos = restUrl + 'rotaciones/periodo/periodo/';
    vm.reporte = reporte;

    vm.cambiandoGestion = cambiandoGestion;
    vm.listarPeriodos = listarPeriodos;
    vm.cambiandoPeriodo = cambiandoPeriodo;
    vm.cambiandoSedes = cambiandoSedes;
    vm.cambiandoRed = cambiandoRed;

    // vm.cod_area = 0;
    // vm.cod_muni = 0;
    // vm.id_establecimiento_salud = 0;
    vm.id_sedes = 0;
    vm.gestion = 0;
    vm.tipo_cupos = 0;
    vm.ambito = 'R';
    vm.cod_area = 0;
    vm.cod_muni = 0;

    vm.periodosGenericos = [{
      id_periodo: -1,
      numero: 1
    },{
      id_periodo: -1,
      numero: 2
    },{
      id_periodo: -1,
      numero: 3
    },{
      id_periodo: -1,
      numero: 4
    }];

    var actual = new Date().getFullYear();

    listarSedes();
    reiniciar();

    function reiniciar() {
      // vm.cod_area = 0;
      // vm.cod_muni = 0;
      // vm.id_establecimiento_salud = 0;
      vm.periodo = 0;
    }

    function listarSedes() {
      vm.sedes = [];
      DataService.get(vm.urlSedes)
      .then(function(sedes) {
        if (sedes && sedes.datos) {
          vm.sedes = sedes.datos;
          if (vm.sedes && vm.sedes.length > 0) {
            vm.id_sedes = vm.sedes[0].id_sedes;
          }
        }
        cambiandoSedes();
      });
    }

    function listarGestiones() {
      var query = {
        id_sedes: vm.id_sedes
      };
      vm.gestiones = [];
      vm.gestion = 0;
      DataService.list(vm.urlGestiones, query)
        .then(function(gestiones) {
          if (gestiones && gestiones.datos) {
            vm.gestiones = gestiones.datos;
            if (vm.gestiones && vm.gestiones.length > 0) {
              for (var i in vm.gestiones) {
                if (actual == vm.gestiones[i].gestion) {
                  vm.gestion = vm.gestiones[i].gestion;
                  break;
                }
              }
              if (vm.gestion == 0) {
                vm.gestion = vm.gestiones[0].gestion;
              }
            }
          } else {
            Message.warning("El SEDES aún no ha generado períodos para ninguna gestión.");
          }
          cambiandoGestion();
      });
    }

    function listarPeriodos() {
      var query = {
        id_sedes: vm.id_sedes
      };
      vm.periodos = [];
      DataService.list(vm.urlPeriodos + vm.gestion, query)
        .then(function(periodos) {
          if (periodos && periodos.datos) {
            vm.periodos = periodos.datos;
            if (vm.periodos.length > 0) {
              vm.periodo = vm.periodos[0];
            }
          }
          cambiandoPeriodo();
        });
    }

    function listarRedes() {
      var query = {
        gestion: vm.gestion,
        periodo: vm.periodo == 0 ? vm.periodo : vm.periodo.id_periodo,
        id_sedes: vm.id_sedes
      };
      vm.redes = [];
      DataService.list(vm.urlRed, query)
        .then(function(redes) {
          if (redes && redes.datos) {
            vm.redes = redes.datos;
          }
          cambiandoRed();
      });
    }

    function listarMunicipios(id) {
      var query = {
        gestion: vm.gestion,
        periodo: vm.periodo == 0 ? vm.periodo : vm.periodo.id_periodo,
        id_sedes: vm.id_sedes
      };
      vm.municipios = [];
      DataService.list(vm.urlMunicipios + '/' + id, query)
        .then(function(municipios) {
          if (municipios && municipios.datos) {
            vm.municipios = municipios.datos;
          }
      });
    }

    function cambiandoSedes() {
      listarGestiones();
      listarRedes();
    }

    function cambiandoRed() {
      listarMunicipios(vm.cod_area);
    }

    function cambiandoGestion() {
      if (vm.id_sedes > 0) {
        listarPeriodos();
      } else {
        vm.periodo = vm.periodosGenericos[0];
      }
    }
    function cambiandoPeriodo() {
      vm.cod_area = 0;
    }

    function reporte() {
      DataService.pdf2(vm.urlCupos, {
        id_sedes: vm.id_sedes,
        gestion: vm.gestion,
        periodo: vm.periodo,
        tipo_cupos: vm.tipo_cupos,
        ambito: vm.ambito,
        cod_area: vm.cod_area,
        cod_muni: vm.cod_muni
      })
      .then(function(data) {
        data = new Blob([data.data], {type: 'application/vnd.oasis.opendocument.spreadsheet'});
        FileSaver.saveAs(data, 'cuposEstablecimientos.ods');
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesTramitesObservados', {
      templateUrl: 'app/modules/rotaciones/observados/tramitesObservados/modules.rotaciones.observados.tramitesObservados.html',
      controller: TramitesObservadosController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function TramitesObservadosController($scope, $location) {
    var vm = this;
    vm.title = 'Lista de estudiantes con trámites observados';
    vm.seleccionable = false;
    vm.rezagados = true;
    vm.estados = ['OBSERVADO'];

    vm.verDetalle = verDetalle;

    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo >= 0) {
          vm.periodoFiltro = id_periodo;
        }
        vm.listarHabilitados(id_periodo);
      }
    }


    vm.buttons = [{
      tooltip: 'Ver detalle',
      icon: 'remove_red_eye',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        verDetalle(id);
      }
    }];

    function verDetalle(id_habilitacion) {
      $location.path('rotaciones/detalleObservados/' + id_habilitacion);
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('DetalleObservadosController', DetalleObservadosController);

  /** @ngInject */
  function DetalleObservadosController($scope, restUrl, Modal, DataService, Util, Message, $location, $stateParams, moment, Upload, $sce, DemofiService, ConsultasService) {
    var vm = this;
    var params = $stateParams;
    vm.idHabilitacion = params.idHabilitacion;
    vm.permission = Util.getMenuProcess();
    vm.title = 'Datos del estudiante';
    vm.url = restUrl + 'rotaciones/habilitacion/';
    vm.urlFaltas = restUrl + 'rotaciones/habilitacion/faltas/';
    vm.urlArchivos = restUrl + 'rotaciones/habilitacion_archivo/';
    vm.urlInforme = restUrl + 'rotaciones/habilitacion_informe/';
    vm.urlMostrarResolucion = restUrl + 'rotaciones/resolucion/';
    vm.urlResolucion = restUrl + 'rotaciones/habilitacion_resolucion/';
    vm.urlCrearArchivos = restUrl + 'rotaciones/archivo/subir/';
    vm.urlSubsanar = restUrl + 'rotaciones/observacion/subsanado/';
    vm.urlRequisito = restUrl + 'rotaciones/archivo/bin/';
    vm.urlGenerarInforme = restUrl + 'rotaciones/habilitacion_generar_informe/';

    vm.listarFaltas = listarFaltas;
    vm.obtenerHabilitacion = obtenerHabilitacion;
    vm.guardarArchivos = guardarArchivos;
    vm.abrirRequisito = abrirRequisito;
    vm.mostrarInformeTecnicoGenerado = mostrarInformeTecnicoGenerado;
    vm.mostrarResolucion = mostrarResolucion;
    vm.subsanarObservacion = subsanarObservacion;

    activate();

    function activate() {
      obtenerHabilitacion();
    }

    function obtenerHabilitacion() {
      DataService.get(vm.url, params.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          vm.habilitacion = response.datos;
        } else {
          Message.warning("No se encuentra la información solicitada.");
        }
      });
      obtenerFaltas();
      obtenerArchivos();
    }
    $scope.$on('archivoCargado', obtenerArchivos);
    function obtenerArchivos(){
      DataService.get(vm.urlArchivos, vm.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          vm.archivos = response.datos;
        } else {
          Message.warning("No se encontraron archivos registrados.");
        }
      });
    }

    function guardarArchivos() {
      var contador = 0;
      for (var i in vm.archivos) {
        if (vm.archivos[i].files.length == 1) {
          contador++;
          Upload.upload({
            url: vm.urlCrearArchivos + vm.idHabilitacion + '/' + vm.archivos[i].id_par_archivo,
            fields: {},
            file: vm.archivos[i].files[0].lfFile
          }).progress(function(event) {
            var progressPercentage = parseInt(100.0 * event.loaded / event.total);
            vm.progreso = progressPercentage;
          }).success(function(response) {
            if (response && response.mensaje) {
              Message.success(response.mensaje);
              obtenerHabilitacion();
            }
            vm.mostrarProgreso = false;
          }).catch(function(error) {
            if (error && error.data && error.data.error) {
              Message.error(error.data.error);
            }
            Message.error("Ocurrió un error al procesar el archivo. Favor revisar si el formato es el correcto.");
          });
        }
      }
      if (contador == 0) {
        Message.warning("No seleccionó ningún archivo para ser guardado.");
      }
    }

    function abrirRequisito(event, archivo) {
      // var parametros = {
      //   id: archivo.archivo[0].id_archivo
      // }
      DataService.get(restUrl + 'rotaciones/archivo/base/' + archivo.archivo[0].id_archivo)
      .then(function(response) {
        if (response && response.datos) {
          var respuestaArchivo = response.datos;
          var dialog;
          if (respuestaArchivo.type.startsWith('image')) {
            dialog = 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.req.html';
            Modal.show({
              event: event,
              data: respuestaArchivo.base64,
              title: respuestaArchivo.nombre,
              templateUrl: dialog,
              controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
            });
          } else {
            ConsultasService.mostrarRequisitoPdfBase64(event, respuestaArchivo.base64, respuestaArchivo.nombre)
          }
        } else {
          Message.error("No se encontraron los datos solicitados.");
        }
      });
    }

    // ------------- DOCUMENTOS GENERADOS

    function mostrarInformeTecnicoGenerado(event) {
      DataService.post(vm.urlInforme, {id_habilitacion: [vm.idHabilitacion]})
        .then(function(response) {
          if (response && response.datos) {
            var documento = response.datos;
            if (documento.length == 1) {
              var data = {
                documento: documento[0].credencial
              }
              mostrarFirmas(data, event);
            } else {
              Message.error("El Informe Técnico Legal no se recuperó correctamente.");
            }
          }
        });
    }

    function mostrarResolucion(event) {
      if (vm.habilitacion.estado_habilitacion == 'INFORME_GENERADO') {
        mostrarResolucionPdf(event, vm.idHabilitacion);
      } else {
        DataService.post(vm.urlResolucion, {id_habilitacion: [vm.idHabilitacion]})
          .then(function(response) {
            if (response && response.datos) {
              var documento = response.datos;
              if (documento.length == 1) {
                var data = {
                  documento: documento[0].credencial
                }
                mostrarFirmas(data, event);
              } else {
                Message.error("La Resolución Administrativa no se recuperó correctamente.");
              }
            }
          });
      }
    }

    function mostrarFirmas(data, event) {
      DemofiService.encontrarFirmas(data.documento)
      .then(function(response) {
        if (response && response.datos && response.datos.length > 0) {
          data.firmas = response.datos;
        } else if (response && response.datos && response.datos.length == 0) {
          data.firmasMensaje = response.mensaje;
        }
        abrirPopupDocumento(data, event);
      }).catch(function() {
        Message.warning("Ocurrió un error al leer la firmas.");
      });
    }

    function abrirPopupDocumento(data, event) {
      Modal.show({
        event: event,
        data: data,
        title: 'Resolución Administrativa',
        templateUrl: 'app/modules/rotaciones/resoluciones/detalleResoluciones/dialog.pdf.html',
        controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
      });
    }

    function mostrarResolucionPdf(event, id_habilitacion) {
      DataService.pdf(vm.urlMostrarResolucion, {id_habilitacion: [id_habilitacion]})
        .then(function(response) {
          if (response) {
            Modal.show({
              event: event,
              data: response,
              title: 'Resolución Administrativa',
              templateUrl: 'app/components/crudTable/dialog.pdf.html',
              controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
            });
          }
          else {
            Message.error("La resolución administrativa no se recuperó correctamente.");
          }
        });
    }

    // ------------------ FALTAS

    function listarFaltas(event) {
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'DataService', 'restUrl', 'Message', DialogMonitoreoController],
        templateUrl: 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.monitoreo.lista.html'
      });
    }

    function obtenerFaltas() {
      DataService.list(vm.urlFaltas + vm.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          var faltas = response.datos;
          vm.faltas = response.datos;
          for (var f in faltas) {
            if (faltas[f].fecha_fin_bloqueo) {
              vm.habilitacion.fecha_fin_bloqueo = faltas[f].fecha_fin_bloqueo;
            }
          }
        }
      });
    }

    // -------------- OBSERVACIONES --------------------------------

    function subsanarObservacion(event) {
       Modal.confirm('Si subsana la observación, asegurese de tener aprobada la conclusión del SSSRO del estudiante, luego debe enviarla al Asesor Legal ingresando a la bandeja de Resoluciones Administrativas buscar por C.I. y enviar el informe técnico al Asesor Legal. El trámite será enviado al Asesor Legal para que se firme el Informe Técnico Legal y continúe el flujo normal del proceso. ¿Desea continuar?' , function() {
        DataService.put(vm.urlSubsanar + vm.habilitacion.observacion.id_observacion, {})
          .then(function(response) {
            if (response.mensaje) {
              if (vm.habilitacion.estado_habilitacion == 'CREDENCIAL_FIRMADA') {
                obtenerHabilitacion();
                Message.success(response.mensaje);
              } else {
                enviarAsesorObservacion();
                Message.success(response.mensaje);
              }
            }
          });
      }, null, event);
    }

    function enviarAsesorObservacion() {
      DataService.post(vm.urlGenerarInforme, {
          ids_habilitacion: vm.habilitacion.id_habilitacion,
          rezagado: vm.habilitacion.rezagado
        })
        .then(function(response) {
          if (response && response.datos) {
            obtenerHabilitacion();
            Message.success(response.mensaje);
          } else {
            Message.warning("La solicitud no se procesó correctamente.");
          }
        });
    }

    function PdfController($scope, $mdDialog, data, title) {
      var vm = $scope;

      vm.formatearUrl = function(url) {
        //return $sce.trustAsResourceUrl('data:image;base64,' + url);
        return $sce.trustAsResourceUrl(url);
      }

      vm.formatearUrlPdf = function(url) {
        return $sce.trustAsResourceUrl('data:application/pdf;base64,' + url);
      }

      vm.formatearHtml = function(texto) {
        var res = texto.replace(/\n/g, "<br>");
        return $sce.trustAsHtml(res);
      }

      vm.title = title;
      vm.data = data;
      vm.hide = $mdDialog.hide;
      vm.cancel = $mdDialog.cancel;
    }

  }

  function DialogMonitoreoController($scope, $mdDialog, data) {
    var vm = $scope;
    vm.faltas = data.faltas;

    vm.close = function() {
      $mdDialog.hide();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('MonitoreoController', MonitoreoController);

  /** @ngInject */
  function MonitoreoController() {
    
  }
})();

(function () {
    'use strict';

    angular
            .module('app')
            .controller('DetalleMonitoreoController', DetalleMonitoreoController);

    /** @ngInject */
    function DetalleMonitoreoController(restUrl, Modal, DataService, Util, Message, $location, $stateParams, Upload, $sce, BreadcrumbFactory, SideNavFactory, ConsultasService, $window) {
        var vm = this;
//    var params = $stateParams;
//    vm.idHabilitacion = params.idHabilitacion;
        vm.idHabilitacion = $window.sessionStorage.id_habilitacion;
        vm.permission = Util.getMenuProcess();
        vm.title = 'Datos del estudiante';
        vm.url = restUrl + 'rotaciones/habilitacion/';
        vm.urlTiposFaltas = restUrl + 'parametros/parametro/tipo_falta/';
        vm.urlArchivos = restUrl + 'rotaciones/habilitacion_archivo/';
        vm.urlFaltasCrud = restUrl + "rotaciones/falta/";
        vm.urlFaltas = restUrl + 'rotaciones/habilitacion/faltas/';

        vm.registrarFalta = registrarFalta;
        vm.obtenerHabilitacion = obtenerHabilitacion;
        vm.observarTramite = observarTramite;
        vm.volverMonitoreo = volverMonitoreo;
        vm.obtenerArchivos = obtenerArchivos;
        vm.eliminarFalta = eliminarFalta;
        vm.mostrarObservarTramite = mostrarObservarTramite;

        activate();

        function activate() {
            obtenerHabilitacion();
            obtenerArchivos();
        }

        function mostrarObservarTramite(habilitacion) {
            if (ConsultasService.verificarCredencialFirmada(habilitacion)) {
                return true;
            } else {
                return false;
            }
        }
        function obtenerHabilitacion() {
            DataService.get(vm.url, vm.idHabilitacion)
                    .then(function (response) {
                        if (response && response.datos) {
                            vm.habilitacion = response.datos;
                            obtenerFaltas();
                            mostrarMapa(vm.habilitacion.establecimiento_salud);
                        } else {
                            Message.warning("No se encuentra la información solicitada.");
                        }
                    });
            obtenerTiposFaltas();
        }

        function obtenerTiposFaltas() {
            DataService.list(vm.urlTiposFaltas)
                    .then(function (response) {
                        if (response && response.datos) {
                            vm.tipos_faltas = response.datos;
                        } else {
                            vm.tipos_faltas = [];
                        }
                    });
        }

        function mostrarMapa(establecimiento) {
            if (establecimiento && establecimiento.latitud && establecimiento.longitud) {
                vm.mapaEstablecimiento = {
                    ubicacion: {
                        lat: establecimiento.latitud,
                        lng: establecimiento.longitud,
                        zoom: 16
                    },
                    markers: {
                        establecimiento: {
                            lat: establecimiento.latitud,
                            lng: establecimiento.longitud,
                            title: establecimiento.establecimiento,
                            focus: true,
                            message: "<md-icon style='color: red'>local_hospital</md-icon><strong> " + establecimiento.establecimiento + "</strong>"
                        }
                    },
                    legend: {
                        position: 'bottomleft',
                        colors: ['#376EA6'],
                        labels: [establecimiento.establecimiento]
                    }
                };

            } else {
                vm.mapaVacio = "El establecimiento de salud no cuenta con datos de localización.";
            }
        }

        function registrarFalta(event) {
            Modal.show({
                event: event,
                data: vm,
                dialogController: ['$scope', '$mdDialog', 'data', 'DataService', 'restUrl', 'Message', DialogMonitoreoController],
                templateUrl: 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.monitoreo.crud.html'
            });
        }

        function observarTramite(event) {
            Modal.show({
                event: event,
                data: vm,
                dialogController: ['$scope', '$mdDialog', 'data', 'DataService', 'restUrl', 'Message', DialogObservacionController],
                templateUrl: 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.observacion.crud.html'
            });
        }

        function obtenerFaltas() {
            DataService.list(vm.urlFaltas + vm.idHabilitacion)
                    .then(function (response) {
                        if (response && response.datos) {
                            vm.faltas = response.datos;
                            for (var f in vm.faltas) {
                                if (vm.faltas[f].fecha_fin_bloqueo) {
                                  vm.habilitacion.fecha_inicio_bloqueo = vm.faltas[f].fecha_inicio_bloqueo;
                                  vm.habilitacion.fecha_fin_bloqueo = vm.faltas[f].fecha_fin_bloqueo;
                                }
                            }
                        } else {
                            vm.faltas = [];
                        }
                    });
        }

        function obtenerArchivos() {
            DataService.get(vm.urlArchivos, vm.idHabilitacion)
                    .then(function (response) {
                        if (response && response.datos) {
                            vm.archivos = response.datos;
                        } else {
                            Message.warning("No se encontraron archivos registrados.");
                        }
                    });
        }

        function volverMonitoreo() {
            var path = "/rotaciones/asignacionesEstudiantes";
            $location.path(path);
            BreadcrumbFactory.actualizar(path);
            SideNavFactory.actualizar(path);
        }

        function eliminarFalta(event, id_falta) {
            Modal.confirm('¿Desea eliminar la falta?', function () {
                DataService.delete(vm.urlFaltasCrud, id_falta)
                        .then(function (response) {
                            if (response && response.datos) {
                                Message.success(response.mensaje);
                                obtenerFaltas();
                            } else {
                                Message.error("Ocurrió un error al tratar de eliminar la falta.");
                            }
                        });
            }, null, event);
        }

    }

    function DialogMonitoreoController($scope, $mdDialog, data, DataService, restUrl, Message) {
        var vm = $scope;
        obtenerFaltas();

        vm.tipos_faltas = data.tipos_faltas;
        vm.url = restUrl + "rotaciones/falta/";

        vm.falta = {
            nro_periodos: 0,
            fid_habilitacion: data.idHabilitacion,
            fid_tipo_falta: 305
        }
        vm.guardarFalta = function () {
            if ((vm.falta.fid_tipo_falta == 305 && vm.faltas.length < 2) || confirm('El estudiante será suspendido.\n¿Desea continuar?')) {
                DataService.save(vm.url, vm.falta)
                        .then(function (response) {
                            if (response && response.datos) {
                                data.obtenerHabilitacion();
                                $mdDialog.hide();
                                Message.success(response.mensaje);
                            } else {
                                Message.error("Ocurrió un error al tratar de guardar la falta.");
                            }
                        });
            }
        }
        vm.eliminarFalta = function (id_falta) {
            DataService.delete(vm.url, id_falta)
                    .then(function (response) {
                        if (response && response.datos) {
                            Message.success(response.mensaje);
                            obtenerFaltas();
                        } else {
                            Message.error("Ocurrió un error al tratar de eliminar la falta.");
                        }
                    });
        }
        vm.obtenerDescripcionFalta = function (id_falta) {
            for (var f in vm.tipos_faltas) {
                if (id_falta == vm.tipos_faltas[f].id_parametro) {
                    return vm.tipos_faltas[f].descripcion;
                }
            }
        }
        vm.close = function () {
            $mdDialog.hide();
        }
        function obtenerFaltas() {
            DataService.list(data.urlFaltas + data.idHabilitacion)
                    .then(function (response) {
                        if (response && response.datos) {
                            vm.faltas = response.datos;
                        } else {
                            vm.faltas = [];
                        }
                    });
        }
    }

    function DialogObservacionController($scope, $mdDialog, data, DataService, restUrl, Message) {
        var vm = $scope;

        vm.url = restUrl + "rotaciones/observacion/";

        vm.observacion = {
            fid_habilitacion: data.idHabilitacion
        }
        vm.guardarObservacion = function () {
            if (vm.observacion.definitiva) {
                vm.observacion.estado_observacion = 'NOSUBSANABLE';
            } else {
                vm.observacion.estado_observacion = 'PENDIENTE';
            }
            DataService.save(vm.url, vm.observacion)
                    .then(function (response) {
                        if (response && response.datos) {
                            data.obtenerHabilitacion();
                            $mdDialog.hide();
                            Message.success(response.mensaje);
                        } else {
                            Message.error("Ocurrió un error al tratar de guardar la observación.");
                        }
                    });
        }
        vm.close = function () {
            $mdDialog.hide();
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('VerificacionCredencialController', VerificacionCredencialController);

  /** @ngInject */
  function VerificacionCredencialController(Modal, DataService, Message, $location, $stateParams, $sce, verificarCredencial) {
    var vm = this;
    var params = $stateParams;
    vm.title = 'Datos del estudiante';
    vm.urlHabilitacion = verificarCredencial + params.codigo;

    vm.formatearUrl = formatearUrl;

    activate();

    function activate() {
      angular.element('body').addClass('no-login');
      angular.element('body').removeClass('principal');
      DataService.get(vm.urlHabilitacion, params.idHabilitacion)
      .then(function(response) {
        if (response && response.datos) {
          vm.habilitacion = response.datos;
          if (vm.habilitacion.credencial !== false) {
            //vm.habilitacion.credencial = 'data:application/pdf;base64,' + vm.habilitacion.credencial;
            vm.habilitacion.credencial = vm.habilitacion.credencial;
          }
        } else {
          Message.info("No se encontraron los datos solicitados.");
        }
      })
    }

    function formatearUrl(url) {
      return $sce.trustAsResourceUrl(url);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('DetalleCredencialesController', DetalleCredencialesController);

  /** @ngInject */
  function DetalleCredencialesController(restUrl, Modal, DataService, Util, Message, $location, $stateParams, $sce, DemofiService, ConsultasService, $window) {
    var vm = this;
//    var params = $stateParams;
    vm.permission = Util.getMenuProcess();
    vm.title = 'Datos del estudiante';
    vm.url = restUrl + 'rotaciones/habilitacion/';
    vm.urlObtenerCredenciales = restUrl + 'rotaciones/habilitacion_credencial/';
    vm.urlObtenerFirmas = restUrl + 'rotaciones/habilitacion/firmas/pdf';
    vm.formatearUrl = formatearUrl;
    vm.formatearHtml = formatearHtml;

    activate();

    function activate() {
//      DataService.get(vm.url, params.idHabilitacion)
      DataService.get(vm.url, $window.sessionStorage.id_habilitacion)
      .then(function(response) {
        if (response.datos) {
          vm.habilitacion = response.datos;
          mostrarCredencial(vm.habilitacion.id_habilitacion)
        } else {
          Message.error(response.mensaje);
        }
      })
    }

    function mostrarCredencial(id_habilitacion) {
      DataService.post(vm.urlObtenerCredenciales, {id_habilitacion: [id_habilitacion]})
        .then(function(response) {
          if (response && response.datos) {
            var documento = response.datos;
            if (documento.length == 1) {

              mostrarFirmas(documento[0].credencial);

              var userAgent = $window.navigator.userAgent;
              var ieEDGE = userAgent.match(/Edge/g);
              var ie = userAgent.match(/.NET/g); // IE 11+
              var oldIE = userAgent.match(/MSIE/g);
              var file = ConsultasService.crearBlobDeBase64(documento[0].credencial);

              if (ie || oldIE || ieEDGE) {
                $window.navigator.msSaveOrOpenBlob(file, 'CREDENCIAL.pdf');
              } else {
                vm.habilitacion.credencial = documento[0].credencial;
              }
            } else {
              Message.error("La credencial no se recuperó correctamente.");
            }
          }
        });
    }

    function mostrarFirmas(credencial) {
      // DemofiService.encontrarFirmas(credencial)
      DataService.post(vm.urlObtenerFirmas, { pdf_base64: credencial})
      .then(function(response) {
        if (response && response.datos && response.datos.length > 0) {
          vm.firmas = response.datos;
        } else if (response && response.datos && response.datos.length == 0) {
          vm.firmasMensaje = response.mensaje;
        }
      }).catch(function() {
        Message.warning("Ocurrió un error al leer la firmas.");
      });
    }

    function formatearUrl(url) {
      return $sce.trustAsResourceUrl('data:application/pdf;base64,' + url);
    }

    function formatearHtml(texto) {
      var res = texto.replace(/\n/g, "<br>");
      return $sce.trustAsHtml(res);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('VerificacionEstudiantesController', VerificacionEstudiantesController);

  angular
    .module('app')
    .component('verificacionEstudiantes', {
      templateUrl: 'app/modules/rotaciones/components/verificacionEstudiantes/modules.rotaciones.components.verificacionEstudiantes.html',
      controller: VerificacionEstudiantesController,
      bindings: {
        esconderResultado: '=',
        habilitacion: '=',
        login: '='
      }
    });

  /** @ngInject */
  function VerificacionEstudiantesController(Modal, DataService, Message, $location, $sce, verificarEstudiante, ConsultasService) {
    var vm = this;
    vm.buscarEstudiante = buscarEstudiante;
    vm.volverBuscar = volverBuscar;

    vm.formatearUrl = formatearUrl;
    vm.verificarMostrarCredencial = function(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'SUSPENDIDA' ||
          habilitacion.estado_habilitacion == 'CREDENCIAL_FIRMADA' ||
          habilitacion.estado_habilitacion == 'INFORME_GENERADO' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }
    vm.verificarMostrarResolucion = function(habilitacion) {
      if (habilitacion && habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR') {
        return true;
      }
      return false;
    }
    vm.mostrarResolucion = function(event, hab) {
      var file = ConsultasService.crearBlobDeBase64(hab.resolucion, 'application/pdf');
      ConsultasService.mostrarBlob(event, file, 'Resolución Administrativa');
    }
    vm.mostrarResolucionModificatoria = function(event, hab) {
      var file = ConsultasService.crearBlobDeBase64(hab.resolucion_casada, 'application/pdf');
      ConsultasService.mostrarBlob(event, file, 'Resolución Administrativa');
    }
    vm.mostrarCredencial = function(event, hab) {
      var file = ConsultasService.crearBlobDeBase64(hab.credencial, 'application/pdf');
      ConsultasService.mostrarBlob(event, file, 'Credencial');
    }

    vm.tipo = 100;
    vm.tipos = [
      {
        value: 100,
        name: 'CI'
      },
      {
        value: 110,
        name: 'CI Extranjero'
      },
      {
        value: 105,
        name: 'Pasaporte'
      }
    ]

    activate();

    function activate() {
      // angular.element('body').addClass('no-login');
      // angular.element('body').addClass('sin-fondo');
    }

    function formatearUrl(url) {
      return $sce.trustAsResourceUrl(url);
    }

    function buscarEstudiante() {
      vm.sinResultado = false;
      var datos = {
        tipo: vm.tipo,
        documento_identidad: vm.documento_identidad,
        dia: vm.dia,
        mes: vm.mes,
        anio: vm.anio
      };
      DataService.post(verificarEstudiante, datos, "Información")
      .then(function(response) {
        if (response && response.datos && response.datos.enProceso) {
          vm.enProceso = true;
          vm.login = true;
        } else if (response && response.datos && response.datos.length > 0) {
          vm.esconderResultado = false;
          vm.habilitaciones = response.datos;
          vm.habilitacion = vm.habilitaciones[0];
        } else {
          Message.info("No se encontraron estudiantes coincidentes con los datos solicitados.");
          vm.sinResultado = true;
          vm.login = true;
        }
      });
    }

    function volverBuscar(noBorrar) {
      vm.login = false;
      vm.enProceso = false;
      vm.esconderResultado = true;
      vm.sinResultado = false;
      if (!noBorrar) {
        vm.tipo = 100;
        vm.documento_identidad = "";
        vm.dia = "";
        vm.mes = "";
        vm.anio = "";
      }
    }

    vm.abrirCalendario = function(event) {
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'urlGenerica', DialogCalendarioController],
        templateUrl: 'app/modules/rotaciones/components/verificacionEstudiantes/modules.calendario.html'
      });
    }
  }

  function DialogCalendarioController($scope, $mdDialog, data, restUrl, DataService, Message, urlGenerica) {
    var vm = $scope;
    vm.close = function() {
      $mdDialog.hide();
    }
    vm.cargarGestiones = function() {
      vm.gestiones = [];
      DataService.get(urlGenerica + 'periodo/gestiones')
      .then(function(resultado) {
        if (resultado && resultado.datos) {
          vm.gestiones = resultado.datos;
          if (vm.gestiones.length > 0) {
            vm.gestionActual = vm.gestiones.length - 1;
            vm.cargarPeriodos(vm.gestiones[vm.gestionActual].gestion);
          }
        }
      });
    }
    vm.cargarPeriodos = function(gestion) {
      vm.periodos = [];
      DataService.get(urlGenerica + 'periodo/periodos/' + gestion)
      .then(function(resultado) {
        if (resultado && resultado.datos) {
          vm.periodos = resultado.datos;
        }
      });
    }
    vm.cambiarGestion = function(siguiente) {
      if (vm.gestiones.length > 0) {
        if (siguiente) {
          if (vm.gestionActual < (vm.gestiones.length - 1)) {
            vm.gestionActual++;
            vm.cargarPeriodos(vm.gestiones[vm.gestionActual].gestion);
          }
        } else {
          if (vm.gestionActual != 0) {
            vm.gestionActual--;
            vm.cargarPeriodos(vm.gestiones[vm.gestionActual].gestion);
          }
        }
      }
    }
    function activate() {
      vm.cargarGestiones();
    }
    activate();
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesEdicion', {
      templateUrl: 'app/modules/rotaciones/components/rotacionesEdicion/modules.rotaciones.components.rotacionesEdicion.html',
      controller: RotacionesEdicionController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function RotacionesEdicionController($scope, restUrl, Modal, DataService, Message, $location, $sce, $timeout) {
    var vm = this;
    vm.title = 'Lista de estudiantes';

    vm.seleccionable = false;
    vm.rezagados = true;
    vm.urlActualizacion = restUrl + 'rotaciones/habilitacion/';

    vm.estados = ['PREASIGNADO'];
    vm.listarHabilitados = function () {}

    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo) {
          vm.periodoFiltro = id_periodo;
        }
        vm.listarHabilitados(vm.periodoFiltro);
      }
    }

    vm.seleccionados = [];

    vm.buttons = [{
      tooltip: 'Editar',
      icon: 'edit',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        editarInformacion(event, id);
      }
    }, {
      tooltip: 'Eliminar',
      icon: 'delete_forever',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        eliminarRegistro(id);
      }
    }];

    function eliminarRegistro(id) {
      Modal.confirm('¿Esta seguro que desea eliminar el registro? Esta operación no puede revertirse.' , function() {
        DataService.delete(restUrl + "rotaciones/habilitacion/extras/", id)
          .then(function(response) {
            if (response && response.datos) {
              Message.success(response.mensaje);
              vm.listarHabilitados(vm.periodoFiltro);
            }
          });
      });
    }

    function editarInformacion (event, id) {
      vm.requisito = {fid_sedes: vm.id_sedes};
      // obtener datos de la rotacion
      vm.id_habilitacion = id;
      DataService.get(vm.urlActualizacion, id)
      .then(function(response) {
        if (response.datos) {
          vm.habilitacion = response.datos;
          Modal.show({
            event: event,
            data: vm,
            title: 'Agregar requisito',
            dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogRequisitoController],
            templateUrl: 'app/modules/rotaciones/components/rotacionesEdicion/editInfo.dialog.html'
          });
        } else {
          Message.error(response.mensaje);
        }
      });
    }

    function DialogRequisitoController($scope, $mdDialog, data, restUrl, DataService, Message) {
      var vm = $scope;
      vm.listarHabilitados = data.listarHabilitados;
      vm.periodoFiltro = data.periodoFiltro;
      vm.habilitacion = data.habilitacion;
      vm.estudiante = data.habilitacion.estudiante;
      vm.carreras = [];

      getCarreras(vm.estudiante.fid_sede);

      vm.cambiarSedeUniversitaria = function() {
        $timeout(function () {
          vm.carreras = [];
          vm.estudiante.fid_sede = vm.sedeSel.id_sede;
          DataService.list(restUrl + 'rotaciones/carrera/listar/' + vm.sedeSel.id_sede)
            .then(function(response) {
              if (response && response.datos) {
                vm.carreras = response.datos;
              } else {
                Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
              }
            });
        }, 500);
      }

      function getCarreras(id_sede) {
        vm.carreras = [];
        DataService.list(restUrl + 'rotaciones/carrera/listar/' + id_sede)
          .then(function(response) {
            if (response && response.datos) {
              vm.carreras = response.datos;
            } else {
              Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
            }
          });
      }
      vm.guardarEditar = function () {
        var objActualizar = {
          id_sede: vm.estudiante.fid_sede,
          fid_carrera: vm.estudiante.fid_carrera,
          id_habilitacion : vm.habilitacion.id_habilitacion
        };
        DataService.put(restUrl + 'rotaciones/estudiante/' + vm.estudiante.id_estudiante, objActualizar)
          .then(function (response) {
              // actualizar(response);
              if (response) {
                $mdDialog.cancel();
                Message.success();
                vm.listarHabilitados(vm.periodoFiltro);
              }
          });
      }
      vm.close = function () {
          $mdDialog.cancel();
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('tablaEstudiantes', {
      templateUrl: 'app/modules/rotaciones/components/tablaEstudiantes/modules.rotaciones.components.tablaEstudiantes.html',
      controller: TablaEstudiantesController,
      bindings: {
        title: '=',
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        seleccionable: '=',
        estados: '=',
        query: '=',
        seleccionados: '=',
        etapa: '=',
        buttons: '=',
        listarHabilitados: '=',
        showFilter: '=',
        removeFilter: '=',
        buscarEstudiante: '=',
        filter: '=',
        estadoCorreo: '=',
        casoEspecial: '=',
        columnas: '=',
        rezagados: '='
      }
    });

  /** @ngInject */
  function TablaEstudiantesController($scope, restUrl, Modal, DataService, Message, $timeout, $sce, $location, BreadcrumbFactory, SideNavFactory, ConsultasService, Util, $window) {

    var vm = this;
    vm.url = restUrl + 'rotaciones/habilitacion/lista/';
    vm.filter = {
      show: false,
      form: 'formulario'
    }

    vm.listarHabilitados = listarHabilitados;
    vm.lista = lista;
    vm.verDetalle = verDetalle;
    vm.buttonEvent = buttonEvent;

    vm.showFilter = function() {
      vm.filter.show = true;
      $timeout(function() {
        angular.element('#crud-table-input').focus();
      }, 300);
    }
    vm.removeFilter = function() {
      vm.filter.show = false;
      vm.query.filter = '';

      if (vm.filter.form.$dirty) {
        vm.filter.form.$setPristine();
      }
      vm.listarHabilitados();
    }
    vm.buscarEstudiante = function() {
      vm.listarHabilitados();
    }

    // Paginación
    vm.order = '';
    vm.options = {
      boundaryLinks: true
    };
    vm.query = {
      order: vm.order,
      limit: 50,
      page: 1,
      filter: ''
    };
    vm.seleccionados = {
      selected: []
    };

    activate();

    function activate() {
      listarHabilitados();
    }

    function lista() {
      listarHabilitados();
    }
    function listarHabilitados(id_periodo) {
      if ((vm.etapa == 'POSTULACIONES' || vm.etapa == 'ASIGNACIONES') && !vm.estados) {
        vm.query.estados = ['SOLICITADO', 'HABILITADO', 'APROBADO', 'REPROBADO', 'RECHAZADO', 'ASIGNADO', 'CREDENCIAL_GENERADA', 'CREDENCIAL_FIRMADA', 'SUSPENDIDA',
          'INFORME_GENERADO', 'PREASIGNADO', 'INFORME_GENERADO', 'RESOLUCION_GENERADA', 'RESOLUCION_FIRMADA_ASESOR', 'RESOLUCION_FIRMADA_DIRECTOR', 'RESO_GENERADA_AP_CASADA', 'RESO_AP_CASADA_FIRMA_ASESOR'
        ];
      } else if (!vm.estados) {
        vm.query.estados = ['SOLICITADO', 'HABILITADO', 'APROBADO', 'ASIGNADO', 'PREASIGNADO', 'CREDENCIAL_GENERADA', 'CREDENCIAL_FIRMADA', 'SUSPENDIDA',
          'INFORME_GENERADO', 'PREASIGNADO', 'INFORME_GENERADO', 'RESOLUCION_GENERADA', 'RESOLUCION_FIRMADA_ASESOR', 'RESOLUCION_FIRMADA_DIRECTOR', 'RESO_GENERADA_AP_CASADA', 'RESO_AP_CASADA_FIRMA_ASESOR'
        ];
      } else {
        vm.query.estados = vm.estados;
      }
      var id_per = id_periodo >= 0 ? id_periodo : vm.periodoFiltro;
      if (vm.rezagados) {
        vm.query.mostrarRezagados = true;
      }
      DataService.list(vm.url + id_per, vm.query)
        .then(function(response) {
          vm.seleccionados.selected = [];
          vm.estudiantes = [];
          if (response && response.datos.rows && response.datos.rows.length > 0) {
            vm.estudiantes = response.datos;
            procesarHabilitados();
          } else {
            Message.info("No se encontraron estudiantes en la rotación seleccionada.");
          }
        });
    }

    function procesarHabilitados(arrayEstudiantes) {
      arrayEstudiantes = arrayEstudiantes ? arrayEstudiantes : vm.estudiantes.rows;
      for (var i in arrayEstudiantes) {
        if (arrayEstudiantes[i].nota) {
          arrayEstudiantes[i].nota = Number(arrayEstudiantes[i].nota);
        }
      }
      return arrayEstudiantes;
    }

    function verDetalle(event, id_habilitacion) {
      $window.sessionStorage.id_habilitacion = id_habilitacion;
      $location.path('rotaciones/detalleMonitoreo');
    }

    function buttonEvent(event, item, callback) {
      callback(event, item.id_habilitacion, item, listarHabilitados);
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesResolucionesFirmadas', {
      templateUrl: 'app/modules/rotaciones/components/resolucionesFirmadas/modules.rotaciones.components.resolucionesFirmadas.html',
      controller: ResolucionesFirmadasController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function ResolucionesFirmadasController($scope, restUrl, Modal, DataService, Message, $location, $sce, $timeout, $window, ConsultasService) {
    var vm = this;
    vm.title = 'Lista de resoluciones administrativas firmadas';
    vm.seleccionados = [];
    vm.seleccionable = false;
    vm.rezagados = true;
    vm.estados = ['RESOLUCION_FIRMADA_ASESOR', 'RESOLUCION_FIRMADA_DIRECTOR', 'RESO_GENERADA_AP_CASADA', 'RESO_AP_CASADA_FIRMA_ASESOR'];

    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo) {
          vm.periodoFiltro = id_periodo;
        }
        vm.listarHabilitados(vm.periodoFiltro);
      }
    }

    vm.buttons = [{
      tooltip: 'Mostrar resolución administrativa',
      icon: 'filter_none',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        mostrarResolucion(event, id);
      }
    }, {
      tooltip: 'Mostrar resolución modificatoria',
      icon: 'insert_drive_file',
      show: false,
      mostrar: function(habilitacion) {
        return vm.permission.update && habilitacion.resolucion_casada !== null;
      },
      onclick: function(event, id) {
        mostrarResolucion(event, id, 'RESO_CASADA');
      }
    }, {
      tooltip: 'Ver detalle',
      icon: 'remove_red_eye',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update
      },
      onclick: function(event, id) {
        verDetalle(id);
      }
    }];

    function verDetalle(id_habilitacion) {
       $window.sessionStorage.id_habilitacion = id_habilitacion;
       $location.path('rotaciones/detalleResoluciones');

    }

    function mostrarResolucion(event, id_habilitacion, tipo) {
      ConsultasService.mostrarPdfBase64(event,
                                        ConsultasService.urlMostrarResolucion,
                                        {
                                          id_habilitacion: [id_habilitacion],
                                          tipo: tipo
                                        },
                                        "Resolución Administrativa",
                                        "La resolución administrativa no se recuperó correctamente.");
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesInformesFirmados', {
      templateUrl: 'app/modules/rotaciones/components/informesFirmados/modules.rotaciones.components.informesFirmados.html',
      controller: InformesFirmadosController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function InformesFirmadosController($scope, restUrl, Modal, DataService, Message, $location, $sce, $timeout, ConsultasService, $window) {
    var vm = this;
    vm.title = 'Lista de informes técnicos firmados';
    vm.seleccionados = [];
    vm.seleccionable = false;
    vm.rezagados = true;
    vm.estados = ['RESOLUCION_GENERADA', 'RESOLUCION_FIRMADA_ASESOR', 'RESOLUCION_FIRMADA_DIRECTOR', 'RESO_AP_CASADA_FIRMA_ASESOR'];

    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo) {
          vm.periodoFiltro = id_periodo;
        }
        vm.listarHabilitados(vm.periodoFiltro);
      }
    }

    vm.buttons = [{
      tooltip: 'Mostrar informe técnico legal',
      icon: 'insert_drive_file',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        mostrarInforme(event, id);
      }
    }, {
      tooltip: 'Ver detalle',
      icon: 'remove_red_eye',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        verDetalle(id);
      }
    }];

    function verDetalle(id_habilitacion) {
      $window.sessionStorage.id_habilitacion = id_habilitacion;
      $location.path('rotaciones/detalleResoluciones');
    }

    function mostrarInforme(event, id_habilitacion) {
      ConsultasService.mostrarPdfBase64(event,
                                        ConsultasService.urlMostrarInforme,
                                        { id_habilitacion: [id_habilitacion] },
                                        "Informe Técnico Legal",
                                        "El informe técnico legal no se recuperó correctamente.");
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesGeneracionResoluciones', {
      templateUrl: 'app/modules/rotaciones/components/generacionResoluciones/modules.rotaciones.components.generacionResoluciones.html',
      controller: GeneracionResolucionesController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function GeneracionResolucionesController($scope, restUrl, Modal, DataService, Message, $location, $sce, $mdDialog, blockUI, BreadcrumbFactory, SideNavFactory, $timeout, ConsultasService, Util, $window, FirmaticService, Storage) {
    var vm = this;
    var cuenta = Storage.getUser();
    vm.title = 'Lista de estudiantes con informes técnicos generados';
    vm.urlGuardarInformesFirmados = restUrl + 'rotaciones/habilitacion/firmados/informe/';
    vm.seleccionable = true;
    vm.rezagados = true;
    vm.estados = ['INFORME_GENERADO'];

    vm.firmarInformes = firmarInformes;

    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo >= 0) {
          vm.periodoFiltro = id_periodo;
        }
        vm.listarHabilitados(id_periodo);
      }
    }

    vm.buttons = [{
      tooltip: 'Mostrar informe técnico legal',
      icon: 'insert_drive_file',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        mostrarInformeTecnicoGenerado(event, id);
      }
    }, {
      tooltip: 'Ver detalle',
      icon: 'remove_red_eye',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        verDetalle(id);
      }
    }];

    function verDetalle(id_habilitacion) {
      $window.sessionStorage.id_habilitacion = id_habilitacion;
      $location.path('rotaciones/detalleResoluciones');
    }

    function mostrarInformeTecnicoGenerado(event, id_habilitacion) {
        ConsultasService.mostrarPdfBase64(event,
                                          ConsultasService.urlMostrarInforme,
                                          { id_habilitacion: [id_habilitacion] },
                                          "Informe Técnico Legal",
                                          "El informe técnico legal no se recuperó correctamente.");
    }


    function firmarInformes() {
      vm.solicitados = 0;
      vm.contador = 0;
      if (vm.seleccionados.selected.length === 0) {
        Message.error("Debe seleccionar al menos un archivo para firmar.");
      } else {
        ConsultasService.obtenerDocumentosBinarios(ConsultasService.urlMostrarInformeBinario, vm.seleccionados.selected, "INFORME")
          .then(function(resultados) {
            if (resultados && resultados.length) {
              vm.solicitados = resultados.length;
              Util.bloquearPagina("Por favor espere a que terminen de firmarse los informes técnicos.");
              vm.archivosFirmar = [];
              FirmaticService.verificarEstado()
                .then(function (respEstado){
                  if(respEstado.activo === false) throw respEstado.mensaje;
                  vm.handleIniciarProceso()
                  var nroDocumento = cuenta.documento;
                  return FirmaticService.firmarPdf(resultados, nroDocumento)
                })
                .then(function(respuestaFirma) {
                  if (!respuestaFirma || respuestaFirma.status !== 200) {
                    throw "No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.";
                  }
                  vm.handleFinalizarProceso(respuestaFirma, resultados)
                }).catch(function(error) {
                  if (error) {
                    Message.error(error.mensaje || error || 'Error al firmar informes técnicos');
                  }
                });
            } else {
              Message.error("No se encontraron los datos solicitados.");
            }
          });
      }
    }

    vm.handleError = function (mensajeError) {
      Message.error(mensajeError);
    };

    vm.handleSuccess = function (mensajeSuccess) {
      Message.success(mensajeSuccess);
    }

    vm.handleIniciarProceso = function (mensajeInicio) {
      blockUI.start(mensajeInicio);
    }

    vm.handleFinalizarProceso = function (respFirmaDoc, solDoc) {
      if (respFirmaDoc && respFirmaDoc.data) {
        var archivos = [];
        var _files = respFirmaDoc.data.files;
        for (var i = 0; i < _files.length; i++) {
          archivos.push({
            base_64: _files[i].base64,
            id_habilitacion: solDoc[i].id_habilitacion
          })
        }
        DataService.post(vm.urlGuardarInformesFirmados, { archivos: archivos })
          .then(function(response) {
            if (response && response.mensaje) {
              Message.success(response.mensaje);
              Util.desbloquearPagina();
              $mdDialog.hide();
              vm.listarHabilitados();
            } else {
              Message.error("No se encontraron los datos solicitados.");
            }
          });
      }
      blockUI.stop();
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesFirmaResoluciones', {
      templateUrl: 'app/modules/rotaciones/components/firmaResoluciones/modules.rotaciones.components.firmaResoluciones.html',
      controller: FirmaResolucionesController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function FirmaResolucionesController($scope, restUrl, Modal, DataService, Message, $location, $mdDialog, blockUI, $sce, $timeout, ConsultasService, $window, Util, FirmaticService, Storage) {
    var vm = this;
    var cuenta = Storage.getUser();
    vm.title = 'Lista de estudiantes con resoluciones administrativas generadas';
    vm.seleccionable = true;
    vm.rezagados = true;
    vm.estados = ['FIRMA_RESOLUCION'];

    vm.urlGuardarDocumentosFirmados = restUrl + 'rotaciones/habilitacion/firmados/resolucion/';

    vm.firmarResoluciones = firmarResoluciones;

    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo >= 0) {
          vm.periodoFiltro = id_periodo;
        }
        vm.listarHabilitados(id_periodo);
      }
    }

    vm.buttons = [{
      tooltip: 'Mostrar resolución administrativa',
      icon: 'filter_none',
      show: vm.permission.update,
      mostrar: function(habilitacion) {
        return vm.permission.update && habilitacion.estado_habilitacion != 'RESO_AP_CASADA_FIRMA_ASESOR' && habilitacion.estado_habilitacion != 'RESO_GENERADA_AP_CASADA';
      },
      onclick: function(event, id) {
        mostrarResolucion(event, id);
      }
    },
    {
      tooltip: 'Mostrar resolución modificatoria',
      icon: 'insert_drive_file',
      show: false,
      mostrar: function(habilitacion) {
        return vm.permission.update && ( habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' || habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA');
      },
      onclick: function(event, id) {
        mostrarResolucion(event, id, 'RESO_CASADA');
      }
    },
     {
      tooltip: 'Ver detalle',
      icon: 'remove_red_eye',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        verDetalle(id);
      }
    }
  ];

    function mostrarResolucion(event, id_habilitacion, tipo) {
      // console.log(id_habilitacion)
      ConsultasService.mostrarPdfBase64(event,
                                        ConsultasService.urlMostrarResolucion,
                                        { id_habilitacion: [id_habilitacion],
                                          tipo : tipo
                                        },
                                        "Resolución Administrativa",
                                        "La resolución administrativa no se recuperó correctamente.");
    }


    function firmarResoluciones() {
      vm.solicitados = 0;
      vm.contador = 0;
      if (vm.seleccionados.selected.length === 0) {
        Message.error("Debe seleccionar al menos un archivo para firmar.");
      } else {
        ConsultasService.obtenerDocumentosBinarios(ConsultasService.urlMostrarResolucionBinario, vm.seleccionados.selected, "RA")
          .then(function(resultados) {
            if (resultados && resultados.length) {
              vm.solicitados = resultados.length;
              Util.bloquearPagina("Por favor espere a que terminen de firmarse las Resoluciones Administrativas.");
              FirmaticService.verificarEstado()
                .then(function (respEstado){
                  if(respEstado.activo === false) throw respEstado.mensaje;
                  vm.handleIniciarProceso()
                  var nroDocumento = cuenta.documento;
                  return FirmaticService.firmarPdf(resultados, nroDocumento)
                })
                .then(function(respuestaFirma) {
                  if (!respuestaFirma || respuestaFirma.status !== 200) {
                    throw "No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.";
                  }
                  vm.handleFinalizarProceso(respuestaFirma, resultados);
                }).catch(function(error) {
                  if (error) {
                    Message.error(error.mensaje || error || 'Error al firmar resoluciones');
                  }
                });
            } else {
              Message.error("No se encontraron los datos solicitados.");
            }
          });
      }
    }

    vm.handleError = function (mensajeError) {
      Message.error(mensajeError);
    };

    vm.handleSuccess = function (mensajeSuccess) {
      Message.success(mensajeSuccess);
    }

    vm.handleIniciarProceso = function (mensajeInicio) {
      blockUI.start(mensajeInicio);
    }

    vm.handleFinalizarProceso = function (respFirmaDoc, solDoc) {
      if (solDoc && respFirmaDoc && respFirmaDoc.data) {
        var archivos = [];
        var _files = respFirmaDoc.data.files;
        for (var i = 0; i < _files.length; i++) {
          archivos.push({
            base_64: _files[i].base64,
            id_habilitacion: solDoc[i].id_habilitacion
          })
        }
        DataService.post(vm.urlGuardarDocumentosFirmados, { archivos: archivos })
          .then(function(response) {
            if (response && response.mensaje) {
              Message.success(response.mensaje);
              Util.desbloquearPagina();
              $mdDialog.hide();
              vm.listarHabilitados();
            } else {
              Message.error("No se encontraron los datos solicitados.");
            }
          });
      }
      blockUI.stop();
    }

    function verDetalle(id_habilitacion) {
      $window.sessionStorage.id_habilitacion = id_habilitacion;
      $location.path('rotaciones/detalleResoluciones');
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesFirmaCredenciales', {
      templateUrl: 'app/modules/rotaciones/components/firmaCredenciales/modules.rotaciones.components.firmaCredenciales.html',
      controller: FirmaCredencialesController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function FirmaCredencialesController($scope, restUrl, Modal, DataService, Message, $location, $mdDialog, blockUI, $sce, $timeout, ConsultasService, $window, Util, FirmaticService, Storage) {
    var vm = this;
    var cuenta = Storage.getUser();
    vm.title = 'Lista de estudiantes con credenciales generadas';
    vm.seleccionable = true;
    vm.rezagados = true;
    vm.estados = ['CREDENCIAL_GENERADA'];
    vm.listarHabilitados = function () {}
    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo) {
          vm.periodoFiltro = id_periodo;
        }
        vm.listarHabilitados(id_periodo);
      }
    }

    vm.urlGuardarDocumentosFirmados = restUrl + 'rotaciones/habilitacion/firmados/credencial/'; 

    vm.firmarCredenciales = firmarCredenciales;

    vm.buttons = [{
      tooltip: 'Mostrar credencial',
      icon: 'credit_card',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        mostrarCredencial(event, id);
      }
    }, {
      tooltip: 'Ver detalle',
      icon: 'remove_red_eye',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        verDetalle(id);
      }
    }];

    vm.handleError = function(mensajeError) {
      Message.error(mensajeError);
    };

    vm.handleSuccess = function(mensajeSuccess) {
      Message.success(mensajeSuccess);
    }

    vm.handleIniciarProceso = function(mensajeInicio) {
      blockUI.start(mensajeInicio);
    }

    vm.handleFinalizarProceso = function(respFirmaDoc, solDoc) { 
      if (respFirmaDoc && respFirmaDoc.data) {
        var archivos = [];
        var _files = respFirmaDoc.data.files;
        for (var i = 0; i < _files.length; i++) {
          archivos.push({
            base_64: _files[i].base64,
            id_habilitacion: solDoc[i].id_habilitacion
          })
        }
        DataService.post(vm.urlGuardarDocumentosFirmados, { archivos: archivos })
          .then(function(response) {
            if (response && response.mensaje) {
              Message.success(response.mensaje);
              Util.desbloquearPagina();
              $mdDialog.hide();
              vm.listarHabilitados();
            } else {
              Message.error("No se encontraron los datos solicitados.");
            }
          });
      }
      blockUI.stop();
    }

    function firmarCredenciales() {
      vm.solicitados = 0;
      vm.contador = 0;
      if (vm.seleccionados.selected.length === 0) {
        Message.error("Debe seleccionar al menos un archivo para firmar.");
      } else {
        ConsultasService.obtenerDocumentosBinarios(ConsultasService.urlMostrarCredencialBinario, vm.seleccionados.selected, "CREDENCIAL")
          .then(function(documentosResult) {
            if (documentosResult && documentosResult.length) {
              vm.solicitados = documentosResult.length;
              Util.bloquearPagina("Por favor espere a que terminen de firmarse las credenciales.");

              FirmaticService.verificarEstado()
                .then(function (respEstado){
                  if(respEstado.activo === false) throw respEstado.mensaje;
                  vm.handleIniciarProceso()
                  var nroDocumento = cuenta.documento;
                  return FirmaticService.firmarPdf(documentosResult, nroDocumento)
                })
                .then(function (respuestaFirma) {
                  if (!respuestaFirma || respuestaFirma.status !== 200) {
                    throw "No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.";
                  }
                  vm.handleFinalizarProceso(respuestaFirma, documentosResult)
                })
                .catch(function (error) {
                  if (error) {
                    Message.error(error.mensaje || error || 'Error al firmar credenciales');
                  }
                })
            } else {
              Message.error("No se encontraron los datos solicitados.");
            }
          });
      }
    }


    function verDetalle(id_habilitacion) {
      $window.sessionStorage.id_habilitacion = id_habilitacion;
      $location.path('rotaciones/detalleCredenciales');
    }

    function mostrarCredencial(event, id_habilitacion) {
      ConsultasService.mostrarPdfBase64(event,
        ConsultasService.urlMostrarCredencial, {
          id_habilitacion: [id_habilitacion]
        },
        "Credencial",
        "La credencial no se recuperó correctamente.");
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesEstudiantesEnviados', {
      templateUrl: 'app/modules/rotaciones/components/estudiantesEnviados/modules.rotaciones.estudiantesEnviados.html',
      controller: EstudiantesEnviadosController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function EstudiantesEnviadosController($scope, restUrl, Modal, DataService, Message, $timeout, ConsultasService) {
    var vm = this;
    vm.title = 'Lista de estudiantes autorizados';
    vm.url = restUrl + 'rotaciones/estudiante/listar/historial/';

    vm.verificarMostrarCredencial = function(habilitacion) {
      return ConsultasService.credencialFirmada(habilitacion);
    }
    vm.verificarMostrarInforme = function(habilitacion) {
      return ConsultasService.informeFirmado(habilitacion);
    }
    vm.verificarMostrarResolucion = function(habilitacion) {
      return ConsultasService.resolucionFirmada(habilitacion);
    }
    vm.mostrarCredencial = function(event, id_habilitacion) {
      ConsultasService.mostrarPdfBase64(event,
        ConsultasService.urlMostrarCredencial, {
          id_habilitacion: [id_habilitacion]
        },
        "Credencial",
        "La credencial no se recuperó correctamente.");
    }
    vm.mostrarResolucion = function(event, id_habilitacion) {
      ConsultasService.mostrarPdfBase64(event,
                                        ConsultasService.urlMostrarResolucion,
                                        { id_habilitacion: [id_habilitacion] },
                                        "Resolución Administrativa",
                                        "La resolución administrativa no se recuperó correctamente.");
    }

    vm.listarHabilitados = listarHabilitados;
    vm.showFilter = function() {
      vm.filter.show = true;
      $timeout(function () {
          angular.element('#crud-table-input').focus();
      }, 300);
    }
    vm.removeFilter = function() {
      vm.filter.show = false;
      vm.query.filter = '';

      if(vm.filter.form.$dirty) {
          vm.filter.form.$setPristine();
      }
      listarHabilitados();
    }
    vm.buscarEstudiante = function() {
      listarHabilitados();
    }
    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo) {
          vm.periodoFiltro = id_periodo;
        }
        listarHabilitados();
      }
    }

    vm.selected = [];

    // Paginación
    vm.order = '';
    vm.options = {
      boundaryLinks: true
    };
    vm.query = {
      order: vm.order,
      limit: 20,
      page: 1
    };

    activate();

    function activate() {
      listarHabilitados();
    }

    function listarHabilitados() {
      vm.query.estados = 'SOLICITADO';
      DataService.list(vm.url + vm.periodoFiltro, vm.query)
        .then(function(response) {
          vm.selected = [];
          vm.estudiantes = [];
          if (response && response.datos.rows && response.datos.rows.length > 0) {
            vm.estudiantes = response.datos;
          } else {
            Message.info("No se encontraron estudiantes registrados.");
          }
        });
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesCredencialesFirmadas', {
      templateUrl: 'app/modules/rotaciones/components/credencialesFirmadas/modules.rotaciones.components.credencialesFirmadas.html',
      controller: CredencialesFirmadasController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function CredencialesFirmadasController($scope, restUrl, Modal, DataService, Message, $location, $sce, $timeout, ConsultasService, $window) {
    var vm = this;
    vm.title = 'Lista de credenciales firmadas';

    vm.seleccionable = false;
    vm.rezagados = false;

    vm.estados = ['CREDENCIAL_FIRMADA', 'INFORME_GENERADO', 'RESOLUCION_GENERADA', 'RESOLUCION_FIRMADA_ASESOR','RESOLUCION_FIRMADA_DIRECTOR', 'RESO_AP_CASADA_FIRMA_ASESOR', 'RESO_GENERADA_AP_CASADA'];
    vm.listarHabilitados = function () {}

    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo) {
          vm.periodoFiltro = id_periodo;
        }
        vm.listarHabilitados(vm.periodoFiltro);
      }
    }

    vm.seleccionados = [];

    vm.buttons = [{
      tooltip: 'Mostrar credencial',
      icon: 'credit_card',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        mostrarCredencial(event, id);
      }
    }, {
      tooltip: 'Ver detalle',
      icon: 'remove_red_eye',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        verDetalle(id);
      }
    }];

    function verDetalle(id_habilitacion) {
      $window.sessionStorage.id_habilitacion = id_habilitacion;
      $location.path('rotaciones/detalleCredenciales');
    }

    function mostrarCredencial(event, id_habilitacion) {
        ConsultasService.mostrarPdfBase64(event,
                                          ConsultasService.urlMostrarCredencial,
                                          {id_habilitacion: [id_habilitacion]},
                                          "Credencial",
                                          "La credencial no se recuperó correctamente.");
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('detalleTramite', {
      templateUrl: 'app/modules/rotaciones/components/detalleTramite/modules.rotaciones.components.detalleTramite.html',
      controller: DetalleTramiteController,
      bindings: {
        permission: '=',
        habilitacion: '=',
        idHabilitacion: '=',
        archivos: '=',
        faltas: "=",
        eliminarFalta: '='
      }
    });

  /** @ngInject */
  function DetalleTramiteController($scope, restUrl, Modal, DataService, Message, $location, $sce, $timeout, ConsultasService, moment, $window, SideNavFactory) {
    var vm = this;
    vm.currentUserRol = SideNavFactory.getUser().rol;
    vm.title = 'Lista de credenciales firmadas';
    vm.url = restUrl + 'rotaciones/habilitacion/lista/';

    vm.mostrarCredencial = mostrarCredencial;
    vm.mostrarResolucion = mostrarResolucion;
    vm.mostrarInformeTecnicoGenerado = mostrarInformeTecnicoGenerado;
    vm.abrirRequisito = abrirRequisito;
    vm.mostrarPoder = mostrarPoder;
    vm.credencialFirmada = credencialFirmada;
    vm.informeFirmado = informeFirmado;
    vm.verificarMostrarInforme = verificarMostrarInforme;
    vm.resolucionFirmada = resolucionFirmada;
    vm.resolucionFirmadaApellidoCasada = resolucionFirmadaApellidoCasada;
    vm.verificarMostrarResolucion = verificarMostrarResolucion;
    vm.verificarMostrarResolucionApellidoCasada = verificarMostrarResolucionApellidoCasada;
    vm.verificarMostrarCredencial = verificarMostrarCredencial;
    vm.editarInformacion = editarInformacion;

    vm.textoConFirma = 'Firmado';
    vm.textoSinFirma = 'Sin firmar';
    vm.textoRezagado = 'Documento Manual';

    activate();

    function activate() {
      var inicio = moment(vm.habilitacion.fecha_inicio);
      var fin = moment(vm.habilitacion.fecha_fin);
      var ahora = moment(new Date());

      vm.barra = {
        min: 0,
        max: Number(fin.diff(inicio, 'days')),
        valor: Number(ahora.diff(inicio, 'days'))
      }
      if (vm.barra.valor > vm.barra.max) {
        vm.barra.valor = vm.barra.max;
      }
      vm.barra.valor = (vm.barra.valor / vm.barra.max) * 100;
      vm.barra.valor = Math.round(vm.barra.valor);
      if (vm.habilitacion.estado_habilitacion == 'RECHAZADO' || vm.habilitacion.estado_habilitacion == 'REPROBADO' || vm.barra.valor < 0) {
        vm.barra.valor = 0;
      }

      vm.barra.options = {
        max: 100,
        displayPrevious: true,
        // barCap: 25,
        trackWidth: 25,
        barWidth: 20,
        // trackColor: '#D8D8D8',
        // trackColor: 'rgba(255,0,0,.1)',
        // barColor: '#67983E',
        // textColor: 'rgba(255,0,0,.6)',

        trackColor: 'rgba(5,167,207,.4)',
        barColor: 'rgba(5,167,207,.9)',
        textColor: 'rgba(5,167,207,.9)',

        readOnly: true,
        unit: '%'
        // subText: {
        //   enabled: true,
        //   text: 'días'
        // }
      };
    }

    function editarInformacion (event) {
      vm.requisito = {fid_sedes: vm.id_sedes};
      vm.personaSegip = null;
      DataService.put(restUrl + 'persona/servicio/segip/actualizar/', {id: vm.habilitacion.estudiante.persona.id_persona})
          .then(function(response) {
            Message.success('' + (response.datos.nombres) + ' ' +(response.datos.primer_apellido || '') + ' ' + (response.datos.segundo_apellido || ''));
          vm.personaSegip = response.datos;
          Modal.show({
            event: event,
            data: vm,
            title: 'Datos Persona Segip',
            dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'OpcionesNombreCompleto', DialogRequisitoController],
            templateUrl: 'app/modules/rotaciones/components/detalleTramite/editAppcasada.dialog.html'
          });
        });
    }

    function DialogRequisitoController($scope, $mdDialog, data, restUrl, DataService, Message, OpcionesNombreCompleto) {
      var vm = $scope;
      vm.listarHabilitados = data.listarHabilitados;
      // vm.periodoFiltro = data.periodoFiltro;
      // vm.habilitacion = data.habilitacion;
      vm.personaSegip = data.personaSegip;
      vm.estudiante = data.habilitacion.estudiante;
      vm.carreras = [];
      vm.opcionesNombre = [];
      vm.opcionesNombreTexto = [];
      vm.persona = {
        nombre_completo: ''
      };
      vm.cambiaOpciones = function () {
        vm.opcionesNombre = OpcionesNombreCompleto.crearOpciones(vm.personaSegip.nombres, vm.personaSegip.primer_apellido, vm.personaSegip.segundo_apellido, (vm.persona.apellido_casada.toUpperCase() || ''));
      }

      vm.guardarEditar = function () {
        DataService.post(restUrl + 'rotaciones/habilitacionresolucion_ap_casada', {
          id_habilitacion_a_modificar: data.habilitacion.id_habilitacion,
          nombre_completo_ci : vm.persona.nombre_completo_ingresado,
          apellido_casada: vm.persona.apellido_casada
        })
          .then(function(response) {
          // vm.personaSegip = response.datos;
          Modal.close();
          Message.success(response.mensaje);
          $window.location.reload();
        });
      }

      vm.verReporte = function () {
        if (vm.persona.nombre_completo_ingresado) {
          var parametros = {
            id_habilitacion_a_moficar: data.habilitacion.id_habilitacion,
            nombre_completo_ci: '' + vm.persona.nombre_completo_ingresado
          }
          DataService.pdf2(restUrl + 'rotaciones/habilitacion/resolucion_ap_casada_prev', parametros)
            .then(function(response) {
              var file = new Blob([response.data] , {type: 'application/pdf'});
              var fileURL = URL.createObjectURL(file);
              vm.archivoPdf = $sce.trustAsResourceUrl(fileURL)
            });
        } else {
          Message.warning('Debe ingresar su nombre completo');
        }
      }

      vm.searchTextChange = function (text) {
        var uppercase = text.toUpperCase();
        if (text !== uppercase)  {
          vm.persona.nombre_completo_ingresado = uppercase;
        }
      }

      vm.close = function () {
          $mdDialog.cancel();
      }
    }
    function mostrarCredencial(event) {
      ConsultasService.mostrarPdfFirmas(event,
        ConsultasService.urlMostrarCredencial, {
          id_habilitacion: [vm.idHabilitacion]
        },
        "Credencial",
        "La credencial no se recuperó correctamente.");
    }

    function mostrarInformeTecnicoGenerado(event) {
      ConsultasService.mostrarPdfFirmas(event,
        ConsultasService.urlMostrarInforme, {
          id_habilitacion: vm.idHabilitacion
        },
        "Informe Técnico Legal",
        "El informe técnico legal no se recuperó correctamente.");
    }

    function mostrarResolucion(event, tipo) {
      ConsultasService.mostrarPdfFirmas(event,
        ConsultasService.urlMostrarResolucion, {
          id_habilitacion: vm.idHabilitacion,
          tipo: tipo
        },
        "Resolución Administrativa",
        "La resolución administrativa no se recuperó correctamente.");
    }

    function abrirRequisito(event, archivo) {
      DataService.get(restUrl + 'rotaciones/archivo/base/' + archivo.archivo[0].id_archivo)
        .then(function(response) {
          if (response && response.datos) {
            var respuestaArchivo = response.datos;
            var dialog;
            if (respuestaArchivo.type.startsWith('image')) {
              dialog = 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.req.html';
              Modal.show({
                event: event,
                data: respuestaArchivo.base64,
                title: archivo.nombre,
                templateUrl: dialog,
                controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
              });
            } else {
              ConsultasService.mostrarRequisitoPdfBase64(event, respuestaArchivo.base64, archivo.nombre)
            }
          } else {
            Message.error("No se encontraron los datos solicitados.");
          }
        });
    }

    function mostrarPoder(event, id_apoderado) {
      DataService.get(restUrl + 'rotaciones/apoderado/base/' + id_apoderado)
        .then(function(response) {
          if (response && response.datos) {
            var respuestaArchivo = response.datos;
            var dialog;
            if (respuestaArchivo.type.startsWith('image')) {
              dialog = 'app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.req.html';
              Modal.show({
                event: event,
                data: respuestaArchivo.base64,
                title: "Documento",
                templateUrl: dialog,
                controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
              });
            } else {
              ConsultasService.mostrarRequisitoPdfBase64(event, respuestaArchivo.base64, "Documento")
            }
          } else {
            Message.error("No se encontraron los datos solicitados.");
          }
        });
    }

    function credencialFirmada(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'HABILITADO' ||
          habilitacion.estado_habilitacion == 'APROBADO' ||
          habilitacion.estado_habilitacion == 'REPROBADO' ||
          habilitacion.estado_habilitacion == 'RECHAZADO' ||
          habilitacion.estado_habilitacion == 'ASIGNADO' ||
          habilitacion.estado_habilitacion == 'ELIMINADO' ||
          habilitacion.estado_habilitacion == 'PREASIGNADO' ||
          habilitacion.estado_habilitacion == 'CREDENCIAL_GENERADA')) {
        return false;
      }
      return true;
    }
    function verificarMostrarCredencial(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'SUSPENDIDA' ||
          habilitacion.estado_habilitacion == 'CREDENCIAL_GENERADA' ||
          habilitacion.estado_habilitacion == 'CREDENCIAL_FIRMADA' ||
          habilitacion.estado_habilitacion == 'INFORME_GENERADO' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }
    function informeFirmado(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }
    function verificarMostrarInforme(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'INFORME_GENERADO' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }

    function resolucionFirmada(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR')) {
        return true;
      }
      return false;
    }

    function resolucionFirmadaApellidoCasada(habilitacion) {
      if (habilitacion && ( (habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR' &&
                                ( habilitacion.resolucion_casada !== null &&
                                  habilitacion.resolucion_casada !== undefined) ) || // eslint-disable-line
                            habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR')) {
        return true;
      }
      return false;
    }

    function verificarMostrarResolucion(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }

    function verificarMostrarResolucionApellidoCasada(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
                          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
                          (habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR' &&
                              ( habilitacion.resolucion_casada !== null &&
                                habilitacion.resolucion_casada !== undefined) ) ) ) { // eslint-disable-line
        return true;
      }
      return false;
    }

    function PdfController($scope, $mdDialog, data, title) {
      var vm = $scope;

      vm.formatearUrl = function(url) {
        return $sce.trustAsResourceUrl(url);
      }

      vm.formatearUrlPdf = function(url) {
        return $sce.trustAsResourceUrl(url);
      }

      vm.title = title;
      vm.data = data;
      vm.hide = $mdDialog.hide;
      vm.cancel = $mdDialog.cancel;
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesAsignacionesEstudiantes', {
      templateUrl: 'app/modules/rotaciones/components/asignacionesEstudiantes/modules.rotaciones.components.asignacionesEstudiantes.html',
      controller: AsignacionesEstudiantesController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function AsignacionesEstudiantesController($scope, restUrl, Modal, DataService, Message, $timeout, $sce, $location, BreadcrumbFactory, SideNavFactory, ConsultasService, Util, $window) {
    var vm = this;
    vm.title = 'Lista de solicitudes de estudiantes';
    vm.url = restUrl + 'rotaciones/habilitacion/lista/';
    vm.urlEstudiante = restUrl + 'rotaciones/estudiante/';
    vm.urlCorreo = restUrl + 'rotaciones/habilitacion/envio';
    vm.urlAsignar = restUrl + 'rotaciones/habilitacion_asignar/';
    vm.urlGenerarCredenciales = restUrl + 'rotaciones/habilitacion_generar_credencial/';
    vm.urlGenerarCredencial = restUrl + 'rotaciones/credencial/';
    vm.urlAsignacion = restUrl + 'rotaciones/habilitacion/';
    vm.urlMejoresPromedios = restUrl + 'rotaciones/habilitacion/promedios/';
    vm.caso_especial_buena_nota = 'BUENA NOTA';
    vm.fechaEnviada = null;
    vm.agregarEstudiante = agregarEstudiante;
    vm.editarEstudiante = editarEstudiante;
    vm.listarHabilitados = listarHabilitados;
    vm.asignarEstablecimientos = asignarEstablecimientos;
    vm.generarCredencial = generarCredencial;
    vm.enviarCredenciales = enviarCredenciales;
    vm.mejoresPromedios = mejoresPromedios;
    vm.editarAsignacion = editarAsignacion;
    vm.verDetalle = verDetalle;
    vm.registrarPeriodosSedes = registrarPeriodosSedes;
    vm.asignarEstablecimientosFinal = asignarEstablecimientosFinal;
    vm.verificarMostrarCredencial = verificarMostrarCredencial;
    vm.eliminarRegistro = eliminarRegistro;


    vm.showFilter = function() {
      vm.filter.show = true;
      $timeout(function() {
        angular.element('#crud-table-input').focus();
      }, 300);
    }
    vm.removeFilter = function() {
      vm.filter.show = false;
      vm.query.filter = '';
      if (vm.filter.form.$dirty) {
        vm.filter.form.$setPristine();
      }
      listarHabilitados();
    }

    vm.buscarEstudiante = function() {
      listarHabilitados();
    }
    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo) {
          vm.periodoFiltro = id_periodo;
        }
        listarHabilitados();
      }
    }

    vm.selected = [];

    // Paginación
    vm.order = '';
    vm.options = {
      boundaryLinks: true
    };
    vm.query = {
      order: vm.order,
      limit: 20,
      page: 1
    };

    activate();

    function activate() {
      getSedesUniversitariasCarreras();
      getCasosEspeciales();
      listarHabilitados();
    }

    function listarHabilitados() {

      vm.etapa = null;
      vm.fecha_limite = null;
      vm.etapaError = null;
      vm.registrar = false;
      vm.registroFlotante = false;
      DataService.get(restUrl + "rotaciones/periodo/estado_actual/" + vm.periodoFiltro)
        .then(function(data) {
          if (data && data.datos && !data.datos.vacio) {
            vm.etapa = data.datos.etapa;
            vm.fecha_limite = data.datos.fecha_examen;
            vm.tipoSedes = data.datos.tipo;
            vm.depositoSedes = data.datos.deposito;
            vm.id_sedes = data.datos.id_sedes;
            vm.nota_minima = Number(data.datos.nota_minima);
            vm.registrar = data.datos.registrar;
            vm.registroFlotante = data.datos.registroFlotante;
          } else {
            vm.etapaError = "Se deben registrar los datos de la rotación para poder continuar.";
          }
          vm.permiso = data.datos.permiso;
          lista();
        });
    }

    function lista() {
      if (vm.etapa == 'POSTULACIONES' || vm.etapa == 'ASIGNACIONES') {
        vm.query.estados = ['SOLICITADO', 'HABILITADO', 'APROBADO', 'REPROBADO', 'RECHAZADO', 'ASIGNADO', 'CREDENCIAL_GENERADA', 'CREDENCIAL_FIRMADA', 'SUSPENDIDA',
          'INFORME_GENERADO', 'PREASIGNADO', 'INFORME_GENERADO', 'RESOLUCION_GENERADA', 'RESOLUCION_FIRMADA_ASESOR', 'RESOLUCION_FIRMADA_DIRECTOR', 'RESO_AP_CASADA_FIRMA_ASESOR', 'RESO_GENERADA_AP_CASADA'
        ];
      } else {
        vm.query.estados = ['SOLICITADO', 'HABILITADO', 'APROBADO', 'ASIGNADO', 'PREASIGNADO', 'CREDENCIAL_GENERADA', 'CREDENCIAL_FIRMADA', 'SUSPENDIDA',
          'INFORME_GENERADO', 'PREASIGNADO', 'INFORME_GENERADO', 'RESOLUCION_GENERADA', 'RESOLUCION_FIRMADA_ASESOR', 'RESOLUCION_FIRMADA_DIRECTOR', 'RECHAZADO', 'RESO_AP_CASADA_FIRMA_ASESOR', 'RESO_GENERADA_AP_CASADA'
        ];
      }
      $window.sessionStorage.id_periodo_seleccionado = vm.periodoFiltro;
      DataService.list(vm.url + vm.periodoFiltro, vm.query)
        .then(function(response) {
          vm.selected = [];
          vm.estudiantes = [];
          if (response && response.datos.rows && response.datos.rows.length > 0) {
            vm.estudiantes = response.datos;
            procesarHabilitados();
          } else {
            Message.info("No se encontraron estudiantes registrados.");
          }
        });
    }

    function procesarHabilitados(arrayEstudiantes) {
      arrayEstudiantes = arrayEstudiantes ? arrayEstudiantes : vm.estudiantes.rows;
      for (var i in arrayEstudiantes) {
        if (arrayEstudiantes[i].nota) {
          arrayEstudiantes[i].nota = Number(arrayEstudiantes[i].nota);
        }
      }
      return arrayEstudiantes;
    }

    function getSedesUniversitariasCarreras() {
      vm.carreras = [];
      vm.sedesUniversitarias = [];
      DataService.list(restUrl + 'rotaciones/sede_seleccionar')
        .then(function(response) {
          if (response && response.datos) {
            vm.sedesUniversitarias = response.datos.rows;
            if (vm.sedesUniversitarias.length == 1) {
              getCarreras(vm.sedesUniversitarias[0].id_sede);
            }
          }
        });
    }

    function getCarreras(id_sede) {
      DataService.list(restUrl + 'rotaciones/carrera/listar/' + id_sede)
        .then(function(response) {
          if (response && response.datos) {
            vm.carreras = response.datos;
          } else {
            Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
          }
        });
    }

    function getCasosEspeciales() {
      DataService.list(restUrl + 'parametros/parametro/caso_especial')
        .then(function(response) {
          if (response && response.datos) {
            vm.casosEspeciales = response.datos;
          } else {
            Message.warning("No se encontraron casos especiales registrados.");
          }
        });
    }

    function agregarEstudiante(event, borrar) {
      if (borrar) {
        vm.estudianteNuevo = undefined;
      }
      vm.estudianteSeleccionado = null;
      vm.registrarUniversidad = true;
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'OpcionesNombreCompleto', DialogEstudianteController],
        templateUrl: 'app/modules/rotaciones/estudiantes/create.dialog.html'
      });
    }

    function editarEstudiante(event, id_estudiante) {
      DataService.get(vm.urlEstudiante + id_estudiante)
        .then(function(response) {
          var item = response.datos;
          vm.estudianteSeleccionado = filterItem(item);
          vm.estudianteSeleccionado.persona.fecha_nacimiento = new Date(vm.estudianteSeleccionado.persona.fecha_nacimiento);
          vm.mostrarEdicionPersona = true;
          Modal.show({
            event: event,
            data: vm,
            dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'Modal', DialogEstudianteController],
            templateUrl: 'app/modules/rotaciones/estudiantes/edit.dialog.html'
          });
        });
    }

    function eliminarRegistro(event, habilitacion) {
      Modal.confirm('El registro será eliminado y ya no podrá ser inscrito en esta rotación. ¿Desea continuar?', function() {
        DataService.put(restUrl + 'rotaciones/habilitacion/' + habilitacion.id_habilitacion + '/eliminar', {})
          .then(function(response) {
            listarHabilitados();
            if (response.mensaje) {
              Message.success(response.mensaje);
            }
          });
      }, null, event);
    }

    function asignarEstablecimientosFinal(event) {
      Modal.confirm('Los estudiantes que tengan nota de aprobación serán asignados a un establecimiento de salud aleatorio. Posteriormente no se podrán hacer cambios. ¿Desea continuar?', function() {
        var enviarAutoizar = {
          id_periodo: vm.periodoFiltro
        };
        DataService.post(vm.urlAsignar, enviarAutoizar)
          .then(function(response) {
            vm.selected = [];
            listarHabilitados();
            if (response && response.mensaje) {
              Message.success(response.mensaje);
            }
          });
      }, null, event);
    }

    function asignarEstablecimientos(event, pasarRecordatorio) {
      vm.estudiantesRep = [];
      var continuar = true;
      for (var est in vm.estudiantes.rows) {
        if (!vm.estudiantes.rows[est].nota && vm.estudiantes.rows[est].nota !== 0) {
          Message.error("Algunos estudiantes no tienen nota. Por favor complete los datos.");
          continuar = false;
          break;
        }
        if (vm.estudiantes.rows[est].estado_habilitacion == 'PREASIGNADO') {
          Message.error("Existen estudiantes preasignados pendientes de ser aprobados.");
          continuar = false;
          break;
        }
      }
      if (!pasarRecordatorio && continuar) {
        $window.sessionStorage.recordatorio = true;
        Modal.show({
          event: event,
          data: vm,
          dialogController: ['$scope', 'data', '$mdDialog', RecordatorioController],
          templateUrl: 'app/modules/rotaciones/components/asignacionesEstudiantes/dialog.recordatorio.html'
        });
      } else {
        if (continuar) {
          var query2 = {
            order: vm.order,
            limit: vm.estudiantes.count,
            page: 1,
            estados: ['REPROBADO']
          };
          DataService.list(vm.url + vm.periodoFiltro, query2)
            .then(function(response) {
              if (response && response.datos && response.datos.rows && response.datos.rows.length > 0) {
                vm.estudiantesRep = procesarHabilitados(response.datos.rows);
                Modal.show({
                  event: event,
                  data: vm,
                  dialogController: ['$scope', '$mdDialog', 'data', DialogConfirmacionController],
                  templateUrl: 'app/modules/rotaciones/components/asignacionesEstudiantes/dialog.confirmacion.html'
                });
              } else {
                asignarEstablecimientosFinal();
              }
            });
        }
      }
    }

    function generarCredencial(event, id_habilitacion) {
      var parametros = {
        id_habilitacion: id_habilitacion
      }
      DataService.pdf2(vm.urlGenerarCredencial, parametros)
        .then(function(response) {
          ConsultasService.mostrarPdf(event, [response.data], 'Credencial');
        });
    }

    function enviarCredenciales(event) {
      var query2 = {
        order: vm.order,
        limit: vm.estudiantes.count,
        page: 1,
        estados: ['PREASIGNADO']
      };
      DataService.list(vm.url + vm.periodoFiltro, query2)
      .then(function(response) {
        if (response && response.datos && response.datos.rows && response.datos.rows.length > 0) {
          Message.error("Existen estudiantes preasignados pendientes de ser aprobados por el Director de SEDES.");
        } else {
          enviarCredencialesFinal(event);
        }
      });
    }

    function enviarCredencialesFinal(event) {
      Modal.confirm('Una vez enviadas las credenciales al Director ya no podrán ser modificadas. ¿Desea continuar?', function() {
        Util.bloquearPagina("Por favor espere a que terminen de generarse las credenciales.");
        DataService.put(vm.urlGenerarCredenciales, {
            id_periodo: vm.periodoFiltro
          })
          .then(function(response) {
            Util.desbloquearPagina();
            if (response && response.mensaje) {
              Message.success(response.mensaje);
              listarHabilitados();
            } else {
              Message.error("No se encontraron los datos solicitados.");
            }
          }).catch(function() {
            Util.desbloquearPagina();
          });
      }, null, event);
    }

    function mejoresPromedios(event) {
      Modal.confirm('RECUERDE: La selección de los mejores promedios debe hacerse al finalizar el registro de todos los estudiantes. Se seleccionarán los mejores promedios por universidad y carrera. ¿Desea continuar?', function() {
        DataService.put(vm.urlMejoresPromedios + vm.periodoFiltro, {})
          .then(function(response) {
            if (response && response.mensaje) {
              Message.success(response.mensaje);
              vm.filter.show = true;
              vm.query.filter = 'BUENA NOTA';
              listarHabilitados();
            } else {
              Message.error("No se encontraron estudiantes para ser marcados con BUENA NOTA.");
            }
          }).catch(function() {
            Util.desbloquearPagina();
          });
      }, null, event);
    }

    function editarAsignacion(event, habilitado) {
      if (habilitado.nota >= 80 || habilitado.estado_habilitacion == 'APROBADO' || habilitado.estado_habilitacion == 'PREASIGNADO') {
        DataService.get(vm.urlAsignacion + habilitado.id_habilitacion)
          .then(function(response) {
            var item = response.datos;
            vm.habilitacionSeleccionada = filterItem(item);
            Modal.show({
              event: event,
              data: vm,
              dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogAsignacionController],
              templateUrl: 'app/modules/rotaciones/components/asignacionesEstudiantes/dialog.asignacion.html'
            });
          });
      } else {
        Message.info("Sólo es posible modificar el establecimiento de salud de aquellos estudiantes con nota mayor o igual a 80 puntos.", null, 7000);
      }
    }

    function verDetalle(event, id_habilitacion) {
      $window.sessionStorage.id_habilitacion = id_habilitacion;
      $location.path('rotaciones/detalleMonitoreo');
    }

    function registrarPeriodosSedes() {
      var path = '/rotaciones/gestiones';
      $location.path(path);
      BreadcrumbFactory.actualizar(path);
      SideNavFactory.actualizar(path);
    }

    function filterItem(data) {
      for (var i in data) {
        if (i.indexOf('fecha') != -1 && data[i]) {
          data[i] = new Date(data[i]);
        }
      }
      return data;
    }

    function verificarMostrarCredencial(habilitacion) {
      return ConsultasService.verificarMostrarCredencial(habilitacion);
    }
    vm.abrirRegistroUniversidad = function(event) {
      Modal.show({
        event: event,
        data: vm,
        title: 'Registrar universidad extranjera',
        templateUrl: 'app/modules/rotaciones/components/asignacionesEstudiantes/dialog.universidad.html',
        dialogController: ['$scope', 'data', 'Message', DialogUniversidadController]
      });
    }
    vm.guardarUniversidad = function(event, data) {
      DataService.save(restUrl + 'rotaciones/universidad/extranjera/crear', data)
        .then(function(response) {
          if (response && response.datos) {
            vm.sedesUniversitarias = response.datos.sede_all;
            vm.estudianteNuevo.estudiante.fid_sede = response.datos.sede.id_sede;
            vm.estudianteNuevo.estudiante.fid_carrera = null;
            vm.carreras = response.datos.carreras;
            vm.agregarEstudiante(event);
            Message.success("La universidad fue registrada correctamente. Por favor continúe con el registro del estudiante.", null, 10000);
          }
        });
    }
  }

  function RecordatorioController($scope, data, $mdDialog) {
    var vm = $scope;
    vm.marcado = false;
    vm.aceptar = function (event) {
      data.asignarEstablecimientos(event, true);
    }
    vm.mejoresPromedios = function(event) {
      data.mejoresPromedios(event);
    }
    vm.close = function() {
      $mdDialog.hide();
    }
  }
  function DialogUniversidadController($scope, data, Message) {
    var vm = $scope;

    vm.guardarUniversidad = function(event) {
      data.guardarUniversidad(event, vm.universidad);
    }
    vm.close = function(event) {
      data.agregarEstudiante(event);
      Message.info("Por favor continúe con el registro del estudiante.");
    }
  }

  function DialogEstudianteController($scope, $mdDialog, data, restUrl, DataService, Message, OpcionesNombreCompleto) {
    var vm = $scope;
    vm.registrarUniversidad = data.registrarUniversidad;
    vm.carreras = data.carreras;
    vm.getCarreras = data.getCarreras;
    vm.casosEspeciales = data.casosEspeciales;
    vm.sedesUniversitarias = data.sedesUniversitarias;
    vm.urlEstudiante = data.urlEstudiante;
    vm.mostrar = true;
    vm.mostrarNota = true;
    vm.mostrarDeposito = true;
    vm.mostrarCasoEspecial = true;
    // variable para mostrar el campo de Condicion especial
    // deberia ser un valor parametrizable desde el administrador del sedes
    // es true en el caso de el sedes y false en el caso de las universidades

    vm.opcionesNombre = [];
    function cambiaOpciones () {
      if (vm.estudiante.persona) {
        vm.opcionesNombre = OpcionesNombreCompleto.crearOpciones(vm.estudiante.persona.nombres, vm.estudiante.persona.primer_apellido, vm.estudiante.persona.segundo_apellido, vm.estudiante.persona.casada_apellido);
        vm.estudiante.persona.nombre_completo_documento_identidad = '';
      }
    }
    // TODO agregar debounce a la función cambiar opciones, de preferencia en un Factory, esto evitará que la función se llame demasiadas veces
    $scope.$watch('estudiante.persona.nombres', cambiaOpciones);
    $scope.$watch('estudiante.persona.primer_apellido', cambiaOpciones);
    $scope.$watch('estudiante.persona.segundo_apellido', cambiaOpciones);
    $scope.$watch('estudiante.persona.casada_apellido', cambiaOpciones);

    vm.otrosRegistros = data.permiso;
    vm.tipoSedes = data.tipoSedes;
    vm.depositoSedes = data.depositoSedes;
    vm.id_sedes = data.id_sedes;
    vm.registroFlotante = data.registroFlotante;
    vm.mostrarEdicionPersona = data.mostrarEdicionPersona;

    if (data.estudianteSeleccionado) {
      vm.estudiante = data.estudianteSeleccionado;

      DataService.list(restUrl + 'rotaciones/carrera/listar/' + vm.estudiante.fid_sede)
        .then(function(response) {
          if (response && response.datos) {
            vm.carreras = response.datos;
          } else {
            Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
          }
        });

    } else if (data.estudianteNuevo) {
      vm.estudiante = data.estudianteNuevo;
    } else {
      vm.estudiante = {
        estudiante: {}
      };
      if (vm.registroFlotante) {
        vm.estudiante.estudiante.fecha_inicio = data.fechaEnviada;
      }
      // TODO: 2. Sacar afuera cuando ya haya edición de persona
      if (vm.sedesUniversitarias.length == 1) {
        vm.estudiante.estudiante.fid_sede = vm.sedesUniversitarias[0].id_sede;
        vm.congelarSede = true;
      }
      if (vm.carreras.length == 1) {
        vm.estudiante.estudiante.fid_carrera = vm.carreras[0].id_carrera;
      }
      // TODO: 2. fin
    }

    vm.estudiante.id_periodo = data.periodoFiltro;

    function actualizar(response) {
      if (response && response.datos) {
        Message.success(response.mensaje);
        data.listarHabilitados();
        $mdDialog.cancel();
      }
    }
    vm.guardarEstudiante = function(pasar) {
      if (vm.estudiante.persona.encontrado === -1 && !vm.estudiante.persona.primer_apellido && !vm.estudiante.persona.segundo_apellido) {
        Message.error("Debe registrar al menos un apellido.");
      } else {
        if (vm.estudiante.persona.extranjero && !pasar) {
          vm.mostrarConfirmacion = true;
        } else {
          vm.estudiante.asignacion_manual = vm.estudiante.estudiante.caso_especial;
          DataService.save(vm.urlEstudiante, vm.estudiante)
            .then(function(response) {
              data.fechaEnviada = vm.estudiante.estudiante.fecha_inicio;
              actualizar(response);
            });
        }
      }
    }
    vm.cerrarConfirmacion = function() {
      vm.mostrarConfirmacion = false;
    }
    vm.editarEstudiante = function() {
      if (vm.estudiante.persona.fid_tipo_documento == 105 && !vm.estudiante.persona.primer_apellido && !vm.estudiante.persona.segundo_apellido) {
        Message.error("Debe registrar al menos un apellido.");
      } else {
        DataService.put(vm.urlEstudiante + vm.estudiante.id_estudiante, vm.estudiante)
          .then(function(response) {
            actualizar(response);
          });
      }
    }
    vm.cambiarSedeUniversitaria = function(item) {
      if (item) {
        vm.estudiante.estudiante.fid_sede = item.id_sede;
      }
      vm.estudiante.fid_carrera = null;
      if (vm.estudiante.estudiante) {
        vm.estudiante.estudiante.fid_carrera = null;
      }
      vm.carreras = [];
      DataService.list(restUrl + 'rotaciones/carrera/listar/' + (vm.estudiante.estudiante ? vm.estudiante.estudiante.fid_sede : vm.estudiante.fid_sede))
        .then(function(response) {
          if (response && response.datos) {
            vm.carreras = response.datos;
          } else {
            Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
          }
        });
    }
    vm.abrirRegistroUniversidad = function(event) {
      data.estudianteNuevo = vm.estudiante;
      data.abrirRegistroUniversidad(event);
    }
    vm.close = function() {
      $mdDialog.cancel();
    }

  }

  function DialogAsignacionController($scope, $mdDialog, data, restUrl, DataService, Message) {
    var vm = $scope;
    vm.habilitacion = data.habilitacionSeleccionada;
    vm.caso_especial_buena_nota = data.caso_especial_buena_nota;
    vm.gestion = data.gestionFiltro;
    vm.periodo = data.periodoObjeto;
    vm.casosEspeciales = data.casosEspeciales;

    vm.urlEst = restUrl + 'rotaciones/establecimiento_salud/habilitacion/?id_carrera=' + vm.habilitacion.estudiante.fid_carrera + '&id_periodo=' + vm.habilitacion.fid_periodo;

    vm.editarAsignacion = function() {
      DataService.put(restUrl + "rotaciones/habilitacion/cambio/" + vm.habilitacion.id_habilitacion, {
          id_establecimiento_salud: vm.establecimiento.id_establecimiento_salud,
          asignacion_manual: vm.habilitacion.asignacion_manual == 'OTROS' ? vm.habilitacion.asignacion_manual_descripcion : vm.habilitacion.asignacion_manual
        })
        .then(function(response) {
          if (response && response.datos) {
            Message.success(response.mensaje);
            data.listarHabilitados();
            $mdDialog.cancel();
          }
        });
    }
    vm.close = function() {
      $mdDialog.cancel();
    }

  }

  function DialogConfirmacionController($scope, $mdDialog, data) {
    var vm = $scope;
    vm.nota_minima = data.nota_minima;
    vm.estudiantes = data.estudiantesRep;
    vm.asignarEstablecimientos = function(event) {
      data.asignarEstablecimientosFinal(event);
    }
    vm.close = function() {
      $mdDialog.cancel();
    }
  }

  angular.module('app')
    .controller('NotasFilaController', function($scope, $timeout, $document, DataService, Message, restUrl) {
      var vm = $scope;
      vm.urlNotaEditar = restUrl + 'rotaciones/habilitacion/';
      var timeout = null;
      var debounceUpdate = function(newVal, oldVal) {
        if (newVal != oldVal) {
          if (timeout) {
            $timeout.cancel(timeout)
          }
          timeout = $timeout(guardarNota, 500); // 1000 = 1 segundo
        }
      };
      $scope.$watch('habilitado.nota', debounceUpdate);

      function guardarNota() {
        if(angular.isDefined(vm.habilitado.nota)){
            DataService.put(vm.urlNotaEditar + vm.habilitado.id_habilitacion, {
                nota: vm.habilitado.nota
              })
              .then(function(response) {
                vm.habilitado.estado_habilitacion = response.datos.estado_habilitacion;
              });
        }

      }

    });
})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('rotacionesAprobarPreasignacion', {
      templateUrl: 'app/modules/rotaciones/components/aprobarPreasignacion/modules.rotaciones.components.aprobarPreasignacion.html',
      controller: aprobarPreasignacionController,
      bindings: {
        permission: '=',
        gestionFiltro: '=',
        periodoFiltro: '=',
        actualizardatos: '='
      }
    });

  /** @ngInject */
  function aprobarPreasignacionController($scope, restUrl, Modal, DataService, Message) {
    var vm = this;
    vm.title = 'Lista de estudiantes con preasignaciones pendientes';
    vm.seleccionable = true;
    vm.estados = ['PREASIGNADO'];

    vm.urlAprobarPreAsignacion = restUrl + 'rotaciones/habilitacion/aprobar/';

    vm.aprobar = aprobar;
    vm.anular = anular;

    vm.buttons = [
    // {
    //   tooltip: 'Ver detalle',
    //   icon: 'remove_red_eye',
    //   show: vm.permission.update,
    //   onclick: function(event, id) {
    //     verDetalle(id);
    //   }
    // },
    {
      tooltip: 'Rechazar pre-asignación',
      icon: 'delete',
      show: vm.permission.update,
      mostrar: function() {
        return vm.permission.update;
      },
      onclick: function(event, id) {
        anular(event, id);
      }
    }];

    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo) {
          vm.periodoFiltro = id_periodo;
        }
        vm.listarHabilitados(vm.periodoFiltro);
      }
    }

    function anular(event, id_habilitacion) {
      Modal.confirm('¿Desea rechazar la solicitud de pre-asignación?' , function() {
        DataService.put(restUrl + "rotaciones/habilitacion/cambio/" + id_habilitacion, {
            id_establecimiento_salud: null,
            asignacion_manual: null
          })
          .then(function(response) {
            if (response && response.datos) {
              Message.success(response.mensaje);
              vm.listarHabilitados();
            }
          });
      });
    }

    function aprobar() {
      Modal.confirm('¿Desea aprobar las solicitudes de pre-asignación seleccionadas?' , function() {
        vm.solicitados = 0;
        vm.contador = 0;
        if (vm.seleccionados.selected.length === 0) {
          Message.error("Debe seleccionar al menos un registro para aprobar.");
        } else {
          DataService.put(vm.urlAprobarPreAsignacion, {id_habilitacion: vm.seleccionados.selected})
          .then(function(response) {
            if (response && response.mensaje) {
              Message.success(response.mensaje);
              vm.listarHabilitados();
            } else {
              Message.error("No se encontraron los datos solicitados.");
            }
          });
        }
      });
    }

    // function verDetalle(id_habilitacion) {
    //   $window.sessionStorage.id_habilitacion = id_habilitacion;
    //   $location.path('rotaciones/detalleMonitoreo');
    // }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PreasignacionesController', PreasignacionesController);

  /** @ngInject */
  function PreasignacionesController() {

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('vistas', {
      templateUrl: 'app/modules/rotaciones/vistas/modules.rotaciones.vistas.html',
      controller: VistasController,
      bindings: {
        vista: '='
      }
    });

  /** @ngInject */
  function VistasController(restUrl, Modal, DataService, Util, Message, $window, $location, Storage) {
    var vm = this;

    vm.permission = Util.getMenuProcess();
    vm.actualizardatos = function() {}

    vm.urlGestiones = restUrl + 'rotaciones/periodo/gestion';
    vm.urlPeriodos = restUrl + 'rotaciones/periodo/periodo/';
    vm.urlPeriodoActual = restUrl + "rotaciones/periodo_actual";

    vm.listarPeriodos = listarPeriodos;
    vm.cambiarPeriodo = cambiarPeriodo;
    vm.cambiarAccion = cambiarAccion;
    vm.obtenerClasePeriodo = obtenerClasePeriodo;
    vm.obtenerAccion = obtenerAccion;
    vm.mostrarTodos = mostrarTodos;
    vm.mostrarGestionesAnteriores = mostrarGestionesAnteriores;

    activate();

    function activate() {
      // Listar gestiones
      DataService.get(vm.urlGestiones)
        .then(function(gestiones) {
          if (gestiones && gestiones.datos) {
            vm.gestiones = gestiones.datos;
          } else {
            Message.info("Aún no se han generado períodos para ninguna gestión.");
          }
      });

      /* ********************* ACCION Y SELECCIONES ************************** */
      vm.submenu = Util.getSubMenu();
      // VISTAS

      if (vm.vista) {
        vm.menuSeleccionado = vm.vista;
        vm.permissionSubmenu = Util.getMenuProcess();
      } else {
        var datos = $window.sessionStorage.getItem("menusSeleccionados");
        if (datos) {
          datos = angular.fromJson(datos);
          if (datos && datos[$location.path()]) {
            var submenu1 = datos[$location.path()];
            for (var i in vm.submenu) {
              if (vm.submenu[i].url == submenu1.url) {
                vm.menuSeleccionado = vm.submenu[i].url;
                vm.permissionSubmenu = vm.submenu[i].permissions;
              }
            }
          }
        }
        if (!vm.menuSeleccionado || !vm.permissionSubmenu) {
          vm.menuSeleccionado = (vm.submenu.length && vm.submenu.length > 0) ? vm.submenu[0].url : '';
          vm.permissionSubmenu = (vm.submenu.length && vm.submenu.length > 0) ? vm.submenu[0].permissions : [] ;
        }
      }

      if (mostrarTodos()) {
        var mydatacero = $window.sessionStorage.getItem("periodoSeleccionadoCero");
        if (mydatacero) {
          mydatacero = angular.fromJson(mydatacero);
          if (mydatacero.todos) {
            obtenerPeriodoActual(0);
          } else {
            vm.gestionFiltro = mydatacero.gestion;
            vm.periodoFiltro = mydatacero.id_periodo;
            listarPeriodos(false);
          }
        } else {
          obtenerPeriodoActual(0);
        }
      } else {
        var mydata = $window.sessionStorage.getItem("periodoSeleccionado");
        if (mydata) {
          mydata = angular.fromJson(mydata);
          if (mydata.gestion != 0) {
            vm.gestionFiltro = mydata.gestion;
            vm.periodoFiltro = mydata.id_periodo;
            listarPeriodos(false);
          } else {
            obtenerPeriodoActual(0);
          }
        } else {
          if (mostrarTodos()) {
            obtenerPeriodoActual(0);
          } else {
            obtenerPeriodoActual();
          }
        }
      }
    }

    function obtenerPeriodoActual(cero) {
      // Obtener periodo actual
      if (cero === 0) {
        vm.gestionFiltro = 0;
        listarPeriodos(false);
        listarPostulantes();
      } else {
        DataService.get(vm.urlPeriodoActual)
        .then(function(response) {
          if (response && response.datos) {
            vm.gestionFiltro = response.datos.gestion;
            vm.periodoFiltro = response.datos.id_periodo;
            vm.periodoObjeto = response.datos;
            listarPeriodos(false);
            listarPostulantes();
          }
        });
      }
    }

    function listarPeriodos(actualizar) {
      vm.periodos = [];
      if (vm.gestionFiltro != 0) {
        DataService.get(vm.urlPeriodos + vm.gestionFiltro)
          .then(function(periodos) {
            if (periodos &&  periodos.datos) {
              vm.periodos = periodos.datos;
              if (vm.periodos.length > 0 && actualizar) {
                vm.periodoFiltro = vm.periodos[0].id_periodo;
                vm.periodoObjeto = vm.periodos[0];
                $window.sessionStorage.setItem("periodoSeleccionado", angular.toJson({id_periodo: vm.periodoFiltro, gestion: vm.gestionFiltro}));
                if (mostrarTodos()) {
                  $window.sessionStorage.setItem("periodoSeleccionadoCero", angular.toJson({id_periodo: vm.periodoFiltro, gestion: vm.gestionFiltro}));
                }
                listarPostulantes();
              }
            } else {
              Message.warning("No hay períodos registrados en la gestión seleccionada.");
            }
        });
      } else {
        vm.periodoFiltro = 0;
        $window.sessionStorage.setItem("periodoSeleccionadoCero", angular.toJson({todos: true}));
        listarPostulantes();
      }
    }

    function mostrarTodos() {
      if (vm.menuSeleccionado == 'rotaciones-firma-credenciales' ||
          vm.menuSeleccionado == 'rotaciones-firma-resoluciones' ||
          vm.menuSeleccionado == 'rotaciones-generacion-resoluciones' ||
          vm.menuSeleccionado == 'rotaciones-tramites-observados') {
        return true;
      }
      return false;
    }

    function mostrarGestionesAnteriores(gestion) {
      var usuario = Storage.getUser();
      if (usuario) {
        var gestion_inicio = usuario.gestion_inicio;
        if (gestion_inicio && gestion_inicio != -1 && gestion >= gestion_inicio) {
          return true;
        }
        else if (!gestion_inicio || gestion && gestion_inicio == -1) {
          return true;
        } else if (mostrarTodos() ||
                  vm.menuSeleccionado == 'rotaciones-credenciales-firmadas' ||
                  vm.menuSeleccionado == 'rotaciones-resoluciones-firmadas' ||
                  vm.menuSeleccionado == 'rotaciones-informes-firmados') {
          return true;
        }
        return false;
      } else {
        return true;
      }

    }

    function listarPostulantes() {
      vm.actualizardatos(vm.periodoFiltro, vm.periodoObjeto);
    }

    function cambiarPeriodo(periodo) {
      vm.periodoFiltro = periodo.id_periodo;
      vm.periodoObjeto = periodo;
      $window.sessionStorage.setItem("periodoSeleccionado", angular.toJson({id_periodo: vm.periodoFiltro, gestion: vm.gestionFiltro}));
      if (mostrarTodos()) {
        $window.sessionStorage.setItem("periodoSeleccionadoCero", angular.toJson({id_periodo: vm.periodoFiltro, gestion: vm.gestionFiltro}));
      }
      listarPostulantes();
    }
    function cambiarAccion(submenu) {
      vm.menuSeleccionado = submenu.url;
      vm.permissionSubmenu = submenu.permissions;
      var datos = $window.sessionStorage.getItem("menusSeleccionados");
      if (datos) {
        datos = angular.fromJson(datos);
        datos[$location.path()] = submenu;
      } else {
        datos = { };
        datos[$location.path()] = submenu;
      }
      $window.sessionStorage.setItem("menusSeleccionados", angular.toJson(datos));
    }
    function obtenerClasePeriodo(id_periodo) {
      if (vm.periodoFiltro == id_periodo) {
        return "periodo-seleccionado";
      }
      return "";
    }
    function obtenerAccion(submenu) {
      if (submenu.url == vm.menuSeleccionado) {
        return "accion-seleccionado";
      }
      return "";
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('UniversidadesController', UniversidadesController);

  /** @ngInject */
  function UniversidadesController(restUrl, Util, $location, Modal, DataService, Message) {
    var vm = this;
    vm.title = 'Lista de Universidades';
    vm.url = restUrl + 'rotaciones/universidad/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
      'id_universidad',
      'nombre',
      'codigo',
      'resolucion',
      'extranjero'
    ];

    vm.formly = [{
      'key': 'id_universidad',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    },{
      'key': 'extranjero',
      'templateOptions': {
        required: false
      }
    }];

    // vm.archivos = [{
    //   key: 'logo',
    //   label: 'Logo'
    // }];

    vm.buttons = [
      {
        tooltip: 'Sedes universitarias',
        icon: 'domain',
        show: true,
        onclick: function(event, id) {
          $location.path('/rotaciones/sedesUniversitarias/' + id);
        }
      }
    ];

    vm.botones = [{
      tooltip: 'Actualizar universidades',
      texto: 'Actualizar universidades',
      icon: 'refresh',
      onclick: function(event, a, b, getItems) {
        Modal.confirm('Se actualizarán las Universidades según la base de datos del Sistema de Habilitación. Esta operación puede tardar unos minutos. ¿Desea continuar?', function() {
          DataService.get(restUrl + 'rotaciones/universidad/sishab/importar')
            .then(function(response) {
              if (response && response) {
                Message.success("Las universidades han sido actualizadas correctamente.")
                getItems();
              }
            })
            .catch(function() {
              Message.error();
            });
        }, null, event);
      }
    }];

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('TramitesPasadosController', TramitesPasadosController);

  /** @ngInject */
  function TramitesPasadosController(Util, Modal, restUrl, DataService, Message, $timeout, $location, $window, blockUI, Storage) {
    var vm = this;
    vm.title = 'Estudiantes con trámites pasados';
    vm.permission = Util.getMenuProcess();
    vm.urlGestiones = restUrl + 'rotaciones/periodo/gestion';
    vm.urlPeriodos = restUrl + 'rotaciones/periodo/periodo/';
    vm.urlEstudiante = restUrl + 'rotaciones/estudiante/';
    vm.url = restUrl + 'rotaciones/habilitacion/lista/0/';
    vm.urlGenerarInforme = restUrl + 'rotaciones/habilitacion_generar_informe/';


    vm.agregarEstudiante = agregarEstudiante;
    vm.listarHabilitados = listarHabilitados;
    vm.editarEstudiante = editarEstudiante;
    vm.listarCasosEspeciales = listarCasosEspeciales;
    vm.verDetalle = verDetalle;
    vm.enviarAsesor = enviarAsesor;

    vm.showFilter = function() {
      vm.filter.show = true;
      $timeout(function() {
        angular.element('#crud-table-input').focus();
      }, 300);
    }
    vm.removeFilter = function() {
      vm.filter.show = false;
      vm.query.filter = '';
      if (vm.filter.form.$dirty) {
        vm.filter.form.$setPristine();
      }
      listarHabilitados();
    }

    vm.buscarEstudiante = function() {
      listarHabilitados();
    }
    if (vm.actualizardatos) {
      vm.actualizardatos = function(id_periodo) {
        if (id_periodo) {
          vm.periodoFiltro = id_periodo;
        }
        listarHabilitados();
      }
    }

    vm.selected = [];

    // Paginación
    vm.order = '';
    vm.options = {
      boundaryLinks: true
    };
    vm.query = {
      order: vm.order,
      limit: 20,
      page: 1
    };

    activate();

    function activate() {
      listarGestiones();
      getSedesUniversitariasCarreras();
      listarHabilitados();
      listarCasosEspeciales();
    }

    function agregarEstudiante(event, borrar) {
      if (borrar) {
        vm.estudianteNuevo = undefined;
      }
      vm.estudianteSeleccionado = null;
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'Util', 'OpcionesNombreCompleto', DialogEstudianteController],
        templateUrl: 'app/modules/rotaciones/estudiantes/create.dialog.html'
      });
    }

    function listarHabilitados() {
      vm.query.rezagados = true;
      vm.query.estados = ['HABILITADO', 'APROBADO', 'REPROBADO', 'ASIGNADO', 'CREDENCIAL_GENERADA', 'CREDENCIAL_FIRMADA', 'SUSPENDIDA',
        'INFORME_GENERADO', 'PREASIGNADO', 'INFORME_GENERADO', 'RESOLUCION_GENERADA', 'RESOLUCION_FIRMADA_ASESOR', 'RESOLUCION_FIRMADA_DIRECTOR',
        'RESO_GENERADA_AP_CASADA', 'RESO_AP_CASADA_FIRMA_ASESOR'
      ];
      DataService.list(vm.url, vm.query)
        .then(function(response) {
          vm.estudiantes = [];
          if (response && response.datos.rows && response.datos.rows.length > 0) {
            vm.estudiantes = response.datos;
          } else {
            Message.info("No se encontraron estudiantes registrados.");
          }
        });
    }

    function getSedesUniversitariasCarreras() {
      vm.carreras = [];
      vm.sedesUniversitarias = [];
      DataService.list(restUrl + 'rotaciones/sede_seleccionar')
        .then(function(response) {
          if (response && response.datos) {
            vm.sedesUniversitarias = response.datos.rows;
            if (vm.sedesUniversitarias.length == 1) {
              getCarreras(vm.sedesUniversitarias[0].id_sede);
            }
          }
        });
    }

    function getCarreras(id_sede) {
      DataService.list(restUrl + 'rotaciones/carrera/listar/' + id_sede)
        .then(function(response) {
          if (response && response.datos) {
            vm.carreras = response.datos;
          } else {
            Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
          }
        });
    }

    function listarGestiones() {
      DataService.get(vm.urlGestiones)
        .then(function(gestiones) {
          if (gestiones && gestiones.datos) {
            procesarGestiones(gestiones.datos);
          } else {
            Message.warning("Aún no se ha generado períodos para ninguna gestión pasada.");
          }
        });
    }

    function procesarGestiones(gestiones) {
      var gestion_inicio = Storage.getUser().gestion_inicio;
      var gestionesAux = [];
      for (var i in gestiones) {
        if (gestiones[i].gestion < gestion_inicio) {
          gestionesAux.push(gestiones[i]);
        }
      }
      vm.gestiones = gestionesAux;
      if (vm.gestiones.length == 0) {
        Message.warning("Aún no se ha generado períodos para ninguna gestión pasada.");
      }
    }

    function verDetalle(event, id_habilitacion) {
      $window.sessionStorage.id_habilitacion = id_habilitacion;
      $location.path('rotaciones/detalleMonitoreo');
    }

    function listarCasosEspeciales() {
      DataService.list(restUrl + 'parametros/parametro/caso_especial')
        .then(function(response) {
          if (response && response.datos) {
            vm.casosEspeciales = response.datos;
          } else {
            Message.warning("No se encontraron casos especiales registrados.");
          }
        });
    }

    function editarEstudiante(event, id_estudiante) {
      DataService.get(vm.urlEstudiante + id_estudiante)
        .then(function(response) {
          var item = response.datos;
          vm.estudianteSeleccionado = item;
          Modal.show({
            event: event,
            data: vm,
            dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'Modal', 'Util', DialogEstudianteController],
            templateUrl: 'app/modules/rotaciones/estudiantes/edit.dialog.html'
          });
        });
    }

    vm.abrirRegistroUniversidad = function(event) {
      Modal.show({
        event: event,
        data: vm,
        title: 'Registrar universidad extranjera',
        templateUrl: 'app/modules/rotaciones/components/asignacionesEstudiantes/dialog.universidad.html',
        dialogController: ['$scope', 'data', 'Message', DialogUniversidadController]
      });
    }
    vm.guardarUniversidad = function(event, data) {
      DataService.save(restUrl + 'rotaciones/universidad/extranjera/crear', data)
        .then(function(response) {
          if (response && response.datos) {
            vm.sedesUniversitarias = response.datos.sede_all;
            vm.estudianteNuevo.estudiante.fid_sede = response.datos.sede.id_sede;
            vm.estudianteNuevo.estudiante.fid_carrera = null;
            vm.carreras = response.datos.carreras;
            vm.agregarEstudiante(event);
            Message.success("La universidad fue registrada correctamente. Por favor continúe con el registro del estudiante.", null, 10000);
          }
        });
    }
    vm.abrirRegistroGestion = function(event) {
      Modal.show({
        event: event,
        data: vm,
        title: 'Registrar gestión',
        templateUrl: 'app/modules/rotaciones/periodosGestion/modules.rotaciones.dialog.periodosGestion.html',
        dialogController: ['$scope', 'data', 'Message', 'DataService', 'restUrl', DialogPeriodoController]
      });
    }
    vm.abrirRegistroEstablecimiento = function(event) {
      Modal.show({
        event: event,
        data: vm,
        title: 'Registrar establecimiento de salud',
        templateUrl: 'app/modules/rotaciones/establecimientosSalud/modules.rotaciones.dialog.adicionar.html',
        dialogController: ['$scope', 'data', 'Message', 'DataService', 'restUrl', DialogEstablecimientoController]
      });
    }
    vm.guardarGestion = function(event, data, correlativos) {
      DataService.post(restUrl + 'rotaciones/periodo/', {
        gestion: data.gestion,
        fid_sedes: data.fid_sedes
      }).then(function(response) {
        if (response && response.datos) {
          DataService.get(vm.urlGestiones)
            .then(function(gestiones) {
              if (gestiones && gestiones.datos) {
                procesarGestiones(gestiones.datos)
                vm.estudianteNuevo.periodo = {
                  gestion: data.gestion
                };
                Message.success("La gestión fue registrada correctamente. Por favor continúe con el registro del estudiante.", null, 10000);
                vm.agregarEstudiante(event);
                crearCorrelativos(correlativos, data.gestion);
              }
            });
        }
      });
    }

    vm.guardarEstablecimiento = function(event, data, objeto) {
      DataService.post(restUrl + 'rotaciones/establecimiento_salud/', {
        //                gestion: data.gestion,
        gestion: objeto.gestion,
        cod_prov: objeto.cod_prov,
        nom_prov: objeto.nom_prov,
        cod_muni: objeto.cod_muni,
        nom_municipio: objeto.nom_municipio,
        establecimiento: objeto.nombre_establecimiento
      }).then(function(response) {
        if (response && response.datos) {
          Message.success("Se registro la información de manera correcta.", null, 10000);
          vm.agregarEstudiante(event);
        }
      });
    }

    function crearCorrelativos(correlativos, gestion) {
      correlativos.gestion = gestion;
      DataService.post(restUrl + 'rotaciones/correlativo_sedes/', correlativos);
    }

    function enviarAsesor(event, data) {
      blockUI.start("Generando informe técnico.");
      DataService.post(vm.urlGenerarInforme, {
          ids_habilitacion: data.id_habilitacion,
          rezagado: true
        })
        .then(function(response) {
          Util.desbloquearPagina();
          blockUI.stop();
          if (response && response.datos) {
            Message.success(response.mensaje);
            verDetalle(event, data.id_habilitacion);
          } else {
            Message.warning("La solicitud no se procesó correctamente.");
          }
        });
    }
  }

  function DialogEstudianteController($scope, $mdDialog, data, restUrl, DataService, Message, Util, OpcionesNombreCompleto) {
    var vm = $scope;
    vm.rezagado = true;
    vm.mostrar = false;
    vm.periodo = {};
    vm.registrarUniversidad = true;
    vm.registrarGestion = true;
    vm.getCarreras = data.getCarreras;
    vm.sedesUniversitarias = data.sedesUniversitarias;
    vm.urlEstudiante = data.urlEstudiante;
    vm.casosEspeciales = data.casosEspeciales;
    vm.carreras = data.carreras;
    vm.listarPeriodos = listarPeriodos;

    vm.estudiante = {
      estudiante: {}
    };

    if (data.estudianteSeleccionado) {
      vm.estudiante = data.estudianteSeleccionado;

      DataService.list(restUrl + 'rotaciones/carrera/listar/' + vm.estudiante.fid_sede)
        .then(function(response) {
          if (response && response.datos) {
            vm.carreras = response.datos;
          } else {
            Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
          }
        });

    } else if (data.estudianteNuevo) {
      vm.estudiante = data.estudianteNuevo;
      if (data.estudianteNuevo.periodo) {
        vm.periodo = data.estudianteNuevo.periodo;
      }
    } else {
      vm.estudiante = {
        estudiante: {}
      };
      // TODO: 2. Sacar afuera cuando ya haya edición de persona
      if (vm.sedesUniversitarias.length == 1) {
        vm.estudiante.estudiante.fid_sede = vm.sedesUniversitarias[0].id_sede;
        vm.congelarSede = true;
      }
      if (vm.carreras.length == 1) {
        vm.estudiante.estudiante.fid_carrera = vm.carreras[0].id_carrera;
      }
      // TODO: 2. fin
    }

    if (!data.estudianteNuevo || (data.estudianteNuevo && !data.estudianteNuevo.periodo)) {
      vm.gestiones = data.gestiones;
      if (angular.isDefined(vm.gestiones) && vm.gestiones.length > 0) {
        vm.periodo.gestion = vm.gestiones[0].gestion;
        listarPeriodos();
      } else {
        vm.gestiones = [];
      }
    } else {
      vm.gestiones = data.gestiones;
      if (data.estudianteNuevo && data.estudianteNuevo.periodo && data.estudianteNuevo.periodo.id_periodo) {
        listarPeriodos(data.estudianteNuevo.periodo.id_periodo);
      } else {
        listarPeriodos();
      }
    }

    vm.opcionesNombre = [];
    function cambiaOpciones () {
      if (vm.estudiante.persona) {
        vm.opcionesNombre = OpcionesNombreCompleto.crearOpciones(vm.estudiante.persona.nombres, vm.estudiante.persona.primer_apellido, vm.estudiante.persona.segundo_apellido, vm.estudiante.persona.casada_apellido);
        vm.estudiante.persona.nombre_completo_documento_identidad = '';
      }
    }
    // TODO agregar debounce a la función cambiar opciones, de preferencia en un Factory, esto evitará que la función se llame demasiadas veces
    $scope.$watch('estudiante.persona.nombres', cambiaOpciones);
    $scope.$watch('estudiante.persona.primer_apellido', cambiaOpciones);
    $scope.$watch('estudiante.persona.segundo_apellido', cambiaOpciones);
    $scope.$watch('estudiante.persona.casada_apellido', cambiaOpciones);

    function listarPeriodos(id_periodo_par) {
      vm.mostrar = false;
      // vm.periodo.id_periodo = null;
      vm.estudiante.establecimiento = null;
      vm.urlEst = restUrl + "rotaciones/establecimiento_salud/departamento?gestion=" + vm.periodo.gestion;
      DataService.get(data.urlPeriodos + vm.periodo.gestion)
        .then(function(periodos) {
          if (periodos && periodos.datos) {
            vm.periodos = periodos.datos;
            vm.mostrar = true;
            if (id_periodo_par) {
              vm.periodo.id_periodo = id_periodo_par;
            }
            else if (vm.periodos.length > 0) {
              vm.periodo.id_periodo = vm.periodos[0].id_periodo;
            }
          } else {
            Message.warning("No hay períodos registrados en la gestión seleccionada.");
          }
        });
    }


    vm.cambiarSedeUniversitaria = function(item) {
      if (item) {
        vm.estudiante.estudiante.fid_sede = item.id_sede;
      }
      vm.estudiante.fid_carrera = null;
      vm.carreras = [];
      DataService.list(restUrl + 'rotaciones/carrera/listar/' + (vm.estudiante.estudiante ? vm.estudiante.estudiante.fid_sede : vm.estudiante.fid_sede))
        .then(function(response) {
          if (response && response.datos) {
            vm.carreras = response.datos;
            var carrerasAux = null;
            for (var i in vm.carreras) {
              if (vm.estudiante.estudiante && vm.carreras[i].id_carrera == vm.estudiante.estudiante.fid_carrera) {
                carrerasAux = vm.carreras[i].id_carrera;
              }
            }
            if (carrerasAux) {
              vm.estudiante.estudiante.fid_carrera = carrerasAux;
            } else {
              vm.estudiante.estudiante.fid_carrera = null;
            }
          } else {
            Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
          }
        });
    }

    vm.guardarEstudiante = function(pasar) {
      if (vm.estudiante.persona.encontrado === -1 && !vm.estudiante.persona.primer_apellido && !vm.estudiante.persona.segundo_apellido) {
        Message.error("Debe registrar al menos un apellido.");
      } else {
        if (vm.estudiante.persona.extranjero && !pasar) {
          vm.mostrarConfirmacion = true;
        } else {
          var estudiante = vm.estudiante;
          estudiante.id_periodo = vm.periodo.id_periodo;
          if(vm.estudiante.establecimiento === null){
              Message.info("Debe seleccionar un establecimiento de salud válido.");
              return;
          }
          estudiante.establecimiento = {
            id_establecimiento_salud: vm.estudiante.establecimiento.id_establecimiento_salud
          };
          estudiante.gestion = vm.periodo.gestion;
          Util.bloquearPagina("Por favor espere a que termine de procesarse el estudiante.");
          DataService.save(vm.urlEstudiante, estudiante)
            .then(function(response) {
              if (response && response.datos) {
                $mdDialog.hide();
                data.enviarAsesor(null, response.datos);
              }
            });
        }
      }
    }
    vm.cerrarConfirmacion = function() {
      vm.mostrarConfirmacion = false;
    }
    vm.editarEstudiante = function() {
      DataService.put(vm.urlEstudiante + vm.estudiante.id_estudiante, vm.estudiante)
        .then(function(response) {
          actualizar(response);
        });
    }

    function actualizar() {
      $mdDialog.hide();
      data.listarHabilitados();
    }

    vm.abrirRegistroUniversidad = function(event) {
      data.estudianteNuevo = vm.estudiante;
      data.abrirRegistroUniversidad(event);
    }

    vm.abrirRegistroGestion = function(event) {
      data.estudianteNuevo = vm.estudiante;
      data.estudianteNuevo.periodo = vm.periodo;
      data.abrirRegistroGestion(event);
    }

    vm.abrirRegistroEstablecimiento = function(event) {
      data.gestion = vm.periodo.gestion;
      data.estudianteNuevo = vm.estudiante;
      data.estudianteNuevo.periodo = vm.periodo;
      data.abrirRegistroEstablecimiento(event);
    }

    vm.close = function() {
      $mdDialog.hide();
    }
  }

  function DialogUniversidadController($scope, data, Message) {
    var vm = $scope;

    vm.guardarUniversidad = function(event) {
      data.guardarUniversidad(event, vm.universidad);
    }
    vm.close = function(event) {
      data.agregarEstudiante(event);
      Message.info("Por favor continúe con el registro del estudiante.");
    }
  }

  function DialogPeriodoController($scope, data, Message, DataService, restUrl) {
    var vm = $scope;
    vm.esconderCorrelativos = true;
    vm.item = {
      gestion: (new Date()).getFullYear()
    };

    vm.correlativos = {
      nro_credencial: 1,
      nro_informe: 1,
      nro_resolucion: 1
    };

    getSedes();

    function getSedes() {
      DataService.list(restUrl + 'rotaciones/sedes')
        .then(function(response) {
          if (response) {
            vm.sedes = response.datos;
            if (vm.sedes && vm.sedes.length > 0) {
              vm.item.fid_sedes = vm.sedes[0].id_sedes;
              vm.bloquearSedes = true;
              listarPeriodos();
            }
          }
        });
    }

    function listarPeriodos() {
      vm.periodos = [];
      vm.gestionNueva = 0;
      DataService.get(restUrl + 'parametros/par_periodo?nac=1&fid_sedes=' + vm.item.fid_sedes)
        .then(function(response) {
          if (response && response.datos) {
            vm.periodos = response.datos.rows;
            var mesAux = 0;
            for (var i in vm.periodos) {
              if (vm.periodos[i].mes_fin > mesAux) {
                mesAux = vm.periodos[i].mes_fin;
              }
              if (vm.periodos[i].mes_fin < mesAux) {
                vm.gestionNueva = vm.item.gestion + 1;
                mesAux = vm.periodos[i].mes_fin;
              }
            }
          }
        });
    }

    vm.guardarPeriodos = function(event) {
      data.guardarGestion(event, vm.item, vm.correlativos);
    }
    vm.close = function(event) {
      data.agregarEstudiante(event);
      Message.info("Por favor continúe con el registro del estudiante.");
    }
  }

  function DialogEstablecimientoController($scope, data, Message, DataService, restUrl) {
    var vm = $scope;
    vm.esconderCorrelativos = true;
    vm.varCodProvincia = null;
    vm.item = {
      gestion: (new Date()).getFullYear()
    };

    vm.correlativos = {
      nro_credencial: 1,
      nro_informe: 1,
      nro_resolucion: 1
    };

    listarProvincias();

    function listarProvincias() {
      //Listamos provincias
      DataService.list(restUrl + 'rotaciones/establecimiento_salud/provincias')
        .then(function(response) {
          if (response && response.datos) {
            vm.listaProvincias = response.datos.provincias;
            vm.listaMunicipios = response.datos.municipios;
          } else {
            Message.warning("No se encontraron provincias parar elegir.");
          }
        });
    }
    vm.cambiarProvincia = function(cod_prov) {
      vm.varCodProvincia = cod_prov;
    }
    vm.guardarEstablecimiento = function(event) {
      var objeto = {};
      objeto.cod_prov = vm.item.prov.cod_prov;
      objeto.nom_prov = vm.item.prov.nom_prov;
      objeto.cod_muni = vm.item.mun.cod_muni;
      objeto.nom_municipio = vm.item.mun.nom_municipio;
      objeto.nombre_establecimiento = vm.item.nombre_establecimiento;
      objeto.gestion = data.gestion;
      data.guardarEstablecimiento(event, vm.item, objeto);
    }
    vm.close = function(event) {
      data.agregarEstudiante(event);
      Message.info("Por favor continúe con el registro del estudiante.");
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('TiposCarreraController', TiposCarreraController);

  /** @ngInject */
  function TiposCarreraController(restUrl, Util) {
    var vm = this;
    vm.title = 'Lista de tipos de Carreras';
    vm.url = restUrl + 'rotaciones/tipo_carrera/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
      'id_tipo_carrera',
      'nombre',
      'descripcion'
    ];

    vm.formly = [{
      'key': 'id_tipo_carrera',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }];
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('SedesUniversitariasController', SedesUniversitariasController);

  /** @ngInject */
  function SedesUniversitariasController(restUrl, Util, $location, $stateParams, DataService) {
    var vm = this;
    var params = $stateParams;
    vm.title = 'Lista de Sedes Universitarias';
    vm.url = restUrl + 'rotaciones/sede/';
    vm.urldata = restUrl + 'rotaciones/sede/listar/' + params.idUniversidad;
    vm.urlUniversidad = restUrl + 'rotaciones/universidad/';
    vm.volverUniversidades = volverUniversidades;

    vm.permission = {
      delete: false
    };

    vm.fields = [
      'id_sede',
      'fid_universidad',
      'nombre',
      'resolucion',
      'direccion',
      'telefono',
      'fax',
      'sitio_web',
      'correo_electronico',
      'fid_departamento'
    ];

    vm.formly = [{
      'key': 'id_sede',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }, {
      'key': 'fid_universidad',
      'defaultValue': params.idUniversidad,
      'templateOptions': {
        required: false
      },
      'expressionProperties': {
        'templateOptions.disabled': 'model.fid_universidad'
      }
    }];

    vm.fks = ['fid_departamento', 'fid_universidad'];

    vm.buttons = [
      {
        tooltip: 'Carreras universitarias',
        icon: 'layers',
        show: true,
        onclick: function(event, id) {
          $location.path('/rotaciones/carreras/' + id);
        }
      }
    ];

    function volverUniversidades() {
      $location.path('/rotaciones/universidades');
    }

    function obtenerUniversidad() {
      DataService.get(vm.urlUniversidad + params.idUniversidad)
      .then(function(universidad) {
        vm.universidad = universidad.datos;
      });
    }

    function activate() {
      obtenerUniversidad();
    }

    activate();

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('SedesController', SedesController);

  /** @ngInject */
  function SedesController(restUrl, Util, $location, $window) {
    var vm = this;
    vm.title = 'Lista de entidades SEDES';
    vm.url = restUrl + 'rotaciones/sedes/';
    vm.urlDatosSedes = restUrl + 'parametros/par_sedes/sedes/';
    vm.urlDatosSedesOptions = restUrl + 'parametros/par_sedes/';

    activate();
    function activate() {
        $window.sessionStorage.id_sedes = 'undefined';
    }

    vm.permission = Util.getMenuProcess();
    vm.permission.create = false;

    vm.fields = [
      'id_sedes',
      'fid_departamento',
      'descripcion',
      'logo',
      'escudo',
      'fondo',
      'fondo_resolucion',
      // 'correo_host',
      // 'correo_puerto',
      'correo'
      // 'correo_contrasena'
    ];

    vm.esconder = [
      'correo_host',
      'correo_puerto',
      'correo',
      'correo_contrasena'
    ];

    vm.formly = [
      {
        'key': 'id_sedes',
        'templateOptions': {
          'label': 'ID',
          required: false
        }
      },
      {
        'key': 'correo_contrasena',
        'templateOptions': {
          'type': 'password'
        }
      },
      {
        'key': 'logo',
        'hideExpression': 'true',
        'templateOptions': {
          required: false
        }
      },
      {
        'key': 'escudo',
        'hideExpression': 'true',
        'templateOptions': {
          required: false
        }
      },
      {
        'key': 'fondo',
        'hideExpression': 'true',
        'templateOptions': {
          required: false
        }
      },
      {
        'key': 'fondo_resolucion',
        'hideExpression': 'true',
        'templateOptions': {
          required: false
        }
      }
    ];

    vm.fks = ['fid_departamento'];
    vm.archivos = [
      {
        key: 'logo',
        label: 'Logo'
      },
      {
        key: 'escudo',
        label: 'Escudo'
      },
      {
        key: 'fondo',
        label: 'Fondo'
      },
      {
        key: 'fondo_resolucion',
        label: 'Fondo Resolución'
      }
    ];

    vm.buttons = [
      {
        tooltip: 'Detalle SEDES',
        texto: 'Detalle SEDES',
        icon: 'reorder',
        show: true,
        onclick: function(event, id) {
          $window.sessionStorage.id_sedes = id;
//          $location.path('/rotaciones/sedesDetalle/' + id);
          $location.path('/rotaciones/sedesDetalle');
        }
      }
    ];

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('RotacionesEdicionController', RotacionesEdicionController);

  /** @ngInject */
  function RotacionesEdicionController() {

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ResolucionesAdmController', ResolucionesAdmController);

  /** @ngInject */
  function ResolucionesAdmController() {
    
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PostulantesController', PostulantesController);

  /** @ngInject */
  function PostulantesController() {
    
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PeriodosGestionController', PeriodosGestionController);

  /** @ngInject */
  function PeriodosGestionController(Util, ArrayUtil, $scope, restUrl, Modal, $mdDialog, DataService, Message, $timeout) {
    var vm = this;
    vm.title = 'Lista de períodos por gestión'
    vm.url = restUrl + 'rotaciones/periodo';
    vm.gestionDefecto = new Date().getFullYear();
    //vm.redirectDetail = '=?redirect';

    vm.fields = [
      'id_periodo',
      'gestion',
      'numero',
      'fecha_inicio',
      'fecha_fin',
      'fid_sedes'
    ];

    vm.fks = ['fid_sedes'];

    vm.formly = [{
      'key': 'id_periodo',
      'templateOptions': {
        'label': 'ID',
        'required': false
      }
    }];

    vm.filter = {
      show: false,
      options: {
        debounce: 500
      }
    };
    vm.options = {
      boundaryLinks: true
    };
    vm.permissions = Util.getMenuProcess();
    vm.permissions.update = false;

    vm.permissions.filter = true;

    vm.limitOptions = [10, 25, 50];
    vm.query = {
      order: '',
      limit: 50,
      page: 1,
      filter: ''
    }

    vm.headres = [];

    vm.showFilter = function() {
      vm.filter.show = true;
      $timeout(function() {
        angular.element('#input-search').focus();
      }, 300);
    }

    vm.removeFilter = function() {
      vm.filter.show = false;
      vm.query.filter = '';
      vm.getItems();

      if (vm.filter.form.$dirty) {
        vm.filter.form.$setPristine();
      }
    }

    vm.getItems = function() {
      DataService.list(vm.url, vm.query)
        .then(function(response) {
          if (response) {
            vm.items = response.datos;
          }
        });
    }

    function getSedes() {
      DataService.list(restUrl + 'rotaciones/sedes')
        .then(function(response) {
          if (response) {
            vm.sedes = response.datos;
          }
        });
    }
    getSedes();

    function setHeaders(data) {
      var headers = [];
      var order = typeof vm.order == 'undefined';
      for (var i in data) {
        headers.push({
          name: data[i].key,
          title: data[i].templateOptions.label,
          order: order || (vm.order && vm.order.indexOf(data[i].key) != -1)
        });
      }
      vm.headers = headers;
    }

    function getFields() {
      DataService.fields(vm.url)
        .then(function(data) {
          if (data) {
            vm.fieldsData = Util.filterFields(data, vm.fields);
            vm.fieldsData = Util.addPropertiesFormly(vm.fieldsData, vm.formly);
            for (var i in data) {
              if (data[i].type == 'select') {
                var item = Util.searchField(vm.optionSelected, data[i].key);
                if (item) {
                  ArrayUtil.insert(data[i].templateOptions.options, 0, {
                    name: item.text || 'Seleccione',
                    value: item.value || ''
                  });
                }
              }
            }
            DataService.setFormly(vm.fieldsData);

            setHeaders(vm.fieldsData);
            if (vm.editable) {
              var types = {};
              vm.fieldsData.map(function(el) {
                types[el.key] = el;
              });
              vm.types = types;
            }
            if (vm.permission) {
              vm.permissions = angular.merge(vm.permissions, vm.permission);
            }
            vm.getItems();
          }
        });
    }

    getFields();

    vm.add = function(event) {
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'Modal', DialogPeriodosController],
        templateUrl: 'app/modules/rotaciones/periodosGestion/modules.rotaciones.dialog.periodosGestion.html'
      });
    }

    vm.openDialog = function(event, add, item) {
      var ini = item.fecha_inicio.split('/');
      item.fecha_inicio = new Date(ini[2], ini[1] - 1, ini[0]);
      var fin = item.fecha_fin.split('/');
      item.fecha_fin = new Date(fin[2], fin[1] - 1, fin[0]);
      var config = {
        event: event,
        data: item,
        title: add ? 'Agregar' : 'Editar',
        add: add,
        fields: vm.fieldsData,
        column: vm.column || 1,
        templateUrl: vm.template || 'app/components/crudTable/dialog.crudTable.html',
        done: function(answer) {
          if (answer == 'save') {
            DataService.save(vm.url + '/', parseSave(item))
              .then(function(data) {
                if (data.datos) {
                  Message.success();
                  $mdDialog.hide();
                  vm.getItems();
                }
              });
          }
        }
      };
      if (vm.dialogController) {
        config.controller = vm.dialogController;
      }
      Modal.show(config);
    }

    function parseSave(data) {
      var item = {};
      for (var i in data) {
        if (Util.toType(data[i]) == 'date') {
          item[i] = parseDate(data[i]);
        } else {
          item[i] = data[i];
        }
      }
      item.id = getId(item);
      return item;
    }

    function parseDate(date) {
      return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
    }

    function getId(item, key) {
      if (item) {
        var formly = vm.fieldsData;
        for (var i in formly) {
          if (formly[i].templateOptions.label && formly[i].templateOptions.label == 'ID') {
            if (key) {
              return formly[i].key;
            } else {
              return item[formly[i].key];
            }
          }
        }
      }
      return null;
    }
  }

  function DialogPeriodosController($scope, $mdDialog, data, restUrl, DataService, Message) {
    var vm = $scope;
    vm.item = {
      gestion: data.gestionDefecto
    };
    vm.correlativos = {
      nro_credencial: 1,
      nro_informe: 1,
      nro_resolucion: 1
    };
    vm.periodos = [];
    vm.sedes = data.sedes;

    vm.cambiarSedes = function(fid_sedes) {
      vm.periodos = [];
      vm.gestionNueva = 0;
      DataService.get(restUrl + 'parametros/par_periodo?nac=1&fid_sedes=' + fid_sedes)
        .then(function(response) {
          if (response && response.datos) {
            vm.periodos = response.datos.rows;
            var mesAux = 0;
            for (var i in vm.periodos) {
              if (vm.periodos[i].mes_fin > mesAux) {
                mesAux = vm.periodos[i].mes_fin;
              }
              if (vm.periodos[i].mes_fin < mesAux) {
                vm.gestionNueva = vm.item.gestion + 1;
                mesAux = vm.periodos[i].mes_fin;
              }
            }
          }
        });
    }
    vm.guardarPeriodos = function() {
      DataService.post(data.url, {
        gestion: vm.item.gestion,
        fid_sedes: vm.item.fid_sedes
      }).then(function(response) {
        if (response && response.datos) {
          Message.success();
          $mdDialog.hide();
          data.getItems();
          crearCorrelativos();
        } else {
          Message.error();
        }
      });
    }
    vm.close = function() {
      $mdDialog.hide();
    }
    function crearCorrelativos() {
      vm.correlativos.gestion = vm.item.gestion;
      vm.correlativos.fid_sedes = vm.item.fid_sedes;
      DataService.post(restUrl + 'rotaciones/correlativo_sedes/', vm.correlativos)
        .then(function(response) {
          if (response && response.datos) {
            Message.success();
            $mdDialog.hide();
          } else {
            Message.error();
          }
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LegalizacionesController', LegalizacionesController);

  /** @ngInject */
  function LegalizacionesController(restUrl, DataService, Message, $timeout, $scope, Modal, ConsultasService) {
    var vm = this;
    vm.url = restUrl + 'rotaciones/legalizacion';
    vm.listarLegalizaciones = listarLegalizaciones;
    vm.mostrarResolucion = mostrarResolucion;
    vm.title = "Lista de Resoluciones Administrativas Legalizadas";
    vm.buscar = buscar;
    vm.urlBuscar = restUrl + 'rotaciones/legalizacion/habilitacion/buscar/';

    // PAGINACION
    vm.showFilter = function() {
      vm.filter.show = true;
      $timeout(function() {
        angular.element('#crud-table-input').focus();
      }, 300);
    }
    vm.removeFilter = function() {
      vm.filter.show = false;
      vm.query.filter = '';

      if (vm.filter.form.$dirty) {
        vm.filter.form.$setPristine();
      }
      listarLegalizaciones();
    }
    vm.buscarFiltro = function() {
      listarLegalizaciones();
    }

    vm.selected = [];

    // Paginación
    vm.order = '';
    vm.options = {
      boundaryLinks: true
    };
    vm.query = {
      order: vm.order,
      limit: 20,
      page: 1
    };

    vm.tipo = 100;
    vm.tipos = [
      {
        value: 100,
        name: 'CI'
      },
      {
        value: 110,
        name: 'CI EXTRANJERO'
      },
      {
        value: 105,
        name: 'PASAPORTE'
      }
    ]

    // PAGINACION
    function activate() {
      listarLegalizaciones();
    }

    activate();

    function listarLegalizaciones() {
      vm.legalizaciones = [];
      DataService.list(vm.url, vm.query)
        .then(function(legalizaciones) {
          if (legalizaciones &&  legalizaciones.datos) {
            vm.legalizaciones = legalizaciones.datos;
          } else {
            Message.warning("No se encontraron legalizaciones.");
          }
      });
    }

    function mostrarResolucion(event, id_habilitacion) {
      ConsultasService.mostrarPdfBase64(event,
                                        ConsultasService.urlMostrarResolucion,
                                        { id_habilitacion: [id_habilitacion] },
                                        "Resolución Administrativa",
                                        "La resolución administrativa no se recuperó correctamente.");
    }

    function buscar(event) {
      var parametros = {
        documentoIdentidad: vm.documentoIdentidad,
        tipo: vm.tipo
      };
      DataService.post(vm.urlBuscar, parametros)
      .then(function(response) {
        if (response && response.datos) {
          vm.habilitacion = response.datos;
          Modal.show({
            event: event,
            data: vm,
            dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'Modal', DialogLegalizacionController],
            templateUrl: 'app/modules/rotaciones/legalizaciones/dialog.legalizacion.html'
          });
        } else {
          Message.warning("No se encuentra el estudiante con el documento introducido.");
        }
      });
    }
  }

  function DialogLegalizacionController($scope, $mdDialog, data, restUrl, DataService, Message) {
    var vm = $scope;
    vm.url = data.url;
    vm.habilitacion = data.habilitacion;
    vm.agregarLegalizacion = function() {
      var legalizacion = {
        observaciones: vm.legalizacion.observacion,
        codigo_deposito: vm.legalizacion.codigo_deposito,
        fid_habilitacion: vm.habilitacion.id_habilitacion
      };
      DataService.post(vm.url, legalizacion)
      .then(function(response) {
        if (response && response.datos) {
          // vm.habilitacion = response.datos;
          Message.success("Se ha guardado la legalización correctamente.");
          data.listarLegalizaciones();
          $mdDialog.hide();
        }
      });
    }
    vm.close = function() {
      $mdDialog.hide();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('HistorialFirmadosController', HistorialFirmadosController);

  /** @ngInject */
  function HistorialFirmadosController() {

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('HistorialEstudiantesController', HistorialEstudiantesController);

  /** @ngInject */
  function HistorialEstudiantesController() {
    var vm = this;
    vm.vistaPrincipal = 'rotaciones-estudiantes-enviados';
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('GradosAcademicosController', GradosAcademicosController);

  /** @ngInject */
  function GradosAcademicosController(restUrl, Util) {
    var vm = this;
    vm.title = 'Lista de tipos de Grados Académicos';
    vm.url = restUrl + 'rotaciones/grado_academico/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
      'id_grado_academico',
      'nombre',
      'descripcion'
    ];

    vm.formly = [{
      'key': 'id_grado_academico',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }];
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('GestionesController', GestionesController);

  /** @ngInject */
  function GestionesController($scope, restUrl, Util, DataService, Message, Modal, $timeout, FileSaver, $window) {
    var vm = this;
    vm.title = 'Asignación de cupos';
    vm.url = restUrl + 'rotaciones/cupo_establecimiento_salud/';

    vm.urlGestiones = restUrl + 'rotaciones/periodo/gestion';
    vm.urlPeriodos = restUrl + 'rotaciones/periodo/periodo/';
    vm.urlPeriodoSedes = restUrl + 'rotaciones/periodo_sedes/';
    vm.urlPeriodoGestion = restUrl + 'rotaciones/periodo';
    vm.urlCupos = restUrl + 'rotaciones/reporte/cupos';
    vm.fechaLimite = 'Fecha límite de inscripción';
    vm.textoCurso = 'Registrar datos del curso y examen';
    vm.permission = Util.getMenuProcess();
    vm.listarGestiones = listarGestiones;
    vm.listarPeriodos = listarPeriodos;
    vm.cambiarPeriodo = cambiarPeriodo;
    vm.editarPeriodoSedes = editarPeriodoSedes;
    vm.editarPeriodo = editarPeriodo;
    vm.agregarPeriodoSedes = agregarPeriodoSedes;
    vm.listarCorrelativos = listarCorrelativos;
    vm.editarCorrelativos = editarCorrelativos;
    vm.reporte = reporte;
    vm.tipo_cupos = 0;
    vm.ambito = 'R';

    vm.listarCupos = listarCupos;
    vm.agregarGestion = agregarGestion;

    vm.actualizarcruddatos = function() {}

    var fecha = new Date();
    vm.gestionFiltro = fecha.getFullYear();
    vm.periodoFiltro = 0;

    vm.urldata = restUrl + 'rotaciones/cupo_establecimiento_salud/gestion/' + vm.gestionFiltro;
    vm.urldatalistar = restUrl + 'rotaciones/cupo_establecimiento_salud/periodo/' + vm.gestionFiltro + '/';

    vm.fieldsPeriodo = [
      'id_periodo',
      // 'gestion',
      'fecha_inicio'
      // 'fecha_fin'
    ];

    vm.formlyPeriodo = [{
      'key': 'id_periodo',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }];

    vm.showFilter = function() {
      vm.filter.show = true;
      $timeout(function() {
        angular.element('#crud-table-input').focus();
      }, 300);
    }
    vm.removeFilter = function() {
      vm.filter.show = false;
      vm.query.filter = '';

      if (vm.filter.form.$dirty) {
        vm.filter.form.$setPristine();
      }
      listarCupos();
    }
    vm.buscarFiltro = function() {
        listarCupos();
      }
      // Paginación
    vm.order = '';
    vm.options = {
      boundaryLinks: true
    };
    vm.query = {
      order: vm.order,
      limit: 20,
      page: 1
    };

    function listarGestiones() {
      DataService.get(vm.urlGestiones)
        .then(function(gestiones) {
          if (gestiones && gestiones.datos) {
            vm.gestiones = gestiones.datos;
          } else {
            Message.warning("Aún no se ha generado períodos para ninguna gestión.");
          }
        });
    }

    function listarPeriodos() {
      vm.periodoFiltro = 0;
      DataService.get(vm.urlPeriodos + vm.gestionFiltro)
        .then(function(periodos) {
          if (periodos && periodos.datos) {
            vm.periodos = periodos.datos;
            vm.urldata = restUrl + 'rotaciones/cupo_establecimiento_salud/gestion/' + vm.gestionFiltro;
            // vm.query.periodo = 0;
            if (vm.periodos.length > 0) {
              for (var q in vm.periodos) {
                if ($window.sessionStorage.id_periodo_seleccionado && $window.sessionStorage.id_periodo_seleccionado == vm.periodos[q].id_periodo) {
                  vm.query.periodo = vm.periodos[q].id_periodo;
                  vm.periodoFiltro = vm.periodos[q];
                }
              }
              if (vm.periodoFiltro == 0) {
                vm.query.periodo = vm.periodos[0].id_periodo;
                vm.periodoFiltro = vm.periodos[0];
              }
            }
            vm.listarCupos();
            vm.listarCorrelativos();
          } else {
            Message.warning("No hay períodos registrados en la gestión seleccionada.");
          }
        });
    }

    function listarCupos() {
      vm.query.tipo_cupos = vm.tipo_cupos;
      vm.query.ambito = vm.ambito;
      vm.urldatalistar = restUrl + 'rotaciones/cupo_establecimiento_salud/periodo/' + vm.gestionFiltro + '/';
      DataService.list(vm.urldatalistar + vm.query.periodo, vm.query)
        .then(function(response) {
          vm.cupos = [];
          if (response && response.datos.rows && response.datos.rows.length > 0) {
            vm.cupos = response.datos;
            for (var i in vm.cupos.rows) {
              if (vm.cupos.rows[i].cupos.length == 0) {
                vm.cupos.rows[i].cupos = vm.cupos.rows[i].cuposCarreras;
              }
            }
          } else {
            Message.warning("No hay registro de cupos.");
          }
        });
    }

    function cambiarPeriodo() {
      vm.query.periodo = 0;
      vm.urldata = restUrl + 'rotaciones/cupo_establecimiento_salud/gestion/' + vm.gestionFiltro + '/';
      if (vm.periodoFiltro !== 0) {
        vm.query.periodo = vm.periodoFiltro.id_periodo;
      }
      vm.listarCupos();
    }

    function getCarreras() {
      DataService.list(restUrl + 'rotaciones/tipo_carrera')
        .then(function(response) {
          if (response) {
            vm.carreras = response.datos;
          }
        });
    }

    function getFormlyPeriodoSedes() {
      DataService.fields(vm.urlPeriodoSedes)
        .then(function(response) {
          if (response) {
            vm.optionsPeriodoSedes = response;
            vm.fieldsPeriodoSedes = Util.filterFields(response, vm.fieldsPeriodoSedes);
            vm.fieldsPeriodoSedes = Util.addPropertiesFormly(vm.fieldsPeriodoSedes, vm.formlyPeriodoSedes);
            DataService.setFormly(vm.fieldsPeriodoSedes);
          }
        });
    }

    function getFormlyPeriodoSedesOrdenar(periodoSel) {
      vm.fieldsPeriodoSedes = [
        'id_periodo_sedes',
        'lugar_curso',
        'fecha_curso',
        'hora_curso',
        'lugar_examen',
        'fecha_examen',
        'hora_examen',
        'nota_minima',
        'observaciones'
      ];

      vm.formlyPeriodoSedes = [{
        'key': 'id_periodo_sedes',
        'templateOptions': {
          'label': 'ID',
          required: false
        }
      }, {
        'key': 'hora_curso',
        'templateOptions': {
          'type': 'text'
        }
      }, {
        'key': 'hora_examen',
        'templateOptions': {
          'type': 'text'
        }
      }, {
        'key': 'nota_minima',
        'defaultValue': 51
      },{
        'key': 'fecha_examen',
        'templateOptions': {
          minDate: periodoSel.fecha_inicio,
          required: true
         }
      }];
      if (vm.ocultarExamen) {
        vm.fieldsPeriodoSedes = [
          'id_periodo_sedes',
          'fecha_examen'
        ];
        vm.formlyPeriodoSedes = [{
          'key': 'id_periodo_sedes',
          'templateOptions': {
            'label': 'ID',
            required: false
          }
        }, {
          'key': 'fecha_examen',
          'templateOptions': {
            'label': vm.fechaLimite,
            // maxDate: new Date(periodoSel.fecha_inicio),
            required: true
          }
        }];
      }
      vm.fieldsPeriodoSedes = Util.filterFields(vm.optionsPeriodoSedes, vm.fieldsPeriodoSedes);
      vm.fieldsPeriodoSedes = Util.addPropertiesFormly(vm.fieldsPeriodoSedes, vm.formlyPeriodoSedes);
      DataService.setFormly(vm.fieldsPeriodoSedes);
    }

    function agregarPeriodoSedes(event, id_periodo_sedes, periodoSel) {
      var data = {};
      data.datos = {
        fid_periodo: id_periodo_sedes
      };
      getFormlyPeriodoSedesOrdenar(periodoSel);
      Modal.show({
        event: event,
        data: data.datos,
        title: vm.textoCurso,
        fields: vm.fieldsPeriodoSedes,
        templateUrl: 'app/components/crudTable/dialog.crudTable.html',
        done: function(answer, $mdDialog) {
          if (answer == 'save') {
            DataService.save(vm.urlPeriodoSedes, data.datos)
              .then(function(response) {
                if (response && response.datos) {
                  $mdDialog.hide();
                  vm.listarPeriodos();
                  Message.success(response.mensaje);
                }
              });
          }
        }
      });
    }

    function editarPeriodoSedes(event, id_periodo_sedes, periodoSel) {
      DataService.get(vm.urlPeriodoSedes + id_periodo_sedes)
        .then(function(data) {
          if (data && data.datos) {
            if (data.datos.fecha_curso != null)
              data.datos.fecha_curso = new Date(data.datos.fecha_curso);
            data.datos.fecha_examen = new Date(data.datos.fecha_examen);
            data.datos.nota_minima = Number(data.datos.nota_minima);
            getFormlyPeriodoSedesOrdenar(periodoSel);
            Modal.show({
              event: event,
              data: data.datos,
              title: vm.textoCurso,
              fields: vm.fieldsPeriodoSedes,
              templateUrl: 'app/components/crudTable/dialog.crudTable.html',
              done: function(answer, $mdDialog) {
                if (answer == 'save') {
                  DataService.put(vm.urlPeriodoSedes + data.datos.id_periodo_sedes, data.datos)
                    .then(function(response) {
                      if (response && response.datos) {
                        $mdDialog.hide();
                        vm.listarPeriodos();
                        Message.success(response.mensaje);
                      }
                    });
                }
              }
            });
          }
        });
    }

    function getFormlyPeriodo() {
      DataService.fields(vm.urlPeriodoGestion)
        .then(function(response) {
          if (response) {
            vm.fieldsPeriodo = Util.filterFields(response, vm.fieldsPeriodo);
            vm.fieldsPeriodo = Util.addPropertiesFormly(vm.fieldsPeriodo, vm.formlyPeriodo);
            DataService.setFormly(vm.fieldsPeriodo);
          }
        });
    }

    function editarPeriodo(event, id_periodo) {
      DataService.get(vm.urlPeriodoGestion + '/' + id_periodo)
        .then(function(data) {
          if (data && data.datos) {
            data.datos.fecha_inicio = new Date(data.datos.fecha_inicio);
            data.datos.fecha_fin = new Date(data.datos.fecha_fin);
            Modal.show({
              event: event,
              data: data.datos,
              title: 'Editar periodo',
              fields: vm.fieldsPeriodo,
              templateUrl: 'app/components/crudTable/dialog.crudTable.html',
              done: function(answer, $mdDialog) {
                if (answer == 'save') {
                  DataService.put(vm.urlPeriodoGestion + '/actualizar/' + data.datos.id_periodo, data.datos)
                    .then(function(response) {
                      if (response && response.datos) {
                        $mdDialog.hide();
                        vm.listarPeriodos();
                        Message.success(response.mensaje);
                      }
                    });
                }
              }
            });
          }
        });
    }

    function agregarGestion(event) {
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogPeriodosController],
        templateUrl: 'app/modules/rotaciones/periodosGestion/modules.rotaciones.dialog.periodosGestion.html'
      });
    }

    function getSedes() {
      DataService.list(restUrl + 'rotaciones/sedes')
        .then(function(response) {
          if (response) {
            vm.sedes = response.datos;
            if (vm.sedes && vm.sedes.length == 1) {
              vm.ocultarExamen = vm.sedes[0].tipo;
              vm.textoCurso = 'Registrar fecha límite de inscripción';
              vm.fieldsPeriodoSedes = [
                'id_periodo_sedes',
                'fecha_examen'
              ];
              vm.formlyPeriodoSedes = [{
                'key': 'id_periodo_sedes',
                'templateOptions': {
                  'label': 'ID',
                  required: false
                }
              }, {
                'key': 'fecha_examen',
                'templateOptions': {
                  'label': vm.fechaLimite
                }
              }];
              getFormlyPeriodoSedes();
            }
          }
        });
    }

    function listarCorrelativos() {
      DataService.get(restUrl + 'rotaciones/correlativo_sedes/gestion/' + vm.gestionFiltro)
        .then(function(response) {
          if (response && response.datos) {
            vm.correlativos = response.datos;
          }
        });
    }

    function editarCorrelativos(event) {
      if (vm.correlativos) {
        Modal.show({
          event: event,
          data: vm,
          dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'Modal', DialogCorrelativosController],
          templateUrl: 'app/modules/rotaciones/gestiones/modules.rotaciones.dialog.correlativos.html'
        });
      } else {
        Message.error("No se han encontrado los correlativos correspondientes.");
      }

    }

    function reporte() {
      DataService.pdf2(vm.urlCupos, {
        gestion: vm.gestionFiltro,
        periodo: vm.periodoFiltro,
        tipo_cupos: vm.tipo_cupos,
        ambito: vm.ambito
      })
      .then(function(data) {
        data = new Blob([data.data], {type: 'application/vnd.oasis.opendocument.spreadsheet'});
        FileSaver.saveAs(data, 'cupos.ods');
      });
    }

    function activate() {
      listarGestiones();
      listarPeriodos();
      getCarreras();
      listarCupos();
      getSedes();

      getFormlyPeriodo();
    }

    activate();

  }

  function DialogCorrelativosController($scope, $mdDialog, data, restUrl, DataService, Message) {
    var vm = $scope;
    vm.correlativos = data.correlativos;
    vm.item = {
      nro_informe: data.correlativos.nro_informe,
      nro_credencial: data.correlativos.nro_credencial,
      nro_resolucion: data.correlativos.nro_resolucion
    };
    vm.guardarCorrelativos = function() {
      DataService.put(restUrl + 'rotaciones/correlativo_sedes/' + vm.correlativos.id_correlativo_sedes, vm.item)
        .then(function(response) {
          if (response && response.datos) {
            data.listarCorrelativos();
            Message.success();
            $mdDialog.hide();
          } else {
            Message.error();
          }
        });
    }
    vm.close = function() {
      $mdDialog.hide();
    }
  }

  function DialogPeriodosController($scope, $mdDialog, data, restUrl, DataService, Message) {
    var vm = $scope;
    vm.item = {
      gestion: data.gestionFiltro
    };
    vm.correlativos = {
      nro_credencial: 1,
      nro_informe: 1,
      nro_resolucion: 1
    };
    vm.periodos = [];
    vm.sedes = data.sedes;

    vm.cambiarSedes = function(fid_sedes) {
      vm.periodos = [];
      vm.gestionNueva = 0;
      DataService.get(restUrl + 'parametros/par_periodo?nac=1&fid_sedes=' + fid_sedes)
        .then(function(response) {
          if (response && response.datos) {
            vm.periodos = response.datos.rows;
            var mesAux = 0;
            for (var i in vm.periodos) {
              if (vm.periodos[i].mes_fin > mesAux) {
                mesAux = vm.periodos[i].mes_fin;
              }
              if (vm.periodos[i].mes_fin < mesAux) {
                vm.gestionNueva = vm.item.gestion + 1;
                mesAux = vm.periodos[i].mes_fin;
              }
            }
          }
        });
    }
    vm.guardarPeriodos = function() {
      DataService.post(restUrl + 'rotaciones/periodo/', {
        gestion: vm.item.gestion,
        fid_sedes: vm.item.fid_sedes
      }).then(function(response) {
        if (response && response.datos) {
          Message.success();
          $mdDialog.hide();
          data.gestionFiltro = vm.item.gestion;
          data.listarGestiones();
          data.listarCupos();
          data.listarPeriodos();
          crearCorrelativos();
        } else {
          Message.error();
        }
      });
    }
    vm.close = function() {
      $mdDialog.hide();
    }

    function activate() {
      if (vm.sedes && vm.sedes.length == 1) {
        vm.item.fid_sedes = vm.sedes[0].id_sedes;
        vm.cambiarSedes(vm.item.fid_sedes);
        vm.bloquearSedes = true;
      }
    }
    activate();

    function crearCorrelativos() {
      vm.correlativos.gestion = vm.item.gestion;
      DataService.post(restUrl + 'rotaciones/correlativo_sedes/', vm.correlativos)
        .then(function(response) {
          if (response && response.datos) {
            Message.success();
            $mdDialog.hide();
          } else {
            Message.error();
          }
        });
    }
  }

  angular.module('app')
    .controller('CuposController', function($scope, $timeout, $document, DataService, Message, restUrl) {
      var vm = $scope;
      vm.url = restUrl + 'rotaciones/cupo_establecimiento_salud/';
      var timeout = null;
      var debounceUpdate = function(newVal, oldVal) {
        if (newVal != oldVal) {
          if (timeout) {
            $timeout.cancel(timeout)
          }
          timeout = $timeout(guardarCupo, 500);
        }
      };
      $scope.$watch('c.cupos', debounceUpdate);

      function guardarCupo() {
        var cupoEnviar = {
          fid_establecimiento_salud: vm.cupo.id_establecimiento_salud,
          fid_periodo: vm.gestiones.periodoFiltro.id_periodo,
          gestion: vm.gestiones.gestionFiltro,
          tipo_carrera: []
        };
        for (var i in vm.cupo.cupos) {
          cupoEnviar.tipo_carrera.push({
            cupos: vm.cupo.cupos[i].cupos ? vm.cupo.cupos[i].cupos : 0,
            id_tipo_carrera: vm.cupo.cupos[i].tipo_carrera.id_tipo_carrera
          });
        }
        if (vm.c.id_cupo_establecimiento_salud == 0) {
          DataService.post(vm.url, cupoEnviar)
          .then(function(response) {
            if (response && response.datos) {
              vm.gestiones.listarCupos();
              // Message.success("Cupo modificado correctamente.");
            }
          });
        } else {
          if (vm.c.cupos) {
            DataService.put(vm.url + vm.c.id_cupo_establecimiento_salud, {cupos: vm.c.cupos})
            .then(function(response) {
              if (response && response.datos) {
                Message.success("Cupo modificado correctamente.");
              }
            });
          } else {
            Message.error("Debe escribir una cantidad de cupos válida.");
          }
        }

      }

    });

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('EstudiantesController', EstudiantesController);

  /** @ngInject */
  function EstudiantesController($scope, restUrl, Modal, DataService, Util, Message, $timeout) {
    var vm = this;
    vm.permission = Util.getMenuProcess();
    vm.title = 'Lista de estudiantes';
    vm.url = restUrl + 'rotaciones/estudiante/';
    vm.urlGestiones = restUrl + 'rotaciones/periodo/gestion';
    vm.urlPeriodos = restUrl + 'rotaciones/periodo/periodo/';
    vm.urlPeriodoActual = restUrl + "rotaciones/periodo_actual/";
    vm.urlAutorizar = restUrl + 'rotaciones/estudiante_autorizar';
    vm.urlDesAutorizar = restUrl + 'rotaciones/estudiante_desautorizar/';

    vm.agregarEstudiante = agregarEstudiante;
    vm.editarEstudiante = editarEstudiante;
    vm.listarEstudiantes = listarEstudiantes;
    vm.listarPeriodos = listarPeriodos;
    vm.autorizarEstudiantes = autorizarEstudiantes;
    vm.eliminarEstudiante = eliminarEstudiante;

    vm.showFilter = function() {
      vm.filter.show = true;
      $timeout(function () {
          angular.element('#crud-table-input').focus();
      }, 300);
    }
    vm.removeFilter = function() {
      vm.filter.show = false;
      vm.query.filter = '';

      if(vm.filter.form.$dirty) {
          vm.filter.form.$setPristine();
      }
      listarEstudiantes();
    }
    vm.buscarFiltro = function() {
      listarEstudiantes();
    }

    vm.selected = [];

    // Paginación
    vm.order = '';
    vm.options = {
      boundaryLinks: true
    };
    vm.query = {
      order: vm.order,
      limit: 20,
      page: 1
    };

    activate();

    function activate() {
      obtenerPeriodoActual();
      listarEstudiantes();
      getSedesUniversitariasCarreras();
      obtenerTipoSedes();
      obtenerDepositoSedes();
      obtenerIdSedes();
      getCasosEspeciales();
    }

    function obtenerTipoSedes() {
      // Obtener periodo actual
      DataService.get(restUrl + "rotaciones/sedes/obtener/tipo")
        .then(function(response) {
          if (response && response.datos) {
            vm.tipoSedes = response.datos.tipo;
          }
        });
    }
    function obtenerDepositoSedes() {
      // Obtener periodo actual
      DataService.get(restUrl + "rotaciones/sedes/obtener/deposito")
        .then(function(response) {
          if (response && response.datos) {
            vm.depositoSedes = response.datos.deposito;
          }
        });
    }

    function obtenerIdSedes() {
      // Obtener sedes actual
      DataService.get(restUrl + "rotaciones/sedes/obtener/id_sedes")
        .then(function(response) {
          if (response && response.datos) {
            vm.id_sedes = response.datos.id_sedes;
          }
        });
    }


    function obtenerPeriodoActual() {
      // Obtener periodo actual
      DataService.get(vm.urlPeriodoActual)
        .then(function(response) {
          if (response && response.datos) {
            vm.gestionFiltro = response.datos.gestion;
            vm.periodoFiltro = response.datos.id_periodo;
            vm.periodoNumero = response.datos.numero;
            listarGestiones(false);
          }
        });
    }
    function getCasosEspeciales() {
      DataService.list(restUrl + 'parametros/parametro/caso_especial')
        .then(function(response) {
          if (response && response.datos) {
            vm.casosEspeciales = response.datos;
          } else {
            Message.warning("No se encontraron casos especiales registrados.");
          }
        });
    }

    function listarEstudiantes() {
      DataService.list(vm.url, vm.query)
        .then(function(response) {
          vm.estudiantes = [];
          if (response && response.datos.rows && response.datos.rows.length > 0) {
            vm.estudiantes = response.datos;
          } else {
            Message.info("No se encontraron estudiantes registrados.");
          }
        });
    }

    function agregarEstudiante(event) {
      vm.estudianteSeleccionado = null;
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', 'OpcionesNombreCompleto', DialogEstudianteController],
        templateUrl: 'app/modules/rotaciones/estudiantes/create.dialog.html'
      });
    }

    function editarEstudiante(event, id_habilitacion) {
      DataService.get(vm.url + id_habilitacion)
        .then(function(response) {
          var item = response.datos;
          vm.estudianteSeleccionado = filterItem(item);
          vm.estudianteSeleccionado.persona.fecha_nacimiento = new Date(vm.estudianteSeleccionado.persona.fecha_nacimiento);
          vm.mostrarEdicionPersona = true;
          Modal.show({
            event: event,
            data: vm,
            title: 'Editar datos del estudiante',
            dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogEstudianteController],
            templateUrl: 'app/modules/rotaciones/estudiantes/edit.dialog.html'
          });
        });
    }

    function eliminarEstudiante(event, id_estudiante) {
      Modal.confirm('Se eliminará el registro de forma permanente, ¿Está seguro?.', function() {
        DataService.put(vm.urlDesAutorizar + id_estudiante, {})
        .then(function() {
          Message.success('El registro se eliminó correctamente.');
          vm.listarEstudiantes();
        })
        .catch(function() {
          Message.error();
        });
      }, null, event);
    }

    function filterItem(data) {
      for (var i in data) {
        if (i.indexOf('fecha') != -1 && data[i]) {
          data[i] = new Date(data[i]);
        }
      }
      return data;
    }

    function getSedesUniversitariasCarreras() {
      vm.carreras = [];
      vm.sedesUniversitarias = [];
      DataService.list(restUrl + 'rotaciones/sede_seleccionar')
        .then(function(response) {
          if (response && response.datos) {
            vm.sedesUniversitarias = response.datos.rows;
            if (vm.sedesUniversitarias.length == 1) {
              getCarreras(vm.sedesUniversitarias[0].id_sede);
            }
          }
        });
    }

    function getCarreras(id_sede) {
      DataService.list(restUrl + 'rotaciones/carrera/listar/' + id_sede)
        .then(function(response) {
          if (response && response.datos) {
            vm.carreras = response.datos;
          } else {
            Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
          }
        });
    }

    function listarGestiones(actualizar) {
      DataService.get(vm.urlGestiones)
        .then(function(gestiones) {
          vm.gestiones = [];
          if (gestiones && gestiones.datos) {
            vm.gestiones = gestiones.datos;
            listarPeriodos(actualizar);
          } else {
            Message.warning("Aún no se ha generado períodos para ninguna gestión.");
          }
        });
    }

    function listarPeriodos(actualizar) {
      DataService.get(vm.urlPeriodos + vm.gestionFiltro)
        .then(function(periodos) {
          vm.periodos = [];
          if (periodos && periodos.datos) {
            vm.periodos = periodos.datos;
            if (vm.periodos.length > 0 && actualizar) {
              vm.periodoFiltro = vm.periodos[0].id_periodo;
              vm.periodoNumero = vm.periodos[0].numero;
            }
          } else {
            Message.warning("No hay períodos registrados en la gestión seleccionada.");
          }
        });
    }

    function autorizarEstudiantes(event) {
      if (vm.selected && vm.selected.length > 0) {

        Modal.confirm('Los estudiantes seleccionados serán habilitados para la asignación a un establecimiento de salud en SEDES para la rotación ' + obtenerNumeroPeriodo(vm.periodoFiltro) + ' - ' + vm.gestionFiltro + '. ¿Desea continuar?' , function() {
          var enviarAutoizar = {
            fid_periodo: vm.periodoFiltro,
            estudiantes: vm.selected
          };
          DataService.post(vm.urlAutorizar, enviarAutoizar)
            .then(function(response) {
              vm.selected = [];
              listarEstudiantes();
              if (response && response.mensaje) {
                Message.success(response.mensaje);
              }
            });
        }, null, event);
      } else {
        Message.warning("Debe seleccionar al menos un estudiante para autorizar a SEDES.");
      }
    }

    function obtenerNumeroPeriodo(id_periodo) {
      for (var i in vm.periodos) {
        if (vm.periodos[i].id_periodo == id_periodo) {
          return vm.periodos[i].numero;
        }
      }
      return '';
    }

  }

  function DialogEstudianteController($scope, $mdDialog, data, restUrl, DataService, Message, OpcionesNombreCompleto) {
    var vm = $scope;
    vm.carreras = data.carreras;
    vm.getCarreras = data.getCarreras;
    vm.mostrarNota = true;
    vm.mostrarDeposito = true;
    vm.mostrarCasoEspecial = false;
    // variable para mostrar el campo de Condicion especial
    // deberia ser un valor parametrizable desde el administrador del sedes
    // es true en el caso de el sedes y false en el caso de las universidades
    vm.mostrar = true;
    vm.sedesUniversitarias = data.sedesUniversitarias;
    vm.tipoSedes = data.tipoSedes;
    vm.depositoSedes = data.depositoSedes;
    vm.id_sedes = data.id_sedes;
    vm.casosEspeciales = data.casosEspeciales;
    vm.mostrarEdicionPersona = data.mostrarEdicionPersona;

    if (data.estudianteSeleccionado) {
      vm.estudiante = data.estudianteSeleccionado;

      // TODO: 1. Borrar cuando ya haya edición de persona
      if (vm.sedesUniversitarias.length == 1) {
        vm.estudiante.fid_sede = vm.sedesUniversitarias[0].id_sede;
        vm.congelarSede = true;
      }
      if (vm.carreras.length == 1) {
        vm.estudiante.fid_carrera = vm.carreras[0].id_carrera;
      }
      // TODO: 1. fin

    } else {
      vm.estudiante = {
        estudiante: {}
      };
      // TODO: 2. Sacar afuera cuando ya haya edición de persona
      if (vm.sedesUniversitarias.length == 1) {
        vm.estudiante.estudiante.fid_sede = vm.sedesUniversitarias[0].id_sede;
        vm.congelarSede = true;
      }
      if (vm.carreras.length == 1) {
        vm.estudiante.estudiante.fid_carrera = vm.carreras[0].id_carrera;
      }
      // TODO: 2. fin
    }

    vm.opcionesNombre = [];
    function cambiaOpciones () {
      if (vm.estudiante.persona) {
        vm.opcionesNombre = OpcionesNombreCompleto.crearOpciones(vm.estudiante.persona.nombres, vm.estudiante.persona.primer_apellido, vm.estudiante.persona.segundo_apellido, vm.estudiante.persona.casada_apellido);
        vm.estudiante.persona.nombre_completo_documento_identidad = '';
      }
    }
    // TODO agregar debounce a la función cambiar opciones, de preferencia en un Factory, esto evitará que la función se llame demasiadas veces
    $scope.$watch('estudiante.persona.nombres', cambiaOpciones);
    $scope.$watch('estudiante.persona.primer_apellido', cambiaOpciones);
    $scope.$watch('estudiante.persona.segundo_apellido', cambiaOpciones);
    $scope.$watch('estudiante.persona.casada_apellido', cambiaOpciones);

    function actualizar(response) {
      if (response && response.datos) {
        Message.success(response.mensaje);
        data.listarEstudiantes();
        $mdDialog.cancel();
      }
    }
    vm.guardarEstudiante = function(pasar) {
      if (vm.estudiante.persona.encontrado === -1 && !vm.estudiante.persona.primer_apellido && !vm.estudiante.persona.segundo_apellido) {
        Message.error("Debe registrar al menos un apellido.");
      } else {
        if (vm.estudiante.persona.extranjero && !pasar) {
          vm.mostrarConfirmacion = true;
        } else {
          DataService.save(data.url, vm.estudiante)
            .then(function(response) {
              actualizar(response);
            });
        }
      }
    }
    vm.cerrarConfirmacion = function() {
      vm.mostrarConfirmacion = false;
    }
    vm.editarEstudiante = function() {
      if (vm.estudiante.persona.fid_tipo_documento == 105 && !vm.estudiante.persona.primer_apellido && !vm.estudiante.persona.segundo_apellido) {
        Message.error("Debe registrar al menos un apellido.");
      } else {
        DataService.put(data.url + vm.estudiante.id_estudiante, vm.estudiante)
          .then(function(response) {
            actualizar(response);
          });
      }
    }
    vm.cambiarSedeUniversitaria = function() {
      vm.estudiante.estudiante.fid_carrera = null;
      vm.carreras = [];
      DataService.list(restUrl + 'rotaciones/carrera/listar/' + vm.estudiante.estudiante.fid_sede)
        .then(function(response) {
          if (response && response.datos) {
            vm.carreras = response.datos;
          } else {
            Message.warning("No se encontraron carreras registradas para la Sede Universitaria seleccionada.");
          }
        });
    }
    vm.close = function() {
      $mdDialog.cancel();
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('EstablecimientosSaludController', EstablecimientosSaludController);

  /** @ngInject */
  function EstablecimientosSaludController(restUrl, Modal, DataService, Message, Util) {
    var vm = this;
    vm.permission = Util.getMenuProcess();
    vm.ocultarCreate = true;
    vm.permission.acciones_ocultar = true;
    vm.title = 'Lista de establecimientos de salud';
    vm.url = restUrl + 'rotaciones/establecimiento_salud/';

    vm.fields = [
      'codigo',
      'establecimiento',
      'nom_depto',
      'nom_prov',
      'nom_municipio',
      'red',
      'ambito'
    ];
    vm.formly = [{
      'key': 'id_establecimiento_salud',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }];

    vm.botones = [{
      tooltip: 'Actualizar establecimientos',
      texto: 'Actualizar establecimientos',
      icon: 'refresh',
      onclick: function(event, a, b, getItems) {
        Modal.confirm('Se actualizarán los Establecimientos de Salud según la base de datos del SNIS. Esta operación puede tardar unos minutos. ¿Desea continuar?', function() {
          DataService.get(restUrl + 'rotaciones/establecimiento_salud/snis/')
            .then(function(response) {
              if (response && response) {
                Message.success("Los establecimientos de salud han sido actualizados correctamente.")
                getItems();
              }
            })
            .catch(function() {
              Message.error();
            });
        }, null, event);
      }
    }];

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('CorreccionesPostulacionesController', CorreccionesPostulacionesController);

  /** @ngInject */
  function CorreccionesPostulacionesController($scope, restUrl, Util, DataService, Message, Modal, $window) {
    var vm = this;
    vm.url = restUrl + "habilitacion/busqueda/correccion/";
    vm.urlPersona = restUrl + "persona/";
    vm.urlActualizarPersona = restUrl + "persona/servicio/segip/actualizar/";
    vm.texto = "Buscar";
    vm.permission = Util.getMenuProcess();
    vm.buscar = buscar;

    vm.refresh = refresh;
    vm.editarEstado = editarEstado;
    vm.actualizarPersona = actualizarPersona;

    vm.tipo = 100;
    vm.tipos = [
      {
        value: 100,
        name: 'CI'
      },
      {
        value: 110,
        name: 'CI EXTRANJERO'
      },
      {
        value: 105,
        name: 'PASAPORTE'
      }
    ]

    activate();

    function activate() {
      var documento = $window.sessionStorage.getItem("documento_identidad_buscado_correcciones");
      if (documento) {
        documento = angular.fromJson(documento);
        if (documento.documentoIdentidad) {
          vm.documentoIdentidad = documento.documentoIdentidad;
          vm.tipo = documento.tipo
        }
      }
      buscar();
      getCasosEspeciales();
    }

    function refresh() {
      vm.habilitaciones = null;
    }

  function getCasosEspeciales() {
    DataService.list(restUrl + 'parametros/parametro/caso_especial')
      .then(function(response) {
        if (response && response.datos) {
          vm.casosEspeciales = response.datos;
        } else {
          Message.warning("No se encontraron casos especiales registrados.");
        }
      });
  }

    function buscar() {
      if (vm.documentoIdentidad) {
        var parametros = {
          documento_identidad: vm.documentoIdentidad,
          tipo: vm.tipo
        };
        DataService.post(vm.url, parametros)
        .then(function(response) {
          if (response && response.datos) {
            $window.sessionStorage.setItem("documento_identidad_buscado_correcciones", angular.toJson({documentoIdentidad: vm.documentoIdentidad, tipo: vm.tipo}));
            vm.habilitaciones = response.datos;
          } else {
            Message.warning("No se encuentra el estudiante con el documento introducido.");
          }
        });
      }
    }

    function actualizarPersona(event, id_persona) {
      DataService.put(vm.urlActualizarPersona + id_persona, {})
      .then(function(response) {
        if (response && response.datos) {
          vm.habilitaciones[0].estudiante.persona.nombres = response.datos.nombres;
          vm.habilitaciones[0].estudiante.persona.primer_apellido = response.datos.primer_apellido;
          vm.habilitaciones[0].estudiante.persona.segundo_apellido = response.datos.segundo_apellido;
          Message.success(response.mensaje);
        }
      });
    }

    function editarEstado(event, habilitacion) {
      vm.habilitacionSeleccionada = habilitacion;
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'DataService', 'restUrl', 'Message', PersonaController],
        templateUrl: 'app/modules/rotaciones/correccionesPostulaciones/dialog.correccionesPostulaciones.html'
      });
    }

  }
  function PersonaController($scope, $mdDialog, data, DataService, restUrl, Message) {
    var vm = $scope;
    vm.habilitacion = data.habilitacionSeleccionada;
    vm.casosEspeciales = data.casosEspeciales;

    vm.guardarHabilitacion = function() {
      if (vm.habilitacion.estado_cambiar && vm.habilitacion.estado_cambiar != 0) {
        var datos = {
          habilitacion: {
            estado_cambiar: vm.habilitacion.estado_cambiar,
            asignacion_manual: vm.habilitacion.asignacion_manual == 'OTROS' ? vm.habilitacion.asignacion_manual_descripcion : vm.habilitacion.asignacion_manual
          }
        };
        DataService.put(data.url + vm.habilitacion.id_habilitacion, datos)
        .then(function(response) {
          if (response && response.datos) {
            data.buscar();
            Message.success(response.mensaje);
            $mdDialog.hide();
          }
        });
      } else {
        Message.warning("No hay cambios disponibles.");
      }
    }
    vm.close = function() {
      $mdDialog.hide();
    }
  }
 })();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('CarrerasController', CarrerasController);

  /** @ngInject */
  function CarrerasController(restUrl, Util, DataService, $stateParams, $location) {
    var vm = this;
    var params = $stateParams;
    vm.title = 'Lista de Carreras';
    vm.url = restUrl + 'rotaciones/carrera/';
    vm.urldata = restUrl + 'rotaciones/carrera/listar/' + params.idSede;
    vm.urlUniversidad = restUrl + 'rotaciones/universidad/';
    vm.urlSede = restUrl + 'rotaciones/sede/';
    vm.volverSedesUniversidades = volverSedesUniversidades;

    vm.permission = {
      delete: false
    };

    vm.fields = [
      'id_carrera',
      'fid_sede',
      'nombre',
      'codigo',
      'resolucion',
      // 'fid_grado_academico',
      'fid_tipo_carrera'
    ];

    vm.formly = [{
      'key': 'id_carrera',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }, {
      'key': 'fid_sede',
      'defaultValue': params.idSede,
      'templateOptions': {
        required: false
      },
      'expressionProperties': {
        'templateOptions.disabled': 'model.fid_sede'
      }
    }];

    // vm.fks = ['fid_grado_academico', 'fid_tipo_carrera', 'fid_sede'];
    vm.fks = ['fid_tipo_carrera', 'fid_sede'];

    function volverSedesUniversidades() {
      $location.path('/rotaciones/sedesUniversitarias/' + vm.universidad.id_universidad);
    }

    function obtenerDatosSedeUniversidad() {
      DataService.get(vm.urlSede + params.idSede)
      .then(function(sede) {
        vm.sede = sede.datos;
        if (vm.sede.fid_universidad) {
          DataService.get(vm.urlUniversidad + vm.sede.fid_universidad)
          .then(function(universidad) {
            vm.universidad = universidad.datos;
          });
        }
      });
    }

    function activate() {
      obtenerDatosSedeUniversidad();
    }

    activate();
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AsignacionesEstudiantesController', AsignacionesEstudiantesController);

  /** @ngInject */
  function AsignacionesEstudiantesController() {

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AsignacionesController', AsignacionesController);

  /** @ngInject */
  function AsignacionesController() {
    
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PeriodosSedesController', PeriodosSedesController);

  /** @ngInject */
  function PeriodosSedesController(restUrl, Util) {
    var vm = this;
    vm.title = 'Lista de datos del curso de inducción por período';
    vm.url = restUrl + 'rotaciones/periodo_sedes/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
      'id_periodo_sedes',
      // 'fid_sedes',
      'fid_periodo',
      'lugar_curso',
      'fecha_curso',
      'hora_curso',
      'lugar_examen',
      'fecha_examen',
      'hora_examen',
      'observaciones',
      'estado'
    ];

    vm.fks = ['fid_sedes', 'fid_periodo'];

    vm.formly = [{
      'key': 'id_periodo_sedes',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    },{
      'key': 'estado',
      'hideExpression': 'true'
    },{
      'key': 'hora_curso',
      'templateOptions': {
        'type': 'text'
      }
    },{
      'key': 'hora_examen',
      'templateOptions': {
        'type': 'text'
      }
    }];
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ParSedesController', ParSedesController);

  /** @ngInject */
  function ParSedesController(restUrl, Util) {
    var vm = this;
    vm.title = 'Lista de parámetros por SEDES';
    vm.url = restUrl + 'parametros/par_sedes/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
      'id_par_sedes',
      // 'fid_sedes',
      'cargo_tecnico',
      'nombre_tecnico',
      'cargo_asesor',
      'nombre_asesor',
      'cargo_director',
      'nombre_director',
      // 'correo',
      // 'correo_contrasena',
      'estado'
    ];

    vm.fks = ['fid_sedes'];

    vm.formly = [{
      'key': 'id_par_sedes',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    },{
      'key': 'estado',
      'hideExpression': 'true'
    }];
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ParPeriodosController', ParPeriodosController);

  /** @ngInject */
  function ParPeriodosController(restUrl, Util) {
    var vm = this;
    vm.title = 'Lista de parámetros por período';
    vm.url = restUrl + 'parametros/par_periodo/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
      'id_par_periodo',
      'dia_inicio',
      'mes_inicio',
      'dia_fin',
      'mes_fin',
      'numero_periodo',
      'extranjero',
      'fid_sedes'
    ];

    vm.fks = ['fid_sedes'];

    vm.formly = [{
      'key': 'id_par_periodo',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }];
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ParArchivosController', ParArchivosController);

  /** @ngInject */
  function ParArchivosController(restUrl, Util) {
    var vm = this;
    vm.title = 'Lista de tipos de archivos';
    vm.url = restUrl + 'parametros/par_archivo/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
      'id_par_archivo',
      'fid_sedes',
      'nombre',
      'descripcion',
      'metadato_cumple',
      'metadato_no_cumple'
    ];

    vm.formly = [{
      'key': 'id_par_archivo',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    },{
      'key': 'autogenerado',
      'templateOptions': {
        required: false
      }
    }];

    vm.fks = ['fid_sedes'];
  }
})();

/*eslint angular/di: [2,"array"]*/

(function() {
  'use strict';

  angular
    .module('app')
    .controller('UsuariosController', ['restUrl', 'Modal', 'DataService', 'Util', 'Message', 'DemofiService', 'blockUI', '$mdDialog', '$timeout', UsuariosController]);

  /** @ngInject */
  function UsuariosController(restUrl, Modal, DataService, Util, Message, DemofiService, blockUI, $mdDialog, $timeout) {
    var vm = this

    vm.permission = Util.getMenuProcess();

    vm.title = 'Lista de Usuarios';
    vm.url = restUrl + 'usuario/';
    vm.agregarUsuario = agregarUsuario;
    vm.editarUsuario = editarUsuario;
    vm.listarUsuarios = listarUsuarios;
    vm.getFormlyUsuario = getFormlyUsuario;
    vm.cambiar = cambiar;
    vm.darDeBajaAlta = darDeBajaAlta;
    vm.asociarToken = asociarToken;
    vm.obtenerToken = obtenerToken;
    vm.rolUniversidad = 3;
    vm.rolSubUnidad = 5;

    vm.formly = [{
      'key': 'id_usuario',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }, {
      'key': 'usuario',
      'templateOptions': {
        disabled: true
      }
    }, {
      'key': 'estado',
      'templateOptions': {
        disabled: true
      }
    }];

    // Paginación
    vm.order = '';
    vm.options = {
      boundaryLinks: true
    };
    vm.query = {
      order: vm.order,
      limit: 20,
      page: 1
    };

    vm.showFilter = function() {
      vm.filter.show = true;
      $timeout(function() {
        angular.element('#crud-table-input').focus();
      }, 300);
    }
    vm.removeFilter = function() {
      vm.filter.show = false;
      vm.query.filter = '';
      if (vm.filter.form.$dirty) {
        vm.filter.form.$setPristine();
      }
      listarUsuarios();
    }

    vm.buscarUsuarios = function() {
      listarUsuarios();
    }

    activate();

    function activate() {
      listarUsuarios();
      getFormlyUsuario();
      getRoles();
      getSedes();
      getCarreras();
      getSedesUniversitarias();
    }

    function getRoles() {
      DataService.list(restUrl + 'rol')
        .then(function(response) {
          if (response) {
            vm.roles = response.rows;
          }
        });
    }

    function getSedes() {
      DataService.list(restUrl + 'rotaciones/sedes')
        .then(function(response) {
          if (response) {
            vm.sedes = response.datos;
          }
        });
    }

    function getSedesUniversitarias() {
      DataService.list(restUrl + 'rotaciones/sede')
        .then(function(response) {
          if (response) {
            vm.sedes_universitarias = response.datos;
          }
        });
    }

    function getCarreras() {
      DataService.list(restUrl + 'rotaciones/tipo_carrera')
        .then(function(response) {
          if (response) {
            vm.carreras = response.datos;
          }
        });
    }

    function getFormlyUsuario() {
      DataService.fields(vm.url)
        .then(function(response) {
          if (response) {
            vm.fieldsUsuario = Util.filterFields(response, vm.fieldsM);
            // vm.fieldsUsuario = Util.addPropertiesFormly(vm.fieldsControl, vm.formlyControl);
            DataService.setFormly(vm.fieldsUsuario);
          }
        });
    }

    function listarUsuarios() {
      DataService.list(vm.url, vm.query)
        .then(function(response) {
          if (response && response.rows && response.rows.length >= 0) {
            vm.usuarios = response;
          }
        });
    }

    function agregarUsuario(event, usuario) {
      vm.load = false;
      if (usuario) {
        vm.load = true;
      }
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogUsuarioController],
        templateUrl: 'app/modules/admin/usuarios/create.dialog.html'
      });
    }

    function editarUsuario(event, id_usuario) {
      DataService.get(vm.url + id_usuario)
        .then(function(response) {
          var item = response;
          if (!item.fid_sede) {
            item.fid_sede = 0;
          }
          if (!item.fid_sedes) {
            item.fid_sedes = 0;
          }
          if (!item.fid_tipo_carrera) {
            item.fid_tipo_carrera = 0;
          }
          vm.usuarioSeleccionado = item;
          Modal.show({
            event: event,
            data: vm,
            dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogUsuario2Controller],
            templateUrl: 'app/modules/admin/usuarios/edit.dialog.html'
          });
        });
    }

    function cambiar(event, id_usuario) {
      vm.id_usuario = id_usuario;
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogUsuarioController],
        templateUrl: 'app/modules/admin/usuarios/usuario.dialog.html'
      });
    }

    function darDeBajaAlta(event, id_usuario, usuario, alta) {
      vm.id_usuario = id_usuario;
      vm.usuario_actual = usuario;
      vm.alta = alta;
      Modal.show({
        event: event,
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogUsuarioController],
        templateUrl: 'app/modules/admin/usuarios/baja.dialog.html'
      });
    }

    function asociarToken(event, id_usuario) {
      vm.id_usuario_token = id_usuario;
      DemofiService.asociar(false, vm.handleError, vm.handleSuccess, vm.handleIniciarProceso, vm.handleFinalizarProceso)
        .then(function() {

        })
        .catch(function(error) {
          if (error) {
            Message.error(error.mensaje);
          }
        });
    }

    function obtenerToken(persona, usuario) {
      vm.persona = persona;
      vm.usuario = usuario;
      DemofiService.asociar(false, vm.handleError, vm.handleSuccess, vm.handleIniciarProceso, vm.handleFinalizar, vm.handleCerrar)
      .then(function() {})
      .catch(function(error) {
        if (error) {
          Message.error(error.mensaje);
        }
      });
    }

    vm.handleCerrar = function() {
      vm.agregarUsuario(null, vm.usuario);
    }
    vm.handleError = function(mensajeError) {
      Message.error(mensajeError);
    };

    vm.handleSuccess = function() {
      // vm.handleSuccess = function (mensajeSuccess) {
      // Message.success(mensajeSuccess);
    }

    vm.handleIniciarProceso = function(mensajeInicio) {
      blockUI.start(mensajeInicio);
    }

    vm.handleFinalizarProceso = function(certificados) {
      if (certificados && certificados.length) {
        DataService.put(restUrl + 'usuario/' + vm.id_usuario_token + '/token', {
            token: certificados[0].numeroSerie
          })
          .then(function(response) {
            if (response && response.id_usuario >= 0) {
              vm.listarUsuarios();
              Message.success("Los datos fueron guardados correctamente.");
            }
          });
        DemofiService.logout();
        $mdDialog.hide();
      }
      blockUI.stop();
    }

    vm.handleFinalizar = function(certificados) {
      if (certificados && certificados.length) {
        vm.usuario.token = certificados[0].numeroSerie;
        DemofiService.logout();
        $mdDialog.hide();
      }
      blockUI.stop();
      vm.load = true;
      Modal.show({
        data: vm,
        dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogUsuarioController],
        templateUrl: 'app/modules/admin/usuarios/create.dialog.html'
      });
    }

  }

  function DialogUsuarioController($scope, $mdDialog, data, restUrl, DataService, Message) {
    var vm = $scope;
    vm.datos = {};
    if (data.load) {
      vm.persona = data.persona;
      vm.usuario = data.usuario;
    } else {
      vm.usuario = {
        fid_sedes: 0,
        fid_sede: 0
      };
    }
    vm.usuario_actual = data.usuario_actual;
    vm.roles = data.roles;
    vm.sedes = data.sedes;
    vm.sedes_universitarias = data.sedes_universitarias;
    vm.carreras = data.carreras;
    vm.datos.alta = data.alta;
    vm.rolUniversidad = data.rolUniversidad;
    vm.rolSubUnidad = data.rolSubUnidad;
    vm.token = function() {
      data.obtenerToken(vm.persona, vm.usuario);
    };

    vm.close = function() {
      $mdDialog.cancel();
    };

    vm.guardarUsuario = function() {
      vm.usuario.id_persona = vm.persona.id_persona;
      vm.usuario.roles = [vm.usuario.rolesVar];
      DataService.post(restUrl + 'usuario/', vm.usuario)
        .then(function(response) {
          if (response && response.id_usuario >= 0) {
            data.listarUsuarios();
            vm.close();
            Message.success("Los datos fueron guardados correctamente.");
          }
        });
    };

    vm.rolSel = function(r) {
      if (r == vm.rolUniversidad) {
        vm.usuario.fid_sedes = null;
      } else {
        vm.usuario.fid_sede = null;
      }
      if (r != vm.rolSubUnidad) {
        vm.usuario.fid_tipo_carrera = null;
      }
    }

    vm.guardarDatos = function() {
      DataService.post(restUrl + 'pass/' + data.id_usuario, vm.datos)
        .then(function(response) {
          if (response && response.id_usuario >= 0) {
            vm.close();
            Message.success("Los datos fueron guardados correctamente.");
          }
        });
    };

    vm.darDeBajaAlta = function() {
      DataService.put(restUrl + 'usuario/actualizar/' + vm.usuario_actual.id_usuario, vm.datos)
        .then(function(response) {
          if (response && response.id_usuario >= 0) {
            vm.close();
            data.listarUsuarios();
            Message.success("El usuario fue dado de baja correctamente.");
          } else {
            Message.error();
          }

        });
    };

  }

  function DialogUsuario2Controller($scope, $mdDialog, data, restUrl, DataService, Message) {
    var vm = $scope;

    vm.data = data.usuarioSeleccionado;
    vm.data.rolesVar = vm.data.roles && vm.data.roles.length > 0 ? vm.data.roles[0] : null;

    vm.roles = data.roles;
    vm.sedes = data.sedes;
    vm.sedes_universitarias = data.sedes_universitarias;
    vm.carreras = data.carreras;

    vm.rolUniversidad = data.rolUniversidad;
    vm.rolSubUnidad = data.rolSubUnidad;

    vm.close = function() {
      $mdDialog.cancel();
    };

    vm.actualizarUsuario = function() {
      // delete item.ambitos;
      vm.data.roles = [vm.data.rolesVar];
      DataService.put(restUrl + 'usuario/' + vm.data.id_usuario, vm.data)
        .then(function(response) {
          if (response && response.id_usuario) {
            $mdDialog.hide();
            data.listarUsuarios();
            Message.success("Los datos fueron registrados correctamente.");
          } else {
            Message.error();
          }
        });
    }

    vm.rolSel = function(r) {
      if (r == vm.rolUniversidad) {
        vm.data.fid_sedes = null;
      } else {
        vm.data.fid_sede = null;
      }
      if (r != vm.rolSubUnidad) {
        vm.data.fid_tipo_carrera = null;
      }
    }

    vm.close = function() {
      $mdDialog.cancel();
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ServiciosController', ServiciosController);

  /** @ngInject */
  function ServiciosController(restUrl, Util) {
    var vm = this;
    vm.title = 'Lista de servicios';
    vm.url = restUrl + 'parametros/servicio/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
			'id_servicio',
			'servicio',
			'usuario',
			'contrasena',
			'host_port',
			'endpoint_base',
			'endpoint_token'
		];
    vm.formly = [
      {
      'key': 'id_servicio',
      'templateOptions': {
        'label' : 'ID',
        required: false
      }
    }];
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('RutasController', RutasController);

  /** @ngInject */
  function RutasController(restUrl, Util) {
    var vm = this;
    vm.title = 'Lista de rutas';
    vm.url = restUrl + 'ruta/';

    vm.fields = [
      'id_ruta',
      'ruta',
      'descripcion',
      'method_get',
      'method_post',
      'method_put',
      'method_delete'
    ];
    vm.formly = [{
      'key': 'id_ruta',
      'templateOptions': {
        'label' : 'ID',
        required: false
      }
    }];

    vm.permission = Util.getMenuProcess();

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('RolesController', RolesController);

  /** @ngInject */
  function RolesController(restUrl, Modal, DataService, Util) {
    var vm = this;
    vm.title = 'Lista de roles';
    vm.url = restUrl + 'rol/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
      'id_rol',
      'nombre',
      'descripcion',
      'ambito',
      'peso'
    ];

    vm.formly = [{
      'key': 'id_rol',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }];

    vm.buttons = [{
      tooltip: 'Asignar menús',
      icon: 'menu',
      show: vm.permission.update,
      onclick: function(event, id) {
        vm.id_rol = id;
        Modal.show({
          event: event,
          data: vm,
          dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogRolesMenusController],
          templateUrl: 'app/modules/admin/roles/edit.menus.html'
        });
      }
    }, {
      tooltip: 'Asignar rutas',
      icon: 'code',
      show: vm.permission.update,
      onclick: function(event, id) {
        vm.id_rol = id;
        Modal.show({
          event: event,
          data: vm,
          dialogController: ['$scope', '$mdDialog', 'data', 'restUrl', 'DataService', 'Message', DialogRolesRutasController],
          templateUrl: 'app/modules/admin/roles/edit.rutas.html'
        });
      }
    }];

    function activate() {

    }

    activate();
  }

  function DialogRolesMenusController($scope, $mdDialog, data, restUrl, DataService, Message) {
    var vm = $scope;
    vm.seleccionados = false;

    function activate() {
      getMenus();
    }

    activate();

    function getMenus() {
      DataService.list(restUrl + 'rol_menu/' + data.id_rol)
        .then(function(response) {
          if (response) {
            vm.menus = response;
          }
        });
    }

    vm.guardarMenus = function() {
      DataService.post(restUrl + 'rol_menu/' + data.id_rol, vm.menus)
        .then(function(response) {
          if (response) {
            $mdDialog.hide();
            Message.success("La asignación de menús se realizó correctamente.");
          } else {
            Message.error();
          }
        });
    }

    vm.toggleAll = function() {
      angular.forEach(vm.menus, function(menu) {
        angular.forEach(menu.submenus, function(submenu) {
          submenu.get = submenu.method_get && !vm.seleccionados;
          submenu.post = submenu.method_post && !vm.seleccionados;
          submenu.put = submenu.method_put && !vm.seleccionados;
          submenu.delete = submenu.method_delete && !vm.seleccionados;
        });
      });
    }

    vm.isChecked = function() {
      return vm.seleccionados;
    }

    vm.close = function() {
      $mdDialog.cancel();
    };
  }

  function DialogRolesRutasController($scope, $mdDialog, data, restUrl, DataService, Message) {
    var vm = $scope;
    vm.seleccionados = false;

    function activate() {
      getRutas();
    }

    activate();

    function getRutas() {
      DataService.list(restUrl + 'rol_ruta/' + data.id_rol)
        .then(function(response) {
          if (response) {
            vm.rutas = response;
          }
        });
    }

    vm.guardarRutas = function() {
      DataService.post(restUrl + 'rol_ruta/' + data.id_rol, vm.rutas)
        .then(function(response) {
          if (response) {
            $mdDialog.hide();
            Message.success("La asignación de rutas se realizó correctamente.");
          } else {
            Message.error();
          }
        });
    }

    vm.toggleAll = function() {
      angular.forEach(vm.rutas, function(ruta) {
        ruta.get = ruta.method_get && !vm.seleccionados;
        ruta.post = ruta.method_post && !vm.seleccionados;
        ruta.put = ruta.method_put && !vm.seleccionados;
        ruta.delete = ruta.method_delete && !vm.seleccionados;
      });
    }

    vm.isChecked = function() {
      return vm.seleccionados;
    }

    vm.close = function() {
      $mdDialog.cancel();
    };
  }

})();

/*eslint angular/di: [2,"array"]*/

(function() {
  'use strict';

  angular
    .module('app')
    .controller('RestoreController', ['restUrl', 'Modal', 'DataService', '$scope', '$location', 'Message', RestoreController]);

  /** @ngInject */
  function RestoreController(restUrl, Modal, DataService, $scope, $location, Message) {
    var vm = this;
    vm.username = '';
    vm.codigo = '';
    vm.pass = '';
    vm.repass = '';

    vm.restore = function() {
      var data = {
        username: vm.username
      };
      DataService.post(restUrl + '../../restore', data)
        .then(function(response) {
          if (response && response.email) {
            vm.chg = true;
            Message.success('Se envió un correo a ' + response.email);
          }
          else {
//            Message.error(response.error);
            Message.error("No se encontró el usuario "+vm.username);
          }
        });
    }

    $scope.$watch(angular.bind(vm, function () {
      return vm.chg;
    }), function () { });

    vm.change = function() {
      if (vm.pass == vm.repass) {
        var data = {
          username: vm.username,
          codigo: vm.codigo,
          pass: vm.pass
        };
        DataService.post(restUrl + '../../change', data)
          .then(function(response) {
            if (response && response.email) {
              Message.success('Se cambio la contraseña con éxito.');
              $location.path('/login');
            } 
          });
      } else {
        Message.error('Las contraseñas no coinciden.');
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('MenusController', MenusController);

  /** @ngInject */
  function MenusController(restUrl, DataService, Message, Modal, Util) {
    var vm = this;

    vm.permission = Util.getMenuProcess();

    vm.title = 'Lista de Menús';
    vm.url = restUrl + 'menu/';
    vm.abrirMenu = abrirMenu;
    vm.listarMenus = listarMenus;

    vm.fields = [
			'id_menu',
			'nombre',
			'orden',
			'ruta',
			'icono',
      'method_get',
      'method_post',
      'method_put',
      'method_delete'
		];
    vm.formlyMenus = [{
      'key': 'id_menu',
      'templateOptions': {
        'label' : 'ID',
        required: false
      }
    }
    ];

    activate();

    function activate() {
      listarMenus();
      getFormlyMenus();
    }

    function getFormlyMenus() {
      DataService.fields(vm.url)
        .then(function(response) {
          if (response) {
            vm.fieldsMenus = Util.filterFields(response, vm.fields);
            vm.fieldsMenus = Util.addPropertiesFormly(vm.fieldsMenus, vm.formlyMenus);
            DataService.setFormly(vm.fieldsMenus);
          }
        });
    }

    function listarMenus() {
      DataService.get(restUrl + 'menu/submenus')
        .then(function(response) {
          if (response) {
            vm.menus = response;
          }
        });
    }

    function abrirMenu(event, id) {
      if (id) {
        getItem(event, false, id);
      } else {
        openDialog(event, true, {});
      }
    }

    function getId(item, key) {
      if (item) {
        var formly = vm.fieldsMenus;
        for (var i in formly) {
          if (formly[i].templateOptions.label && formly[i].templateOptions.label == 'ID') {
            if (key) {
                return formly[i].key;
            } else {
                return item[formly[i].key];
            }
          }
        }
      }
        return null;
    }

    function getItem(event, add, id) {
        DataService.get(vm.url, id)
        .then(function(data) {
            // if (data && data[getId(data, true)]) {
            if (data) {
                openDialog(event, add, filterItem(data));
            }
        })
    }

    function openDialog(event, add, item) {
        item.menus_padre = vm.menus;
        var config = {
            event: event,
            data: item,
            title: add ? 'Agregar' : 'Editar',
            add: add,
            fields: vm.fieldsMenus,
            column: vm.column || 1,
            templateUrl : vm.template || 'app/modules/admin/menus/dialog.crudTable.menu.html',
            done : function (answer, $mdDialog) {
                if (answer == 'save') {
                    DataService.save(vm.url, parseSave(item))
                    .then(function(data) {
                        if (data) {
                            Message.success();
                            $mdDialog.hide();
                            vm.listarMenus();
                        }
                    });
                }
            }
        };
        Modal.show(config);
    }

    function filterItem(data) {
      for (var i in data) {
        if (i.indexOf('fecha') != -1) {
          if (data[i]) {
            data[i] = new Date(data[i]);
          }
        }
      }
      return data;
    }

    function parseSave(data) {
        var item = {};
        for (var i in data) {
            item[i] = data[i];
        }
        item.id = getId(item);
        return item;
    }
  }

})();

var TIME = 0;
var sessionInterval;

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($auth, $location, Message, SideNavFactory, Storage, Util, BreadcrumbFactory, $timeout, timeSessionExpired, $window, $scope, restUrl, DataService, $mdDialog) {

    var vm = this
    vm.login = login;

    if ($location.search().codigo != undefined) {
      vm.username = $location.search().user;
      vm.codigo = $location.search().codigo;
      vm.chg = true;
    }

    $scope.$watch(angular.bind(vm, function () {
      return vm.chg;
    }), function () { });

    activate()

    function activate() {
      angular.element('body').addClass('no-login');
      angular.element('body').removeClass('principal');

      if (Storage.exist('expired')) {
        Message.warning('Su sesión ha sido cerrada automáticamente después de ' + timeSessionExpired + ' minutos de inactividad.', null, 0);
        Storage.destroy('expired');
      }
    }

    function login() {
      $auth.login({
          email: vm.username,
          contrasena: vm.password
        })
        .then(function(response) {
          var user = response.data.usuario;
          // var param = $location.search();

          angular.element('body').removeClass('no-login');
          angular.element('body').removeClass('principal');

          // Set User data
          SideNavFactory.setUser(user);
          Storage.setUser(user);

          // Set Menu
          // Storage.set('menu', SideNavFactory.getMenu());
          SideNavFactory.setMenu(response.data.menu);
          Storage.set('menu', SideNavFactory.getMenu());

          $timeout(function() {
            var path = Storage.get('path');
            var redireccionar = response.data.menuEntrar ? response.data.menuEntrar : '/';
            $window.sessionStorage.setItem("menuEntrar", redireccionar);

            if (path || redireccionar) {
              if (!path) {
                path = redireccionar;
              }
              var route = path.replace('/', '');

              // Set breadcrumb
              var page = Util.getMenuOption(Storage.get('menu'), route);
              BreadcrumbFactory.setParent(page[0]);
              BreadcrumbFactory.setCurrent(page[1]);

              // Select menu option
              $timeout(function() {
                var $sidenav = angular.element('#sidenav')
                $sidenav.find('.md-button-href').removeClass('active');
                $sidenav.find('.sidenav-sublist').hide();
                $sidenav.find(".md-button-href[data-url='" + route + "']")
                  .addClass('active').parent().parent().prev().click();
              }, 1000);

            }

            TIME = timeSessionExpired * 60 * 1000;
            sessionInterval = $window.setInterval(function() {
              // console.log("TIEMPO EN LOGIN: " + (TIME / 1000));
              TIME -= 1000;
              if (TIME <= 0) {
                $window.clearInterval(sessionInterval);
                logout();
              }
            }, 1000);

            angular.element('#toast-container-main').find('md-toast').fadeOut();

            // Redirect to dashboard
            $location.path(path && path.indexOf('login') == -1 ? path : redireccionar);
          }, 100);
        })
        .catch(function() {
          Message.error('Su Nombre de usuario y Contraseña no son válidos.');
        });
    }

    function logout() {
      $auth.logout()
        .then(function() {
          Storage.removeUser();
          Storage.remove('menu');
          Storage.remove('path');
          $window.localStorage.clear();
          $window.sessionStorage.clear();
          Storage.set('expired', true);
          $location.path("login");
          $mdDialog.hide();
        });
    }

    vm.restore = function() {
      $location.path('/restore');
    }

    vm.change = function() {
      if (vm.password == vm.repassword) {
        if (vm.password.length >= 8) {
          var data = {
            username: vm.username,
            codigo: vm.codigo,
            pass: vm.password
          };
          DataService.post(restUrl + '../../change', data)
            .then(function(response) {
              if (response && response.email) {
                Message.success('Se cambio la contraseña con éxito.');
                $location.url($location.path());
                vm.chg = false;
              } else {
                Message.error(response.error);
              }
            });
        } else {
          Message.error('La contraseña debe tener al menos 8 caracteres.');
        }
      } else {
        Message.error('Las contraseñas no coinciden.');
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ConfiguracionController', ConfiguracionController);

  /** @ngInject */
  function ConfiguracionController(restUrl, Util) {
    var vm = this;
    vm.title = 'Lista de parámetros';
    vm.url = restUrl + 'parametros/parametro/';

    vm.permission = Util.getMenuProcess();

    vm.fields = [
      'id_parametro',
      'grupo',
      'sigla',
      'nombre',
      'descripcion',
      'orden',
      'estado',
      'direccion',
      'telefono'
    ];

    vm.formly = [{
      'key': 'id_parametro',
      'templateOptions': {
        'label': 'ID',
        required: false
      }
    }, {
      'key': 'grupo',
      'defaultValue': 'CASO_ESPECIAL',
      'templateOptions': {
        disabled: true,
        required: true
      }
    },{
      'key': 'estado',
      'hideExpression': 'true'
    }];
  }
})();

(function() {
    'use strict';

    angular
    .module('app')
    .controller('MainController', MainController);

    /** @ngInject */
    function MainController() {
        // var vm = this;

        activate();

        function activate() {

        }

    }
})();

/*eslint angular/di: [2,"array"]*/

(function() {
  'use strict'

  angular
    .module('app')
    .factory('Util', ['$window', '$location', 'Storage', '$stateParams', UtilFactory]);

  /** @ngInject */
  function UtilFactory($window, $location, Storage, $stateParams) {

    var params = $stateParams;

    var $document = $window.document;

    var tmpl_print = '<!DOCTYPE html>' +
      '<html lang="en">' +
      '<head>' +
      '<meta charset="UTF-8"/>' +
      '<title>Document</title>' +
      '<style>{css}</style>' +
      '</head>' +
      '<body>{body}' +
      '</body>' +
      '</html>';

    var factory = {
      toType: toType,
      isJson: isJson,
      getParams: getParams,
      print: print,
      fullscreen: fullscreen,
      nano: nano,
      popup: popup,
      filterFields: filterFields,
      addPropertiesFormly: addPropertiesFormly,
      size: size,
      getFkData: getFkData,
      serialize: serialize,
      getMenuOption: getMenuOption,
      getMenuProcess: getMenuProcess,
      searchField: searchField,
      parseSave: parseSave,
      extend: extend,
      mesIntToStr: mesIntToStr,
      getSubMenu: getSubMenu,
      bloquearPagina: bloquearPagina,
      desbloquearPagina: desbloquearPagina
    }

    return factory;

    function nano(template, data) {
      return template.replace(/\{([\w\.]*)\}/g, function(str, key) {
        var keys = key.split("."),
          v = data[keys.shift()];
        for (var i = 0, l = keys.length; i < l; i++)
          v = v[keys[i]];
        return (typeof v !== "undefined" && v !== null) ? v : "";
      });
    }

    function toType(obj) {
      return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }

    function isJson(text) {
      return /^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
    }

    function getParams(p, args) {
      var first = p.first.defaultValue,
        second = p.second.defaultValue;

      p.first.position = p.first.position || 0;
      p.second.position = p.second.position || 1;

      var type = toType(args[p.first.position]);
      if (type != 'undefined') {
        if (type == p.first.type) {
          first = args[p.first.position];
          second = toType(args[p.second.position]) == p.second.type ? args[p.second.position] : p.second.defaultValue;
        } else {
          if (type == p.second.type) {
            first = toType(args[p.second.position]) == p.first.type ? args[p.second.position] : p.first.defaultValue;
            second = args[p.first.position];
          }
        }
      }
      return {
        first: first,
        second: second
      };
    }

    function print(html, css) {
      if (typeof css == 'string') {
        angular.element.get(css, function(response) {
          var popup = $window.open('', 'print');
          popup.document.write(nano(tmpl_print, {
            body: html,
            css: response
          }));
          popup.document.close();
          popup.focus();
          popup.print();
          popup.close();
        });
      } else {
        var popup = $window.open('', 'print');
        popup.document.write(nano(tmpl_print, {
          body: html,
          css: css
        }));
        popup.document.close();
        popup.focus();
        popup.print();
        popup.close();
      }

      return true;
    }

    function popup(url) {
      $window.open(url, 'print');
    }

    function fullscreen() {
      if (!$document.fullscreenElement && // alternative standard method
        !$document.mozFullScreenElement && !$document.webkitFullscreenElement && !$document.msFullscreenElement) { // current working methods
        if ($document.documentElement.requestFullscreen) {
          $document.documentElement.requestFullscreen();
        } else if ($document.documentElement.msRequestFullscreen) {
          $document.documentElement.msRequestFullscreen();
        } else if ($document.documentElement.mozRequestFullScreen) {
          $document.documentElement.mozRequestFullScreen();
        } else if ($document.documentElement.webkitRequestFullscreen) {
          $document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if ($document.exitFullscreen) {
          $document.exitFullscreen();
        } else if ($document.msExitFullscreen) {
          $document.msExitFullscreen();
        } else if ($document.mozCancelFullScreen) {
          $document.mozCancelFullScreen();
        } else if ($document.webkitExitFullscreen) {
          $document.webkitExitFullscreen();
        }
      }
    }

    function filterFields(data, fields) {
      if (typeof fields == 'undefined' || fields.length == 0) {
        return data;
      }
      var filter = [];
      for (var i in fields) {
        var field = searchField(data, fields[i]);
        if (field) {
          filter.push(field);
        }
      }
      return filter;
    }

    function searchField(fields, field) {
      for (var i in fields) {
        if (fields[i].key == field) {
          return fields[i];
        }
      }
      return null;
    }

    function addPropertiesFormly(data, formly) {
      if (typeof formly == 'undefined' || formly.length == 0) {
        return data;
      }
      for (var i in data) {
        var field = searchField(formly, data[i].key);
        if (field) {
          data[i] = angular.element.extend(true, {}, data[i], field);
        }
      }
      return data;
    }

    function size(obj) {
      return Object.keys(obj).length;
    }

    // Only Django
    function parseSave(data) {
      var item = {};
      for (var i in data) {
        if (toType(data[i]) == 'date') {
          item[i] = parseDate(data[i]);
        } else {
          if (typeof data[i] == 'string' && (data[i] == 'true' || data[i] == 'false')) {
            item[i] = item[i] == 'true';
          } else {
            item[i] = data[i];
          }
        }
      }
      return item;
    }

    function getFkData(fieldsData, key, value) {
      fieldsData.filter(function(e) {
        if (e.key == key && e.templateOptions.options) {
          e.templateOptions.options.filter(function(elem) {
            if (elem.value == value) {
              value = elem.name;
            }
          })
        }
      });
      return value;
    }

    function parseDate(date) {
      return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
    }

    function serialize(json) {
      var string = [];
      for (var i in json) {
        string.push(i + '=' + json[i]);
      }
      return string.join('&');
    }

    function getMenuOption(menu, url) {
      for (var i in menu) {
        if (typeof menu[i].submenu != 'undefined') {
          var pages = menu[i].submenu;
          for (var j in pages) {
            if (pages[j].url == url) {
              return [menu[i].label, pages[j].label];
            }
          }
        }
      }
      for (var k in menu) {
        if (menu[k].url == url) {
          return [menu[k].label, false];
        }
      }
      return [false, false];
    }

    function getSubMenu() {
      var url = $location.path();
      var menu = Storage.get('menu');
      for (var i in menu) {
        if ("/" + menu[i].url == url && typeof menu[i].submenu != 'undefined') {
          return menu[i].submenu;
        }
      }
      return [];
    }

    function getMenuProcess() {
      var url = $location.path();
      var nombreParametro = "";
      var valorParametro = null;
      for (var k in params) {
        nombreParametro = k;
      }
      valorParametro = params[nombreParametro];
      var menu = Storage.get('menu');
      for (var i in menu) {
        if (typeof menu[i].submenu != 'undefined') {
          var pages = menu[i].submenu;
          for (var j in pages) {
            if ("/" + pages[j].url == url) {
              return pages[j].permissions;
            } else if (valorParametro && "/" + pages[j].url + "/" + valorParametro == url) {
              return pages[j].permissions;
            }
          }
        }
      }
      return [];
    }

    function extend(obj1, obj2) {
      for (var i in obj2) {
        if (obj2.hasOwnProperty(i)) {
          obj1[i] = obj2[i];
        }
      }
      return obj1;
    }

    function bloquearPagina(mensaje) {
      $window.onbeforeunload = function () {
       return mensaje ? mensaje : "Por favor espere que termine la operación";
      };
    }
    function desbloquearPagina() {
      // Para deshabilitarlo
      $window.onbeforeunload = undefined;
    }

    function mesIntToStr(intMes) {

      switch (intMes) {
        case 1:
          return 'Enero';
          // break;
        case 2:
          return 'Febrero';
          // break;
        case 3:
          return 'Marzo';
          // break;
        case 4:
          return 'Abril';
          // break;
        case 5:
          return 'Mayo';
          // break;
        case 6:
          return 'Junio';
          // break;
        case 7:
          return 'Julio';
          // break;
        case 8:
          return 'Agosto';
          // break;
        case 9:
          return 'Septiembre';
          // break;
        case 10:
          return 'Octubre';
          // break;
        case 11:
          return 'Noviembre';
          // break;
        case 12:
          return 'Diciembre';
          // break;
        default:
          return 'Mes no reconocido';
          // break;

      }
    }
  }
})();

/*eslint angular/di: [2,"array"]*/

(function() {
    'use strict';

    angular
    .module('app')
    .factory('Storage', ['$window', 'appName', StorageFactory]);

    /** @ngInject */
    function StorageFactory($window, appName) {

        appName = appName || 'app';

        var $local = $window.localStorage;
        var $session = $window.sessionStorage;
        var $JSON = $window.JSON;

        var factory = {
            get: get,
            set: set,
            exist: exist,
            remove: remove,
            destroy: remove,
            setUser: setUser,
            getUser: getUser,
            existUser: existUser,
            destroyUser: removeUser,
            removeUser: removeUser
        };

        return factory;

        function setUser(user) {
            setSession('user', user);
        }

        function getUser() {
            return getSession('user');
        }

        function existUser() {
            return existSession('user');
        }

        function removeUser() {
            removeSession('user');
        }

        // LocalStorage
        function set(key, value) {
            $local.setItem(appName + '_' + key, $JSON.stringify(value));
        }

        function get(key) {
            return $JSON.parse($local.getItem(appName + '_' + key));
        }

        function remove(key) {
            $local.removeItem(appName + '_' + key);
        }

        function exist(key) {
            return typeof $local.getItem(appName + '_' + key) != 'undefined' && $local.getItem(appName + '_' + key) != null;
        }

        // SessionStorage
        function setSession(key, value) {
            $session.setItem(appName + '_' + key, $JSON.stringify(value));
        }

        function getSession(key) {
            return $JSON.parse($session.getItem(appName + '_' + key));
        }

        function removeSession(key) {
            $session.removeItem(appName + '_' + key);
        }

        function existSession(key) {
            return typeof $session.getItem(appName + '_' + key) != 'undefined' && $session.getItem(appName + '_' + key) != null;
        }
    }
})();

/*eslint angular/di: [2,"array"]*/

(function() {
	'use strict';

	angular
	.module('app')
	.factory('OpcionesNombreCompleto', [OpcionesNombreCompletoFactory]);


	/** @ngInject */
	function OpcionesNombreCompletoFactory() {

		return {
      crearOpciones: function (nombres, primer_apellido, segundo_apellido, apellido_casada) {
        if (!nombres || nombres === 'undefined') { nombres = null; }
        if (!primer_apellido || primer_apellido === 'undefined') { primer_apellido = null; }
        if (!segundo_apellido || segundo_apellido === 'undefined') { segundo_apellido = null; }
        if (!apellido_casada || apellido_casada === 'undefined') { apellido_casada = null; }

        if (primer_apellido == null && segundo_apellido == null) {
          return [];
        }
        var opcionesNombre = [];
        opcionesNombre[0]= {
          codigo:'NUAC',
          nombre: (nombres || '')  + ' ' + (primer_apellido || '') + ' ' + (segundo_apellido || '')
          // nombre: primer_apellido  + ' ' + (segundo_apellido || '') + ' ' + nombres
        };

        if (apellido_casada) {
          opcionesNombre[1]= {
            codigo:'U1AC',
            nombre: (nombres || '') + ' ' + (primer_apellido || '')  + ' DE ' + apellido_casada
            // nombre: primer_apellido  + ' DE ' + apellido_casada + ' ' + nombres
          };
          opcionesNombre[2]= {
            codigo:'UTAC',
            nombre: (nombres || '') + ' ' + (primer_apellido || '')  + ' ' + (segundo_apellido || '') +' DE ' + apellido_casada
          };
          opcionesNombre[3]= {
            codigo:'U1ACV',
            nombre: (nombres || '') + ' ' + (primer_apellido || '')  + ' VDA. DE ' + apellido_casada
          };
          opcionesNombre[4]= {
            codigo:'UTACV',
            nombre: (nombres || '') + ' ' + (primer_apellido || '')  + ' ' + (segundo_apellido || '') +' VDA. DE ' + apellido_casada
          };
        }
        return opcionesNombre;
      }
    };
	}
})();

/*eslint angular/di: [2,"array"]*/

(function() {
	'use strict';

	angular
	.module('app')
	.factory('Modal', ['$mdDialog', ModalFactory]);

	/** @ngInject */
	function ModalFactory($mdDialog) {

		var factory = {
			show : show,
			alert : alert,
      confirm : confirm,
      close : close
		};

    return factory;

    function close() {
      $mdDialog.cancel();
    }

		function show(config) {
			var settings = {
				controller: config.dialogController || config.controller || ['$scope', '$mdDialog', 'data', 'fields', 'title', 'add', 'column', 'done', DialogController],
				templateUrl: config.templateUrl || '',
				parent: angular.element('body'),
				// clickOutsideToClose:typeof config.clickOutsideToClose == 'undefined' ? true : config.clickOutsideToClose,
				// escapeToClose:typeof config.escapeToClose == 'undefined' ? true : config.escapeToClose,
				escapeToClose: false,
				locals: {
					data: config.data || '',
					fields: config.fields || '',
					title: config.title || '',
					add: config.add || '',
					column: config.column || 1,
					done: config.done || function () {}
				}
			};
			if (config.event) {
				settings.targetEvent = config.event;
			}
			$mdDialog.show(settings)
			.then(function () {}, function() {
				if (config.close) {
					config.close();
				}
			});
		}

		function DialogController($scope, $mdDialog, data, fields, title, add, column, done) {
			var vm = $scope;

			vm.data = data;
			vm.fields = fields;
			vm.title = title;
			vm.add = add;
			vm.column = column;

			vm.hide = function() {
				$mdDialog.hide();
			};
			vm.cancel = function() {
				$mdDialog.cancel();
			};
			vm.answer = function(answer) {
				done(answer, $mdDialog);
			};
		}

		function alert(text, event) {
			var $alert = $mdDialog.alert()
				.clickOutsideToClose(true)
				.title('Alerta')
				.textContent(text)
				.ariaLabel('Alerta')
				.ok('Aceptar');

			if (event) {
				$alert.targetEvent(event);
			}
			$mdDialog.show($alert);
		}

		function confirm(text, done, cancel, event) {
			var $confirm = $mdDialog.confirm()
				.title('Confirmar')
				.textContent(text)
				.ariaLabel('Confirmar')
				.ok('Aceptar')
				.cancel('Cancelar');

			if (event) {
				$confirm.targetEvent(event);
			}

			$mdDialog.show($confirm)
			.then(function() {
				if (done) {
					done();
				}
			}, function() {
				if (cancel) {
					cancel();
				}
			});
		}

	}
})();

/*eslint angular/di: [2,"array"]*/

(function() {
  'use strict'

  angular
    .module('app')
    .factory('Message', ['$mdToast', MessageFactory]);

  /** @ngInject */
  function MessageFactory($mdToast) {

    var factory = {
      success: success,
      info: info,
      warning: warning,
      error: error
    };

    return factory;

    function success(msg, title, timeout) {
      var data = {
        icon: 'check',
        message: msg || 'La operación se realizó correctamente.',
        title: title || 'Correcto',
        type: 'success',
        timeout: timeout ? timeout : 3000
      };

      render(data);
    }

    function info(msg, title, timeout) {
      var data = {
        icon: 'info',
        message: msg || 'No existen datos para mostrar.',
        title: title || 'Información',
        type: 'info',
        timeout: timeout ? timeout : 3000
      };

      render(data);
    }

    function error(msg, title, timeout) {
      if (msg) {
        msg = msg.replace(new RegExp("Validation error:", 'g'), "");
      }
      var data = {
        icon: 'error',
        message: msg || 'Ocurrió un error al procesar su operación.',
        title: title || 'Error',
        type: 'danger',
        timeout: timeout
      };

      render(data);
    }

    function warning(msg, title, timeout) {
      var data = {
        icon: 'warning',
        message: msg || 'Ocurrió algo inesperado al procesar su operación.',
        title: title || 'Advertencia',
        type: 'warning',
        timeout: timeout
      };

      render(data);
    }

    function render(data) {
      $mdToast.show({
        controller: ToastController,
        templateUrl: 'app/factories/Messages/layout.toast.html',
        parent: angular.element('#toast-container-main'),
        hideDelay: typeof data.timeout != 'undefined' ? (data.timeout == 0 ? 31536000000 : data.timeout) : 5000,
        // hideDelay: typeof data.timeout != 'undefined' ? (data.timeout == 0 ? 5000 : data.timeout) : 5000,
        position: 'top right',
        locals: data
      });
    }

    function ToastController($scope, $mdToast, icon, message, title, type) {
      var vm = $scope;

      vm.icon = icon;
      vm.message = message;
      vm.title = title;
      vm.type = type;

      vm.close = function() {
        $mdToast.hide()
      };
    }
  }
})();

/*eslint angular/di: [2,"array"]*/

(function() {
	'use strict';

	angular
	.module('app')
	.factory('Datetime', ['Util', 'ArrayUtil', DatetimeFactory])
	.factory('ArrayUtil', [ArrayUtilFactory]);

	function ArrayUtilFactory() {
		var factory = {
			replace: replace,
			insert: insert
		};

		function replace (text, find, replace) {
			for (var i = 0, l = find.length, regex; i < l; i++) {
				regex = new RegExp(find[i], "g");
				text = text.replace(regex, replace[i]);
			}
			return text;
		}

		function insert (arr, index, item) {
			return arr.splice(index, 0, item);
		}

		return factory;
	}


	/** @ngInject */
	function DatetimeFactory(Util, ArrayUtil) {

		var formatDate = 'dd/MM/YYYY',
		months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
		days = ["dom", "lun", "mar", "mié" , "jue", "vie" , "sáb"],
		dayslong = ["Domingo", "Lunes", "Martes", "Miércoles" , "Jueves", "Viernes" , "Sábado"];

		var factory = {
			isDate: isDate,
			isValid: isValid,
			isLessThan: isLessThan,
			isLessThanDays: isLessThanDays,
			isGreaterThan: isGreaterThan,
			isGreaterThanDays: isGreaterThanDays,
			addDays: addDays,
			subtractDays: subtractDays,
			diff: diff,
			milliseconds: milliseconds,
			convert: convert,
			setFormatDate: setFormatDate,
			now: now,
			dateLiteral: dateLiteral,
			timeLiteral: timeLiteral,
			datetimeLiteral: datetimeLiteral,
			format: format,
			standar: standar,
			replace: replace,
			last: last,
			secondsBetweenTwoDates: secondsBetweenTwoDates,
			minutesBetweenTwoDates: minutesBetweenTwoDates,
			hoursBetweenTwoDates: hoursBetweenTwoDates,
			daysBetweenTwoDates: daysBetweenTwoDates,
			betweenTwoDates: betweenTwoDates,
			isYesterday: isYesterday,
			parse : parse,
			formatDate: formatDate,
			months: months,
			days: days,
			dayslong: dayslong
		}

		return factory

		function parse(date, separator) {
            return [date.getFullYear(), date.getMonth()+1, date.getDate()].join(separator || '-');
        }

		function isDate (date) {
			if (Util.toType(date) == 'string') {
				date = convert(date);
			}
			return isValid(date);
		}

		function isValid (date) {
			if (Util.toType(date) != 'date')
				return false;
			return !isNaN(date.getTime());
		}

		function isLessThan (date) {
			return milliseconds(date) < (new Date()).getTime();
		}

		function isLessThanDays (date, data) {
			return milliseconds(date) > subtractDays(new Date(), data);
		}

		function isGreaterThan (date) {
			return milliseconds(date) > (new Date()).getTime();
		}

		function isGreaterThanDays (date, data) {
			return milliseconds(date) < addDays(new Date(), data);
		}

		function addDays (date, days) {
			return milliseconds(date) + (days || 0)*24*60*60*1000;
		}

		function subtractDays (date, days) {
			return milliseconds(date) - (days || 0)*24*60*60*1000;
		}

		function diff (date2, date1) {
			return milliseconds(date2) - milliseconds(date1);
		}

		function milliseconds (date) {
			if (Util.toType(date) == 'string') {
				date = convert(date);
			}
			return date.getTime();
		}

		function convert (date) {
			date = date.split('/');
			return formatDate == 'dd/MM/YYYY' ? new Date(date[2], date[1]-1, date[0]) :
			formatDate == 'MM/dd/YYYY' ? new Date(date[2], date[0]-1, date[1]) :
			new Date(date[0], date[1]-1, date[2]);
		}

		function setFormatDate (format) {
			formatDate = format;
		}

		function now (format) {
			return replace(new Date(), format || formatDate);
		}

		function dateLiteral (date) {
			return format(date, 'dd de MMM del YYYY');
		}

		function timeLiteral (date) {
			return format(date, 'HH:mm');
		}

		function datetimeLiteral (date) {
			return format(date, 'dddd dd de MMM del YYYY a la(s) HH:mm');
		}

		function format (date, format) {
			var d = new Date(date);
			if (isDate(d)) {
				return replace(d, format || formatDate);
			}
			return date;
		}

		function standar (date, format) {
			var type = Util.toType(date);
			if (type == 'date') {
				return date;
			}
			if (type == 'string') {
				format = format || formatDate;
				var separator = date.indexOf('/') != -1 ? '/' : '-';
				date = date.split(separator);
				if (format == 'dd/MM/YYYY' || format == 'dd-MM-YYYY') {
					date = date[1] + separator + date[0] + separator + date[2];
				}
				if (format == 'YYYY/dd/MM' || format == 'YYYY-dd-MM') {
					date = date[0] + separator + date[1] + separator + date[0];
				}
			}
			return new Date(date);
		}

		function replace (date, format) {
			format = format || formatDate;
			date = standar(date, format);
			var monthLiteral = format.indexOf('MMM') != -1;
			return ArrayUtil.replace(format, [
				"dddd", "ddd", "dd", monthLiteral ? 'MMM' : 'MM', 'YYYY', 'HH', 'mm', 'ss'
			], [
				dayslong[date.getDay()],
				days[date.getDay()],
				(date.getDate() < 10 ? '0' : '') + date.getDate(),
				monthLiteral ? months[date.getMonth()] : ((date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1)),
				date.getFullYear(),
				(date.getHours() < 10 ? '0' : '') + date.getHours(),
				(date.getMinutes() < 10 ? '0' : '') + date.getMinutes(),
				(date.getSeconds() < 10 ? '0' : '') + date.getSeconds()
			]);
		}

		function last (date) {
			var now = new Date();
			var days = daysBetweenTwoDates(date, now);
			if (days > 31) {
				return dateLiteral(date);
			} else {
				if (days > 7) {
					var weeks = parseInt(days / 7);
					return 'Hace ' + weeks + ' semana' + (weeks > 1 ? 's' : '');
				} else {
					if (days >= 1) {
						return format(date, 'ddd a la(s) HH:mm');
					} else {
						var hours = hoursBetweenTwoDates(date, now);
						if (isYesterday(date, hours)) {
							return 'Ayer a la(s) ' + timeLiteral(date);
						} else {
							if (hours >= 1) {
								return 'Hace ' + hours + ' hora' + (hours > 1 ? 's' : '');
							} else {
								var minutes = minutesBetweenTwoDates(date, now);
								if (minutes >= 1) {
									return 'Hace ' + minutes + ' minuto' + (minutes > 1 ? 's' : '');
								} else {
									var seconds = secondsBetweenTwoDates(date, now);
									return 'Hace ' + seconds + ' segundo' + (seconds > 1 ? 's' : '');
								}
							}
						}
					}
				}
			}
		}

		function secondsBetweenTwoDates (date1, date2, absolute) {
			return betweenTwoDates(date1, date2, "s", absolute);
		}

		function minutesBetweenTwoDates (date1, date2, absolute) {
			return betweenTwoDates(date1, date2, "i", absolute);
		}

		function hoursBetweenTwoDates (date1, date2, absolute) {
			return betweenTwoDates(date1, date2, "h", absolute);
		}

		function daysBetweenTwoDates (date1, date2, absolute) {
			return betweenTwoDates(date1, date2, "d", absolute);
		}

		function betweenTwoDates (date1, date2, type, absolute) {
			var types = {s : 1000, i : 60*1000, h : 60*60*1000, d : 24*60*60*1000};
			var diff = parseInt((standar(date2).getTime() - standar(date1).getTime())/types[type]);

			if (typeof absolute !== 'undefined' && absolute !== false) {
				return Math.abs(diff);
			}
			return diff;
		}

		function isYesterday (date, hours) {
			if (isDate(date)) {
				date = date.split(' ');
				var time = date[1].split(':');
				return hours >= parseInt(time[0]);
			}
			return false;
		}

	}
})();

var TIME = null;
(function() {
  'use strict'

  angular
    .module('app')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(function($httpProvider) {
      $httpProvider.interceptors.push('AuthInterceptor');
    });

  /** @ngInject */
  function AuthInterceptor($q, $location, $injector, $document, timeSessionExpired, BreadcrumbFactory, SideNavFactory) {

    var element;
    var interceptor = {
      request: function(config) {

        // Set new Time
        if (typeof TIME != 'undefined') {
          TIME = timeSessionExpired * 60 * 1000;
        }

        element = $document[0].activeElement;
        if (!(element.attributes['aria-label'] && element.attributes['aria-label'].value == "Nota")) {
          angular.element('#loading-progress').show();
        }
        return config;
      },
      requestError: function(config) {
        return config;
      },
      response: function(response) {
        if (!(element.attributes['aria-label'] && element.attributes['aria-label'].value == "Nota")) {
          angular.element('#loading-progress').hide();
        }
        return response || $q.when(response);
      },
      responseError: function(rejection) {
        if (rejection.status === 401 || rejection.status === 403) {
          // var $auth = $injector.get('$auth');
          // var Modal = $injector.get('Modal');
          // var Message = $injector.get('Message');
          // var Storage = $injector.get('Storage');
          // var SideNavFactory = $injector.get('SideNavFactory');

          // var data = {
          // 	username: '',
          // 	password: ''
          // };

          // Modal.show({
          // 	templateUrl: 'app/modules/admin/login/login.dialog.html',
          // 	data: data,
          // 	clickOutsideToClose: false,
          // 	escapeToClose: false,
          // 	done : function (answer) {
          // 		if (answer == 'login') {
          // 			$auth.login({
          // 				username: data.username,
          // 				password: data.password
          // 			})
          // 			.then(function(response) {
          // 				var user = response.data.user;
          // 				SideNavFactory.setUser(user);
          // 				Storage.setUser(user);
          // 				$window.location = $location.absUrl();
          // 			})
          // 			.catch(function() {
          // 				Message.error('Su Nombre de usuario y Contraseña no son válidos.');
          // 			});
          // 		}
          // 	}
          // });

          var Storage = $injector.get('Storage');
          var $auth = $injector.get('$auth');
          // var SideNavFactory = $injector.get('SideNavFactory');
          var usuario = Storage.getUser();
          if (usuario && usuario.id_usuario && rejection.data.message != 'El token caducó.') {
            $location.path('/').search('returnTo', path);
            BreadcrumbFactory.actualizar();
            SideNavFactory.actualizar();
          } else {
            Storage.removeUser();
            Storage.remove('menu');
            var path = $location.path();
            $location.path('/login').search('returnTo', path);
          }
          $auth.logout()
            .then(function() {
              var $mdDialog = $injector.get('$mdDialog');

              // Storage.set('expired', true);

              Storage.removeUser();
              // Storage.remove('path');
              Storage.remove('menu');
              Storage.remove('visible');

              SideNavFactory.setUser({});
              SideNavFactory.setMenu([]);
              SideNavFactory.setVisible(false);

              $location.path('login');
              $mdDialog.hide();
            });
        }
        return $q.reject(rejection);
      }
    };

    return interceptor;
  }

})();

(function() {
  'use strict';

  angular
      .module('app')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('SideNavFactory', SideNavFactory)

    function SideNavFactory($timeout) {

        var factory = {
            user: {
                id: '',
                nombres: '',
                apellidos: '',
                cargo: '',
                email: '',
                photo: ''
            },
            userColor: '',
            menu: [
            //     // {
            //     //     'label': 'Dashboard',
            //     //     'url' : '',
            //     //     'icon': 'home'
            //     // },
            //     {
            //         'label': 'Beneficiarios',
            //         'url' : 'beneficiario',
            //         'icon': 'supervisor_account',
            //         'submenu': [
            //             {
            //                 'label': 'Madres',
            //                 'url': 'madres',
            //                 'permissions': {
            //                     create: true,
            //                     read: true,
            //                     update: true,
            //                     delete: true
            //                 }
            //             },
            //             {
            //                 'label': 'Menores',
            //                 'url': 'menores',
            //                 'permissions': {
            //                     create: true,
            //                     read: true,
            //                     update: true,
            //                     delete: true
            //                 }
            //             }
            //         ]
            //     },
            //     {
            //         'label': 'Subsidio',
            //         'url' : 'subsidio',
            //         'icon': 'local_grocery_store',
            //         'submenu': [
            //             {
            //                 'label': 'Entrega de Paquetes',
            //                 'url': 'subsidio/entregas',
            //                 'permissions': {
            //                     create: true,
            //                     read: true,
            //                     update: true,
            //                     delete: true
            //                 }
            //             }
            //         ]
            //     },
            //     {
            //         'label': 'Médicos',
            //         'url' : 'medicos',
            //         'icon': 'perm_identity',
            //         'submenu': [
            //             {
            //                 'label': 'Médicos',
            //                 'url': 'medicos',
            //                 'permissions': {
            //                     create: true,
            //                     read: true,
            //                     update: true,
            //                     delete: true
            //                 }
            //             }
            //             ,
            //             {
            //                 'label': 'Cronogramas',
            //                 'url': 'cronograma',
            //                 'permissions': {
            //                     create: false,
            //                     read: true,
            //                     update: true,
            //                     delete: false
            //                 }
            //             }
            //             ,
            //             {
            //                 'label': 'Coordinador',
            //                 'url': 'coordinador',
            //                 'permissions': {
            //                     create: false,
            //                     read: true,
            //                     update: true,
            //                     delete: false
            //                 }
            //             }
            //         ]
            //     },
            //     {
            //         'label': 'Albergues',
            //         'url' : 'albergues',
            //         'icon': 'home',
            //         'submenu': [
            //             {
            //                 'label': 'Albergues',
            //                 'url': 'albergues',
            //                 'permissions': {
            //                     create: true,
            //                     read: true,
            //                     update: true,
            //                     delete: true
            //                 }
            //             }
            //         ]
            //     },
            //     {
            //         'label': 'Transferencias',
            //         'url' : 'transferencias',
            //         'icon': 'input',
            //         'submenu': [
            //             {
            //                 'label': 'Transferencia',
            //                 'url': 'transferencias',
            //                 'permissions': {
            //                     create: false,
            //                     read: true,
            //                     update: true,
            //                     delete: false
            //                 }
            //             }
            //         ]
            //     },
            //     {
            //         'label': 'Coordinadores',
            //         'url' : 'coordinadores',
            //         'icon': 'perm_identity',
            //         'submenu': [
            //             {
            //                 'label': 'Coordinadores',
            //                 'url': 'coordinadores',
            //                 'permissions': {
            //                     create: true,
            //                     read: true,
            //                     update: true,
            //                     delete: true
            //                 }
            //             }
            //         ]
            //     },
            //     {
            //         'label': 'Configuración',
            //         'url' : 'configuracion',
            //         'icon': 'settings_applications',
            //         'submenu': [
            //             {
            //                 'label': 'Usuarios',
            //                 'url': 'usuarios',
            //                 'permissions': {
            //                     create: false,
            //                     read: true,
            //                     update: true,
            //                     delete: false
            //                 }
            //             },
            //             {
            //                 'label': 'Configuración del Sistema',
            //                 'url': 'configuracion',
            //                 'permissions': {
            //                     create: false,
            //                     read: true,
            //                     update: true,
            //                     delete: false
            //                 }
            //             },
            //             {
            //                 'label': 'Roles',
            //                 'url': 'roles',
            //                 'permissions': {
            //                     create: true,
            //                     read: true,
            //                     update: true,
            //                     delete: false
            //                 }
            //             },
            //             {
            //                 'label': 'Rutas',
            //                 'url': 'rutas',
            //                 'permissions': {
            //                     create: true,
            //                     read: true,
            //                     update: true,
            //                     delete: false
            //                 }
            //             },
            //             {
            //                 'label': 'Menús',
            //                 'url': 'menus',
            //                 'permissions': {
            //                     create: true,
            //                     read: true,
            //                     update: true,
            //                     delete: false
            //                 }
            //             }
            //         ]
            //     }
            ],
            getMenu: function () {
                return this.menu;
            },
            getUser: function () {
                return this.user;
            },
            setMenu: function (menu) {
                this.menu = menu;
            },
            setUser: function (user) {
                this.user = user;
            },
            actualizar: function(option) {
              $timeout(function() {
                option = option.replace('/', '');
                var $sidenav = angular.element('#sidenav')
                $sidenav.find('.md-button-href').removeClass('active');
                $sidenav.find('.sidenav-sublist').hide();
                $sidenav.find(".md-button-href[data-url='" + option + "']")
                  .addClass('active').parent().parent().prev().click();
              }, 1000);
            }
        };

        return factory;

    }

})();

(function() {
    'use strict'

    angular
    .module('app')
    .directive('acmeSidenav', SidenavDirective)

    /** @ngInject */
    function SidenavDirective() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sidenav/sidenav.html',
            scope: {},
            controller: SidenavController,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, elem) {
                var $sidenav = elem

                $sidenav.on('click', '.md-button-href', function () {
                    $sidenav.find('.md-button-href').removeClass('active');
                    angular.element(this).addClass('active');
                })

                $sidenav.on('click', '.md-button-toggle', function () {
                    if ($sidenav.hasClass('collapsed')) {
                        return false;
                    }
                    $sidenav.find('.sidenav-sublist').slideUp(300);
                    $sidenav.find('.sidenav-list > li').removeClass('active');

                    var $this = angular.element(this);
                    $this.addClass('active');
                    if(!$this.next().is(":visible")) {
                        $this.next().slideToggle(300);
                        $this.closest('li').addClass('active');
                    }
                })
            }
        }

        return directive

        /** @ngInject */
        function SidenavController($timeout, $mdSidenav, SideNavFactory, $location, Storage, BreadcrumbFactory, Util, $log) {
            var vm = this;
            var color = ['info', 'success', 'danger', 'warning', 'primary'];

            vm.user = {};
            vm.menu = [];

            vm.toggleLeft = buildDelayedToggler('left');

            vm.send = function (url, submenu) {
                if (typeof submenu == 'undefined') {
                    if (Storage.exist('menu')) {
                        var page = Util.getMenuOption(Storage.get('menu'), url);
                        BreadcrumbFactory.setParent(page[0]);
                        BreadcrumbFactory.setCurrent(page[1]);
                    }
                    $location.path(url);
                }
                vm.reset();
            }

            vm.reset = function () {
                angular.element('#toast-container-main').find('md-toast').fadeOut();
            }

            activate();

            function activate() {
                if (Storage.existUser()) {
                    SideNavFactory.setUser(Storage.getUser());
                }
                if (Storage.exist('menu')) {
                    SideNavFactory.setMenu(Storage.get('menu'));
                }
                vm.menu = SideNavFactory.getMenu();
                Storage.set('menu', vm.menu);

                vm.active = $location.path().replace('/', '');
                SideNavFactory.userColor = color[parseInt(Math.random()*color.length)];

                $timeout(function () {
                    angular.element('#sidenav').find('.md-button-href.active').parent().parent().prev().click();
                }, 1000);
            }

            vm.getColor = function () {
                return SideNavFactory.userColor;
            }

            vm.getName = function () {
                var user = SideNavFactory.getUser();
                return user.nombres + ' ' + user.apellidos;
            }

            vm.getRol = function () {
                var user = SideNavFactory.getUser();
                return user.rol;
            }

            vm.getEmail = function () {
                return SideNavFactory.getUser().email;
            }
            vm.getEntidad = function () {
                return SideNavFactory.getUser().entidad;
            }

            vm.getInitial = function () {
                var firstName = SideNavFactory.getUser().nombres;
                return firstName && firstName.length ? firstName[0].toUpperCase() : '?';
            }

            vm.getMenu = function () {
                return SideNavFactory.getMenu();
            }


            /**
            * Supplies a function that will continue to operate until the
            * time is up.
            */
            function debounce(func, wait) {
                var timer
                return function debounced() {
                    var context = vm,
                    args = Array.prototype.slice.call(arguments);
                    $timeout.cancel(timer);
                    timer = $timeout(function() {
                        timer = undefined;
                        func.apply(context, args);
                    }, wait || 10);
                }
            }
            /**
            * Build handler to open/close a SideNav when animation finishes
            * report completion in console
            */
            function buildDelayedToggler(navID) {
                return debounce(function() {
                    $mdSidenav(navID)
                    .toggle()
                    .then(function () {
                        $log.debug("toggle " + navID + " is done");
                    })
                }, 200);
            }

        }
    }
})();

/*eslint angular/no-private-call: [2,{"allow":["$$hashKey"]}]*/

(function() {
  'use strict';

  angular
    .module('app')
    .component('selectTable', {
      templateUrl: 'app/components/selectTable/selectTable.html',
      controller: ['$scope', 'DataService', 'Message', 'Modal', 'Util', '$timeout', 'restUrl', SelectTableController],
      controllerAs: 'vm',
      bindings: {
        url: '=',
        fields: '=',
        fks: '=',
        title: '=',
        template: '=',
        formly: '=',
        dialogController: '=',
        order: '=',
        optionSelected: '=',
        idnombre: '=',
        selected: '=?seleccionados',
        mostrar: '='
      }
    });

  function SelectTableController($scope, DataService, Message, Modal, Util, $timeout, restUrl) {
    var vm = this;
    var bookmark;
    vm.selected = [];
    vm.getData = getData;
    vm.removeFilter = removeFilter;
    vm.showFilter = showFilter;

    vm.query = {
      order: vm.order,
      limit: 5,
      page: 1,
      filter: ''
    };

    vm.filter = {
        options: {
            debounce: 500
        }
    };

    function getData() {
      return DataService.list(restUrl + vm.url, vm.query)
        .then(function(data) {
          if (data) {
            vm.items = data;
            vm.selected = arrayUnique(vm.selected.concat(data.selected));
          }
        });
    }

    function arrayUnique(array) {
      var a = array.concat();
      var devolver = [];
      for (var i = 0; i < a.length; i++) {
        var existe = false;
        delete a[i].$$hashKey;
        for (var j = 0; j < devolver.length; j++) {
          if (angular.toJson(a[i]) == angular.toJson(devolver[j])) {
            existe = true;
          }
        }
        if (!existe) {
          devolver.push(a[i]);
        }
      }
      return devolver;
    }

    function activate() {
      getData();
    }

    activate();

    function showFilter() {
        vm.filter.show = true;
        $timeout(function () {
            angular.element('#crud-table-input').focus();
        }, 100);
    }

    function removeFilter () {
        vm.filter.show = false;
        vm.query.filter = '';

        if(vm.filter.form.$dirty) {
            vm.filter.form.$setPristine();
        }
    }

    $scope.$watch('vm.query.filter', function (newValue, oldValue) {
        if(!oldValue) {
            bookmark = vm.query.page;
        }
        if(newValue !== oldValue) {
            vm.query.page = 1;
        }
        if(!newValue) {
            vm.query.page = bookmark;
        }
        vm.getData();
    });

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('reportePar1', {
      templateUrl: 'app/components/reportePar1/reportePar1.html',
      controller: ReportePar1Controller,
      bindings: {
        datos: '='
      }
    });

  /** @ngInject */
  function ReportePar1Controller(Datetime) {
    var vm = this;

    activate();

    function activate() {
      initMonths();
      initYears();
    }

    function initMonths() {
      var months = [];
      for (var i = 0; i < 12; i++) {
        months.push({
          name: Datetime.months[i],
          value: i + 1
        });
      }
      vm.months = months;
    //  vm.month = 0;
    }

    function initYears() {
      var year = parseInt(Datetime.now('YYYY'));
      var years = [];
      for (var i = year, l = year - 50; i >= l; i--) {
        years.push({
          name: i,
          value: i
        });
      }
      vm.years = years;
      // vm.datos.year = year;
    }
  }

})();

(function() {
  'use strict'

  angular
    .module('app')
    .directive('pwCheck', pwCheckDirective);

  function pwCheckDirective() {
    return {
      require: 'ngModel',
      link: function(scope, elem, attrs, ctrl) {
        var firstPassword = '#' + attrs.pwCheck;
        elem.add(firstPassword).on('keyup', function() {
          scope.$apply(function() {
            var v = elem.val() === angular.element(firstPassword).val();
            ctrl.$setValidity('pwmatch', v);
          });
        });
      }
    }
  }

})();

(function() {
  'use strict'

  angular
    .module('app')
    .directive('onlyDigits', onlyDigitsDirective);

  function onlyDigitsDirective() {
    return {
      require: 'ngModel',
      scope: {
        odCantidad: '=',
        odMinimo: '=',
        odMaximo: '='
      },
      link: function(scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          var texto = String(text);
          if (texto) {
            var transformedInput = texto.replace(/[^0-9]/g, '');
            if (transformedInput !== texto) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            if (transformedInput && transformedInput.length > 0 && scope.odCantidad) {
              transformedInput = transformedInput.substr(0, scope.odCantidad);
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            if (transformedInput && transformedInput.length > 0 && scope.odMaximo) {
              if (transformedInput > scope.odMaximo) {
                transformedInput = transformedInput.substr(0, (transformedInput.length - 1));  
                ngModelCtrl.$setViewValue(transformedInput);
                ngModelCtrl.$render();
              }
            }
            return transformedInput;
          }
          return undefined;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    }
  }

})();

/*global sessionInterval:true*/
(function() {
  'use strict'

  angular
    .module('app')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {},
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    }

    return directive

    /** @ngInject */
    function NavbarController($auth, $location, Storage, SideNavFactory, Util, $window, Modal, BreadcrumbFactory, $mdDialog) {
      var vm = this;

      vm.toggle = function() {
        angular.element('#sidenav-main').toggleClass('collapsed');
      }

      vm.back = function() {
        var entrar = $window.sessionStorage.getItem("menuEntrar");
        if ($window.location.hash === '#' + entrar) {
          return false;
        }
        $window.history.back();
        var path = $window.location.hash;
        path = path.replace("#", "");
        BreadcrumbFactory.actualizar(path);
        SideNavFactory.actualizar(path);
      }

      vm.openMenu = function($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
      }

      vm.profile = function() {
        $location.path("profile");
      }

      vm.settings = function() {
        $location.path("configuracion");
      }

      vm.getFirstName = function() {
        if (Storage.existUser()) {
          return Storage.getUser().first_name;
        }
        return SideNavFactory.getUser().first_name;
      }

      vm.getColor = function() {
        return SideNavFactory.userColor;
      }

      vm.getInitial = function() {
        var firstName = SideNavFactory.getUser().first_name;
        return firstName.length ? firstName[0].toUpperCase() : '?';
      }

      vm.logout = function() {
        $auth.logout()
          .then(function() {
            if (sessionInterval) {
              $window.clearInterval(sessionInterval);
            }
            Storage.removeUser();
            Storage.remove('menu');
            Storage.remove('path');
            $window.localStorage.clear();
            $window.sessionStorage.clear();
            $location.path("login");
            $mdDialog.hide();
          });
      }

      vm.cambiarRol = function(event) {
        Modal.show({
          event: event,
          dialogController: ['$scope', '$mdDialog', 'restUrl', 'DataService', 'Message', '$location', 'SideNavFactory', 'Storage', 'Util', 'BreadcrumbFactory', '$timeout', 'timeSessionExpired', '$window', '$auth', DialogController],
          templateUrl: 'app/components/navbar/cambiarRol.dialog.html'
        });
      }

      vm.cambiarContrasena = function(event) {
        Modal.show({
          event: event,
          dialogController: ['$scope', '$mdDialog', 'restUrl', 'DataService', 'Message', DialogUsuarioController],
          templateUrl: 'app/components/navbar/usuario.dialog.html'
        });
      }

      vm.fullscreen = function() {
        angular.element('body').toggleClass('fullscreen');
        Util.fullscreen();
      }
    }

    function DialogController($scope, $mdDialog, restUrl, DataService, Message, $location, SideNavFactory, Storage, Util, BreadcrumbFactory, $timeout, timeSessionExpired, $window, $auth) {
      var vm = $scope;
      vm.usuario = SideNavFactory.getUser();
      vm.cambiarRol = function() {
        var rol = {
          rolCambio: vm.usuario.cambioRol
        }
        DataService.post(restUrl + "cambiarRol/", rol).then(function(response) {
          if (response && response.usuario) {
            var user = response.usuario;
            // var param = $location.search();

            angular.element('body').removeClass('no-login');

            // Set User data
            SideNavFactory.setUser(user);
            Storage.setUser(user);
            $auth.setToken(response.token);

            // Set Menu
            // Storage.set('menu', SideNavFactory.getMenu());
            SideNavFactory.setMenu(response.menu);
            Storage.set('menu', SideNavFactory.getMenu());

            var path = Storage.get('path');
            var redireccionar = response.menuEntrar ? response.menuEntrar : '/';

            if (path || redireccionar) {
              if (!path) {
                path = redireccionar;
              }
              var route = path.replace('/', '');

              // Set breadcrumb
              var page = Util.getMenuOption(Storage.get('menu'), route);
              BreadcrumbFactory.setParent(page[0]);
              BreadcrumbFactory.setCurrent(page[1]);

              // Select menu option
              $timeout(function() {
                var $sidenav = angular.element('#sidenav')
                $sidenav.find('.md-button-href').removeClass('active');
                $sidenav.find('.sidenav-sublist').hide();
                $sidenav.find(".md-button-href[data-url='" + route + "']")
                  .addClass('active').parent().parent().prev().click();
              }, 1000);

            }

            var TIME = timeSessionExpired * 60 * 1000;
            var sessionInterval = $window.setInterval(function() {
              TIME -= 1000;
              if (TIME <= 0) {
                $window.clearInterval(sessionInterval);
                vm.logout();
              }
            }, 1000);

            angular.element('#toast-container-main').find('md-toast').fadeOut();

            // Redirect to dashboard
            $location.path(path && path.indexOf('login') == -1 ? path : redireccionar);
            Message.success("Se ha cambiado su rol correctamente.");
            $mdDialog.hide();
          } else {
            Message.error();
          }
        });
      }

      vm.close = function() {
        $mdDialog.hide();
      }
    }

    function DialogUsuarioController($scope, $mdDialog, restUrl, DataService, Message) {
      var vm = $scope;

      vm.cambiarContrasena = function() {
        DataService.put(restUrl + "mypass/", vm.datos).then(function(response) {
          if (response && response.usuario) {
            Message.success("Se ha cambiado su contraseña correctamente.");
            $mdDialog.hide();
          } else {
            Message.error();
          }
        });
      }

      vm.close = function() {
        $mdDialog.hide();
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('helpMessage', {
      templateUrl: 'app/components/helpMessage/helpMessage.html',
      controller: HelpMessageController,
      bindings: {
        mensaje: '@'
      }
    });

  /** @ngInject */
  function HelpMessageController() {

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('documentoIdentidad', {
      templateUrl: 'app/components/documentoIdentidad/documentoIdentidad.html',
      controller: DocumentoIdentidadController,
      bindings: {
        persona: '=',
        personas: '=',
        url: '=',
        birthday: '@',
        source: '@',
        documentoIdentidad: '=?documento',
        texto: '=',
        get: '=',
        mensaje: '='
      }
    });

  /** @ngInject */
  function DocumentoIdentidadController(DataService, Datetime, Message, $window, restUrl, $scope) {
    var vm = this;

    vm.search = search;
    vm.encontrado = false;

    $scope.$watch('$ctrl.extranjeroNro', function() {
      if (vm.extranjeroNro === 0) {
        vm.extranjero = false;
        if (vm.persona) {
          vm.persona.extranjero = false;
          vm.persona.encontrado = 1;
          vm.persona.nombres = null;
          vm.persona.primer_apellido = null;
          vm.persona.segundo_apellido = null;
          vm.persona.casada_apellido = null;
        } else {
          vm.persona = {
            extranjero: false,
            encontrado: 1,
            nombres: null,            
            primer_apellido: null,
            segundo_apellido: null,
            casada_apellido: null
          };
        }
      } else if (vm.extranjeroNro === 1) {
        if (vm.persona) {
          vm.persona.encontrado = 1;
          vm.persona.extranjero = true;
          vm.persona.id_persona = null;
        } else {
          vm.persona = {
            encontrado: -1,
            extranjero: true,
            id_persona: null
          };
        }
        vm.extranjero = true;
      }
    });


    $scope.$watch('$ctrl.documentoIdentidad', function() {
      if (vm.extranjeroNro === 1) {
        if (vm.persona) {
          vm.persona.documento_identidad = vm.documentoIdentidad;
        } else {
          vm.persona = {
            documento_identidad: vm.documentoIdentidad
          };
        }
      }
    });

    $scope.$watch('$ctrl.year', function() {
      if (vm.extranjeroNro === 1) {
        if (vm.persona) {
          vm.persona.fecha_nacimiento = Datetime.replace([vm.day, vm.month, vm.year].join('/'));
        } else {
          vm.persona = {
            fecha_nacimiento: Datetime.replace([vm.day, vm.month, vm.year].join('/'))
          };
        }
      }
    });

    activate();

    function activate() {
      initDays();
      initMonths();
      initYears();

      // Cargando persona por defecto
      if (vm.persona) {
        vm.documentoIdentidad = vm.persona.documento_identidad;
        var fecha_nacimiento = new Date(vm.persona.fecha_nacimiento);
        vm.day = fecha_nacimiento.getDate();
        vm.month = fecha_nacimiento.getUTCMonth() + 1;
        vm.year = fecha_nacimiento.getUTCFullYear();
        vm.extranjero = vm.persona.extranjero;
      }
    }

    function initDays() {
      var days = [];
      for (var i = 1; i <= 31; i++) {
        days.push({
          name: i,
          value: i
        });
      }
      vm.days = days;
    }

    function initMonths() {
      var months = [];
      for (var i = 0; i < 12; i++) {
        months.push({
          name: Datetime.months[i],
          value: i + 1
        });
      }
      vm.months = months;
    }

    function initYears() {
      var year = parseInt(Datetime.now('YYYY'));
      var years = [];
      for (var i = year - 10, l = year - 80; i >= l; i--) {
        years.push({
          name: i,
          value: i
        });
      }
      vm.years = years;
      // vm.year = year - 25;
    }

    function search() {
      var vlExtranjero = vm.extranjero == undefined ? false : vm.extranjero;
      if (vm.documentoIdentidad.length < 5) {
        Message.error("El documento de identidad debe tener un mínimo de 5 caracteres.");
      } else if (vm.year < 1900) {
        Message.error("Por favor escriba un año válido.");
      } else if (!vlExtranjero && !(vm.primer_apellido || vm.segundo_apellido)) {
        Message.error("Por favor escriba al menos un apellido.");
      } else {
        /*
        if (vm.url && !vm.get) {
          DataService.post(vm.url, {
            extranjero: vlExtranjero,
            documento_identidad: vm.documentoIdentidad
          })
          .then(function(response) {
            // Cargando valores por defecto para la busqueda
            if (response && response.datos && response.datos.length) {
              $window.sessionStorage.setItem("busquedaPostulante", vm.documentoIdentidad);
              vm.personas = response.datos;
            } else {
              Message.error('No existe el registro');
              vm.personas = [];
            }
          });
        } else if (vm.url && vm.get) {
          DataService.get(vm.url + '?ci=' + vm.documentoIdentidad + '&fecha_nacimiento=' + Datetime.replace([vm.day, vm.month, vm.year].join('/')) + '&extranjero=' + vlExtranjero)
            .then(function(response) {
              if (response) {
                vm.persona = response;
                if (vm.mensaje) {
                  Message.success(vm.mensaje);
                }
              } else {
                vm.persona = {};
              }
              vm.persona.extranjero = vlExtranjero;
            });
        } else {
        */

          vm.primer_apellido = vm.primer_apellido == undefined ? '' : vm.primer_apellido;
          vm.segundo_apellido = vm.segundo_apellido == undefined ? '' : vm.segundo_apellido;
          vm.casada_apellido = vm.casada_apellido == undefined ? '' : vm.casada_apellido;
          vm.persona = {};
          var urlConsulta = restUrl + 'persona/servicio/segip' +
                            '?ci=' + vm.documentoIdentidad +
                            '&fecha_nacimiento=' + Datetime.replace([vm.day, vm.month, vm.year].join('/')) +
                            '&extranjero=' + vlExtranjero +
                            '&nombres=' + vm.nombres +
                            '&primer_apellido=' + vm.primer_apellido +
                            '&segundo_apellido=' + vm.segundo_apellido +
                            '&casada_apellido=' + vm.casada_apellido +
                            '&tipo_persona=' + vm.tipoPersona
                            ;
          DataService.get(urlConsulta)
            .then(function(response) {
              if (response && response.datos) {
                vm.persona = response.datos;
                vm.persona.extranjero = vlExtranjero;
                vm.encontrado = true;
                if (!vlExtranjero) {
                  vm.persona.encontrado = 1;
                  // vm.persona.casada_apellido = '';
                }
              } else {
                vm.persona = {
                  documento_identidad: vm.documentoIdentidad,
                  fecha_nacimiento: Datetime.replace([vm.day, vm.month, vm.year].join('/'))
                };
                // TODO: Quitar cuando ya esta validado el servicio de migración (HECHO)
                if (vlExtranjero === true) {
                  vm.persona.encontrado = -1;
                }
              }
              vm.persona.extranjero = vlExtranjero;
            });
        // }
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .service('DemofiService', DemofiService);

  DemofiService.$inject = ['$q', '$mdDialog', 'demofiUrl', '$document', 'moment'];
  /* @ngInject */
  function DemofiService($q, $mdDialog, demofiUrl, $document, moment) {

    var self = this;

    self.firmar = firmar;
    self.asociar = asociar;
    self.listTokens = listTokens;
    self.login = login;
    self.verificarSesionToken = verificarSesionToken;
    self.listCertificates = listCertificates;
    self.sign = sign;
    self.logout = logout;
    self.getFileBase64 = getFileBase64;
    self.postBlobFile = postBlobFile;
    self.matarProceso = matarProceso;
    self.encontrarFirmas = encontrarFirmas;

    var mensajeErrorDemofi = "No se pudo conectar con Demofi. Verifique que su equipo esté ejecutando el programa y vuelva a intentarlo.";

    function encontrarFirmas(credencial) {
      return $q(function(resolve, reject) {
        angular.element.ajax({
          url: demofiUrl.servicios.encontrarFirmas,
          dataType: "json",
          type: "POST",
          data: angular.toJson({
            "pdf_base64": credencial
          }),
          success: function(data) {
            if (data.finalizado === false) {
              reject(data);
              return;
            }
            resolve(data);
          },
          error: function(XMLHttpRequest) {
          // error: function(XMLHttpRequest, textStatus, errorThrown) {
            if (XMLHttpRequest) {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            } else {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            }
          }
        });
      });
    }

    function firmar(documentos, onError, onSuccess, onIniciarProceso, onFinalizarProceso) {
      var deferred = $q.defer();
      this.listTokens().then(function() {
      // this.listTokens().then(function(response) {
        return $mdDialog.show({
          parent: angular.element($document.body),
          templateUrl: 'app/components/demofi/demofi.dialog.html',
          locals: {
            solicitudes: documentos,
            onError: onError,
            onSuccess: onSuccess,
            onIniciarProceso: onIniciarProceso,
            onFinalizarProceso: onFinalizarProceso,
            handleCerrar: null
          },
          controller: 'DemofiController as vm'
        });
      }).then(function(response) {
        deferred.resolve(response);
      }).catch(function(error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function asociar(documentos, onError, onSuccess, onIniciarProceso, onFinalizarProceso, handleCerrar) {
      var deferred = $q.defer();
      this.listTokens().then(function() {
        return $mdDialog.show({
          parent: angular.element($document.body),
          templateUrl: 'app/components/demofi/asociar.dialog.html',
          locals: {
            solicitudes: documentos,
            onError: onError,
            onSuccess: onSuccess,
            onIniciarProceso: onIniciarProceso,
            onFinalizarProceso: onFinalizarProceso,
            handleCerrar: handleCerrar
          },
          controller: 'DemofiController as vm'
        });
      }).then(function(response) {
        deferred.resolve(response);
      }).catch(function(error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }

    //función para listar tokens
    function listTokens() {
      return $q(function(resolve, reject) {
        angular.element.ajax({
          url: demofiUrl.servicios.tokens,
          dataType: "json",
          type: "GET",
          success: function(data) {
            if (data.finalizado === false) {
              reject(data);
              return;
            }
            resolve(data);
          },
          error: function(XMLHttpRequest) {
          // error: function(XMLHttpRequest, textStatus, errorThrown) {
            if (XMLHttpRequest) {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            } else {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            }
          }
        });
      });
    }

    // Función que permite iniciar sesión en el token
    // TODO implementar seguridad
    function login(pinToken) {
      return $q(function(resolve, reject) {
        angular.element.ajax({
          url: demofiUrl.servicios.start,
          dataType: "json",
          type: "GET",
          data: {
            pin: pinToken
          },
          success: function(data) {
            if (data.finalizado === false) {
              reject(data);
              return;
            }
            resolve(data);
          },
          error: function(XMLHttpRequest) {
          // error: function(XMLHttpRequest, textStatus, errorThrown) {
            if (XMLHttpRequest) {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            } else {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            }
          }
        });
      });
    }

    function verificarSesionToken() {
      return $q(function(resolve, reject) {
        angular.element.ajax({
          url: demofiUrl.servicios.estadoToken,
          dataType: 'json',
          success: function(data) {
            if (data.finalizado === false) {
              reject(data);
              return;
            }
            resolve(data);
          },
          error: function(XMLHttpRequest) {
          // error: function(XMLHttpRequest, textStatus, errorThrown) {
            if (XMLHttpRequest) {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            } else {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            }
          }
        });
      });
    }

    // Función que lista los certificados de un token
    function listCertificates() {
      return $q(function(resolve, reject) {
        angular.element.ajax({
          url: demofiUrl.servicios.certs,
          dataType: "json",
          success: function(data) {
            // Controlando que el token tenga certificado no caducado
            if (data.datos[0].finValidez) {
              var finValidezParseado = moment(data.datos[0].finValidez, 'DD/MM/YYYY').format('YYYY-MM-DD');
              var fechaFin = new Date(finValidezParseado);
              var fechaActual = new Date();
              if (fechaFin.getTime() < fechaActual.getTime()) {
                // Validez del token sobrepasado - token caducado
                reject({
                  finalizado: false,
                  mensaje: 'El certificado del token ya caducó, necesita renovar su token para firmar documentos'
                });
                return;
              }
            }
            // --
            if (data.finalizado === false) {
              reject(data);
              return;
            }
            resolve(data);
          },
          error: function(XMLHttpRequest) {
          // error: function(XMLHttpRequest, textStatus, errorThrown) {
            if (XMLHttpRequest) {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            } else {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            }
          }
        });
      });
    }

    function sign(solicitudFirma, aliasParaFirmar) {
      return $q(function(resolve, reject) {
        angular.element.ajax({
          url: demofiUrl.servicios.sign,
          type: "POST",
          data: angular.toJson({
            nombre_archivo: solicitudFirma.codigo_archivo,
            pdf_base64: solicitudFirma.pdf_base64,
            alias: aliasParaFirmar
          }),
          dataType: "json",
          success: function(result) {
            resolve(result);
          },
          error: function() {
          // error: function(xhr, status, error) {
            reject({
              finalizado: false,
              mensaje: mensajeErrorDemofi
            });
          }
        });
      });
    }

    // Función que permite cerrar sesión en un token
    function logout() {
      return $q(function(resolve, reject) {
        angular.element.ajax({
          url: demofiUrl.servicios.finish,
          dataType: "json",
          success: function(data) {
            if (data.finalizado === false) {
              reject(data);
              return;
            }
            resolve(data);
          },
          error: function(XMLHttpRequest) {
          // error: function(XMLHttpRequest, textStatus, errorThrown) {
            if (XMLHttpRequest) {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            } else {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            }
          }
        });
      });
    }

    // Función que permite matar el demonio en caso de ser necesario.
    function matarProceso() {
      return $q(function(resolve, reject) {
        angular.element.ajax({
          url: demofiUrl.servicios.matarProceso,
          dataType: "json",
          success: function(data) {
            if (data.finalizado === false) {
              reject(data);
              return;
            }
            resolve(data);
          },
          error: function(XMLHttpRequest) {
          // error: function(XMLHttpRequest, textStatus, errorThrown) {
            if (XMLHttpRequest) {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            } else {
              reject({
                finalizado: false,
                mensaje: mensajeErrorDemofi
              });
            }
          }
        });
      });
    }

    // Utilidades: función que obtiene un archivo a partir de un string en base64
    function getFileBase64(urlFile) {
      return $q(function(resolve) {
      // return $q(function(resolve, reject) {
        var request = new XMLHttpRequest();
        request.open("GET", urlFile, true);
        request.responseType = "blob";
        request.onload = function() {
        // request.onload = function(e) {
          if (this.status === 200) {
            // `blob` response
            var blob = this.response;
            var reader = new FileReader();
            reader.onload = function() {
              resolve(reader.result);
            };
            reader.readAsDataURL(blob);
          }
        };
        request.send();
      });
    }

    // Eventualmente no se utiliza
    function postBlobFile(urlPostFile, blobData) {
      return $q(function(resolve, reject) {
        var fd = new FormData();
        fd.append('fname', 'test.wav');
        fd.append('data', blobData);
        angular.element.ajax({
          type: 'POST',
          url: urlPostFile,
          data: fd,
          processData: false,
          contentType: false,
          success: function(blobResult) {
            resolve(blobResult);
          },
          error: function() {
          // error: function(errorResult) {
            reject();
          }
        });
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('DemofiController', DemofiController);

  DemofiController.$inject = ['$q', '$mdDialog', '$interval', '$http', '$window', 'DemofiService',
    'solicitudes', 'onError', 'onSuccess', 'onIniciarProceso', 'onFinalizarProceso', 'handleCerrar',
    'configNumeroIntentos', 'configNumeroPeticiones', 'DataService', 'restUrl'
  ];
  /* @ngInject */
  function DemofiController($q, $mdDialog, $interval, $http, $window, DemofiService, solicitudes, onError, onSuccess, onIniciarProceso, onFinalizarProceso, handleCerrar, configNumeroIntentos, configNumeroPeticiones, DataService, restUrl) {
    var vm = this;
    vm.onError = onError;
    vm.onSuccess = onSuccess;
    vm.onIniciarProceso = onIniciarProceso;
    vm.onFinalizarProceso = onFinalizarProceso;
    vm.handleCerrar = handleCerrar;
    vm.solicitudes = solicitudes;

    //   COMENZANDO CON LAS PANTALLAS
    vm.pin = undefined;
    vm.tokens = [];
    vm.certificados = [];
    vm.firmados = 0;
    vm.certificado_seleccionado = undefined;
    vm.autenticado = false;
    vm.numeroIntentos = 0;

    //variables
    var idInterval;
    var numeroPeticiones = 0;

    activate();

    function activate() {
      //Mandamos a verificar si el token está conectado por primera vez al instante de levantar el modal
      verificarTokenConectado();

      // Verifica si un token está conectado cada 7 segundos
      idInterval = $interval(verificarTokenConectado, 7000);

      // Verifica el estado del token
      if (vm.solicitudes !== false) {
        DemofiService.verificarSesionToken().then(function(resToken) {
          var bolAnteriorSesion = (resToken.mensaje === 'True');
          if (bolAnteriorSesion) {
            DemofiService.logout();
          }

          // Busca el certificado digital del usuario logueado
          DataService.get(restUrl + 'usuarios/buscar/token')
          .then(function(data) {
            if (data && data.datos) {
              vm.certificadoRecuperado = data.datos.token;
            } else {
              vm.certificadoRecuperadoError = "El usuario logueado no cuenta con certificado digital registrado.";
            }
          });

          // Inicaliza los estados de los documentos pendientes de firma
          inicializarEstados();
        });
      }
    }

    // introduciendo a todas las solicitudes un estado por defecto PENDIENTE
    function inicializarEstados() {
      for (var index = 0; index < vm.solicitudes.length; index++) {
        vm.solicitudes[index].estado = 'PENDIENTE';
      }
    }

    // Verifica si el token esta conectado cada cierto tiempo
    function verificarTokenConectado() {
      DemofiService.listTokens().then(function(response) {
        numeroPeticiones++;
        // El token soporta 190 peticiones hasta antes de dejar de responder. Si las petciones hacen un total de 170 (valor en config.js), el componente modal se cierra
        if (numeroPeticiones === configNumeroPeticiones) {
          vm.cancelar();
        }
        vm.tokens = response.datos;
        if (vm.tokens.length === 0) {
          vm.autenticado = false;
          vm.certificados = [];
          vm.certificado_seleccionado = undefined;
          vm.pin = undefined;
        }
      }).catch(function(error) {
        vm.cancelar(error); // Mandar a cerrar
      });
    }

    // Inicia sesión con el PIN escrito
    vm.autenticar = function() {
      onIniciarProceso('Iniciando sesión...'); // ejecutar función personalizada
      DemofiService.login(vm.pin).then(function() {

        onFinalizarProceso(); // ejecturar función personalizada
        vm.autenticado = true;
        // Una vez autenticado actualizamos la lista de certificados
        DemofiService.listCertificates().then(function(respCert) {
          vm.certificados = respCert.datos;
          for (var i in vm.certificados) {
            if (vm.certificados[i].numeroSerie == vm.certificadoRecuperado) {
              vm.certificado_seleccionado = vm.certificados[i];
            }
          }
          if (vm.certificado_seleccionado) {
            onSuccess('Sesión iniciada correctamente');
            vm.firmar();
          } else {
            onError('Ninguno de los certificados digitales del token conectado coincide con el certificado digital del usuario logueado.');
            salirModal();
          }

        }).catch(function(error) {
          onError(error.mensaje);
        });
      }).catch(function(error) {
        numeroPeticiones = 0;
        onFinalizarProceso(); // función personalizada detener proceso
        vm.autenticado = false;
        if (error.mensaje === 'La sesión ya fue iniciada, no se puede iniciar nuevamente.') {
          DemofiService.logout().then(function() {
            onSuccess('Sesión cerrada correctamente');
          });
        } else {
          onError(error.mensaje); // funcion personalizada error
          vm.numeroIntentos++;
          validarNumeroIntentos();
        }

      });

    };

    vm.asociar = function() {
      onIniciarProceso('Iniciando sesión...'); // ejecutar función personalizada
      DemofiService.login(vm.pin).then(function() {

        vm.autenticado = true;
        // Una vez autenticado actualizamos la lista de certificados
        DemofiService.listCertificates().then(function(respCert) {
          vm.certificados = respCert.datos;
          if (vm.certificados && vm.certificados.length) {
            onSuccess('Sesión iniciada correctamente');
            onFinalizarProceso(vm.certificados, vm.cancelar); // ejecturar función personalizada
            vm.autenticado = false;
            salirModal();
          } else {
            onError("No se encuentraron certificados digitales en el token.");
            salirModal();
          }
        }).catch(function(error) {
          onError(error.mensaje);
        });
      }).catch(function(error) {
        onFinalizarProceso(); // función personalizada detener proceso
        vm.autenticado = false;
        if (error.mensaje === 'La sesión ya fue iniciada, no se puede iniciar nuevamente.') {
          DemofiService.logout().then(function() {
            onSuccess('Sesión cerrada correctamente');
          });
        } else {
          onError(error.mensaje); // funcion personalizada error
          validarNumeroIntentos();
        }

      });

    }

    vm.cancelar = function(error) {
      vm.autenticado ? cerarSesionSalir(error) : salirModal(error);
    };

    vm.cancelarAsociar = function(error) {
      if (vm.autenticado) {
        cerarSesionSalir(error);
      } else {
        salirModal(error);
      }
      if (vm.handleCerrar) {
        vm.handleCerrar();
      }
    };


    var validarNumeroIntentos = function() {
      if (vm.numeroIntentos === configNumeroIntentos) {
        // funcion personalizada error
        onError('Ha ingresado erróneamente su PIN dos veces. Al tercer intento fallido el token se bloqueará permanentemente. Por favor, retire su token y vuelva a autenticarse con los datos correctos.');
        salirModal();

      }
    };

    var cerarSesionSalir = function(error) {
      DemofiService.logout().then(function() {
        salirModal(error);
      }).
      catch(function(errorLogout) {
        salirModal(errorLogout);
      });
    };

    var salirModal = function(error) {
      if (idInterval) {
        $interval.cancel(idInterval);
      }
      $mdDialog.cancel(error);
    }

    vm.linkModelFunc = function(url) {
      $window.open(url);
    }


    var indice = 0;
    vm.firmar = function() {

      // Obtener todos los documentos en blobs
      vm.estaFirmando = true;
      var aliasSeleccionado = vm.certificado_seleccionado.alias;
      indice = 0;
      vm.firmados = 0;
      var firmadosConError = 0;
      // Función de control
      var continuarOFinalizarFirma = function() {
        vm.firmados++;
        if (indice + 1 >= vm.solicitudes.length) {
          DemofiService.logout().then(function() {
            if (idInterval) {
              $interval.cancel(idInterval);
            }
            if (vm.firmados === vm.solicitudes.length - 1) {
              onSuccess('Todos los documentos fueron firmados correctamente');
            }
          })
          .catch(function(error) {
            onError(error.mensaje); // función error
          });

        } else {
          indice++;
          firmarDocumento(indice, aliasSeleccionado).then(function() {
            continuarOFinalizarFirma();
          }).catch(function() {
            firmadosConError++;
            continuarOFinalizarFirma();
          });
        }
      };
      var firmarDocumento = function(indice, aliasSeleccionado) {
        var solDoc = vm.solicitudes[indice];
        onIniciarProceso('Firmando documentos'); // funcion iniciar proceso
        return $q(function(resolve, reject) {
          // solDoc.estado = "DESCARGANDO";
          solDoc.estado = 'FIRMANDO';
          DemofiService.sign(solDoc, aliasSeleccionado).then(function(respFirma) {
            solDoc.estado = 'VER';
            solDoc.pdf_base64 = respFirma.datos.pdf_base64;
            onFinalizarProceso(respFirma, solDoc); // función detener proceso
            resolve(solDoc);
          }).catch(function(error) {
            solDoc.estado = 'ERROR_FIRMA';
            reject(error);
          });
        });
      };

      firmarDocumento(indice, aliasSeleccionado).then(function() {
        continuarOFinalizarFirma();
      }).catch(function() {
        firmadosConError++;
        continuarOFinalizarFirma();
      });
    };

    vm.enviar = function() {
      $mdDialog.hide(vm.solicitudes);
    };

  }

})();

(function() {
    'use strict';
    var demofiUrl = 'https://localhost:3200';
    var objDemofiUrl = {
      url: demofiUrl,
      servicios: {
        tokens: demofiUrl + '/tokens',
        certs: demofiUrl + '/certs',
        finish: demofiUrl + '/finish',
        sign: demofiUrl + '/sign',
        start: demofiUrl + '/start',
        estadoToken: demofiUrl + '/estadoToken',
        encontrarFirmas: demofiUrl + '/firmasEncontradas',
        matarProceso: demofiUrl + '/matarProceso'
      }
    }
    var configNumeroIntentos = 2;
    var configNumeroPeticiones = 170;

    angular
        .module('app')
        .constant('demofiUrl', objDemofiUrl)
        .constant('configNumeroIntentos', configNumeroIntentos)
        .constant('configNumeroPeticiones', configNumeroPeticiones)

})();

(function() {
    'use strict';

    angular
    .module('app')
    .component('crudTableAlt', {
        templateUrl : 'app/components/crudTableAlt/crudTableAlt.html',
        controller : ['$scope', 'DataService', 'Message', 'Modal', 'Util', '$timeout', 'ArrayUtil', '$location', CrudTableAltController],
        controllerAs: 'vm',
        bindings: {
            url: '=',
            fields: '=',
            fks: '=',
            titleTable: '=',
            template: '=',
            permission: '=',
            column: '=',
            formly: '=',
            editable: '=',
            eventSave: '=',
            dialogController: '=',
            order: '=',
            optionSelected: '=',
            buttons: '=',
            botones: '=',
            redirectDetail: '=?redirect',
            urldata: '=',
            archivo: '='
        }
    });

    function CrudTableAltController($scope, DataService, Message, Modal, Util, $timeout, ArrayUtil, $location) {
        var vm = this;
        var limit = 10;

        vm.headers = [];
        vm.items = [];
        vm.item = null;

        vm.add = add;
        vm.edit = edit;
        vm.delete = deleteItem;
        vm.print = print;
        vm.save = save;
        vm.saveAll = saveAll;
        vm.removeFilter = removeFilter;
        vm.showFilter = showFilter;
        vm.buscarFiltro = buscarFiltro;
        vm.getItems = getItems;
        vm.buttonEvent = buttonEvent;
        vm.dataGrid = {};

        vm.permissions = {
            create: true,
            read: true,
            update: true,
            delete: true,
            print: false,
            filter: true
        }

        vm.limitOptions = [limit, 25, 50];
        // vm.limitOptions = [limit];

        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: true,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: false
        }

        vm.query = {
            order: '',
            limit: limit,
            page: 1,
            filter: ''
        }

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        activate();

        function activate() {
            getFields();
        }

        function getItems () {
            if (vm.fieldsData) {
                vm.promise = getData();
            }
        }

        function add(event, item) {
          var id = getId(item);
          if (id) {
            getItem(event, false, id);
          } else {
            openDialog(event, true, {});
          }
        }

        function getId(item, key) {
          if (item) {
            var formly = vm.fieldsData;
            for (var i in formly) {
              if (formly[i].templateOptions.label && formly[i].templateOptions.label == 'ID') {
                if (key) {
                    return formly[i].key;
                } else {
                    return item[formly[i].key];
                }
              }
            }
          }
            return null;
        }

        function save (data) {
          var obj = {};
          for (var i in data) {
              obj[i] = vm.dataGrid[data[i]]
          }
          DataService.save(vm.url, parseSave(obj))
          .then(function(data) {
              if (data) {
                  Message.success('Registro actualizado');
              }
          });
        }

        function parseSave(data) {
          var item = {};
          for (var i in data) {
              if (Util.toType(data[i]) == 'date') {
                  item[i] = parseDate(data[i]);
              } else {
                  item[i] = data[i];
              }
          }
          item.id = getId(item);
          return item;
        }

        function parseDate(date) {
          return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
        }

        function saveAll () {
            var data = vm.dataGrid,
                c = 0,
                length = vm.headers.length,
                dataSave = [],
                obj = {},
                promises = [];

            for (var i in data) {
                var key = i.split('_');
                key.shift();
                key = key.join('_');
                obj[key] = data[i];
                c++;
                if (c % length == 0) {
                    dataSave.push(obj);
                    promises.push(savePromise(obj));
                    obj = {};
                }
            }
            Promise.all(promises)
            .then(function (response) {
                for (var i in response) {
                    if (response[i] === false) {
                        Message.error('Se produjo un error al grabar todos los datos.');
                        throw new Error('Error al grabar todos los datos');
                    }
                }
                Message.success('Se guardaron todos los datos');
            });
        }

        function savePromise(data) {
          return new Promise(function (resolve, reject) {
              DataService.save(vm.url, parseSave(data))
              .then(function(data) {
                  if (data) {
                      resolve(true);
                  } else {
                      reject(false);
                  }
              }).catch(function () {
                  reject(false);
              });
          });
        }

        function edit (event, item) {
            vm.add(event, item)
        }

        function deleteItem (event, item) {
            Modal.confirm('Se eliminará el registro de forma permanente, ¿Está seguro?.', function () {
                DataService.delete(vm.url, getId(item))
                .then(function() {
                    Message.success('El registro se eliminó correctamente.');
                    vm.getItems();
                })
                .catch(function () {
                    Message.error();
                });
            }, null, event);
        }

        function getItem(event, add, id) {
          DataService.get(vm.url, id)
          .then(function(data) {
              if (data && data[getId(data, true)]) {
                  openDialog(event, add, filterItem(data));
              }
          })
        }

        function openDialog(event, add, item) {
          if (vm.archivo) {
            item.mostrarArchivo = true;
            item.labelArchivo = vm.archivo.label;
          }
          var config = {
            event: event,
            data: item,
            title: add ? 'Agregar' : 'Editar',
            add: add,
            fields: vm.fieldsData,
            column: vm.column || 1,
            templateUrl : vm.template || 'app/components/crudTableAlt/dialog.crudTableAlt.html',
            done : function (answer, $mdDialog) {
              if (answer == 'save') {
                DataService.save(vm.url, parseSave(item))
                .then(function(data) {
                  if (data) {
                    Message.success();
                    $mdDialog.hide();
                    if (vm.redirectDetail) {
                      $location.path(vm.redirectDetail + getId(data));
                    } else {
                      vm.getItems();
                      if (vm.eventSave) {
                        vm.eventSave(data);
                      }
                    }
                  }
                });
              }
            }
          };
          if (vm.dialogController) {
              config.controller = vm.dialogController;
          }
          Modal.show(config);
        }

        // function guardarItem(item, $mdDialog) {
        //   DataService.save(vm.url, parseSave(item))
        //   .then(function(data) {
        //       if (data) {
        //           Message.success();
        //           $mdDialog.hide();
        //           if (vm.redirectDetail) {
        //               $location.path(vm.redirectDetail + getId(data));
        //           } else {
        //             vm.getItems();
        //             if (vm.eventSave) {
        //                 vm.eventSave(data);
        //             }
        //           }
        //       }
        //   });
        // }

        function getData() {
          var urlData = vm.urldata != null ? vm.urldata : vm.url;
            return DataService.list(urlData, vm.query)
            .then(function(data) {
                if (data) {
                  var items = data;
                  items.data = filterItems(data.rows);
                  vm.items = items;
                }
            });
        }

        function getFields() {
            DataService.fields(vm.url)
            .then(function(data) {
                if (data) {
                    vm.fieldsData = Util.filterFields(data, vm.fields);
                    vm.fieldsData = Util.addPropertiesFormly(vm.fieldsData, vm.formly);
                    addOptionSelected(vm.fieldsData, vm.optionSelected);
                    DataService.setFormly(vm.fieldsData);

                    setHeaders(vm.fieldsData);
                    if (vm.editable) {
                        vm.types = getTypes(vm.fieldsData);
                    }
                    if (vm.permission) {
                        vm.permissions = angular.merge(vm.permissions, vm.permission);
                    }
                    vm.getItems();
                }
            });
        }

        function addOptionSelected(data, options) {
            for (var i in data) {
                if (data[i].type == 'select') {
                    var item = Util.searchField(options, data[i].key);
                    if (item) {
                        ArrayUtil.insert(data[i].templateOptions.options, 0, {
                            name: item.text || 'Seleccione',
                            value: item.value || ''
                        });
                    }
                }
            }
        }

        function getTypes(data) {
            var types = {};

            data.map(function(el) {
                types[el.key] = el;
            });

            return types;
        }

        function filterItems(data) {
            var fields = typeof vm.fields != 'undefined';
            var fks = typeof vm.fks != 'undefined';
            var array = [];
            for (var i in data) {
                for (var j in data[i]) {
                    if (fields && vm.fields.indexOf(j) == -1) {
                        delete data[i][j];
                    } else {
                        if (typeof vm.editable == 'undefined') {
                            if (typeof data[i][j] == 'boolean') {
                                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
                            } else if (fks && vm.fks.indexOf(j) != -1) {
                                if (Util.toType(data[i][j]) == 'array') {
                                    var l = lengthOptions(vm.fieldsData, j);
                                    if (l > 1 && l == data[i][j].length) {
                                        data[i][j] = 'Todos';
                                    } else {
                                        var text = [];
                                        data[i][j].map(function (e) {
                                           text.push(Util.getFkData(vm.fieldsData ,j, e));
                                        });
                                        data[i][j] = text.join(', ');
                                    }
                                } else {
                                    data[i][j] = Util.getFkData(vm.fieldsData ,j, data[i][j]);
                                }
                            } else if (typeof data[i][j] == 'string' && !/[a-zA-Z]+/g.test(data[i][j]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[i][j]) && data[i][j].length == 10) {
                                data[i][j] = formatDate(data[i][j]);
                            } else if (Util.toType(data[i][j]) == 'array') {
                                data[i][j] = data[i][j][0];
                            } else if (typeof data[i][j] == 'string' && !/[a-zA-Z]+/g.test(data[i][j]) && /^-?[0-9.]+\:?[0-9]+\:?[0-9]*$/g.test(data[i][j]) && data[i][j].length == 8) {
                              data[i][j] = formatTime(data[i][j])
                            }
                        }
                    }
                }
                array.push(orderItem(data[i], vm.fieldsData, i));
            }
            return array;
        }

        function lengthOptions(data, key) {
            for (var i in data) {
                if (data[i].key == key && data[i].templateOptions && data[i].templateOptions.options) {
                    return data[i].templateOptions.options.length;
                }
            }
            return 0;
        }

        function orderItem(data, fields, pos) {

            if (typeof fields == 'undefined' || fields.length == 0) {
                return data;
            }

            var item = {};

            for (var i in fields) {
                var field = fields[i].key
                if (typeof data[field] != 'undefined') {
                    if (vm.editable) {
                        if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
                            var date = data[field].split('-');
                            vm.dataGrid[pos + '_' + field] = new Date(date[0], date[1]-1, date[2]);
                        } else {
                            vm.dataGrid[pos + '_' + field] = data[field];
                        }
                        item[field] = pos + '_' + field;
                    } else {
                        item[field] = data[field];
                    }
                }
            }

            return item;
        }

        function filterItem(data) {
            for (var i in data) {
                if (typeof data[i] == 'string') {
                    if (!/[a-zA-Z]+/g.test(data[i]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[i]) && data[i].length == 10) {
                        var date = data[i].split('-');
                        data[i] = new Date(date[0],date[1]-1,date[2]);
                    } else if (!/[a-zA-Z]+/g.test(data[i]) && /^-?[0-9.]+\:?[0-9]+\:?[0-9]*$/g.test(data[i]) && data[i].length == 8) {
                        data[i] = formatTime(data[i]);
                    }
                } else if (Util.toType(data[i]) == 'array') {
                    // console.log(i, data[i])
                    // data[i] = data[i][0];
                }
            }
            return data;
        }

        function formatDate(date) {
            date = date.split('-')
            return [date[2], date[1], date[0]].join('/');
        }

        function formatTime(time) {
            time = time.split(':')
            return [time[0], time[1]].join(':')
        }

        function setHeaders(data) {
            var headers = [];
            var order = typeof vm.order == 'undefined';
            for (var i in data) {
                headers.push({
                    name: data[i].key,
                    title: data[i].templateOptions.label,
                    order: order || (vm.order && vm.order.indexOf(data[i].key) != -1)
                });
            }
            vm.headers = headers;
        }

        function print(event, item) {
            DataService.pdf(vm.url + 'print/' + getId(item) + '/')
            .then(function (data) {
                Modal.show({
                    event: event,
                    data: data,
                    title: 'Impresión',
                    templateUrl : 'app/components/crudTableAlt/dialog.pdf.html',
                    controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
                });
            });
        }

        function PdfController($scope, $mdDialog, data, title) {
            var vm = $scope;

            vm.title = title;
            vm.data = data;
            vm.hide = $mdDialog.hide;
            vm.cancel = $mdDialog.cancel;
        }

        function showFilter() {
            vm.filter.show = true;
            $timeout(function () {
                angular.element('#crud-table-input').focus();
            }, 300);
        }

        function removeFilter () {
            vm.filter.show = false;
            vm.query.filter = '';

            if(vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
            vm.getItems();
        }

        function buscarFiltro() {
          vm.getItems();
        }

        //New Bottons
        function buttonEvent(event, item, callback) {
            callback(event, getId(item), item, getItems);
        }

    }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('crudTable', {
      templateUrl: 'app/components/crudTable/crudTable.html',
      controller: ['$scope', 'DataService', 'Message', 'Modal', 'Util', '$timeout', 'ArrayUtil', '$location', CrudTableController],
      controllerAs: 'vm',
      bindings: {
        url: '=',
        fields: '=',
        esconder: '=',
        fks: '=',
        titleTable: '=',
        template: '=',
        permission: '=',
        column: '=',
        formly: '=',
        editable: '=',
        eventSave: '=',
        dialogController: '=',
        order: '=',
        optionSelected: '=',
        buttons: '=',
        botones: '=',
        redirectDetail: '=?redirect',
        urldata: '=',
        archivos: '=',
        actualizarcruddatos: '=',
        ocultarCreate:'='
      }
    });

  function CrudTableController($scope, DataService, Message, Modal, Util, $timeout, ArrayUtil, $location) {
    var vm = this;
    // var bookmark;
    var limit = 10;

    if (vm.actualizarcruddatos) {
      vm.actualizarcruddatos = function(urldata, url, query) {
        if (urldata) {
          vm.urldata = urldata;
        }
        if (url) {
          vm.urldata = url;
        }
        if (query) {
          for (var i in query) {
            vm.query[i] = query[i];
          }
        }
        getData();
      }
    }

    vm.headers = [];
    vm.items = [];
    vm.item = null;

    vm.add = add;
    vm.edit = edit;
    vm.delete = deleteItem;
    vm.print = print;
    vm.save = save;
    vm.saveAll = saveAll;
    vm.removeFilter = removeFilter;
    vm.buscarFiltro = buscarFiltro;
    vm.showFilter = showFilter;
    vm.getItems = getItems;
    vm.buttonEvent = buttonEvent;
    vm.dataGrid = {};
    vm.mostrarCampo = mostrarCampo;

    vm.permissions = {
      create: true,
      read: true,
      update: true,
      delete: true,
      print: false,
      filter: true
    }

    vm.limitOptions = [limit, 25, 50];
    // vm.limitOptions = [limit];

    vm.options = {
      rowSelection: false,
      multiSelect: false,
      autoSelect: true,
      decapitate: false,
      largeEditDialog: true,
      boundaryLinks: true,
      limitSelect: true,
      pageSelect: false
    }

    vm.query = {
      order: '',
      limit: limit,
      page: 1,
      filter: ''
    }

    vm.filter = {
      options: {
        debounce: 500
      }
    };

    activate();

    function activate() {
      getFields();
    }

    function getItems() {
      if (vm.fieldsData) {
        vm.promise = getData();
      }
    }

    function add(event, item) {
      var id = getId(item);
      if (id) {
        getItem(event, false, id);
      } else {
        openDialog(event, true, {});
      }
    }

    function getId(item, key) {
      if (item) {
        var formly = vm.fieldsData;
        for (var i in formly) {
          if (formly[i].templateOptions.label && formly[i].templateOptions.label == 'ID') {
            if (key) {
              return formly[i].key;
            } else {
              return item[formly[i].key];
            }
          }
        }
      }
      return null;
    }

    function save(data) {
      var obj = {};
      for (var i in data) {
        obj[i] = vm.dataGrid[data[i]]
      }
      DataService.save(vm.url, parseSave(obj))
        .then(function(data) {
          if (data.datos) {
            Message.success('Registro actualizado');
          }
        });
    }

    function parseSave(data) {
      var item = {};
      for (var i in data) {
        if (Util.toType(data[i]) == 'date') {
          item[i] = parseDate(data[i]);
        } else {
          item[i] = data[i];
        }
      }
      item.id = getId(item);
      return item;
    }

    function parseDate(date) {
      return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
    }

    function saveAll() {
      var data = vm.dataGrid,
        c = 0,
        length = vm.headers.length,
        dataSave = [],
        obj = {},
        promises = [];

      for (var i in data) {
        var key = i.split('_');
        key.shift();
        key = key.join('_');
        obj[key] = data[i];
        c++;
        if (c % length == 0) {
          dataSave.push(obj);
          promises.push(savePromise(obj));
          obj = {};
        }
      }
      Promise.all(promises)
        .then(function(response) {
          for (var i in response) {
            if (response[i] === false) {
              Message.error('Se produjo un error al grabar todos los datos.');
              throw new Error('Error al grabar todos los datos');
            }
          }
          Message.success('Se guardaron todos los datos');
        });
    }

    function savePromise(data) {
      return new Promise(function(resolve, reject) {
        DataService.save(vm.url, parseSave(data))
          .then(function(data) {
            if (data.datos) {
              resolve(true);
            } else {
              reject(false);
            }
          }).catch(function() {
            reject(false);
          });
      });
    }

    function edit(event, item) {
      vm.add(event, item)
    }

    function deleteItem(event, item) {
      Modal.confirm('Se eliminará el registro de forma permanente, ¿Está seguro?.', function() {
        DataService.delete(vm.url, getId(item))
          .then(function() {
            Message.success('El registro se eliminó correctamente.');
            vm.getItems();
          })
          .catch(function() {
            Message.error();
          });
      }, null, event);
    }

    function getItem(event, add, id) {
      DataService.get(vm.url, id)
        .then(function(data) {
          var item = data.datos;
          var nombreId = getId(item, true);
          if (item && item[nombreId]) {
            openDialog(event, add, filterItem(item));
          }
        })
    }

    function loadFiles(i, item, $mdDialog) {
      if (i < vm.archivos.length) {
        if (vm.archivos[i].files && vm.archivos[i].files.length > 0) {
          var archivo = vm.archivos[i].files[0].lfFile;
          var reader = new FileReader();
          reader.onload = function(readerEvt) {
            var binaryString = readerEvt.target.result;
            var imgData = 'data:' + archivo.type + ';base64,' + btoa(binaryString);
            item[vm.archivos[i].key] = imgData;
            loadFiles(i + 1, item, $mdDialog);
          };
          reader.readAsBinaryString(archivo);
        } else {
          loadFiles(i + 1, item, $mdDialog);
        }
      } else {
        guardarItem(item, $mdDialog);
      }

    }

    function openDialog(event, add, item) {
      for (var i = 0; i < vm.fieldsData.length; i++) {
        if (vm.fieldsData[i].type == 'datepicker') {
          if (item[vm.fieldsData[i].key]) {
            item[vm.fieldsData[i].key] = new Date(item[vm.fieldsData[i].key]);
          }
        }
      }
      if (vm.archivos) {
        item.archivos = vm.archivos;
      }
      var config = {
        event: event,
        data: item,
        title: add ? 'Agregar' : 'Editar',
        add: add,
        fields: vm.fieldsData,
        column: vm.column || 1,
        templateUrl: vm.template || 'app/components/crudTable/dialog.crudTable.html',
        done: function(answer, $mdDialog) {
          if (answer == 'save') {
            if (vm.archivos && vm.archivos.length > 0) {
              loadFiles(0, item, $mdDialog);
            } else {
              guardarItem(item, $mdDialog);
            }
          }
        }
      };
      if (vm.dialogController) {
        config.controller = vm.dialogController;
      }
      Modal.show(config);
    }

    function guardarItem(item, $mdDialog) {
      DataService.save(vm.url, parseSave(item))
        .then(function(data) {
          if (data && data.datos) {
            Message.success();
            $mdDialog.hide();
            if (vm.redirectDetail) {
              $location.path(vm.redirectDetail + getId(data.datos));
            } else {
              vm.getItems();
              if (vm.eventSave) {
                vm.eventSave(data.datos);
              }
            }
          }
        });
    }

    function getData() {
      var urlData = vm.urldata != null ? vm.urldata : vm.url;
      return DataService.list(urlData, vm.query)
        .then(function(data) {
          if (data) {
            var items = data.datos;
            items.data = filterItems(data.datos.rows);
            vm.items = items;
          } else {
            vm.items = [];
          }
        });
    }

    function getFields() {
      DataService.fields(vm.url)
        .then(function(data) {
          if (data) {
            vm.fieldsData = Util.filterFields(data, vm.fields);
            vm.fieldsData = Util.addPropertiesFormly(vm.fieldsData, vm.formly);
            addOptionSelected(vm.fieldsData, vm.optionSelected);
            DataService.setFormly(vm.fieldsData);

            setHeaders(vm.fieldsData);
            if (vm.editable) {
              vm.types = getTypes(vm.fieldsData);
            }
            if (vm.permission) {
              vm.permissions = angular.merge(vm.permissions, vm.permission);
            }
            vm.getItems();
          }
        });
    }

    function addOptionSelected(data, options) {
      for (var i in data) {
        if (data[i].type == 'select') {
          var item = Util.searchField(options, data[i].key);
          if (item) {
            ArrayUtil.insert(data[i].templateOptions.options, 0, {
              name: item.text || 'Seleccione',
              value: item.value || ''
            });
          }
        }
      }
    }

    function getTypes(data) {
      var types = {};

      data.map(function(el) {
        types[el.key] = el;
      });

      return types;
    }

    function filterItems(data) {
      var fields = typeof vm.fields != 'undefined';
      var fks = typeof vm.fks != 'undefined';
      var array = [];
      for (var i in data) {
        for (var j in data[i]) {
          if (fields && vm.fields.indexOf(j) == -1) {
            delete data[i][j];
          } else {
            if (typeof vm.editable == 'undefined') {
              if (typeof data[i][j] == 'boolean') {
                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
              } else if (fks && vm.fks.indexOf(j) != -1) {
                if (Util.toType(data[i][j]) == 'array') {
                  var l = lengthOptions(vm.fieldsData, j);
                  if (l > 1 && l == data[i][j].length) {
                    data[i][j] = 'Todos';
                  } else {
                    var text = [];
                    data[i][j].map(function(e) {
                      text.push(Util.getFkData(vm.fieldsData, j, e));
                    });
                    data[i][j] = text.join(', ');
                  }
                } else {
                  data[i][j] = Util.getFkData(vm.fieldsData, j, data[i][j]);
                }
              } else if (typeof data[i][j] == 'string' && !/[a-zA-Z]+/g.test(data[i][j]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[i][j]) && data[i][j].length == 10) {
                data[i][j] = formatDate(data[i][j]);
              } else if (Util.toType(data[i][j]) == 'array') {
                data[i][j] = data[i][j][0];
              } else if (typeof data[i][j] == 'string' && !/[a-zA-Z]+/g.test(data[i][j]) && /^-?[0-9.]+\:?[0-9]+\:?[0-9]*$/g.test(data[i][j]) && data[i][j].length == 8) {
                data[i][j] = formatTime(data[i][j])
              }
            }
          }
        }
        array.push(orderItem(data[i], vm.fieldsData, i));
      }
      return array;
    }

    function lengthOptions(data, key) {
      for (var i in data) {
        if (data[i].key == key && data[i].templateOptions && data[i].templateOptions.options) {
          return data[i].templateOptions.options.length;
        }
      }
      return 0;
    }

    function orderItem(data, fields, pos) {

      if (typeof fields == 'undefined' || fields.length == 0) {
        return data;
      }

      var item = {};

      for (var i in fields) {
        var field = fields[i].key
        if (typeof data[field] != 'undefined') {
          if (vm.editable) {
            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
              var date = data[field].split('-');
              vm.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
            } else {
              vm.dataGrid[pos + '_' + field] = data[field];
            }
            item[field] = pos + '_' + field;
          } else {
            item[field] = data[field];
          }
        }
      }

      return item;
    }

    function filterItem(data) {
      for (var i in data) {
        if (typeof data[i] == 'string') {
          if (!/[a-zA-Z]+/g.test(data[i]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[i]) && data[i].length == 10) {
            var date = data[i].split('-');
            data[i] = new Date(date[0], date[1] - 1, date[2]);
          } else if (!/[a-zA-Z]+/g.test(data[i]) && /^-?[0-9.]+\:?[0-9]+\:?[0-9]*$/g.test(data[i]) && data[i].length == 8) {
            data[i] = formatTime(data[i]);
          }
        } else if (Util.toType(data[i]) == 'array') {
          // console.log(i, data[i])
          // data[i] = data[i][0];
        }
      }
      return data;
    }

    function formatDate(date) {
      date = date.split('-')
      return [date[2], date[1], date[0]].join('/');
    }

    function formatTime(time) {
      time = time.split(':')
      return [time[0], time[1]].join(':')
    }

    function setHeaders(data) {
      var headers = [];
      var order = typeof vm.order == 'undefined';
      for (var i in data) {
        headers.push({
          name: data[i].key,
          title: data[i].templateOptions.label,
          order: order || (vm.order && vm.order.indexOf(data[i].key) != -1)
        });
      }
      vm.headers = headers;
    }

    function print(event, item) {
      DataService.pdf(vm.url + 'print/' + getId(item) + '/')
        .then(function(data) {
          Modal.show({
            event: event,
            data: data,
            title: 'Impresión',
            templateUrl: 'app/components/crudTable/dialog.pdf.html',
            controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
          });
        });
    }

    function PdfController($scope, $mdDialog, data, title) {
      var vm = $scope;

      vm.title = title;
      vm.data = data;
      vm.hide = $mdDialog.hide;
      vm.cancel = $mdDialog.cancel;
    }

    function showFilter() {
      vm.filter.show = true;
      $timeout(function() {
        angular.element('#crud-table-input').focus();
      }, 300);
    }

    function removeFilter() {
      vm.filter.show = false;
      vm.query.filter = '';

      if (vm.filter.form.$dirty) {
        vm.filter.form.$setPristine();
      }
      vm.getItems();
    }

    function mostrarCampo(columna) {
      if (vm.esconder && vm.esconder.length > 0) {
        for (var i in vm.esconder) {
          if (vm.esconder[i] == columna) {
            return false;
          }
        }
      }
      return true;
    }

    function buscarFiltro() {
      vm.getItems();
    }

    //New Bottons
    function buttonEvent(event, item, callback) {
      callback(event, getId(item), item, getItems);
    }

  }

})();

(function() {
    'use strict';

    angular
    .module('app')
    .component('combobox', {
        templateUrl : 'app/components/combobox/combobox.html',
        controller : ComboboxController,
        bindings: {
            options: '=',
            label: '='
        }
    });

    /** @ngInject */
    function ComboboxController() {

    }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('cedulaIdentidad', {
      templateUrl: 'app/components/cedulaIdentidad/cedulaIdentidad.html',
      controller: CedulaIdentidadController,
      bindings: {
        persona: '=',
        url: '=',
        birthday: '@',
        source: '@',
        documentoIdentidad: '=?documento',
        texto: '=',
        get: '=',
        mensaje: '='
      }
    });

  /** @ngInject */
  function CedulaIdentidadController(DataService, Datetime, Message, $window, restUrl) {
    var vm = this;

    vm.search = search;

    vm.encontrado = false;

    activate();

    function activate() {
      initDays();
      initMonths();
      initYears();

      // Cargando persona por defecto
      if (vm.persona) {
        vm.documentoIdentidad = vm.persona.documento_identidad;
        var fecha_nacimiento = new Date(vm.persona.fecha_nacimiento);
        vm.day = fecha_nacimiento.getDate();
        vm.month = fecha_nacimiento.getUTCMonth() + 1;
        vm.year = fecha_nacimiento.getUTCFullYear();
      }
    }

    function initDays() {
      var days = [];
      for (var i = 1; i <= 31; i++) {
        days.push({
          name: i,
          value: i
        });
      }
      vm.days = days;
    }

    function initMonths() {
      var months = [];
      for (var i = 0; i < 12; i++) {
        months.push({
          name: Datetime.months[i],
          value: i + 1
        });
      }
      vm.months = months;
    }

    function initYears() {
      var year = parseInt(Datetime.now('YYYY'));
      var years = [];
      for (var i = year - 10, l = year - 80; i >= l; i--) {
        years.push({
          name: i,
          value: i
        });
      }
      vm.years = years;
      vm.year = year - 25;
    }

    function search() {
      /*
      if (vm.url && !vm.get) {
        DataService.post(vm.url, {
            documento_identidad: vm.documentoIdentidad,
            documento_identidad_titular: vm.documentoIdentidad,
            fecha_nacimiento: Datetime.replace([vm.day, vm.month, vm.year].join('/'))
          })
          .then(function(response) {
            // Cargando valores por defecto para la busqueda
            if (response && response.length) {
              vm.persona = response;
              for (var i = 0; i < response.length; i++) {
                if (response[i].mensajeMostrar) {
                  Message.success(response[i].mensajeMostrar);
                }
              }
            } else {
              Message.error('No existe el registro');
              vm.persona = {};
            }
          });
      } else if (vm.url && vm.get) {
        DataService.get(vm.url + '?ci=' + vm.documentoIdentidad + '&fecha_nacimiento=' + Datetime.replace([vm.day, vm.month, vm.year].join('/')))
          .then(function(response) {
            if (response) {
              vm.persona = response;
              if (vm.mensaje) {
                Message.success(vm.mensaje);
              }
            } else {
              vm.persona = {};
            }
          });
      } else {
      */
        vm.primer_apellido = vm.primer_apellido == undefined ? '' : vm.primer_apellido;
        vm.segundo_apellido = vm.segundo_apellido == undefined ? '' : vm.segundo_apellido;
        vm.casada_apellido = vm.casada_apellido == undefined ? '' : vm.casada_apellido;

        var urlConsulta = restUrl + 'persona/servicio/segip' +
          '?ci=' + vm.documentoIdentidad +
          '&fecha_nacimiento=' + Datetime.replace([vm.day, vm.month, vm.year].join('/')) +
          '&nombres=' + vm.nombres +
          '&primer_apellido=' + vm.primer_apellido +
          '&segundo_apellido=' + vm.segundo_apellido +
          '&casada_apellido=' + vm.casada_apellido +
          '&tipo_persona=' + vm.tipoPersona +
          '&extranjero=false';
        // DataService.get(restUrl + 'persona/servicio/segip' + '?ci=' + vm.documentoIdentidad + '&fecha_nacimiento=' + Datetime.replace([vm.day, vm.month, vm.year].join('/')) + '&extranjero=false')
        DataService.get(urlConsulta)
          .then(function(response) {
            if (response && response.datos) {
              vm.persona = response.datos;
              vm.encontrado = true;
            } else {
              vm.persona = {};
            }
          });
      // }
    }
  }

})();

(function() {
  'use strict'

  angular
    .module('app')
    .directive('capitalize', capitalizeDirective);

  function capitalizeDirective() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        var capitalize = function(inputValue) {
          if (inputValue == undefined) inputValue = '';
          var capitalized = inputValue.toUpperCase();
          if (capitalized !== inputValue) {
            modelCtrl.$setViewValue(capitalized);
            modelCtrl.$render();
          }
          return capitalized;
        }
        modelCtrl.$parsers.push(capitalize);
        capitalize(scope[attrs.ngModel]); // capitalize initial value
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('busquedaSedeUniversitaria', {
      templateUrl: 'app/components/busquedaSedeUniversitaria/busquedaSedeUniversitaria.html',
      controller: BusquedaSedeUniversitariaController,
      bindings: {
        sede: '=',
        url: '=',
        idSede: '=',
        onCambiar: '='
      }
    });

  /** @ngInject */
  function BusquedaSedeUniversitariaController(DataService, Datetime, Message, restUrl, $timeout, $q) {
    var vm = this;

    vm.simulateQuery = false;
    vm.isDisabled = false;
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.searchTextChange = searchTextChange;

    activate();

    function activate() {
      loadAll();
    }

    function querySearch(query) {
      var results = query ? vm.sedes.filter(createFilterFor(query)) : vm.sedes,
        deferred;
      if (vm.simulateQuery) {
        deferred = $q.defer();
        $timeout(function() {
          deferred.resolve(results);
        }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    // function searchTextChange(text) {
    function searchTextChange() {
      // $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      vm.sede = item;
      if (item && vm.onCambiar) {
        vm.onCambiar(item);
      }
    }
    /**
     * Build `components` list of key/value pairs
     */
    function loadAll() {
      var urlQuery = vm.url ? vm.url : restUrl + 'rotaciones/sede_seleccionar';
      DataService.get(urlQuery)
        .then(function(response) {
          if (response && response.datos && response.datos.rows) {
            vm.sedes = response.datos.rows;
            return vm.sedes.map(function(repo) {
              if (vm.idSede && repo.id_sede && vm.idSede == repo.id_sede) {
                vm.sede = repo;
                vm.selectedItem = repo;
              }
              repo.value = repo.nombre.toLowerCase() + " " + repo.departamento.nombre.toLowerCase() + " " + repo.id_sede + " " + repo.universidad.nombre.toLowerCase();
              return repo;
            });
          }
          else {
            vm.sedes = [];
            Message.error("No cuenta con sedes universitarias registradas.");
          }
        }).catch(function(e) {
          vm.sedes = [];
          Message.error(e.error);
        });
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return (item.value.indexOf(lowercaseQuery) === 0 || item.value.indexOf(lowercaseQuery) > 0);
      };
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .component('busquedaEstablecimiento', {
      templateUrl: 'app/components/busquedaEstablecimiento/busquedaEstablecimiento.html',
      controller: BusquedaEstablecimientoController,
      bindings: {
        establecimiento: '=',
        url: '='
      }
    });

  /** @ngInject */
  function BusquedaEstablecimientoController(DataService, Datetime, Message, restUrl, $timeout, $q) {
    var vm = this;

    vm.establecimientos = [];
    
    vm.simulateQuery = false;
    vm.isDisabled = false;
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.searchTextChange = searchTextChange;

    activate();

    function activate() {
      loadAll();
    }

    function querySearch(query) {
      var results = query ? vm.establecimientos.filter(createFilterFor(query)) : vm.establecimientos,
        deferred;
      if (vm.simulateQuery) {
        deferred = $q.defer();
        $timeout(function() {
          deferred.resolve(results);
        }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    // function searchTextChange(text) {
    function searchTextChange() {
      // $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      vm.establecimiento = item;
    }
    /**
     * Build `components` list of key/value pairs
     */
    function loadAll() {
      var urlQuery = vm.url ? vm.url : restUrl + 'rotaciones/establecimiento_salud';
      DataService.get(urlQuery)
        .then(function(response) {
          if (response && response.datos) {
            vm.establecimientos = response.datos;
            return vm.establecimientos.map(function(repo) {
              if (vm.establecimiento && vm.establecimiento.id_establecimiento_salud) {
                vm.establecimiento = repo;
                vm.selectedItem = repo;
              }
              repo.value = repo.establecimiento.toLowerCase() + " " + repo.codigo;
              return repo;
            });
          }
          else {
            vm.establecimientos = [];
            Message.error("No cuenta con establecimientos de salud asignados.");
          }
        }).catch(function(e) {
          vm.establecimientos = [];
          Message.error(e.error);
        });
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return (item.value.indexOf(lowercaseQuery) === 0 || item.value.indexOf(lowercaseQuery) > 0);
      };
    }

  }

})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('BreadcrumbFactory', BreadcrumbFactory)

    function BreadcrumbFactory(Util, Storage) {

        var factory = {
            parent: '',
            current: '',
            setParent: function (parent) {
                this.parent = parent;
            },
            setCurrent: function (current) {
                this.current = current;
            },
            getParent: function () {
                return this.parent;
            },
            getCurrent: function () {
                return this.current;
            },
            actualizar: function(option) {
              if (!option) {
                option = ''
              }
              option = option.replace('/', '');
              var page = Util.getMenuOption(Storage.get('menu'), option);
              this.setParent(page[0]);
              this.setCurrent(page[1]);
            }
        };

        return factory;

    }

})();

(function() {
    'use strict';

    angular
    .module('app')
    .component('breadcrumb', {
        templateUrl : 'app/components/breadcrumb/breadcrumb.html',
        controller : BreadcrumbController,
        bindings: {
            // parent: '=',
            // current: '='
        }
    });

    /** @ngInject */
    function BreadcrumbController(Storage, $location, BreadcrumbFactory, Util) {
        var vm = this;

        vm.getParent = getParent;
        vm.getCurrent = getCurrent;

        activate();

        function activate() {
            if (Storage.exist('menu')) {
                var page = Util.getMenuOption(Storage.get('menu'), $location.path().replace('/', ''));
                BreadcrumbFactory.setParent(page[0]);
                BreadcrumbFactory.setCurrent(page[1]);
            }
        }

        function getParent() {
            return BreadcrumbFactory.getParent();
        }

        function getCurrent() {
            return BreadcrumbFactory.getCurrent();
        }

    }

})();

/*eslint angular/di: [2,"array"]*/

(function () {
  'use strict';

  angular
  .module('app')
  .service('FirmaticService', ['$http', '$log', '$q',  FirmaticService]);

  // FirmaticService.$inject = ['$q', '$mdDialog', 'demofiUrl', '$document'];
  /** @ngInject */
  function FirmaticService($http, $log, $q) {
    var urlFirmatic = 'https://localhost:4637';
    var service = {
      firmarPdf: firmarPdf,
      verificarEstado: verificarEstado
    };
    return service;

    function firmarPdf(documentos, ci) {
      // $log.log('Iniciando el proceso de firma', documentos);
      var datos = {
        archivo: documentos,
        format: 'pades',
        language: 'es'
      };
      if(angular.isDefined(ci)) datos.ci = ci;
      var cabeceras = {
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      var urlFirma = urlFirmatic + '/sign';
      return $q(function (resolve, reject) {
        $http.post(urlFirma, datos, cabeceras)
        .then(function (respFirma) {
          $log.log('Revisando la respuesta de la firma', respFirma);
          return resolve(respFirma);
        })
        .catch(function (errorFirma) {
          $log.log('#error en la firma', errorFirma);
          return reject({
            finalizado: false,
            message: (errorFirma.response.data.message || errorFirma.response.data) + ' (Error en el firmador.)'
          });
        });
      });
    }

    function verificarEstado() {
      var respuesta = {
        activo: false,
        mensaje: ''
      }
      return $q(function (resolve) {
        $http.get(urlFirmatic)
        .then(function (respEstado) {
          // $log.log('Revisando la respuesta del estado', respEstado);
          if(respEstado.status === 200) {
            respuesta.activo = true;
          }
          else {
            $log.log('Error no definido');
          }
          return resolve(respuesta);
        })
        .catch(function (errorEstado) {
          // $log.log('Error estado ::: ', errorEstado);
          respuesta.activo = false;
          // TODO: mejorar el tratamiento de error cuando no esta activo firmatic
          respuesta.mensaje = 'El servicio de firmador no se encuentra iniciado'
          if(errorEstado.message && errorEstado.message.indexOf('Network Error' > -1)) {
            // console.log('Error de network ???')
            respuesta.mensaje = 'El servicio del firmador no se encuentra iniciado.'
          }

          return resolve(respuesta);
        });
      });
    }
  }
  
})();
/*eslint angular/di: [2,"array"]*/
/*eslint angular/di: [2,"$inject"]*/

(function() {
    'use strict';

    angular
    .module('app')
    .service('DataService', ['$http', 'Message', 'Util', '$sce', DataService])
    .config(function($httpProvider) {
      //initialize get if not there
      if (!$httpProvider.defaults.headers.get) {
          $httpProvider.defaults.headers.get = {};
      }

      // Answer edited to include suggestions from comments
      // because previous version of code introduced browser-related errors

      // //disable IE ajax request caching
      // $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      // extra
      $httpProvider.defaults.headers.get['Cache-Control'] = 'private, no-cache, no-store, must-revalidate';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

    });



    /** @ngInject */
    function DataService($http, Message, Util, $sce) {

        var formly = null;
        var errorConnection = 'No se pudo establecer conexión con el servidor.';
        var error500 = 'Se produjo un error en el servidor, inténtelo más tarde.';
        var error404 = 'No existe el recurso solicitado.';
        var error403 = 'No tiene los permisos necesarios.';
        var labels = {
            'msg' : 'Mensaje'
        };

        var service = {
            list: list,
            all: list,
            delete: remove,
            save: save,
            get: get,
            put: put,
            patch: patch,
            post: post,
            fields: fields,
            option: fields,
            pdf: pdf,
            pdf2: pdf2,
            // file: file,
            setFormly: setFormly
        };

        return service;

        function list(url, query) {
            return $http.get(url + (query ? '?' + Util.serialize(query) : ''))
            .then(function (response) {
                return response.data;
            }).catch(function (error) {
                msgError(error);
            });
        }

        function save(url, data) {
            return $http[data.id ? 'put' : 'post'](url + (data.id ? data.id + '/': ''), data)
            .then(function (response) {
                return response.data;
            }).catch(function (error) {
                msgError(error);
            });
        }

        function put(url, data) {
            return $http.put(url + (data.id ? data.id + '/': ''), data)
            .then(function (response) {
                return response.data;
            }).catch(function (error) {
                msgError(error);
            });
        }

        function patch(url, data) {
            return $http.patch(url + (data.id ? data.id + '/': ''), data)
            .then(function (response) {
                return response.data;
            }).catch(function (error) {
                msgError(error);
            });
        }

        function post(url, data, titulo) {
            return $http.post(url, data)
            .then(function (response) {
                return response.data;
            }).catch(function (error) {
                msgError(error, titulo);
            });
        }

        function remove(url, id) {
            return $http.delete(url + id + '/')
            .then(function (response) {
                return response.data;
            }).catch(function (error) {
                msgError(error);
            });
        }

        function get(url, id) {
            return $http.get(url + (id ? id + '/' : ''))
            .then(function (response) {
              if (response.status == 204) {
                msgError(response);
              } else {
                return response.data;
              }
            }).catch(function (error) {
                msgError(error);
            });
        }

        function fields(url) {
            return $http({method: 'OPTIONS', url: url})
            .then(function (response) {
                return response.data;
            }).catch(function (error) {
                msgError(error);
            });
        }

        function pdf(url, data) {
          return $http.post(url, data || {}, {responseType:'arraybuffer'})
          .then(function (response) {
            if (response.data) {
              var file = new Blob([response.data], {type: response.headers('Content-Type')});
              var fileURL = URL.createObjectURL(file);
              return $sce.trustAsResourceUrl(fileURL);
            }
            return null;
          }).catch(function (error) {
            msgError(error);
          });
        }

        function pdf2(url, data) {
          return $http.post(url, data || {}, {responseType:'arraybuffer'})
          .success(function (response) {
            return response;
          }).error(function (data) {
            var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
            var obj = angular.fromJson(decodedString);
            var obj2 = {
              data: {
                mensaje: obj.mensaje
              }
            }
            msgError(obj2);
          });
        }

        // function file(url, data, type, filename) {
        //     // return $http.get(url, data || {}, {responseType:'arraybuffer'})
        //     return $http.get(url, data || {})
        //     .then(function (response) {
        //         if (response.data) {
        //             // var blob = new Blob([response.data], { type: type || 'text/plain' }),
        //             //     url = $window.URL || $window.webkitURL;
        //             var blob = new Blob([response.data], { type: (type || 'text/plain') }, false);
        //             saveAs(blob, filename || 'file.CR');
        //
        //             //return url.createObjectURL(blob);
        //         }
        //         return true;
        //     }).catch(function (error) {
        //         msgError(error);
        //     });
        // }

        function setFormly(data) {
            formly = data;
        }

        function parseError(error) {
            var message = [];
            if (error) {
                if (error.detail || error.error || error.non_field_errors) {
                    return error.detail || error.error || error.non_field_errors;
                }
                for (var i in error) {
                    var label = i;
                    if (formly) {
                        formly.filter(function (el) {
                            if (el.key == i) {
                                label = el.templateOptions.label;
                            }
                        });
                    } else {
                        if (labels[label]) {
                            label = labels[label];
                        } else {
                            label = label[0].toUpperCase() + label.substring(1);
                        }
                    }
                    message.push('<strong>' + label + ':</strong> ' + (Util.toType(error[i]) == 'array' ? error[i].join(', ') : error[i]));
                }
                return message.join('<br>');
            }
            return null;
        }

        function msgError(error, titulo) {

          if (error.data && error.data.mensaje) {
            Message.error(error.data.mensaje, titulo);
          } else if (error.status === 204) {
            Message.warning("No se ha encontrado la información solicitada.", titulo);
          } else if (error.status === 500) {
              Message.error(error500, titulo);
          } else if (error.status === 503) {
              Message.error('No se pudo establecer conexión con el servidor, por favor vuelva a intentarlo', 'Error de conexión');
          } else if (error.status === 404) {
              Message.error(error404, titulo);
          } else if (error.status === 403) {
              Message.error(error403, titulo);
          } else {
              Message.error(parseError(error.data) || errorConnection, titulo);
          }
        }

    }

})();

/*eslint angular/di: [2,"array"]*/

(function() {
  'use strict';

  angular
    .module('app')
    .service('ConsultasService', ['restUrl', 'Modal', 'Message', '$sce', 'DataService', '$window','DemofiService', 'blockUI', '$q', ConsultasService]);

  /** @ngInject */
  // function Consultas($http, Message, Util, $sce) {
  function ConsultasService(restUrl, Modal, Message, $sce, DataService, $window, DemofiService, blockUI, $q) {

    var service = {
      // funciones
      crearBlobDeBase64: crearBlobDeBase64,
      mostrarPdfBase64: mostrarPdfBase64,
      mostrarRequisitoPdfBase64: mostrarRequisitoPdfBase64,

      mostrarPdf: mostrarPdf,
      mostrarPdfFirmas: mostrarPdfFirmas,
      mostrarBlob: mostrarBlob,

      // Documentos binarios
      obtenerDocumentosBinarios: obtenerDocumentosBinarios,

      verificarCredencialFirmada: verificarCredencialFirmada,
      verificarMostrarCredencial: verificarMostrarCredencial,
      verificarMostrarInforme: verificarMostrarInforme,
      verificarMostrarResolucion: verificarMostrarResolucion,

      credencialFirmada: credencialFirmada,
      informeFirmado: informeFirmado,
      resolucionFirmada: resolucionFirmada,

      // Bin
      urlMostrarCredencialBinario: restUrl + 'rotaciones/habilitacion_credencial/bin/',
      urlMostrarInformeBinario: restUrl + 'rotaciones/habilitacion_informe/bin/',
      urlMostrarResolucionBinario: restUrl + 'rotaciones/habilitacion_resolucion/bin/',

      // Urls
      urlMostrarCredencial: restUrl + 'rotaciones/habilitacion_credencial/',
      urlMostrarCredencialFirmas: restUrl + 'rotaciones/habilitacion/firmas/pdf',
      urlMostrarInforme: restUrl + 'rotaciones/habilitacion_informe/',
      urlMostrarResolucion: restUrl + 'rotaciones/habilitacion_resolucion/'

    };

    return service;

    function mostrarPdfBase64(event, urlPeticion, parametros, titulo, mensajeError) {
      DataService.post(urlPeticion, parametros)
        .then(function(response) {
          if (response && response.datos) {
            var documento = response.datos;
            if (documento.length == 1) {
              var file = crearBlobDeBase64(documento[0].credencial, 'application/pdf');
              mostrarBlob(event, file, titulo);
            } else {
              // Message.error("La credencial no se recuperó correctamente.");
              Message.error(mensajeError);
            }
          }
        });
    }

    function crearBlobDeBase64(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {
        type: contentType
      });
      return blob;
    }

    function mostrarRequisitoPdfBase64(event, base64, titulo) {
      var file = crearBlobDeBase64(base64, 'application/pdf');
      mostrarBlob(event, file, titulo);
    }

    function mostrarBlob(event, file, titulo) {
      var userAgent = $window.navigator.userAgent;
      var ieEDGE = userAgent.match(/Edge/g);
      var ie = userAgent.match(/.NET/g); // IE 11+
      var oldIE = userAgent.match(/MSIE/g);

      var fileURL = URL.createObjectURL(file);
      if (ie || oldIE || ieEDGE) {
        $window.navigator.msSaveOrOpenBlob(file, titulo + '.pdf');
      } else {
        if (file) {
          Modal.show({
            event: event,
            data: $sce.trustAsResourceUrl(fileURL),
            title: titulo,
            templateUrl: 'app/components/crudTable/dialog.pdf.html',
            controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
          });
        } else {
          Message.error("No se encontraron los datos solicitados.");
        }
      }
    }

    function mostrarPdf(event, archivo, titulo) {
      var file = new Blob(archivo, {type: 'application/pdf'});
      mostrarBlob(event, file, titulo);
    }

    function mostrarPdfFirmas(event, url, parametros, titulo, mensajeError) {
      blockUI.start("Cargando documento...");
      DataService.post(url, parametros)
        .then(function(response) {
          if (response && response.datos) {
            var documento = response.datos;
            if (documento.length == 1) {
              var data = {
                documento: documento[0].credencial
              }
              mostrarFirmas(data, event, titulo);
            } else {
              Message.error(mensajeError);
            }
          } else {
            blockUI.stop();
          }
        });
    }

    function mostrarFirmas(data, event, titulo) {
      // DemofiService.encontrarFirmas(data.documento)
      DataService.post(service.urlMostrarCredencialFirmas, { pdf_base64: data.documento})
      .then(function(response) {
        if (response && response.datos && response.datos.length > 0) {
          data.firmas = response.datos;
        } else if (response && response.datos && response.datos.length == 0) {
          data.firmasMensaje = response.mensaje;
        }
        mostrarBlobFirmas(event, data, titulo);
      }).catch(function() {
        data.firmasMensaje = "No se pudieron leer las firmas. Por favor revise la versión DEMOFI.";
        mostrarBlobFirmas(event, data, titulo);
        Message.warning("Ocurrió un error al leer la firmas.");
      });
    }

    function mostrarBlobFirmas(event, data, titulo) {
      blockUI.stop();
      var file = crearBlobDeBase64(data.documento, 'application/pdf');
      var userAgent = $window.navigator.userAgent;
      var ieEDGE = userAgent.match(/Edge/g);
      var ie = userAgent.match(/.NET/g); // IE 11+
      var oldIE = userAgent.match(/MSIE/g);

      var fileURL = URL.createObjectURL(file);
      if (ie || oldIE || ieEDGE) {
        $window.navigator.msSaveOrOpenBlob(file, titulo + '.pdf');
      } else {
        data.fileDocumento = $sce.trustAsResourceUrl(fileURL);
        data.pdfConFirmas = 'pdfConFirmas';
      }
      if (file) {
        Modal.show({
          event: event,
          data: data,
          title: titulo,
          templateUrl: 'app/components/crudTable/dialog.pdf.firmas.html',
          controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
        });
      } else {
        Message.error("No se encontraron los datos solicitados.");
      }
    }

    function obtenerDocumentosBinarios(urlPeticion, parametros, prefijoDocumento) {
      var deferred = $q.defer();
      var contador = 0;
      var respuesta = [];
      prefijoDocumento = prefijoDocumento ? prefijoDocumento : 'DOCUMENTO';
      for (var i in parametros) {
        DataService.pdf2(urlPeticion, {id_habilitacion: parametros[i]})
          .then(function(response) {
            var reader = new $window.FileReader();
            reader.id_habilitacion = response.config.data.id_habilitacion;
            var file = new Blob([response.data], {type: 'application/pdf'});
            reader.readAsDataURL(file);
            reader.onloadend = function(readerEvt) {
              var base64data = reader.result;
              respuesta.push({
                id_habilitacion: readerEvt.target.id_habilitacion,
                base64: base64data, // para firmatic
                name: prefijoDocumento + "-" + readerEvt.target.id_habilitacion + ".pdf" // para firmatic
                // nombre_archivo: prefijoDocumento + "-" + readerEvt.target.id_habilitacion + ".pdf",
                // codigo_archivo: prefijoDocumento + "-" + readerEvt.target.id_habilitacion + ".pdf",
                // pdf_base64: base64data,
                // estado: 'no-firmado'
              });
              contador++;
              if (contador == parametros.length) {
                deferred.resolve(respuesta);
              }
            }
          }).catch(function(error) {
            deferred.reject(error);
          });
      }
      return deferred.promise;
    }

    function verificarCredencialFirmada(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'SUSPENDIDA' ||
          habilitacion.estado_habilitacion == 'CREDENCIAL_FIRMADA' ||
          habilitacion.estado_habilitacion == 'INFORME_GENERADO' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }

    function verificarMostrarInforme(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'INFORME_GENERADO' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }
    function verificarMostrarCredencial(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'SUSPENDIDA' ||
          habilitacion.estado_habilitacion == 'CREDENCIAL_GENERADA' ||
          habilitacion.estado_habilitacion == 'CREDENCIAL_FIRMADA' ||
          habilitacion.estado_habilitacion == 'INFORME_GENERADO' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }
    function verificarMostrarResolucion(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }

    function credencialFirmada(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'HABILITADO' ||
          habilitacion.estado_habilitacion == 'APROBADO' ||
          habilitacion.estado_habilitacion == 'REPROBADO' ||
          habilitacion.estado_habilitacion == 'RECHAZADO' ||
          habilitacion.estado_habilitacion == 'ASIGNADO' ||
          habilitacion.estado_habilitacion == 'ELIMINADO' ||
          habilitacion.estado_habilitacion == 'PREASIGNADO' ||
          habilitacion.estado_habilitacion == 'CREDENCIAL_GENERADA')) {
        return false;
      }
      return true;
    }
    function informeFirmado(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'RESOLUCION_GENERADA' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR' ||
          habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR')) {
        return true;
      }
      return false;
    }
    function resolucionFirmada(habilitacion) {
      if (habilitacion && (habilitacion.estado_habilitacion == 'RESOLUCION_FIRMADA_DIRECTOR' ||
          habilitacion.estado_habilitacion == 'RESO_GENERADA_AP_CASADA' ||
          habilitacion.estado_habilitacion == 'RESO_AP_CASADA_FIRMA_ASESOR')) {
        return true;
      }
      return false;
    }


    function PdfController($scope, $mdDialog, data, title) {
      var vm = $scope;

      vm.formatearUrl = function(url) {
        //return $sce.trustAsResourceUrl('data:image;base64,' + url);
        return $sce.trustAsResourceUrl(url);
      }

      vm.formatearUrlPdf = function(url) {
        //return $sce.trustAsResourceUrl('data:application/pdf;base64,' + url);
        return $sce.trustAsResourceUrl('data:application/pdf;base64,' + url);
      }

      vm.formatearHtml = function(texto) {
        var res = texto.replace(/\n/g, "<br>");
        return $sce.trustAsHtml(res);
      }

      vm.title = title;
      vm.data = data;
      vm.hide = $mdDialog.hide;
      vm.cancel = $mdDialog.cancel;
    }

  }

})();



(function() {
  'use strict';

    angular
    .module('app')
    .filter('datetime', function(Datetime) {

    return function(date, format) {

        if (format) {
            if (format == 'literal') {
                return Datetime.dateLiteral(date);
            }
            if (format == 'year') {
                return Datetime.now('YYYY');
            }
        }

        return date;
    }
});

})();

(function() {
	'use strict';

	angular
	.module('app')
	.filter('reverse', function() {
		return function(items) {
			return items.slice().reverse();
		}
	});

})();

/*global TIME:true*/
/*global sessionInterval:true*/

(function() {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock(Storage, $location, $log, PageNoLogin, $window, timeSessionExpired, $auth, $mdDialog) {

    var $container = angular.element('#container-main');
    var $document = $window.document;

    $window.onbeforeunload = undefined;

    // Collapsed Panel
    $container.on('click', '.btn-collapsed', function() {
      var $el = angular.element(this)
      $el.parent().parent().next().slideToggle()
      $el.toggleClass('rotate')
    })

    var $toasts = angular.element('#toast-container-main')
    $toasts.on('click', '.md-toast-close', function() {
      angular.element(this).parent().parent().parent().fadeOut()
    });

    // Redirect

    if (!Storage.existUser()) {
      var path = $location.path();
      if (!exist(path)) {
        if (path.length) {
          Storage.set('path', path.replace('/', ''));
        }
        $location.path('login');
      }
    } else {
      if (typeof TIME != 'undefined') {
        TIME = timeSessionExpired * 60 * 1000;
        sessionInterval = $window.setInterval(function() {
          // console.log("TIEMPO EN RUN: " + (TIME / 1000));
          TIME -= 1000;
          if (TIME <= 0) {
            $window.clearInterval(sessionInterval);
            logout();
          }
        }, 1000);
      }
    }

    function logout() {
      $auth.logout()
        .then(function() {
          if (sessionInterval) {
            $window.clearInterval(sessionInterval);
          }
          Storage.removeUser();
          Storage.remove('menu');
          Storage.remove('path');
          $window.localStorage.clear();
          $window.sessionStorage.clear();
          Storage.set('expired', true);
          $location.path("login");
          $mdDialog.hide();
        });
    }


    function exist(path) {
      var paths = PageNoLogin;
      for (var i in paths) {
        if (path.indexOf('/' + paths[i]) == 0 || path.indexOf('/' + paths[i] + '/') == 0 || path.indexOf('verificacion/credencial/') != -1 || path.indexOf('verificacion/resolucion/') != -1) {
          return true;
        }
      }
      return false;
    }

    //Fullscreen
    function exitFullScreen() {
      angular.element('body').removeClass('fullscreen');
    }

    angular.element($window.document).on('keyup', function(e) {
      if (e.keyCode == 27) {
        exitFullScreen();
      }
    });

    $document.addEventListener("mozfullscreenchange", function() {
      if (!$document.mozFullScreen) {
        exitFullScreen();
      }
    }, false);
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('dashboard', {
        url: '/',
        templateUrl: 'app/modules/dashboard/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('usuarios', {
        url: '/usuarios',
        templateUrl: 'app/modules/admin/usuarios/modules.admin.usuarios.html',
        controller: 'UsuariosController',
        controllerAs: 'usuarios'
      })
      .state('login', {
        url: '/login',
        templateUrl: 'app/modules/admin/login/modules.admin.login.html',
        controller: 'LoginController',
        controllerAs: 'login'
      })
      .state('configuracion', {
        url: '/configuracion',
        templateUrl: 'app/modules/admin/configuracion/modules.admin.configuracion.html',
        controller: 'ConfiguracionController',
        controllerAs: 'configuracion'
      })
      .state('roles', {
        url: '/roles',
        templateUrl: 'app/modules/admin/roles/modules.admin.roles.html',
        controller: 'RolesController',
        controllerAs: 'roles'
      })
      .state('rutas', {
        url: '/rutas',
        templateUrl: 'app/modules/admin/rutas/modules.admin.rutas.html',
        controller: 'RutasController',
        controllerAs: 'rutas'
      })
      .state('menus', {
        url: '/menus',
        templateUrl: 'app/modules/admin/menus/modules.admin.menus.html',
        controller: 'MenusController',
        controllerAs: 'menus'
      })
      .state('restore', {
        url: '/restore',
        templateUrl: 'app/modules/admin/restore/modules.admin.restore.html',
        controller: 'RestoreController',
        controllerAs: 'restore'
      })
      .state('servicios', {
        url: '/servicios',
        templateUrl: 'app/modules/admin/servicios/modules.admin.servicios.html',
        controller: 'ServiciosController',
        controllerAs: 'servicios'
      })
      .state('parSedes', {
        url: '/parametros/parSedes',
        templateUrl: 'app/modules/parametros/parSedes/modules.parametros.parSedes.html',
        controller: 'ParSedesController',
        controllerAs: 'parSedes'
      })
      .state('sedes', {
        url: '/rotaciones/sedes',
        templateUrl: 'app/modules/rotaciones/sedes/modules.rotaciones.sedes.html',
        controller: 'SedesController',
        controllerAs: 'sedes'
      })
      .state('universidades', {
        url: '/rotaciones/universidades',
        templateUrl: 'app/modules/rotaciones/universidades/modules.rotaciones.universidades.html',
        controller: 'UniversidadesController',
        controllerAs: 'universidades'
      })
      .state('sedesUniversitarias', {
        url: '/rotaciones/sedesUniversitarias/:idUniversidad',
        templateUrl: 'app/modules/rotaciones/sedesUniversitarias/modules.rotaciones.sedesUniversitarias.html',
        controller: 'SedesUniversitariasController',
        controllerAs: 'sedesUniversitarias'
      })
      .state('carreras', {
        url: '/rotaciones/carreras',
        templateUrl: 'app/modules/rotaciones/carreras/modules.rotaciones.carreras.html',
        controller: 'CarrerasController',
        controllerAs: 'carreras'
      })
      .state('carrerasId', {
        url: '/rotaciones/carreras/:idSede',
        templateUrl: 'app/modules/rotaciones/carreras/modules.rotaciones.carreras.html',
        controller: 'CarrerasController',
        controllerAs: 'carreras'
      })
      .state('establecimientosSalud', {
        url: '/rotaciones/establecimientosSalud',
        templateUrl: 'app/modules/rotaciones/establecimientosSalud/modules.rotaciones.establecimientosSalud.html',
        controller: 'EstablecimientosSaludController',
        controllerAs: 'establecimientosSalud'
      })
      .state('periodosGestion', {
        url: '/rotaciones/periodosGestion',
        templateUrl: 'app/modules/rotaciones/periodosGestion/modules.rotaciones.periodosGestion.html',
        controller: 'PeriodosGestionController',
        controllerAs: 'periodosGestion'
      })
      .state('gradosAcademicos', {
        url: '/rotaciones/gradosAcademicos',
        templateUrl: 'app/modules/rotaciones/gradosAcademicos/modules.rotaciones.gradosAcademicos.html',
        controller: 'GradosAcademicosController',
        controllerAs: 'gradosAcademicos'
      })
      .state('parPeriodos', {
        url: '/parametros/parPeriodos',
        templateUrl: 'app/modules/parametros/parPeriodos/modules.parametros.parPeriodos.html',
        controller: 'ParPeriodosController',
        controllerAs: 'parPeriodos'
      })
      .state('tiposCarrera', {
        url: '/rotaciones/tiposCarrera',
        templateUrl: 'app/modules/rotaciones/tiposCarrera/modules.rotaciones.tiposCarrera.html',
        controller: 'TiposCarreraController',
        controllerAs: 'tiposCarrera'
      })
      .state('parArchivos', {
        url: '/parametros/parArchivos',
        templateUrl: 'app/modules/parametros/parArchivos/modules.parametros.parArchivos.html',
        controller: 'ParArchivosController',
        controllerAs: 'parArchivos'
      })
      .state('estudiantes', {
        url: '/rotaciones/estudiantes',
        templateUrl: 'app/modules/rotaciones/estudiantes/modules.rotaciones.estudiantes.html',
        controller: 'EstudiantesController',
        controllerAs: 'estudiantes'
      })
      .state('detalleCredenciales', {
//        url: '/rotaciones/detalleCredenciales/:idHabilitacion',
        url: '/rotaciones/detalleCredenciales',
        templateUrl: 'app/modules/rotaciones/credenciales/detalleCredenciales/modules.rotaciones.credenciales.detalleCredenciales.html',
        controller: 'DetalleCredencialesController',
        controllerAs: 'detalleCredenciales'
      })
      .state('detalleMonitoreo', {
        url: '/rotaciones/detalleMonitoreo',
        templateUrl: 'app/modules/rotaciones/monitoreo/detalleMonitoreo/modules.rotaciones.monitoreo.detalleMonitoreo.html',
        controller: 'DetalleMonitoreoController',
        controllerAs: 'detalleMonitoreo'
      })
      .state('periodosSedes', {
        url: '/parametros/periodosSedes',
        templateUrl: 'app/modules/parametros/periodosSedes/modules.parametros.periodosSedes.html',
        controller: 'PeriodosSedesController',
        controllerAs: 'periodosSedes'
      })
      .state('detalleResoluciones', {
        url: '/rotaciones/detalleResoluciones',
        templateUrl: 'app/modules/rotaciones/resoluciones/detalleResoluciones/modules.rotaciones.resoluciones.detalleResoluciones.html',
        controller: 'DetalleResolucionesController',
        controllerAs: 'detalleResoluciones'
      })
      .state('tramitesObservados', {
        url: '/rotaciones/tramitesObservados',
        templateUrl: 'app/modules/rotaciones/observados/tramitesObservados/modules.rotaciones.observados.tramitesObservados.html',
        controller: 'TramitesObservadosController',
        controllerAs: 'tramitesObservados'
      })
      .state('detalleObservados', {
        url: '/rotaciones/detalleObservados/:idHabilitacion',
        templateUrl: 'app/modules/rotaciones/observados/detalleObservados/modules.rotaciones.observados.detalleObservados.html',
        controller: 'DetalleObservadosController',
        controllerAs: 'detalleObservados'
      })
      .state('postulantes', {
        url: '/rotaciones/postulantes',
        templateUrl: 'app/modules/rotaciones/postulantes/modules.rotaciones.postulantes.html',
        controller: 'PostulantesController',
        controllerAs: 'postulantes'
      })
      .state('asignaciones', {
        url: '/rotaciones/asignaciones',
        templateUrl: 'app/modules/rotaciones/asignaciones/modules.rotaciones.asignaciones.html',
        controller: 'AsignacionesController',
        controllerAs: 'asignaciones'
      })
      .state('resolucionesAdm', {
        url: '/rotaciones/resoluciones',
        templateUrl: 'app/modules/rotaciones/resolucionesAdm/modules.rotaciones.resolucionesAdm.html',
        controller: 'ResolucionesAdmController',
        controllerAs: 'resolucionesAdm'
      })
      .state('monitoreo', {
        url: '/rotaciones/monitoreo',
        templateUrl: 'app/modules/rotaciones/monitoreo/monitoreo/modules.rotaciones.monitoreo.monitoreo.html',
        controller: 'MonitoreoController',
        controllerAs: 'monitoreo'
      })
      .state('historialEstudiantes', {
        url: '/rotaciones/historialEstudiantes',
        templateUrl: 'app/modules/rotaciones/historialEstudiantes/modules.rotaciones.historialEstudiantes.html',
        controller: 'HistorialEstudiantesController',
        controllerAs: 'historialEstudiantes'
      })
      .state('requisitosResoluciones', {
        url: '/rotaciones/requisitosResoluciones/:idHabilitacion',
        templateUrl: 'app/modules/rotaciones/resoluciones/requisitosResoluciones/modules.rotaciones.resoluciones.requisitosResoluciones.html',
        controller: 'RequisitosResolucionesController',
        controllerAs: 'requisitosResoluciones'
      })
      .state('asignacionesEstudiantes', {
        url: '/rotaciones/asignacionesEstudiantes',
        templateUrl: 'app/modules/rotaciones/asignacionesEstudiantes/modules.rotaciones.asignacionesEstudiantes.html',
        controller: 'AsignacionesEstudiantesController',
        controllerAs: 'asignacionesEstudiantes'
      })
      .state('correccionesPostulaciones', {
        url: '/correcciones/postulaciones',
        templateUrl: 'app/modules/rotaciones/correccionesPostulaciones/modules.rotaciones.correccionesPostulaciones.html',
        controller: 'CorreccionesPostulacionesController',
        controllerAs: 'correccionesPostulaciones'
      })
      .state('historialFirmados', {
        url: '/rotaciones/historialFirmados',
        templateUrl: 'app/modules/rotaciones/historialFirmados/modules.rotaciones.historialFirmados.html',
        controller: 'HistorialFirmadosController',
        controllerAs: 'historialFirmados'
      })
      .state('sedesDetalle', {
        url: '/rotaciones/sedesDetalle',
        templateUrl: 'app/modules/rotaciones/sedes/sedesDetalle/modules.rotaciones.sedes.sedesDetalle.html',
        controller: 'SedesDetalleController',
        controllerAs: 'sedesDetalle'
      })
      .state('sedesDetalleID', {
        url: '/rotaciones/sedesDetalle',
        templateUrl: 'app/modules/rotaciones/sedes/sedesDetalle/modules.rotaciones.sedes.sedesDetalle.html',
        controller: 'SedesDetalleController',
        controllerAs: 'sedesDetalle'
      })
      .state('gestiones', {
        url: '/rotaciones/gestiones',
        templateUrl: 'app/modules/rotaciones/gestiones/modules.rotaciones.gestiones.html',
        controller: 'GestionesController',
        controllerAs: 'gestiones'
      })
      .state('verificacionCredencial', {
        url: '/verificacion/credencial/:codigo',
        templateUrl: 'app/modules/rotaciones/credenciales/verificacionCredencial/modules.rotaciones.credenciales.verificacionCredencial.html',
        controller: 'VerificacionCredencialController',
        controllerAs: 'verificacionCredencial'
      })
      .state('verificacionResolucion', {
        url: '/verificacion/resolucion/:codigo',
        templateUrl: 'app/modules/rotaciones/resoluciones/verificacionResolucion/modules.rotaciones.resoluciones.verificacionResolucion.html',
        controller: 'VerificacionResolucionController',
        controllerAs: 'verificacionResolucion'
      })
      .state('legalizaciones', {
        url: '/rotaciones/legalizaciones',
        templateUrl: 'app/modules/rotaciones/legalizaciones/modules.rotaciones.legalizaciones.html',
        controller: 'LegalizacionesController',
        controllerAs: 'legalizaciones'
      })
      .state('preasignaciones', {
        url: '/rotaciones/preasignaciones',
        templateUrl: 'app/modules/rotaciones/preasignaciones/modules.rotaciones.preasignaciones.html',
        controller: 'PreasignacionesController',
        controllerAs: 'preasignaciones'
      })
      .state('reporteEstudiantes', {
        url: '/rotaciones/reporte/estudiantes',
        templateUrl: 'app/modules/rotaciones/reportes/reporteEstudiantes/modules.rotaciones.reportes.reporteEstudiantes.html',
        controller: 'ReporteEstudiantesController',
        controllerAs: 'reporteEstudiantes'
      })
      .state('reporteCupos', {
        url: '/rotaciones/reporte/cupos',
        templateUrl: 'app/modules/rotaciones/reportes/reporteCupos/modules.rotaciones.reportes.reporteCupos.html',
        controller: 'ReporteCuposController',
        controllerAs: 'reporteCupos'
      })
      .state('tramitesPasados', {
        url: '/rotaciones/tramitesPasados',
        templateUrl: 'app/modules/rotaciones/tramitesPasados/modules.rotaciones.tramitesPasados.html',
        controller: 'TramitesPasadosController',
        controllerAs: 'tramitesPasados'
      })
      .state('rotacionesEdicion', {
        url: '/rotaciones/ediciones',
        templateUrl: 'app/modules/rotaciones/rotacionesEdicion/modules.rotaciones.rotacionesEdicion.html',
        controller: 'RotacionesEdicionController',
        controllerAs: 'rotacionesEdicion'
      })
    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  var url = "https://qmara.minsalud.gob.bo/ws/";

  angular
    .module('app')
    .constant('moment', moment)
    .constant('appName', 'sssro')
    .constant('timeSessionExpired', 30) //Tiempo en minutos para que la sesión se cierre automáticamente si existe inactividad
    .constant('PageNoLogin', ['login', 'verificacion/credencial/:codigo', 'verificacion/estudiantes'])
    .constant('authUrl', url + 'autenticar') // Rest Crud
    .constant('verificarCredencial', url + 'verificar/credencial/') // Rest Crud
    .constant('verificarResolucion', url + 'verificar/resolucion/') // Rest Crud
    .constant('verificarEstudiante', url + 'verificar/estudiante/') // Rest Crud
    .constant('urlGenerica', url) // Rest Crud
    .constant('restUrl', url + 'api/v1/'); // Rest Crud

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $httpProvider, $authProvider, restUrl, authUrl, $mdDateLocaleProvider, moment, blockUIConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    blockUIConfig.message = 'Cargando...';

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    // Config auth
    $authProvider.loginUrl = authUrl;
    // $authProvider.signupUrl = "http://api.com/auth/signup";
    $authProvider.tokenName = "token";
    $authProvider.tokenPrefix = "sssro";
    // $authProvider.authToken = 'JWT';

    $mdDateLocaleProvider.formatDate = function(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY');
      }
      return null;
    }

    $mdDateLocaleProvider.parseDate = function(dateString) {
      var m = moment(dateString, 'DD/MM/YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };
  }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/factories/Messages/layout.toast.html","<md-toast class=md-toast-{{type}}><div class=md-toast-title><md-icon class=md-toast-icon>{{icon}}</md-icon>{{title}}<md-button class=\"md-toast-close md-icon-button\" aria-label=Close><md-icon class=md-icon>close</md-icon></md-button></div><div class=md-toast-message ng-bind-html=message></div></md-toast>");
$templateCache.put("app/modules/dashboard/main.html","");
$templateCache.put("app/components/breadcrumb/breadcrumb.html","<ol class=breadcrumb><li ng-if=$ctrl.getCurrent()>{{$ctrl.getParent()}}</li><li class=active ng-if=$ctrl.getCurrent()>{{$ctrl.getCurrent()}}</li></ol>");
$templateCache.put("app/components/busquedaEstablecimiento/busquedaEstablecimiento.html","<form name=form ng-submit=$ctrl.search()><div layout=row class=form-horizontal><md-autocomplete md-input-name=establecimiento ng-if=$ctrl.establecimientos ng-disabled=$ctrl.isDisabled md-no-cache=$ctrl.noCache md-selected-item=$ctrl.selectedItem md-search-text-change=$ctrl.searchTextChange($ctrl.searchText) md-search-text=$ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(item) md-items=\"item in $ctrl.querySearch($ctrl.searchText)\" md-item-text=item.establecimiento md-min-length=0 placeholder=\"Establecimiento de salud\" md-menu-class=autocomplete-custom-template-establecimiento style=\"width: 100%; margin: 0 0 15px 0\" required><md-item-template><span class=item-title><md-icon>local_hospital</md-icon><span>{{item.establecimiento}}</span> </span><span class=item-metadata><span class=item-metastat>{{item.nom_depto}}, </span><span class=item-metastat>{{item.nom_prov}}, </span><span class=item-metastat>{{item.nom_municipio}}, </span><span class=item-metastat>{{item.codigo}}</span></span></md-item-template></md-autocomplete></div><div flex></div><div ng-messages=form.establecimiento.$error><div ng-message=required style=\"color:rgb(221, 44, 0); font-size: 9pt;margin-top: -18px\">Debe seleccionar establecimiento.</div></div><div ng-if=$ctrl.establecimiento.establecimiento style=\"margin-left:10px; font-size: 12px; line-height: 12px\"><p><label>Establecimiento:</label>{{$ctrl.establecimiento.establecimiento}} - {{$ctrl.establecimiento.codigo}}</p><p><label>Departamento:</label>{{$ctrl.establecimiento.nom_depto}}</p><p><label>Provincia:</label>{{$ctrl.establecimiento.nom_prov}}</p><p><label>Municipio:</label>{{$ctrl.establecimiento.nom_municipio}}</p></div></form>");
$templateCache.put("app/components/busquedaSedeUniversitaria/busquedaSedeUniversitaria.html","<form name=form ng-submit=$ctrl.search()><div layout=row class=form-horizontal><md-autocomplete md-input-name=sedeUniversitaria ng-disabled=$ctrl.isDisabled md-no-cache=$ctrl.noCache md-selected-item=$ctrl.selectedItem md-search-text-change=$ctrl.searchTextChange($ctrl.searchText) md-search-text=$ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(item) md-items=\"item in $ctrl.querySearch($ctrl.searchText)\" md-item-text=item.nombre md-min-length=0 placeholder=\"Sede universitaria\" md-menu-class=autocomplete-custom-template-sede-univ style=\"width: 100%; margin: 0 0 15px 0\" required><md-item-template><span class=item-title><md-icon>domain</md-icon><span>{{item.universidad.nombre}}</span> </span><span class=item-metadata><span class=item-metastat><strong>{{item.nombre}} - {{item.departamento.nombre}}</strong></span></span></md-item-template></md-autocomplete></div><div flex></div><div ng-messages=form.sedeUniversitaria.$error><div ng-message=required style=\"color:rgb(221, 44, 0); font-size: 9pt;margin-top: -18px\">Debe seleccionar una sede universitaria.</div></div><div ng-if=\"$ctrl.sede && $ctrl.sede.nombre\" style=\"margin-left:10px; font-size: 12px; line-height: 12px\"><p><label>Universidad:</label>{{$ctrl.sede.universidad.nombre}}</p><p><label>Departamento:</label>{{$ctrl.sede.departamento.nombre}}</p></div></form>");
$templateCache.put("app/components/cedulaIdentidad/cedulaIdentidad.html","<form name=form ng-submit=\"form.$valid && $ctrl.search()\" novalidate><!-- <help-message mensaje=\"Ingrese número de cédula de identidad y fecha de nacimiento.\"></help-message> --><div class=cedula-identidad-container layout-gt-xs=row layout-xs=column class=form-horizontal style=\"margin-top: 20px\"><md-input-container class=large aria-label=\"Tipo de documento\" ng-if=!$ctrl.extranjero><div style=\"margin-top: -20px; margin-bottom: 5px; color:rgb(112, 110, 110); font-size: 8pt\">Tipo de documento <span style=\"color:rgb(221, 44, 0)\">*</span></div><md-radio-group name=tipoDocumento layout=row flex=50 ng-model=$ctrl.tipoPersona required ng-required=true ng-disabled=$ctrl.encontrado><md-radio-button value=1 class=md-primary checked name=tipoDocumentoNacional title=\"Si la persona nació en Bolivia\">Nacional</md-radio-button><md-radio-button value=2 name=tipoDocumentoExtranjero title=\"Si la persona NO nació en Bolivia\">Extranjero</md-radio-button></md-radio-group><div class=md-errors-spacer></div><div ng-if=!$ctrl.tipoPersona style=\"color:rgb(221, 44, 0); font-size: 9pt\">Debe seleccionar tipo documento.</div></md-input-container><md-input-container class=large style=\"margin-right: 10px\" aria-label=\"Cédula de identidad\"><label>Cédula de identidad</label><input ng-model=$ctrl.documentoIdentidad required od-cantidad=20 ng-pattern=/^([0-9](-[0-9]{1}[a-zA-Z]{1})?)+$/ capitalize ng-disabled=$ctrl.encontrado></md-input-container><md-input-container style=\"width: 165px; margin-bottom: 20px\" ng-if=!$ctrl.birthday><label>Fecha de nacimiento:</label></md-input-container><div layout=row><md-input-container ng-if=!$ctrl.birthday class=small><label>Día</label><input ng-model=$ctrl.day type=text ng-maxlength=2 only-digits od-cantidad=2 od-minimo=1 od-maximo=31 required ng-disabled=$ctrl.encontrado></md-input-container><md-input-container ng-if=!$ctrl.birthday class=small><label>Mes</label><input ng-model=$ctrl.month type=text ng-maxlength=2 only-digits od-cantidad=2 od-minimo=1 od-maximo=12 required ng-disabled=$ctrl.encontrado></md-input-container><md-input-container ng-if=!$ctrl.birthday class=small><label>Año</label><input ng-model=$ctrl.year type=text ng-maxlength=4 only-digits od-cantidad=4 required ng-disabled=$ctrl.encontrado></md-input-container></div></div><div class=cedula-identidad-container layout-gt-xs=row layout-xs=column class=form-horizontal><md-input-container class=large><label>Nombre(s){{persona}}</label><input ng-model=$ctrl.nombres required capitalize maxlength=30 ng-disabled=$ctrl.encontrado></md-input-container><md-input-container class=large><label>Primer apellido</label><input ng-model=$ctrl.primer_apellido capitalize maxlength=30 ng-disabled=$ctrl.encontrado></md-input-container><md-input-container class=large><label>Segundo apellido</label><input ng-model=$ctrl.segundo_apellido capitalize maxlength=30 ng-disabled=$ctrl.encontrado></md-input-container><md-button type=submit class=\"md-raised md-primary little-button\" ng-if=!$ctrl.texto ng-disabled=$ctrl.encontrado><md-icon>check</md-icon>Validar</md-button><md-button type=submit class=\"md-raised md-primary little-button\" ng-if=$ctrl.texto><md-icon>check</md-icon>{{$ctrl.texto}}</md-button></div></form>");
$templateCache.put("app/components/combobox/combobox.html","<md-input-container><label>{{$ctrl.label}}</label><md-select ng-model=$ctrl.userState><md-option ng-repeat=\"option in $ctrl.options\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/components/crudTable/crudTable.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-show=vm.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=vm.filter.form ng-submit=vm.buscarFiltro()><input type=text class=crud-table-filter id=crud-table-input ng-model=vm.query.filter ng-model-options=vm.filter.options placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=vm.removeFilter()><md-icon>close</md-icon></md-button></div></md-toolbar><md-toolbar class=md-table-toolbar ng-show=!vm.filter.show><div class=md-toolbar-tools><md-icon>grid_on</md-icon><span>{{vm.titleTable}}</span><div flex></div><md-button class=md-icon-button ng-click=vm.showFilter() ng-if=vm.permissions.filter><md-tooltip>Filtrar registros</md-tooltip><md-icon>search</md-icon></md-button><md-button class=md-icon-button ng-click=vm.saveAll() ng-if=vm.editable><md-tooltip>Guardar todo</md-tooltip><md-icon>playlist_add_check</md-icon></md-button><md-button class=md-icon-button ng-click=vm.getItems() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon>refresh</md-icon></md-button><md-button class=\"md-icon-button btn-collapsed\"><md-tooltip>Ocultar/Ver</md-tooltip><md-icon>keyboard_arrow_down</md-icon></md-button></div></md-toolbar><md-card-content><!--<div class=\"btn-container\" ng-if=\"vm.permissions.create\">\n            <md-button class=\"md-fab md-primary\" ng-click=\"vm.add($event)\" aria-label=\"Add\">\n                <md-tooltip>Agregar nuevo registro</md-tooltip>\n                <md-icon>add</md-icon>\n            </md-button>\n        </div>--><div layout=row layout-align=\"end center\"><div style=\"min-height: 30px\" ng-if=\"vm.permissions.create && !vm.ocultarCreate\"><md-button class=\"md-raised md-primary\" ng-click=vm.add($event) aria-label=Add style=\"bottom: 0; right: 0\"><md-icon>add</md-icon>Nuevo registro</md-button></div><div style=\"min-height: 30px\" ng-repeat=\"boton in vm.botones\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.buttonEvent($event, null, boton.onclick)\" aria-label=boton.tooltip style=\"bottom: 0; right: 0\" ng-if=\"vm.botones && vm.botones.length > 0 && vm.permissions.create\"><md-icon>{{boton.icon}}</md-icon>{{boton.texto}}</md-button></div></div><md-table-container><table md-table ng-model=selected md-progress=promise ng-if=vm.permissions.read><thead md-head md-order=vm.query.order md-on-reorder=vm.getItems><tr md-row><th md-column class=text-center ng-if=!vm.permissions.acciones_ocultar>Acciones</th><th ng-repeat=\"header in vm.headers\" md-column ng-if=\"header.name != \'id\' && vm.mostrarCampo(header.name)\" md-order-by=\"{{header.order ? header.name : \'\'}}\"><span>{{header.title}}</span></th></tr></thead><tbody md-body class=\"{{vm.editable ? \'formly-table-editable\' : \'\'}}\"><tr md-row md-select=item ng-repeat=\"item in vm.items.data\"><td md-cell class=\"text-center md-table-options\" ng-if=!vm.permissions.acciones_ocultar><md-button class=md-icon-button aria-label=Editar ng-click=\"vm.edit($event, item)\" ng-if=\"vm.permissions.update && !vm.editable\"><md-tooltip>Editar</md-tooltip><md-icon class=\"md-icon icon-edit\">mode_edit</md-icon></md-button><md-button class=md-icon-button aria-label=Editar ng-click=vm.save(item) ng-if=\"vm.permissions.update && vm.editable\"><md-tooltip>Guardar registro</md-tooltip><md-icon class=\"md-icon icon-other\">check</md-icon></md-button><md-button class=md-icon-button aria-label=Editar ng-click=\"vm.print($event, item)\" ng-if=vm.permissions.print><md-tooltip>Imprimir</md-tooltip><md-icon class=\"md-icon icon-other\">print</md-icon></md-button><md-button class=md-icon-button ng-repeat=\"button in vm.buttons\" aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick)\" ng-if=\"!(button.ocultar && item.estado == button.estado) && button.show\"><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon class=\"md-icon icon-other\" ng-if=\"!button.iconColor || item[\'\' + button.nombreColumnaColor + \'\'] != button.valorColumnaColor\">{{button.icon}}</md-icon><md-icon class=\"md-icon icon-other\" style=\"color: {{button.iconColor}}\" ng-if=\"button.iconColor && item[\'\' + button.nombreColumnaColor + \'\'] == button.valorColumnaColor\">{{button.icon}}</md-icon></md-button><md-button class=\"md-icon-button md-accent\" aria-label=Eliminar ng-click=\"vm.delete($event, item)\" ng-if=vm.permissions.delete><md-tooltip>Eliminar</md-tooltip><md-icon class=\"md-icon icon-danger\">delete</md-icon></md-button></td><td md-cell ng-repeat=\"(key, value) in item\" ng-if=\"key != \'id\' && vm.mostrarCampo(key)\"><div ng-if=vm.editable><div ng-switch on=vm.types[key].type><div ng-switch-when=input><md-input-container><label>{{vm.types[key].templateOptions.label}}</label><input ng-model=vm.dataGrid[value]></md-input-container></div><div ng-switch-when=textarea><md-input-container><label>{{vm.types[key].templateOptions.label}}</label><textarea ng-model=vm.dataGrid[value]></textarea></md-input-container></div><div ng-switch-when=select><md-input-container><md-select ng-model=vm.dataGrid[value]><label>{{vm.types[key].templateOptions.label}}</label><md-option ng-repeat=\"option in vm.types[key].templateOptions.options\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container></div><div ng-switch-when=checkbox><md-checkbox ng-model=vm.dataGrid[value] aria-label={{vm.types[key].templateOptions.label}}></md-checkbox></div><div ng-switch-when=datepicker><md-datepicker ng-model=vm.dataGrid[value] md-placeholder={{vm.types[key].templateOptions.label}}></md-datepicker></div><div ng-switch-default>{{value}}</div></div></div><div ng-if=!vm.editable><div ng-if=\"!(value.type==\'Buffer\')\"><div ng-switch on=value><div ng-switch-when=check_circle_success><md-icon class=bg-success>check_circle</md-icon></div><div ng-switch-when=check_circle_gray><md-icon class=bg-gray>check_circle</md-icon></div><div ng-switch-default>{{value}}</div></div></div><div ng-if=\"value.type==\'Buffer\'\"><image style=\"width: 100px\" alt=\"Debe subir la imagen\" data-ng-src=data:image;base64,{{value.data}}></div></div></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.items.count}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks md-on-paginate=vm.getItems></md-table-pagination></md-card-content></md-card>");
$templateCache.put("app/components/crudTable/dialog.crudTable.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=\"formly-dialog formly-column-{{column}}\"><form ng-submit=\"form.$valid && answer(\'save\')\" id=data-form name=form novalidate><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><formly-form model=data fields=fields options=options form=form></formly-form><div class=crudFileInput ng-repeat=\"archivo in data.archivos\"><md-input-container style=\"margin-left: 10px; width: 85%\"><label>{{archivo.label}}</label><br></md-input-container><lf-ng-md-file-input lf-files=archivo.files aria-label=\"Subir archivo\" lf-placeholder=\"Subir archivo\" lf-browse-label=Buscar lf-remove-label=Limpiar accept=image/*></lf-ng-md-file-input></div></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=cancel()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/crudTable/dialog.crudTable.lectura.html","<md-dialog aria-label=Ver ng-cloak class=\"formly-dialog formly-column-{{column}}\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"pull-left alert alert-danger md-alert-required\">Los datos no están habilitados para edición.</div><div style=\"clear: both\"></div><p></p><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><formly-form model=data fields=fields options=options form=form></formly-form></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=cancel()><md-icon>cancel</md-icon>Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/crudTable/dialog.pdf.firmas.html","<!-- <md-dialog class=\"fullscreen-dialog\" aria-label=\"Documento\" ng-cloak class=\"formly-dialog formly-column-{{column}}\"> --><md-dialog aria-label=Documento ng-cloak class={{data.pdfConFirmas}}><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=formulario-datos ng-if=!data.fileDocumento><p>Se descargará el documento.</p></div><div layout-gt-xs=row layout-xs=column><iframe ng-if=data.fileDocumento src={{data.fileDocumento}} style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe><div class=formulario-datos><md-card-header><md-card-header-text><span class=md-title>Firmas del documento</span></md-card-header-text></md-card-header><div><p class=mensajeFirmas ng-if=data.firmasMensaje>{{data.firmasMensaje}}</p><div ng-repeat=\"firma in data.firmas\"><md-card style=\"font-size: 12px; padding: 10px; max-width: 250px\" layout=row><div style=\"margin-right: 5px\"><span style=text-left><md-icon class=colorPrimario>border_color</md-icon></span></div><div><!-- <span ng-bind-html=\"formatearHtml(firma)\"></span> --><div><b>Nombre: </b>{{firma.nombreComunSubject}}</div><div><b>Fecha firma:</b> {{firma.fechaFirma}}</div></div></md-card></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/crudTable/dialog.pdf.html","<md-dialog aria-label=Imprimir ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"width: 960px\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><iframe ng-src={{data}} type=application/pdf style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/components/crudTableAlt/crudTableAlt.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-show=vm.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=vm.filter.form ng-submit=vm.buscarFiltro()><input type=text class=crud-table-filter id=crud-table-input ng-model=vm.query.filter ng-model-options=vm.filter.options placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=vm.removeFilter()><md-icon>close</md-icon></md-button></div></md-toolbar><md-toolbar class=md-table-toolbar ng-show=!vm.filter.show><div class=md-toolbar-tools><md-icon>grid_on</md-icon><span>{{vm.titleTable}}</span><div flex></div><md-button class=md-icon-button ng-click=vm.showFilter() ng-if=vm.permissions.filter><md-tooltip>Filtrar registros</md-tooltip><md-icon>search</md-icon></md-button><md-button class=md-icon-button ng-click=vm.saveAll() ng-if=vm.editable><md-tooltip>Guardar todo</md-tooltip><md-icon>playlist_add_check</md-icon></md-button><md-button class=md-icon-button ng-click=vm.getItems() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon>refresh</md-icon></md-button><md-button class=\"md-icon-button btn-collapsed\"><md-tooltip>Ocultar/Ver</md-tooltip><md-icon>keyboard_arrow_down</md-icon></md-button></div></md-toolbar><md-card-content><!--<div class=\"btn-container\" ng-if=\"vm.permissions.create\">\n            <md-button class=\"md-fab md-primary\" ng-click=\"vm.add($event)\" aria-label=\"Add\">\n                <md-tooltip>Agregar nuevo registro</md-tooltip>\n                <md-icon>add</md-icon>\n            </md-button>\n        </div>--><div class=\"btn-container text-right\" style=\"min-height: 30px\" ng-if=\"(!vm.botones.length || (vm.botones.length && vm.botones.length == 0)) && vm.permissions.create\"><md-button class=\"md-raised md-primary\" ng-click=vm.add($event) aria-label=Add style=\"bottom: 0; right: 0\"><md-icon>add</md-icon>Nuevo registro</md-button></div><div class=\"btn-container text-right\" style=\"min-height: 30px\" ng-repeat=\"boton in vm.botones\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.buttonEvent($event, null, boton.onclick)\" aria-label=boton.tooltip style=\"bottom: 0; right: 0\" ng-if=\"vm.botones && vm.botones.length > 0 && vm.permissions.create\"><md-icon>{{boton.icon}}</md-icon>{{boton.texto}}</md-button></div><md-table-container><table md-table ng-model=selected md-progress=promise ng-if=vm.permissions.read><thead md-head md-order=vm.query.order md-on-reorder=vm.getItems><tr md-row><th md-column class=text-center ng-if=!vm.permissions.acciones_ocultar>Acciones</th><th ng-repeat=\"header in vm.headers\" md-column ng-if=\"header.name != \'id\'\" md-order-by=\"{{header.order ? header.name : \'\'}}\"><span>{{header.title}}</span></th></tr></thead><tbody md-body class=\"{{vm.editable ? \'formly-table-editable\' : \'\'}}\"><tr md-row md-select=item ng-repeat=\"item in vm.items.data\"><td md-cell class=\"text-center md-table-options\" ng-if=!vm.permissions.acciones_ocultar><md-button class=md-icon-button aria-label=Editar ng-click=\"vm.edit($event, item)\" ng-if=\"vm.permissions.update && !vm.editable\"><md-tooltip>Editar</md-tooltip><md-icon class=\"md-icon icon-edit\">mode_edit</md-icon></md-button><md-button class=md-icon-button aria-label=Editar ng-click=vm.save(item) ng-if=\"vm.permissions.update && vm.editable\"><md-tooltip>Guardar registro</md-tooltip><md-icon class=\"md-icon icon-other\">check</md-icon></md-button><md-button class=md-icon-button aria-label=Editar ng-click=\"vm.print($event, item)\" ng-if=vm.permissions.print><md-tooltip>Imprimir</md-tooltip><md-icon class=\"md-icon icon-other\">print</md-icon></md-button><md-button class=md-icon-button ng-repeat=\"button in vm.buttons\" aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick)\" ng-if=\"!(button.ocultar && item.estado == button.estado) && button.show\"><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon class=\"md-icon icon-other\" ng-if=\"!button.iconColor || item[\'\' + button.nombreColumnaColor + \'\'] != button.valorColumnaColor\">{{button.icon}}</md-icon><md-icon class=\"md-icon icon-other\" style=\"color: {{button.iconColor}}\" ng-if=\"button.iconColor && item[\'\' + button.nombreColumnaColor + \'\'] == button.valorColumnaColor\">{{button.icon}}</md-icon></md-button><md-button class=\"md-icon-button md-accent\" aria-label=Eliminar ng-click=\"vm.delete($event, item)\" ng-if=vm.permissions.delete><md-tooltip>Eliminar</md-tooltip><md-icon class=\"md-icon icon-danger\">delete</md-icon></md-button></td><td md-cell ng-repeat=\"(key, value) in item\" ng-if=\"key != \'id\'\"><div ng-if=vm.editable><div ng-switch on=vm.types[key].type><div ng-switch-when=input><md-input-container><label>{{vm.types[key].templateOptions.label}}</label><input ng-model=vm.dataGrid[value]></md-input-container></div><div ng-switch-when=textarea><md-input-container><label>{{vm.types[key].templateOptions.label}}</label><textarea ng-model=vm.dataGrid[value]></textarea></md-input-container></div><div ng-switch-when=select><md-input-container><md-select ng-model=vm.dataGrid[value]><label>{{vm.types[key].templateOptions.label}}</label><md-option ng-repeat=\"option in vm.types[key].templateOptions.options\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container></div><div ng-switch-when=checkbox><md-checkbox ng-model=vm.dataGrid[value] aria-label={{vm.types[key].templateOptions.label}}></md-checkbox></div><div ng-switch-when=datepicker><md-datepicker ng-model=vm.dataGrid[value] md-placeholder={{vm.types[key].templateOptions.label}}></md-datepicker></div><div ng-switch-default>{{value}}</div></div></div><div ng-if=!vm.editable><div ng-switch on=value><div ng-switch-when=check_circle_success><md-icon class=bg-success>check_circle</md-icon></div><div ng-switch-when=check_circle_gray><md-icon class=bg-gray>check_circle</md-icon></div><div ng-switch-default>{{value}}</div></div></div></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.items.count}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks md-on-paginate=vm.getItems></md-table-pagination></md-card-content></md-card>");
$templateCache.put("app/components/crudTableAlt/dialog.crudTableAlt.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=\"formly-dialog formly-column-{{column}}\"><form ng-submit=\"form.$valid && answer(\'save\')\" id=data-form name=form novalidate><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><formly-form model=data fields=fields options=options form=form></formly-form></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=cancel()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/crudTableAlt/dialog.crudTableAlt.lectura.html","<md-dialog aria-label=Ver ng-cloak class=\"formly-dialog formly-column-{{column}}\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"pull-left alert alert-danger md-alert-required\">Los datos no están habilitados para edición.</div><div style=\"clear: both\"></div><p></p><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><formly-form model=data fields=fields options=options form=form></formly-form></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=cancel()><md-icon>cancel</md-icon>Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/crudTableAlt/dialog.pdf.html","<md-dialog aria-label=Imprimir ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"width: 960px\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><iframe src={{data}} style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/components/demofi/asociar.dialog.html","<md-dialog id=modal-signer aria-label=firmador><md-toolbar><div class=md-toolbar-tools><h2>Asociar token</h2><span flex></span><md-button class=md-icon-button ng-click=vm.cancelarAsociar()><md-icon aria-label=\"Cerrar modal\">close</md-icon></md-button></div></md-toolbar><form name=formAutenticar ng-submit=vm.asociar()><md-dialog-content><div style=\"padding: 15px\"><!-- Estado del token --><div layout=row><span><b>Token detectado: </b></span><span ng-if=\"vm.tokens.length == 0\">&nbsp;&nbsp;Ningun token conectado </span><span ng-repeat=\"tokenName in vm.tokens\"><span>&nbsp;&nbsp;{{tokenName}}</span></span></div><div layout=row layout-xs=column layout-align=left><div><img class=certificate src=app/components/demofi/images/certificate.png></div><div style=\"padding: 30px 0 0\"><md-input-container><label style=\"font-weight: bold\">Pin</label><input ng-model=vm.pin type=password required ng-disabled=\"vm.tokens.length === 0\" aria-label=Pin></md-input-container><br></div></div></div></md-dialog-content><md-dialog-actions layout=row><md-button class=md-raised ng-click=vm.cancelarAsociar()><span>Cancelar</span></md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=!vm.pin aria-label=Firmar><span>Asociar token</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/demofi/demofi.dialog.html","<md-dialog id=modal-signer aria-label=firmador><md-toolbar><div class=md-toolbar-tools><h2>Firma de documentos</h2><span flex></span><md-button class=md-icon-button ng-click=vm.cancelar()><md-icon aria-label=\"Cerrar modal\">close</md-icon></md-button></div></md-toolbar><form name=formAutenticar ng-submit=vm.autenticar()><md-dialog-content><div style=\"padding: 15px\"><!-- Estado del token --><div layout=row><span><b>Token detectado: </b></span><span ng-if=\"vm.tokens.length == 0\">&nbsp;&nbsp;Ningun token conectado </span><span ng-repeat=\"tokenName in vm.tokens\"><span>&nbsp;&nbsp;{{tokenName}}</span></span></div><div layout=row layout-xs=column layout-align=left><div><img class=certificate src=app/components/demofi/images/certificate.png></div><div flex><div style=\"max-width: 250px; padding: 20px 0\"><span ng-if=vm.certificadoRecuperadoError><md-icon style=\"color: red\">cancel</md-icon>{{vm.certificadoRecuperadoError}} </span><!-- <span ng-if=\"vm.certificadoRecuperado\">\n               <md-icon class=\"bg-success\">check_circle</md-icon> El usuario logueado cuenta con un certificado digital registrado.\n              </span> --></div><md-input-container style=\"padding: 10px 0 0\"><label style=\"font-weight: bold\">Pin</label><input ng-model=vm.pin type=password required ng-disabled=\"vm.tokens.length === 0 || !vm.certificadoRecuperado\" aria-label=Pin></md-input-container><br></div></div></div></md-dialog-content><md-dialog-actions layout=row><md-button class=md-raised ng-click=vm.cancelar()><span>Cancelar</span></md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=\"!vm.certificadoRecuperado || !vm.pin\" aria-label=Firmar><span>Firmar documentos</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/documentoIdentidad/documentoIdentidad.html","<md-tabs class=cedula-identidad-tab md-selected=$ctrl.extranjeroNro md-dynamic-height md-border-bottom><md-tab label=\"Cédula de identidad\"><form name=form ng-submit=\"form.$valid && $ctrl.search()\" novalidate><md-content><help-message mensaje=\"Ingrese datos personales (Validación SEGIP).\"></help-message><div class=cedula-identidad-container layout-gt-xs=row layout-xs=column class=form-horizontal><md-input-container class=large aria-label=\"Tipo de documento\" ng-if=!$ctrl.extranjero><div style=\"margin-top: -20px; margin-bottom: 5px; color:rgb(112, 110, 110); font-size: 8pt\">Tipo de documento <span style=\"color:rgb(221, 44, 0)\">*</span></div><md-radio-group name=tipoDocumento layout=row flex=50 ng-model=$ctrl.tipoPersona required ng-required=true ng-disabled=$ctrl.encontrado><md-radio-button value=1 class=md-primary checked name=tipoDocumentoNacional title=\"Si la persona nació en Bolivia\">Nacional</md-radio-button><md-radio-button value=2 name=tipoDocumentoExtranjero title=\"Si la persona NO nació en Bolivia\">Extranjero</md-radio-button></md-radio-group><div class=md-errors-spacer></div><div ng-if=!$ctrl.tipoPersona style=\"color:rgb(221, 44, 0); font-size: 9pt\">Debe seleccionar tipo documento.</div></md-input-container><md-input-container class=large aria-label=\"Cédula de identidad\" ng-if=!$ctrl.extranjero><label>Cédula de identidad</label><input ng-model=$ctrl.documentoIdentidad ng-disabled=$ctrl.encontrado required ng-pattern=/^([0-9](-[0-9]{1}[a-zA-Z]{1})?)+$/ od-cantidad=20 capitalize placeholder=\"Ejemplo: 4521215\"><!-- <div class=\"hint\">Nacional o extranjera (sólo números)</div> --></md-input-container><md-input-container style=\"width: 145px\" ng-if=!$ctrl.birthday><label style=font-size:13px>Fecha de nacimiento:</label></md-input-container><md-input-container ng-if=!$ctrl.birthday class=small><label>Día</label><input ng-model=$ctrl.day type=text ng-disabled=$ctrl.encontrado ng-maxlength=2 only-digits od-cantidad=2 od-minimo=1 od-maximo=31 required placeholder=31></md-input-container><md-input-container ng-if=!$ctrl.birthday class=small><label>Mes</label><input ng-model=$ctrl.month type=text ng-disabled=$ctrl.encontrado ng-maxlength=2 only-digits od-cantidad=2 od-minimo=1 od-maximo=12 required placeholder=12></md-input-container><md-input-container ng-if=!$ctrl.birthday style=\"margin-right: 10px\" class=small><label>Año</label><input ng-model=$ctrl.year type=text ng-disabled=$ctrl.encontrado ng-maxlength=4 only-digits od-cantidad=4 required placeholder=1992></md-input-container></div><div class=cedula-identidad-container layout-gt-xs=row layout-xs=column class=form-horizontal><md-input-container class=large><label>Nombre(s){{persona}}</label><input ng-model=$ctrl.nombres required capitalize maxlength=30 ng-disabled=$ctrl.encontrado></md-input-container><md-input-container class=large><label>Primer apellido</label><input ng-model=$ctrl.primer_apellido capitalize maxlength=30 ng-disabled=$ctrl.encontrado></md-input-container><md-input-container class=large><label>Segundo apellido</label><input ng-model=$ctrl.segundo_apellido capitalize maxlength=30 ng-disabled=$ctrl.encontrado></md-input-container><md-input-container class=large><label>Apellido del esposo</label><input ng-model=$ctrl.casada_apellido capitalize maxlength=30 ng-disabled=$ctrl.encontrado></md-input-container><md-button type=submit class=\"md-raised md-primary little-button\" ng-if=!$ctrl.texto ng-disabled=$ctrl.encontrado><md-icon>check</md-icon>Validar</md-button><md-button type=submit class=\"md-raised md-primary little-button\" ng-if=$ctrl.texto><md-icon>check</md-icon>{{$ctrl.texto}}</md-button></div></md-content></form></md-tab><md-tab label=Pasaporte><form name=form1 ng-submit=\"form1.$valid && $ctrl.search()\" novalidate><md-content><help-message mensaje=\"Ingrese el número de documento extranjero, fecha de nacimiento, nombres y apellidos.\"></help-message><div class=cedula-identidad-container layout-gt-xs=row layout-xs=column class=form-horizontal><!-- <md-input-container class=\"middle\" aria-label=\"Nombre\" ng-if=\"$ctrl.extranjero\">\n						<label>Nombre</label>\n						<input ng-model=\"$ctrl.nombres\" placeholder=\"Ejemplo: JUAN\" required capitalize>\n					</md-input-container> --><md-input-container class=middle aria-label=Documento ng-if=$ctrl.extranjero><label>Pasaporte Nro.</label><input ng-model=$ctrl.documentoIdentidad placeholder=\"Ejemplo: JK7123131\" required capitalize><!-- <div class=\"hint\">Ejemplo: JK7711223</div> --></md-input-container><md-input-container style=\"width: 145px\" ng-if=!$ctrl.birthday><label style=font-size:13px>Fecha de nacimiento:</label></md-input-container><md-input-container ng-if=!$ctrl.birthday class=small><label>Día</label><input ng-model=$ctrl.day type=text ng-maxlength=2 only-digits od-cantidad=2 od-minimo=1 od-maximo=31 required placeholder=31></md-input-container><md-input-container ng-if=!$ctrl.birthday class=small><label>Mes</label><input ng-model=$ctrl.month type=text ng-maxlength=2 only-digits od-cantidad=2 od-minimo=1 od-maximo=12 required placeholder=12></md-input-container><md-input-container ng-if=!$ctrl.birthday style=\"margin-right: 10px\" class=small><label>Año</label><input ng-model=$ctrl.year type=text ng-maxlength=4 only-digits od-cantidad=4 required placeholder=1992></md-input-container><md-button type=submit class=\"md-raised md-primary little-button\" ng-if=!$ctrl.texto><md-icon>check</md-icon>Validar</md-button><md-button type=submit class=\"md-raised md-primary little-button\" ng-if=$ctrl.texto><md-icon>check</md-icon>{{$ctrl.texto}}</md-button></div></md-content></form></md-tab></md-tabs>");
$templateCache.put("app/components/navbar/cambiarRol.dialog.html","<md-dialog aria-label=\"Cambiar rol\" ng-cloak><md-toolbar><div class=md-toolbar-tools><h2><md-icon>credit_card</md-icon>Cambiar de rol</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column class=inscripcion-data><form id=formControl name=formRol ng-submit=cambiarRol()><md-card><md-card-header><md-card-header-text><span class=md-title>Cambiar de rol</span></md-card-header-text></md-card-header><md-card-content><p><label style=\"width: 140px\">Rol actual:</label>{{usuario.rol}}</p><p><br></p><p><label>Roles disponibles:</label></p><md-radio-group ng-model=usuario.cambioRol ng-if=\"usuario.roles && usuario.roles.length > 0\" required><md-radio-button value={{r.id_rol}} class=md-primary ng-repeat=\"r in usuario.roles\">{{r.nombre}}</md-radio-button></md-radio-group><p ng-if=\"!usuario.roles || usuario.roles.length <= 0\">Usted no tiene otros roles disponibles.</p></md-card-content></md-card><div class=text-right><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=formRol.$invalid><md-icon>check</md-icon>Guardar</md-button></div></form></md-content></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar><div class=md-toolbar-tools><md-button class=md-icon-button ng-click=vm.toggle() aria-label=\"Menu collapse\" show-gt-md><md-tooltip>Mostrar/ocultar menú</md-tooltip><i class=md-icon>menu</i></md-button><!-- <span class=\"navbar-user-name\" flex>{{vm.getFirstName()}}</span> --> <span flex></span><md-button class=md-icon-button ng-click=vm.back() aria-label=Atrás show-gt-md><md-tooltip>Atrás</md-tooltip><i class=md-icon>arrow_back</i></md-button><md-button class=\"margin-0 md-icon-button btn-fullscreen\" ng-click=vm.fullscreen() aria-label=Fullscreen show-gt-md id=btn-fullscreen><md-icon>fullscreen</md-icon><md-icon>fullscreen_exit</md-icon><md-tooltip class=tooltip-fullscreen><span class=exit>Salir </span>Pantalla completa</md-tooltip></md-button><md-menu><!-- <md-button aria-label=\"interactions menu\" class=\"md-icon-button navbar-user-icon bg-{{vm.getColor()}}-user\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\">\n                {{vm.getInitial()}}\n            </md-button> --><md-button class=\"margin-0 md-icon-button\" aria-label=Más ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-tooltip>Más opciones</md-tooltip><md-icon>more_vert</md-icon></md-button><md-menu-content class=navbar-options><!-- <md-menu-item>\n                    <md-button ng-click=\"vm.profile()\">\n                        <i class=\"md-icon\">account_circle</i> Mi cuenta\n                    </md-button>\n                </md-menu-item> --><!-- <md-menu-item>\n                    <md-button ng-click=\"vm.settings()\">\n                        <i class=\"md-icon\">settings applications</i> Configuraciones\n                    </md-button>\n                </md-menu-item> --><!-- <md-menu-divider></md-menu-divider> --><md-menu-item style=\"width: 250px\"><md-button ng-click=vm.cambiarContrasena($event)><i class=md-icon>keyboard</i> Cambiar contraseña</md-button></md-menu-item><!-- <md-menu-item style=\"width: 250px;\">\n                    <md-button ng-click=\"vm.cambiarRol($event)\">\n                        <i class=\"md-icon\">credit_card</i> Cambiar rol\n                    </md-button>\n                </md-menu-item> --><md-menu-item style=\"width: 250px\"><md-button ng-click=vm.logout()><i class=md-icon>power_setting_new</i> Salir</md-button></md-menu-item></md-menu-content></md-menu><md-button class=md-icon-button aria-label=More style=\"display: none\"><i class=md-icon>more_vert</i></md-button></div></md-toolbar>");
$templateCache.put("app/components/navbar/usuario.dialog.html","<md-dialog aria-label=Agregar/Editar ng-cloak><md-toolbar><div class=md-toolbar-tools><md-icon>perm_identity</md-icon><h2>Cambiar contraseña</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form name=formMedico ng-submit=cambiarContrasena()><md-dialog-content><div class=md-dialog-content><md-card-content layout=column><md-input-container><label>Contraseña actual</label><input ng-model=datos.contrasena id=contrasena name=contrasena type=password required></md-input-container><md-input-container><label>Contraseña nueva</label><input ng-model=datos.contrasena_nueva id=contrasena_nueva name=contrasena_nueva type=password required></md-input-container><md-input-container><label>Confirmar contraseña nueva</label><input ng-model=datos.confirmar_contrasena id=confirmar_contrasena name=confirmar_contrasena type=password pw-check=contrasena_nueva required></md-input-container><div class=msg-block ng-show=formMedico.$error><span class=msg-error ng-show=formMedico.confirmar_contrasena.$error.pwmatch>Las contraseñas no coinciden.</span></div></md-card-content></div></md-dialog-content><md-dialog-actions layout=row><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=formMedico.$invalid><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/reportePar1/reportePar1.html","<div><md-input-container><label>Año</label><md-select ng-model=$ctrl.datos.year required><md-option ng-repeat=\"option in $ctrl.years\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container><md-input-container><label>Mes</label><md-select ng-model=$ctrl.datos.month required><md-option ng-repeat=\"option in $ctrl.months\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/components/selectTable/selectTable.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-show=vm.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=vm.filter.form><input type=text class=crud-table-filter id=crud-table-input ng-model=vm.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=vm.removeFilter()><md-icon>close</md-icon></md-button></div></md-toolbar><md-toolbar class=md-table-toolbar ng-show=!vm.filter.show><div class=md-toolbar-tools><span>{{vm.title}}</span><div flex></div><md-button class=md-icon-button ng-click=vm.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon>search</md-icon></md-button></div></md-toolbar><md-card-content><md-table-container><md-card class=selected-list><strong>Seleccionados:</strong><ul><li ng-repeat=\"sel in vm.selected\"><span ng-repeat=\"(key, value) in sel\" ng-if=\"key == vm.mostrar\">{{value}}</span></li></ul></md-card><table md-table md-row-select multiple ng-model=vm.selected md-progress=promise><thead md-head md-order=vm.query.order md-on-reorder=vm.getData><tr md-row><th md-column ng-repeat=\"column in vm.fields\">{{column.label}}</th></tr></thead><tbody md-body><tr md-row md-select=item md-select-id={{vm.idnombre}} md-auto-select ng-repeat=\"item in vm.items.rows\"><td md-cell ng-repeat=\"(key, value) in item\" ng-if=\"key != vm.idnombre\">{{value}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=vm.query.limit md-limit-options=\"[5, 20, 30]\" md-page=vm.query.page md-total={{vm.items.count}} md-on-paginate=vm.getData md-page-select></md-table-pagination></md-card-content></md-card>");
$templateCache.put("app/components/sidenav/sidenav.html","<md-sidenav class=md-sidenav-left md-component-id=left md-is-locked-open=\"$mdMedia(\'gt-sm\')\" id=sidenav><md-toolbar class=sidenav-title><h1 class=md-toolbar-tools><i class=\"md-icon sidenav-title-icon\">content_copy</i> <span class=sidenav-title-text>SSSRO - SEDES</span></h1></md-toolbar><div class=sidenav-user><figure><img class=sidenav-user-photo src=\"\" alt=\"Image User\" hidden><div class=\"sidenav-user-default bg-{{vm.getColor()}}-user\"><!-- <i class=\"md-icon\">account_circle</i> --> {{vm.getInitial()}}</div></figure><!-- <div class=\"sidenav-user-item\">{{vm.getEmail()}}</div> --><h2 class=sidenav-user-name>{{vm.getName()}}</h2><div class=sidenav-user-item>{{vm.getRol()}}</div><div class=sidenav-user-item>{{vm.getEntidad()}}</div></div><ul class=sidenav-list><li ng-repeat=\"opcion in vm.getMenu()\"><div ng-if=!opcion.url><md-button type=button class=\"md-button-toggle md-button md-button md-ink-ripple\" ng-click=\"vm.send(opcion.url, opcion.submenu.length)\"><i class=\"md-icon md-icon-option\">{{opcion.icon}}</i> <span class=md-icon-text>{{opcion.label}}</span> <i class=\"md-icon md-icon-arrow-down\" ng-if=opcion.submenu.length>keyboard_arrow_down</i></md-button><ul class=sidenav-sublist ng-if=opcion.submenu.length><li ng-repeat=\"sub in opcion.submenu\"><md-button type=button class=\"md-button md-button md-ink-ripple md-button-href {{vm.active == sub.url ? \'active\' : \'\'}}\" data-url={{sub.url}} href=#/{{sub.url}} ng-click=vm.send(sub.url)><span class=md-icon-text>{{sub.label}}</span></md-button></li></ul></div><div class=\"md-button-toggle sidenav-sublist2\" ng-if=opcion.url><md-button type=button class=\"md-button md-button md-ink-ripple md-button-href {{vm.active == opcion.url ? \'active\' : \'\'}}\" data-url={{opcion.url}} href=#/{{opcion.url}} ng-click=vm.send(opcion.url)><i class=\"md-icon md-icon-option\">{{opcion.icon}}</i> <span class=md-icon-text>{{opcion.label}}</span> <i class=\"md-icon md-icon-arrow-down\" ng-if=opcion.submenu.length>keyboard_arrow_right</i></md-button></div></li></ul></md-sidenav><md-button ng-click=vm.toggleLeft() class=md-icon-button hide-gt-md><i class=md-icon>menu</i></md-button>");
$templateCache.put("app/components/helpMessage/helpMessage.html","<div class=messageContainer><md-icon class=iconMessage>help</md-icon>{{$ctrl.mensaje}}</div>");
$templateCache.put("app/modules/admin/configuracion/modules.admin.configuracion.html","<div class=container ng-cloak><help-message mensaje=\"Considere que la manipulación incorrecta de éstos datos puede alterar el funcionamiento normal de la aplicación.\"></help-message><crud-table url=configuracion.url title-table=configuracion.title fields=configuracion.fields formly=configuracion.formly permission=configuracion.permission fks=configuracion.fks node=true></crud-table></div>");
$templateCache.put("app/modules/admin/login/login.dialog.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=login-dialog><form id=data-form name=form ng-submit=\"answer(\'login\')\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>lock_outline</md-icon>Iniciar su sesión</h2><span flex></span></div></md-toolbar><md-dialog-content><div class=md-dialog-content><p class=\"bg-warning-user alert\">Su sesión ha expirado, debe iniciarla de nuevo.</p><md-content layout-gt-sm=column layout-padding style=\"overflow: initial\"><md-input-container><label>Correo electrónico</label><md-icon>person</md-icon><input ng-model=data.username required></md-input-container><md-input-container><label>Contraseña</label><md-icon>lock</md-icon><input ng-model=data.password type=password required></md-input-container><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid>Iniciar sesión</md-button></md-content></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/modules/admin/login/modules.admin.login.html","<md-toolbar class=logos layout=row><div class=logo><img src=assets/images/minsalud.png></div><div flex></div><div class=logo><img src=assets/images/agetic.png></div></md-toolbar><div class=logo-agetic><!-- <img src=\"assets/images/logo.png\"> --></div><div><div class=logo-qmara><img src=assets/images/qmara.png style=\"width: 100%\"></div></div><div class=\"buscador buscador-titulo\">Servicio Social de Salud Rural Obligatorio</div><div class=\"container container-no-login\" layout-gt-sm=row layout-sm=column layout-xs=column layout-align=\"center center\"><verificacion-estudiantes ng-if=!login.chg esconder-resultado=login.esconderResultado habilitacion=login.habilitacion login=login.esconderLogin></verificacion-estudiantes><md-card class=login-panel ng-if=\"(login.esconderResultado || !login.habilitacion) && !login.esconderLogin\"><md-toolbar class=md-table-toolbar ng-hide=login.chg><div class=\"md-toolbar-tools text-left\"><md-icon class=md-icon>lock_outline</md-icon><span>Iniciar sesión</span><div flex></div></div></md-toolbar><md-toolbar class=md-table-toolbar ng-show=\"login.chg || new\"><div class=\"md-toolbar-tools text-left\"><md-icon class=md-icon>lock_outline</md-icon><span>Escriba su contraseña</span><div flex></div></div></md-toolbar><md-card-content><!-- <div class=\"logo text-center\">\n        <img src=\"assets/images/ministerio.jpeg\">\n        <img src=\"assets/images/logo_institucion.jpg\">\n      </div> --><form name=form ng-submit=login.login() ng-hide=login.chg><md-input-container><label>Correo electrónico</label><md-icon class=md-icon>person</md-icon><input ng-model=login.username required></md-input-container><md-input-container><label>Contraseña</label><md-icon class=md-icon>lock</md-icon><input ng-model=login.password type=password required></md-input-container><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid>Iniciar sesión</md-button><div class=text-center style=\"margin-top: 10px\"><md-button-href class=restablecer ng-click=login.restore()>¿Olvidó su contraseña?</md-button-href></div></form><form name=formChange ng-submit=login.change() ng-show=login.chg><div style=\"margin-bottom: 15px\" ng-hide=new><label class=mensajeContrasena>A continuación introduzca su contraseña dos veces para verificar.</label></div><div flex></div><input type=hidden value={{login.username}} required> <input type=hidden value={{login.codigo}} required><md-input-container><label>Nueva contraseña</label><md-icon class=md-icon>lock</md-icon><input ng-model=login.password type=password required></md-input-container><md-input-container><label>Repetir contraseña</label><md-icon class=md-icon>lock</md-icon><input ng-model=login.repassword type=password required></md-input-container><md-button type=submit class=\"md-raised md-primary\" ng-disabled=formChange.$invalid>Restablecer Contraseña</md-button></form></md-card-content></md-card></div>");
$templateCache.put("app/modules/admin/menus/dialog.crudTable.menu.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=\"formly-dialog formly-column-{{column}}\"><form ng-submit=\"answer(\'save\')\" id=data-form name=form novalidate><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><formly-form model=data fields=fields options=options form=form></formly-form><md-input-container><label>Menú padre</label><md-select ng-model=data.fid_menu_padre><md-option ng-repeat=\"option in data.menus_padre\" value={{option.id_menu}} ng-if=\"option.fid_menu_padre == null\">{{option.nombre}}</md-option></md-select></md-input-container></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=cancel()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/admin/menus/modules.admin.menus.html","<div class=container ng-cloak><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>grid_on</md-icon><span>{{menus.title}}</span><div flex></div><!-- <md-button class=\"md-icon-button\" ng-click=\"vm.listarMenus()\" id=\"btn-refresh-crudtable\">\r\n						<md-tooltip>Actualizar</md-tooltip>\r\n						<md-icon>refresh</md-icon>\r\n				</md-button> --></div></md-toolbar><md-card-content><div class=\"btn-container text-right\" style=\"min-height: 30px\"><md-button class=\"md-raised md-primary\" ng-click=menus.abrirMenu($event) aria-label=Add style=\"bottom: 0; right: 0\" ng-if=menus.permission.create><md-icon>add</md-icon>Nuevo Menú</md-button></div><md-table-container><table md-table ng-model=selected md-progress=promise><thead md-head md-order=query.order><tr md-row><th md-column class=text-center>Acciones</th><th md-column class=text-center><span>Nombre</span></th><th md-column class=text-center><span>Ícono</span></th><th md-column class=text-center><span>Orden</span></th><th md-column class=text-center><span>Ruta</span></th><th md-column class=text-center><span>Ver</span></th><th md-column class=text-center><span>Crear</span></th><th md-column class=text-center><span>Modificar</span></th><th md-column class=text-center><span>Eliminar</span></th><!-- <th md-column class=\"text-center\"><span>Menú padre</span></th> --></tr></thead><tbody md-body ng-repeat=\"menu in menus.menus\"><tr md-row><td md-cell><md-button class=md-icon-button aria-label=Editar ng-click=\"menus.abrirMenu($event, menu.id_menu)\" ng-if=menus.permission.update><md-tooltip>Editar</md-tooltip><md-icon class=icon-edit>mode_edit</md-icon></md-button></td><td md-cell><span><b>{{menu.nombre}}</b></span></td><td md-cell><span><b>{{menu.icono}}</b></span></td><td md-cell><span><b>{{menu.orden}}</b></span></td><td md-cell><span><b>{{menu.ruta}}</b></span></td><td md-cell><md-icon ng-if=\"menu.method_get == true\" class=bg-success>check_circle</md-icon><md-icon ng-if=\"menu.method_get == false || menu.method_get == null\" class=bg-gray>check_circle</md-icon></td><td md-cell><md-icon ng-if=\"menu.method_post == true\" class=bg-success>check_circle</md-icon><md-icon ng-if=\"menu.method_post == false || menu.method_post == null\" class=bg-gray>check_circle</md-icon></td><td md-cell><md-icon ng-if=\"menu.method_put == true\" class=bg-success>check_circle</md-icon><md-icon ng-if=\"menu.method_put == false || menu.method_put == null\" class=bg-gray>check_circle</md-icon></td><td md-cell><md-icon ng-if=\"menu.method_delete == true\" class=bg-success>check_circle</md-icon><md-icon ng-if=\"menu.method_delete == false || menu.method_delete == null\" class=bg-gray>check_circle</md-icon></td><td md-cell><span>{{menu.fid_menu_padre}}</span></td></tr><tr md-row ng-repeat=\"submenu in menu.submenus\"><td md-cell><md-button class=md-icon-button aria-label=Editar ng-click=\"menus.abrirMenu($event, submenu.id_menu)\"><md-tooltip>Editar</md-tooltip><md-icon class=icon-edit>mode_edit</md-icon></md-button></td><td md-cell><span>{{submenu.nombre}}</span></td><td md-cell><span>{{submenu.icono}}</span></td><td md-cell><span>{{submenu.orden}}</span></td><td md-cell><span>{{submenu.ruta}}</span></td><td md-cell><md-icon ng-if=\"submenu.method_get == true\" class=bg-success>check_circle</md-icon><md-icon ng-if=\"submenu.method_get == false || submenu.method_get == null\" class=bg-gray>check_circle</md-icon></td><td md-cell><md-icon ng-if=\"submenu.method_post == true\" class=bg-success>check_circle</md-icon><md-icon ng-if=\"submenu.method_post == false || submenu.method_post == null\" class=bg-gray>check_circle</md-icon></td><td md-cell><md-icon ng-if=\"submenu.method_put == true\" class=bg-success>check_circle</md-icon><md-icon ng-if=\"submenu.method_put == false || submenu.method_put == null\" class=bg-gray>check_circle</md-icon></td><td md-cell><md-icon ng-if=\"submenu.method_delete == true\" class=bg-success>check_circle</md-icon><md-icon ng-if=\"submenu.method_delete == false || submenu.method_delete == null\" class=bg-gray>check_circle</md-icon></td><!-- <td md-cell><span>{{submenu.fid_menu_padre}}</span></td> --></tr></tbody></table></md-table-container></md-card-content></md-card></div>");
$templateCache.put("app/modules/admin/restore/modules.admin.restore.html","<md-toolbar style=\"display: none\"><div class=logo><img src=assets/images/logo.png></div></md-toolbar><div class=container layout-align=\"center center\"><div class=logo-agetic><img src=assets/images/logo.png></div><div layout=row layout-align=\"center center\"><md-card class=login-panel><md-toolbar class=md-table-toolbar><div class=\"md-toolbar-tools text-left\"><md-icon class=md-icon>lock_outline</md-icon><span>Restaurar contraseña</span><div flex></div></div></md-toolbar><md-card-content><!-- <div class=\"logo text-center\">\r\n  				<img src=\"assets/images/ministerio.jpeg\">\r\n  				<img src=\"assets/images/logo_institucion.jpg\">\r\n  			</div> --><form name=form ng-submit=restore.restore() ng-hide=restore.chg><md-input-container><label>Correo electrónico</label><md-icon class=md-icon>person</md-icon><input ng-model=restore.username required></md-input-container><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid>Enviar Código</md-button></form><form name=formChange ng-submit=restore.change() ng-show=restore.chg><div style=\"margin-bottom: 15px\"><label class=mensajeContrasena>A continuación introduzca el código que recibió en su correo electrónico.</label></div><md-input-container><label>Codigo</label><md-icon class=md-icon>code</md-icon><input ng-model=restore.codigo required></md-input-container><md-input-container><label>Nueva contraseña</label><md-icon class=md-icon>lock</md-icon><input ng-model=restore.pass type=password required></md-input-container><md-input-container><label>Repetir contraseña</label><md-icon class=md-icon>lock</md-icon><input ng-model=restore.repass type=password required></md-input-container><md-button type=submit class=\"md-raised md-primary\" ng-disabled=formChange.$invalid>Restablecer Contraseña</md-button></form></md-card-content></md-card></div></div>");
$templateCache.put("app/modules/admin/roles/edit.menus.html","<md-dialog aria-label=Agregar/Editar ng-cloak><md-toolbar><div class=md-toolbar-tools><md-icon>menu</md-icon><h2>Asignar menús</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-content class=md-padding><form name=formMenus ng-submit=guardarMenus()><div layout=row><md-card><md-card-content><div flex-xs><md-checkbox ng-model=seleccionados aria-label=\"Seleccionar todos\" ng-click=toggleAll()><span ng-if=isChecked()>Des-</span>Seleccionar todos</md-checkbox></div><table class=\"table table-hovered table-striped margin-0\"><thead><tr><th>Menú</th><th>Ver</th><th>Crear</th><th>Modificar</th><th>Eliminar</th></tr></thead><tbody ng-repeat=\"menu in menus\"><tr><td class=\"no-wrap text-center\" colspan=5>{{menu.nombre}}</td></tr><tr ng-repeat=\"submenu in menu.submenus\"><td class=no-wrap><md-checkbox ng-checked=\"submenu.get || submenu.post || submenu.put || submenu.delete\" aria-label=submenu.nombre style=\"margin-top: 20px\" ng-disabled=true>{{submenu.nombre}}</md-checkbox></td><td class=\"no-wrap text-center\"><md-checkbox ng-model=submenu.get aria-label=Ver style=\"margin-top: 20px\" ng-disabled=!submenu.method_get></md-checkbox></td><td class=\"no-wrap text-center\"><md-checkbox ng-model=submenu.post aria-label=Crear style=\"margin-top: 20px\" ng-disabled=!submenu.method_post></md-checkbox></td><td class=\"no-wrap text-center\"><md-checkbox ng-model=submenu.put aria-label=Modificar style=\"margin-top: 20px\" ng-disabled=!submenu.method_put></md-checkbox></td><td class=\"no-wrap text-center\"><md-checkbox ng-model=submenu.delete aria-label=Eliminar style=\"margin-top: 20px\" ng-disabled=!submenu.method_delete></md-checkbox></td></tr></tbody></table></md-card-content></md-card></div><div class=text-right><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=formMenus.$invalid><md-icon>check</md-icon>Guardar</md-button></div></form></md-content></md-dialog>");
$templateCache.put("app/modules/admin/roles/edit.rutas.html","<md-dialog aria-label=Agregar/Editar ng-cloak><md-toolbar><div class=md-toolbar-tools><md-icon>code</md-icon><h2>Asignar rutas</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-content class=md-padding><form name=formMenus ng-submit=guardarRutas()><div layout=row><md-card><md-card-content><div flex-xs><md-checkbox ng-model=seleccionados aria-label=\"Seleccionar todos\" ng-click=toggleAll()><span ng-if=isChecked()>Des-</span>Seleccionar todos</md-checkbox></div><table class=\"table table-hovered table-striped margin-0\"><thead><tr><th>Menú</th><th>Ver</th><th>Crear</th><th>Modificar</th><th>Eliminar</th></tr></thead><tbody><tr ng-repeat=\"ruta in rutas\"><td class=no-wrap><md-checkbox ng-checked=\"ruta.get || ruta.post || ruta.put || ruta.delete\" aria-label=ruta.ruta style=\"margin-top: 20px\" ng-disabled=true>{{ruta.ruta}}</md-checkbox></td><td class=\"no-wrap text-center\"><md-checkbox ng-model=ruta.get aria-label=Ver style=\"margin-top: 20px\" ng-disabled=!ruta.method_get></md-checkbox></td><td class=\"no-wrap text-center\"><md-checkbox ng-model=ruta.post aria-label=Crear style=\"margin-top: 20px\" ng-disabled=!ruta.method_post></md-checkbox></td><td class=\"no-wrap text-center\"><md-checkbox ng-model=ruta.put aria-label=Modificar style=\"margin-top: 20px\" ng-disabled=!ruta.method_put></md-checkbox></td><td class=\"no-wrap text-center\"><md-checkbox ng-model=ruta.delete aria-label=Eliminar style=\"margin-top: 20px\" ng-disabled=!ruta.method_delete></md-checkbox></td></tr></tbody></table></md-card-content></md-card></div><div class=text-right><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=formMenus.$invalid><md-icon>check</md-icon>Guardar</md-button></div></form></md-content></md-dialog>");
$templateCache.put("app/modules/admin/roles/modules.admin.roles.html","<div class=container ng-cloak><crud-table-alt url=roles.url title-table=roles.title fields=roles.fields formly=roles.formly permission=roles.permission buttons=roles.buttons fks=roles.fks node=true></crud-table-alt></div>");
$templateCache.put("app/modules/admin/rutas/modules.admin.rutas.html","<div class=container ng-cloak><crud-table-alt url=rutas.url title-table=rutas.title fields=rutas.fields formly=rutas.formly permission=rutas.permission fks=rutas.fks node=true></crud-table-alt></div>");
$templateCache.put("app/modules/admin/servicios/modules.admin.servicios.html","<div class=container ng-cloak><help-message mensaje=\"Considere que la manipulación incorrecta de éstos datos puede alterar el funcionamiento normal de la aplicación.\"></help-message><crud-table url=servicios.url title-table=servicios.title fields=servicios.fields formly=servicios.formly permission=servicios.permission fks=servicios.fks node=true></crud-table></div>");
$templateCache.put("app/modules/admin/usuarios/baja.dialog.html","<md-dialog aria-label=Agregar/Editar ng-cloak><md-toolbar><div class=md-toolbar-tools><md-icon ng-if=!datos.alta>do_not_disturb_alt</md-icon><h2 ng-if=!datos.alta>Dar de baja a usuario</h2><md-icon ng-if=datos.alta>check</md-icon><h2 ng-if=datos.alta>Dar de alta a usuario</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-content class=md-padding><form ng-submit=darDeBajaAlta() id=formUsuario name=formUsuario><div style=\"width: 450px\"><help-message ng-if=!datos.alta mensaje=\"Al dar de baja a un usuario, éste ya no podrá ingresar al Sistema.\"></help-message></div><div style=\"width: 450px\"><help-message ng-if=datos.alta mensaje=\"Al dar de alta a un usuario, éste ya podrá ingresar al Sistema nuevamente.\"></help-message></div><div layout=row><md-card><md-card-content><label><strong>{{usuario_actual.persona.nombres}} {{usuario_actual.persona.primer_apellido}} {{usuario_actual.persona.segundo_apellido}}</strong></label><md-divider></md-divider><div flex></div><md-input-container style=\"margin-top: 40px\"><label>Correo electrónico</label><input ng-model=usuario_actual.usuario required ng-disabled=true></md-input-container><md-input-container><label ng-if=datos.alta>Motivo del alta del usuario</label><label ng-if=!datos.alta>Motivo de la baja del usuario</label><textarea ng-model=datos.observaciones required></textarea></md-input-container></md-card-content></md-card></div><div class=text-right><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=formUsuario.$invalid><span ng-if=!datos.alta><md-icon>check</md-icon>Dar de baja</span> <span ng-if=datos.alta><md-icon>check</md-icon>Dar de alta</span></md-button></div></form></md-content></md-dialog>");
$templateCache.put("app/modules/admin/usuarios/create.dialog.html","<md-dialog aria-label=Agregar/Editar style=\"width: 900px\"><md-toolbar><div class=md-toolbar-tools><md-icon>perm_identity</md-icon><h2>Registro de usuario</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><div style=\"padding: 0px 16px\"><h4>Datos personales</h4><cedula-identidad persona=persona></cedula-identidad></div><form name=formUsuario ng-submit=\"formUsuario.$valid && guardarUsuario()\" novalidate><md-dialog-content class=contenedor-usuarios style=\"padding: 0px 20px\"><div layout-gt-xs=row layout-xs=column style=\"margin-top: 10px\"><!-- <md-input-container class=\"automatico\">\n          <label>Nombre(s)</label>\n          <input ng-model=\"persona.nombres\" required ng-readonly=\"true\" ng-disabled=\"true\" capitalize class=\"input-automatico\">\n        </md-input-container>\n        <md-input-container class=\"automatico\">\n          <label>Primer apellido</label>\n          <input ng-model=\"persona.primer_apellido\" ng-readonly=\"true\" ng-disabled=\"true\" capitalize class=\"input-automatico\">\n        </md-input-container>\n        <md-input-container class=\"automatico\">\n          <label>Segundo apellido</label>\n          <input ng-model=\"persona.segundo_apellido\" required ng-readonly=\"true\" ng-disabled=\"true\" capitalize class=\"input-automatico\">\n        </md-input-container> --><!-- <md-input-container class=\"automatico\">\n              <label>Apellido del esposo</label>\n              <input ng-model=\"persona.casada_apellido\" ng-readonly=\"true\" ng-disabled=\"true\" capitalize>\n            </md-input-container> --> <input ng-model=persona.id_persona type=hidden></div><h4>Datos de usuario</h4><div layout-gt-xs=row layout-xs=column><!-- <md-input-container>\n          <label>Nombre de usuario</label>\n          <input ng-model=\"usuario.usuario\" required>\n        </md-input-container> --><md-input-container><label>Correo electrónico</label><input ng-model=usuario.email type=email required></md-input-container><md-input-container><label>Roles</label><md-select ng-model=usuario.rolesVar class=select-usuario-roles ng-change=rolSel(usuario.rolesVar) required><md-option ng-value=rol.id_rol ng-repeat=\"rol in roles\">{{rol.nombre}}</md-option></md-select></md-input-container><md-input-container><label>Certificado digital</label><input ng-model=usuario.token></md-input-container><div><md-button class=md-icon-button aria-label=\"Asociar token\" ng-click=token()><md-tooltip>Asociar token</md-tooltip><md-icon class=icon-other>settings_input_hdmi</md-icon></md-button></div></div><div layout-gt-xs=row layout-xs=column><md-input-container ng-if=\"usuario.rolesVar != rolUniversidad\"><label>SEDES al que pertenece</label><md-select ng-model=usuario.fid_sedes><md-option ng-value=0>Ninguno</md-option><md-option ng-value=sedes1.id_sedes ng-repeat=\"sedes1 in sedes\">{{sedes1.descripcion}}</md-option></md-select></md-input-container><md-input-container ng-if=\"usuario.rolesVar == rolUniversidad\"><label>Sede universitaria</label><md-select ng-model=usuario.fid_sede><md-option ng-value=0>Ninguno</md-option><md-option ng-value=sedesUni.id_sede ng-repeat=\"sedesUni in sedes_universitarias\">{{sedesUni.universidad.nombre}} - {{sedesUni.nombre}}</md-option></md-select></md-input-container><md-input-container ng-if=\"usuario.rolesVar == rolSubUnidad\"><label>Unidad a la que pertenece</label><md-select ng-model=usuario.fid_tipo_carrera><md-option ng-value={{null}}><em>Ninguna</em></md-option><md-option ng-value=carrera.id_tipo_carrera ng-repeat=\"carrera in carreras\">{{carrera.nombre}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=!persona.id_persona><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/admin/usuarios/edit.dialog.html","<md-dialog aria-label=Agregar/Editar ng-cloak style=\"max-width: 740px\"><md-toolbar><div class=md-toolbar-tools><md-icon>perm_identity</md-icon><h2>Editar usuario</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-content class=md-padding><form ng-submit=\"form.$valid && actualizarUsuario()\" id=data-form name=form novalidate><div layout=row><md-card><md-card-content><label><strong>{{data.persona.nombres}} {{data.persona.primer_apellido}} {{data.persona.segundo_apellido}}</strong></label><md-divider></md-divider><md-input-container style=\"margin: 20px 0px\"><label>Correo electrónico</label><input ng-model=data.email ng-disabled=\"data.estado != \'PENDIENTE\'\" required></md-input-container><md-input-container style=\"margin-bottom: 20px\"><label>Roles</label><md-select ng-model=data.rolesVar class=select-usuario-roles ng-change=rolSel(data.rolesVar)><md-option ng-value=rol.id_rol ng-repeat=\"rol in roles\">{{rol.nombre}}</md-option></md-select></md-input-container><md-input-container style=\"margin: 20px 0px\" ng-if=\"data.rolesVar != rolUniversidad\"><label>SEDES al que pertenece</label><md-select ng-model=data.fid_sedes><md-option ng-value=0>Ninguna</md-option><md-option ng-value=sedes1.id_sedes ng-repeat=\"sedes1 in sedes\">{{sedes1.descripcion}}</md-option></md-select></md-input-container><md-input-container style=\"margin: 20px 0px\" ng-if=\"data.rolesVar == rolUniversidad\"><label>Sede universitaria</label><md-select ng-model=data.fid_sede><md-option ng-value=0>Ninguno</md-option><md-option ng-value=sedesUni.id_sede ng-repeat=\"sedesUni in sedes_universitarias\">{{sedesUni.universidad.nombre}} - {{sedesUni.nombre}}</md-option></md-select></md-input-container><md-input-container style=\"margin: 20px 0px 40px\" ng-if=\"data.rolesVar == rolSubUnidad\"><label>Unidad a la que pertenece</label><md-select ng-model=data.fid_tipo_carrera><md-option ng-value=0>Ninguna</md-option><md-option ng-value=carrera.id_tipo_carrera ng-repeat=\"carrera in carreras\">{{carrera.nombre}}</md-option></md-select></md-input-container><!-- <md-input-container>\n              <label>Certificado digital</label>\n              <input ng-model=\"data.token\">\n            </md-input-container> --><!-- <md-input-container>\n              <label>Nombre de usuario</label>\n              <input ng-model=\"data.usuario\" required ng-disabled=\"true\">\n            </md-input-container> --></md-card-content></md-card></div><div class=text-right><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=formUsuario.$invalid><md-icon>check</md-icon>Guardar</md-button></div></form></md-content></md-dialog>");
$templateCache.put("app/modules/admin/usuarios/modules.admin.usuarios.html","<div class=container ng-cloak><md-card><div ng-show=usuarios.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=usuarios.filter.form ng-submit=usuarios.buscarUsuarios()><input type=text class=crud-table-filter id=crud-table-input ng-model=usuarios.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=usuarios.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!usuarios.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{usuarios.title}}<div flex></div><div><md-button class=md-icon-button ng-click=usuarios.listarUsuarios() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=usuarios.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><div class=\"btn-container text-right\" style=\"min-height: 30px\"><md-button class=\"md-raised md-primary\" ng-click=usuarios.agregarUsuario($event) aria-label=Add style=\"bottom: 0; right: 0\" ng-if=usuarios.permission.create><md-icon>add</md-icon>Nuevo usuario</md-button></div><md-table-container><table md-table ng-model=selected md-progress=promise><thead md-head md-order=query.order><tr md-row><th md-column class=text-center>Acciones</th><th md-column class=text-center><span>Nombres</span></th><th md-column class=text-center><span>Primer apellido</span></th><th md-column class=text-center><span>Segundo apellido</span></th><th md-column class=text-center><span>Usuario</span></th><th md-column class=text-center><span>SEDES/Universidad</span></th><th md-column class=text-center><span>Roles</span></th><th md-column class=text-center><span>Estado</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"usuario in usuarios.usuarios.rows\"><td md-cell><md-button class=md-icon-button aria-label=Editar ng-click=\"usuarios.editarUsuario($event, usuario.id_usuario)\" ng-if=usuarios.permission.update><md-tooltip>Editar</md-tooltip><md-icon class=icon-edit>mode_edit</md-icon></md-button><!-- <md-button class=\"md-icon-button\" aria-label=\"Cambiar contraseña\" ng-click=\"usuarios.cambiar($event, usuario.id_usuario)\" ng-if=\"usuarios.permission.update\">\r\n									<md-tooltip>Cambiar contraseña</md-tooltip>\r\n									<md-icon class=\"icon-other\">keyboard</md-icon>\r\n									</md-icon>\r\n								</md-button> --><md-button class=md-icon-button aria-label=\"Dar de baja\" ng-click=\"usuarios.darDeBajaAlta($event, usuario.id_usuario, usuario, false)\" ng-if=\"usuario.estado == \'ACTIVO\' && usuarios.permission.update\"><md-tooltip>Dar de baja</md-tooltip><md-icon class=icon-other>do_not_disturb_alt</md-icon></md-button><md-button class=md-icon-button aria-label=\"Dar de alta\" ng-click=\"usuarios.darDeBajaAlta($event, usuario.id_usuario, usuario, true)\" ng-if=\"usuario.estado == \'BAJA\' && usuarios.permission.update\"><md-tooltip>Dar de alta</md-tooltip><md-icon class=icon-other>check</md-icon></md-button><md-button class=md-icon-button aria-label=\"Asociar token\" ng-click=\"usuarios.asociarToken($event, usuario.id_usuario)\" ng-if=\"usuario.estado == \'ACTIVO\' && usuarios.permission.update\"><md-tooltip>Asociar token</md-tooltip><md-icon class=icon-other>settings_input_hdmi</md-icon></md-button></td><td md-cell><span>{{usuario.persona.nombres}}</span></td><td md-cell><span>{{usuario.persona.primer_apellido}}</span></td><td md-cell><span>{{usuario.persona.segundo_apellido}}</span></td><td md-cell><p>{{usuario.email}}</p><p ng-if=usuario.token>({{usuario.token}})</p></td><td md-cell><span ng-if=usuario.sedes.descripcion>{{usuario.sedes.descripcion}}</span> <span ng-if=usuario.sede.nombre>{{usuario.sede.nombre}}</span></td><td md-cell><span>{{usuario.rolesCadena}}</span></td><td md-cell><span>{{usuario.estado}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=usuarios.query.limit md-boundary-links=usuarios.options.boundaryLinks md-total={{usuarios.usuarios.count}} md-limit-options=\"[10, 20, 50]\" md-page=usuarios.query.page md-on-paginate=usuarios.listarUsuarios md-page-select></md-table-pagination></md-card-content></md-card></div>");
$templateCache.put("app/modules/admin/usuarios/usuario.dialog.html","<md-dialog aria-label=Agregar/Editar ng-cloak><md-toolbar><div class=md-toolbar-tools><md-icon>perm_identity</md-icon><h2>Cambiar contraseña</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form name=formMedico ng-submit=guardarDatos()><md-dialog-content><div class=md-dialog-content><md-card-content layout=column><md-input-container><label>Contraseña actual</label><input ng-model=datos.contrasena id=contrasena name=contrasena type=password required></md-input-container><md-input-container><label>Contraseña nueva</label><input ng-model=datos.contrasena_nueva id=contrasena_nueva name=contrasena_nueva type=password required></md-input-container><md-input-container><label>Confirmar contraseña nueva</label><input ng-model=datos.confirmar_contrasena id=confirmar_contrasena name=confirmar_contrasena type=password pw-check=contrasena_nueva required></md-input-container><div class=msg-block ng-show=formMedico.$error><span class=msg-error ng-show=formMedico.confirmar_contrasena.$error.pwmatch>Las contraseñas no coinciden.</span></div></md-card-content></div></md-dialog-content><md-dialog-actions layout=row><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=formMedico.$invalid><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/parametros/parPeriodos/modules.parametros.parPeriodos.html","<div class=container ng-cloak><crud-table url=parPeriodos.url title-table=parPeriodos.title fields=parPeriodos.fields formly=parPeriodos.formly permission=parPeriodos.permission fks=parPeriodos.fks node=true></crud-table></div>");
$templateCache.put("app/modules/parametros/parSedes/modules.parametros.parSedes.html","<div class=container ng-cloak><crud-table url=parSedes.url title-table=parSedes.title fields=parSedes.fields formly=parSedes.formly permission=parSedes.permission fks=parSedes.fks node=true></crud-table></div>");
$templateCache.put("app/modules/parametros/periodosSedes/modules.parametros.periodosSedes.html","<div class=container ng-cloak><crud-table url=periodosSedes.url title-table=periodosSedes.title fields=periodosSedes.fields formly=periodosSedes.formly permission=periodosSedes.permission fks=periodosSedes.fks node=true></crud-table></div>");
$templateCache.put("app/modules/parametros/parArchivos/modules.parametros.parArchivos.html","<div class=container ng-cloak><crud-table url=parArchivos.url title-table=parArchivos.title fields=parArchivos.fields formly=parArchivos.formly permission=parArchivos.permission fks=parArchivos.fks node=true></crud-table></div>");
$templateCache.put("app/modules/rotaciones/asignacionesEstudiantes/modules.rotaciones.asignacionesEstudiantes.html","<vistas></vistas>");
$templateCache.put("app/modules/rotaciones/carreras/modules.rotaciones.carreras.html","<div class=container ng-cloak><div class=formulario-datos><div class=\"btn-container text-right\" style=\"min-height: 30px\"><md-button class=md-raised ng-click=carreras.volverSedesUniversidades($event) aria-label=Volver style=\"bottom: 0; right: 0\"><md-icon>arrow_back</md-icon>Volver a sedes universitarias</md-button></div><h2>Datos de la Sede Universitaria</h2><p ng-if=carreras.universidad.logo><label>Logo:</label><img style=\"width: 100px\" data-ng-src=data:image;base64,{{carreras.universidad.logo}}></p><p><label>Universidad:</label>{{carreras.universidad.nombre}}</p><p><label>Resolución:</label>{{carreras.sede.resolucion}}</p><p><label>Dirección:</label>{{carreras.sede.direccion}}</p><p><label>Teléfono:</label>{{carreras.sede.telefono}}</p><p><label>Fax:</label>{{carreras.sede.fax}}</p><p><label>Sitio web:</label>{{carreras.sede.sitio_web}}</p><p><label>Correo Electrónico:</label>{{carreras.sede.correo_electronico}}</p><p><label>Departamento:</label>{{carreras.sede.departamento.nombre}}</p></div><crud-table url=carreras.url urldata=carreras.urldata title-table=carreras.title fields=carreras.fields formly=carreras.formly permission=carreras.permission fks=carreras.fks node=true></crud-table></div>");
$templateCache.put("app/modules/rotaciones/correccionesPostulaciones/dialog.correccionesPostulaciones.html","<!-- <md-dialog aria-label=\"Agregar/Editar\" class=\"fullscreen-dialog\"> --><md-dialog aria-label=Editar><md-toolbar><div class=md-toolbar-tools><md-icon>perm_identity</md-icon><h2>Estado de la Postulación</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form name=formPersona ng-submit=\"formPersona.$valid && guardarHabilitacion()\" novalidate><md-dialog-content style=\"padding: 0px 20px\" class=contenedor-correciones><div style=\"width: 100%\"><p class=estado><label>Estado el trámite:</label>{{habilitacion.estado_habilitacion}}</p></div><div layout=column><md-input-container style=\"margin: 20px 0px\"><label>Justificación del cambio</label><md-select ng-model=habilitacion.asignacion_manual required><md-option ng-value=caso.nombre ng-repeat=\"caso in casosEspeciales\">{{caso.nombre}}</md-option></md-select></md-input-container><md-input-container style=\"margin: 20px 0px\" ng-if=\"habilitacion.asignacion_manual == \'OTROS\'\"><label>Descripción</label><textarea ng-model=habilitacion.asignacion_manual_descripcion capitalize md-select-on-focus required></textarea></md-input-container><md-input-container style=\"margin: 10px 0px 50px\"><label>Cambiar estado</label><md-select ng-model=habilitacion.estado_cambiar ng-required=true><md-option ng-value=0><i>No hay cambios disponibles.</i></md-option><md-option ng-value=est.key ng-repeat=\"est in habilitacion.estados_disponibles\">{{est.value}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Actualizar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/correccionesPostulaciones/modules.rotaciones.correccionesPostulaciones.html","<div class=\"container contenedor-correciones\" ng-cloak><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>edit</md-icon><span>Corrección de datos de postulantes</span><div flex></div><md-button type=reset class=md-icon-button ng-click=correccionesPostulaciones.refresh()><md-tooltip>Iniciar nueva búsqueda</md-tooltip><md-icon>clear_all</md-icon></md-button></div></md-toolbar><md-card-content><form name=form ng-submit=\"form.$valid && correccionesPostulaciones.buscar(event)\"><div layout=row class=form-horizontal style=\"margin-top: 20px\"><md-input-container style=\"max-width: 140px\"><label>Tipo</label><md-select ng-model=correccionesPostulaciones.tipo ng-required=true><md-option ng-repeat=\"option in correccionesPostulaciones.tipos\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container><md-input-container aria-label=\"Cédula de identidad\" style=\"max-width: 265px\" focus-me=focusInput><label>Documento de identidad</label><input ng-model=correccionesPostulaciones.documentoIdentidad ng-required=true capitalize></md-input-container><md-button type=submit class=\"md-raised md-primary little-button\"><md-icon>check</md-icon>Buscar</md-button><div flex></div></div></form></md-card-content><md-card-content><div class=formulario-datos ng-if=\"correccionesPostulaciones.habilitaciones && correccionesPostulaciones.habilitaciones.length > 0\"><h4><md-icon class=colorPrimario>person</md-icon>{{correccionesPostulaciones.habilitaciones[0].estudiante.persona.nombres}} {{correccionesPostulaciones.habilitaciones[0].estudiante.persona.primer_apellido}} {{correccionesPostulaciones.habilitaciones[0].estudiante.persona.segundo_apellido}} <span>({{correccionesPostulaciones.habilitaciones[0].estado_habilitacion}})</span><md-button class=\"md-icon-button md-icon-button-circle\" aria-label=\"Actualizar datos\" ng-click=\"correccionesPostulaciones.actualizarPersona($event, correccionesPostulaciones.habilitaciones[0].estudiante.fid_persona)\"><md-tooltip>Actualizar datos</md-tooltip><md-icon class=\"md-icon icon-edit\">refresh</md-icon></md-button></h4><div><div flex><p><label>Tipo de documento:</label>{{correccionesPostulaciones.habilitaciones[0].estudiante.persona.tipo_documento_identidad.sigla}}</p><p><label>Número de documento:</label>{{correccionesPostulaciones.habilitaciones[0].estudiante.persona.documento_identidad}}</p><p><label>Fecha de nacimiento:</label>{{correccionesPostulaciones.habilitaciones[0].estudiante.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p><p><label>Nombres:</label>{{correccionesPostulaciones.habilitaciones[0].estudiante.persona.nombres}}</p><p><label>Primer apellido:</label>{{correccionesPostulaciones.habilitaciones[0].estudiante.persona.primer_apellido}}</p><p><label>Segundo apellido:</label>{{correccionesPostulaciones.habilitaciones[0].estudiante.persona.segundo_apellido}}</p><p><label>Correo electrónico:</label>{{correccionesPostulaciones.habilitaciones[0].estudiante.correo_electronico}}</p><p><label>Teléfono de contacto:</label>{{correccionesPostulaciones.habilitaciones[0].estudiante.telefono}}</p><md-divider></md-divider><div ng-repeat=\"hab in correccionesPostulaciones.habilitaciones\"><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>insert_drive_file</md-icon><strong>Rotación:&nbsp;</strong>&nbsp;{{hab.periodo.numero}} - {{hab.periodo.gestion}}<div flex></div></div></md-toolbar><div layout=row><div flex><p>&nbsp;</p><p class=estado><label>Estado el trámite:</label>{{hab.estado_habilitacion}}<md-button class=\"md-icon-button md-icon-button-circle\" aria-label=Editar ng-click=\"correccionesPostulaciones.editarEstado($event, hab)\"><md-tooltip>Editar</md-tooltip><md-icon class=\"md-icon icon-edit\">mode_edit</md-icon></md-button></p><p><label>Universidad:</label>{{hab.estudiante.universidad.nombre}}</p><p><label>Carrera:</label>{{hab.estudiante.carrera.nombre}}</p><p><label>Nota inducción:</label><span ng-if=hab.nota>{{hab.nota}}</span> <span ng-if=!hab.nota><i>PENDIENTE</i></span></p><p><label>Centro de salud:</label><span ng-if=hab.establecimiento_salud>{{hab.establecimiento_salud.establecimiento}}</span> <span ng-if=!hab.establecimiento_salud><i>PENDIENTE</i></span></p><p><label>Inicio del servicio:</label>{{hab.fecha_inicio | date:\'dd/MM/yyyy\'}}</p><p><label>Fin del servicio:</label>{{hab.fecha_fin | date:\'dd/MM/yyyy\'}}</p></div></div><md-divider></md-divider></div></div></div></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/asignaciones/modules.rotaciones.asignaciones.html","<vistas></vistas>");
$templateCache.put("app/modules/rotaciones/estudiantes/create.dialog.html","<!--<md-dialog aria-label=\"Agregar/Editar\" class=\"fullscreen-dialog\">--><!--<md-dialog aria-label=\"Agregar/Editar\" style=\"width: 900px;\">--><md-dialog aria-label=Agregar/Editar style=\"max-width: 100%;max-height: 95%;width: 80%;height: auto;border-radius: 0\"><md-toolbar><div class=md-toolbar-tools><md-icon>perm_identity</md-icon><h2>Registro del estudiante</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><div class=confirmacion-flotante ng-if=mostrarConfirmacion layout=row layout-align=\"center start\"><div class=confirmacion-flotante-contenido><div><h2><md-icon aria-label=\"Close dialog\">remove_red_eye</md-icon>Verificar datos</h2><md-card-content layout=column><help-message mensaje=\"Considere que los siguientes datos serán emitidos en la Credencial de Asignación y la Resolución Administrativa del SSSRO.\"></help-message><h2><md-icon aria-label=\"Close dialog\">person</md-icon>Datos del estudiante</h2><div class=formulario-datos style=\"padding-top: 0px\"><p><label>Nombres:</label>{{estudiante.persona.nombres}}</p><p><label>Primer apellido:</label>{{estudiante.persona.primer_apellido}}</p><p><label>Segundo apellido:</label>{{estudiante.persona.segundo_apellido}}</p><p><label>Fecha de nacimiento:</label>{{estudiante.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p><p><label>Documento de identidad:</label>{{estudiante.persona.documento_identidad}}</p></div><md-dialog-actions layout=row><md-button class=md-raised ng-click=cerrarConfirmacion()><md-icon>mode_edit</md-icon>Editar</md-button><md-button ng-click=guardarEstudiante(true) class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></md-card-content></div></div></div><div style=\"padding: 0px 16px\"><documento-identidad persona=estudiante.persona></documento-identidad></div><form name=formEstudiante ng-submit=\"formEstudiante.$valid && guardarEstudiante()\" novalidate><md-dialog-content style=\"padding: 0px 20px\"><div style=\"width: 100%\"><input ng-model=estudiante.persona.id_persona type=hidden><h4>Datos Personales<md-divider style=\"border-color:#81C04D;border-width: 1px\"></md-divider></h4><div layout-gt-sm=row layout-sm=column layout-xs=column ng-if=estudiante.persona.extranjero><md-input-container><label>Nombre(s)</label><input ng-model=estudiante.persona.nombres ng-disabled=\"estudiante.persona.encontrado !== -1\" capitalize ng-readonly=\"estudiante.persona.encontrado !== -1\" ng-class=\"estudiante.persona.encontrado !== -1? \'input-automatico\' : \'\'\"></md-input-container><md-input-container><label>Primer apellido</label><input ng-model=estudiante.persona.primer_apellido ng-disabled=\"estudiante.persona.encontrado !== -1\" capitalize ng-readonly=\"estudiante.persona.encontrado !== -1\" ng-class=\"estudiante.persona.encontrado !== -1? \'input-automatico\' : \'\'\"></md-input-container><md-input-container><label>Segundo apellido</label><input ng-model=estudiante.persona.segundo_apellido ng-disabled=\"estudiante.persona.encontrado !== -1\" capitalize ng-readonly=\"estudiante.persona.encontrado !== -1\" ng-class=\"estudiante.persona.encontrado !== -1? \'input-automatico\' : \'\'\"></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-xs=column ng-if=estudiante.persona.extranjero><md-input-container><label>Apellido del esposo</label><input ng-model=estudiante.persona.casada_apellido ng-disabled=\"estudiante.persona.encontrado !== -1 && estudiante.persona.extranjero\" capitalize ng-readonly=\"estudiante.persona.encontrado !== -1 && estudiante.persona.extranjero\" ng-class=\"estudiante.persona.encontrado !== -1 && estudiante.persona.extranjero? \'input-automatico\' : \'\'\"></md-input-container><!-- <md-input-container>\n                    <md-select ng-model=\"estudiante.persona.nombre_completo_documento_identidad\" ng-required=\"true\">\n                      <label>Nombre Completo</label>\n                      <md-option ng-repeat=\"opcion in opcionesNombre\" value=\"{{opcion.nombre}}\">\n                        {{opcion.nombre}}\n                      </md-option>\n                    </md-select>\n                  </md-input-container> --></div><div layout-gt-sm=row layout-sm=column layout-xs=column><md-input-container><md-select ng-model=estudiante.persona.nombre_completo_documento_identidad ng-required=true><label>Nombre Completo</label><md-option ng-repeat=\"opcion in opcionesNombre\" value={{opcion.nombre}}>{{opcion.nombre}}</md-option></md-select></md-input-container><md-input-container md-is-error=false><md-radio-group name=sexo layout=row ng-model=estudiante.persona.sexo required ng-required=true><!-- <md-radio-group layout=\"row\" ng-model=\"estudiante.persona.sexo\" required ng-disabled=\"estudiante.persona.sexo && estudiante.persona.id_persona\"> --><md-radio-button value=M class=md-primary name=sexoEstudiante>Masculino</md-radio-button><md-radio-button value=F name=sexoEstudiante>Femenino</md-radio-button></md-radio-group><div class=md-errors-spacer></div><div ng-if=\"estudiante.persona.sexo===undefined\" style=\"color:rgb(221, 44, 0); font-size: 9pt\">Debe seleccionar el género del estudiante.</div><div ng-messages=formEstudiante.sexo.$error><div ng-message=required>Debe seleccionar el género del estudiante.</div></div></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-xs=column><md-input-container><label>Correo electrónico</label><input name=email ng-model=estudiante.estudiante.correo_electronico type=email required><div ng-messages=formEstudiante.email.$error><div ng-message=required>Debe ingresar el correo del estudiante.</div><div ng-message=email>El valor ingresado no es un correo electrónico válido.</div></div></md-input-container><md-input-container><label>Teléfono o Celular</label><input name=telefono ng-model=estudiante.estudiante.telefono only-digits od-cantidad=20 maxlength=20 type=text></md-input-container></div><h4>Datos del estudiante<md-divider style=\"border-color:#81C04D;border-width: 1px\"></md-divider></h4><div layout-gt-sm=row layout-sm=column layout-xs=column><busqueda-sede-universitaria ng-if=registrarUniversidad id-sede=estudiante.estudiante.fid_sede sede=sedeSel on-cambiar=cambiarSedeUniversitaria style=width:95%;padding-top:15px></busqueda-sede-universitaria><md-input-container style=\"margin: 20px 0px\" ng-if=!registrarUniversidad><label>Sede universitaria</label><md-select ng-model=estudiante.estudiante.fid_sede ng-disabled=congelarSede ng-change=cambiarSedeUniversitaria() required><md-option ng-value=sedeUni.id_sede ng-repeat=\"sedeUni in sedesUniversitarias\">{{sedeUni.nombre}}</md-option></md-select><div style=\"font-size: 12px\">{{sedesUniversitarias[0].universidad.nombre}}</div></md-input-container><md-input-container style=\"margin: 20px 0px\"><label>Carrera</label><md-select name=carrera ng-model=estudiante.estudiante.fid_carrera required><md-option ng-value=carrera.id_carrera ng-repeat=\"carrera in carreras\">{{carrera.nombre}}</md-option></md-select><div ng-messages=formEstudiante.carrera.$error><div ng-message=required>Debe seleccionar la carrera del estudiante.</div></div></md-input-container><md-input-container style=\"margin: 20px 0px; max-width: 100px\" ng-if=\"mostrarNota && tipoSedes\"><label>Nota</label><input name=nota ng-model=estudiante.estudiante.nota min=0 max=100 aria-label=Nota type=number min=51 max=100 maxlength=6 ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ required><div ng-messages=formEstudiante.nota.$error><div ng-message=required>Debe ingresar la nota del estudiante.</div><div ng-message=maxlength>Debe ingresar un máximo de carácteres.</div><div ng-message=pattern>Debe ingresar un promedio válido con un máximo de dos decimales separados por coma.</div></div></md-input-container><md-input-container style=\"margin: 20px 0px; max-width: 200px\" ng-if=\"mostrarDeposito && depositoSedes\"><label>Depósito</label><input name=deposito ng-model=estudiante.estudiante.deposito aria-label=Depósito type=text maxlength=20 required><div ng-messages=formEstudiante.deposito.$error><div ng-message=required>Debe ingresar el numero de depósito del estudiante.</div></div></md-input-container><div class=md-datepicker-container style=\"margin-top: -7px\" ng-if=registroFlotante><label class=datepicker-label>Fecha inicio *</label><md-datepicker ng-model=estudiante.estudiante.fecha_inicio md-min-date=fechaMaxima required name=fechaInicio md-placeholder=31/12/1990 style=\"margin-right: 0px\"></md-datepicker></div><md-input-container style=\"margin: 20px 0px\" ng-if=\"(mostrar && !rezagado) && ((id_sedes != 5) || mostrarCasoEspecial)\"><!-- && ((id_sedes != 5) || mostrarCasoEspecial)\n                      se agrego las condiciones para que el campo de registro de caso especial no se muestre para universidades\n                      referenciadas por el sedes Potosi quizas parametrizar este valor para que en los sedes se habiliten o no estos campos --><label>Caso Especial <i>(Si corresponde)</i></label><md-select ng-model=estudiante.estudiante.caso_especial class=input-automatico><md-option></md-option><md-option ng-value=caso.nombre ng-repeat=\"caso in casosEspeciales\">{{caso.nombre}}</md-option></md-select></md-input-container></div><h4 ng-if=rezagado>Datos de la Inscripción<md-divider style=\"border-color:#81C04D;border-width: 1px\"></md-divider></h4><div layout-gt-sm=row layout-sm=column layout-xs=column ng-if=rezagado><md-input-container style=\"margin: 20px 0px\"><label>Gestión</label><md-select ng-model=periodo.gestion ng-change=listarPeriodos()><md-option ng-value=gestion.gestion ng-repeat=\"gestion in gestiones\">{{gestion.gestion}}</md-option><span class=registroUSpan ng-if=registrarGestion><md-button class=registroULink ng-click=abrirRegistroGestion(event) href=\"\"><md-icon class=md-icon>add_circle</md-icon>Registrar gestión</md-button></span></md-select></md-input-container><md-input-container style=\"margin: 20px 0px\" ng-if=mostrar><label>Período</label><md-select ng-model=periodo.id_periodo><md-option ng-value=periodo.id_periodo ng-repeat=\"periodo in periodos\">{{periodo.numero}}</md-option></md-select></md-input-container><busqueda-establecimiento ng-if=mostrar establecimiento=estudiante.establecimiento url=urlEst style=width:95%;padding-top:15px></busqueda-establecimiento></div><div layout-gt-sm=row layout-sm=column layout-xs=column ng-if=rezagado><md-input-container><label>Observaciones</label><input name=observaciones ng-model=estudiante.observaciones type=text required><div ng-messages=formEstudiante.observaciones.$error><div ng-message=required>Debe ingresar observaciones.</div></div></md-input-container><md-input-container><label>Código de Deposito</label><input name=deposito ng-model=estudiante.codigo_deposito type=text required><div ng-messages=formEstudiante.deposito.$error><div ng-message=required>Debe ingresar el código de deposito.</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><span class=registroUSpan ng-if=rezagado><md-button class=registroULink ng-click=abrirRegistroEstablecimiento(event) href=\"\"><md-icon class=md-icon>add_circle</md-icon>Registrar establecimiento de salud</md-button></span><span class=registroUSpan ng-if=registrarGestion><md-button class=registroULink ng-click=abrirRegistroGestion(event) href=\"\"><md-icon class=md-icon>add_circle</md-icon>Registrar gestión</md-button></span><span class=registroUSpan ng-if=\"registrarUniversidad && otrosRegistros\"><md-button class=registroULink ng-click=abrirRegistroUniversidad(event) href=\"\"><md-icon class=md-icon>add_circle</md-icon>Registrar universidad extranjera</md-button></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=\"!estudiante.persona.id_persona && !estudiante.persona.extranjero\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/estudiantes/edit.dialog.html","<!-- <md-dialog aria-label=\"Agregar/Editar\" class=\"fullscreen-dialog\"> --><md-dialog aria-label=Agregar/Editar style=\"max-width: 550px\"><form name=formEstudiante ng-submit=\"formEstudiante.$valid && editarEstudiante()\" novalidate><md-toolbar><div class=md-toolbar-tools><md-icon>perm_identity</md-icon><h2>Registro del estudiante</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><div layout=row><md-card><md-card-header><md-card-header-text><span class=md-title>Datos del estudiante</span></md-card-header-text></md-card-header><div class=md-padding><div class=formulario-datos ng-if=!mostrarEdicionPersona flex><p><label>Nombres:</label>{{estudiante.persona.nombres}}</p><p><label>Primer apellido:</label>{{estudiante.persona.primer_apellido}}</p><p><label>Segundo apellido:</label>{{estudiante.persona.segundo_apellido}}</p><p><label>Fecha de nacimiento:</label>{{estudiante.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p></div><div ng-if=mostrarEdicionPersona flex><div layout=row><md-input-container class=middle aria-label=Documento style=\"margin-top: 30px\"><label>{{estudiante.persona.tipo_documento_identidad.sigla}} - Documento Nro.</label><input ng-model=estudiante.persona.documento_identidad placeholder=\"Ejemplo: JK7123131\" required capitalize ng-disabled=\"estudiante.persona.fid_tipo_documento === 100\"></md-input-container><div class=md-datepicker-container><label class=datepicker-label>Fecha de nacimiento *</label><md-datepicker ng-disabled=\"estudiante.persona.fid_tipo_documento === 100\" ng-model=estudiante.persona.fecha_nacimiento required md-placeholder=31/12/1990 style=\"margin-right: 0px\"></md-datepicker></div></div><md-input-container><label>Nombre(s)</label><input ng-model=estudiante.persona.nombres ng-disabled=\"estudiante.persona.fid_tipo_documento === 100\" ng-required=true capitalize ng-readonly=\"estudiante.persona.fid_tipo_documento === 100\"></md-input-container><div layout=row><md-input-container><label>Primer apellido</label><input ng-model=estudiante.persona.primer_apellido ng-disabled=\"estudiante.persona.fid_tipo_documento === 100\" capitalize ng-readonly=\"estudiante.persona.fid_tipo_documento === 100\"></md-input-container><md-input-container><label>Segundo apellido</label><input ng-model=estudiante.persona.segundo_apellido ng-disabled=\"estudiante.persona.fid_tipo_documento === 100\" capitalize ng-readonly=\"estudiante.persona.fid_tipo_documento === 100\"></md-input-container></div></div></div><md-card-content><md-input-container md-is-error=formEstudiante.sexoEstudiante.$invalid style=\"margin-bottom: 10px\"><md-radio-group layout=row ng-model=estudiante.persona.sexo required><md-radio-button value=M class=md-primary name=sexoEstudiante>Masculino</md-radio-button><md-radio-button value=F name=sexoEstudiante>Femenino</md-radio-button></md-radio-group><div class=md-errors-spacer></div></md-input-container><md-input-container><label>Correo electrónico</label><input ng-model=estudiante.correo_electronico type=email required></md-input-container><md-input-container><label>Teléfono o Celular</label><input ng-model=estudiante.telefono only-digits od-cantidad=20 type=text></md-input-container></md-card-content></md-card></div></md-dialog-content><md-dialog-actions layout=row><div class=text-right><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/estudiantes/modules.rotaciones.estudiantes.html","<div class=container ng-cloak><md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-show=estudiantes.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=estudiantes.filter.form ng-submit=estudiantes.buscarFiltro()><input type=text class=crud-table-filter id=crud-table-input ng-model=estudiantes.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=estudiantes.removeFilter()><md-icon>close</md-icon></md-button></div></md-toolbar><md-toolbar class=md-table-toolbar ng-show=!estudiantes.filter.show style=\"height: 30px; max-height: none; padding: 5px 0px\"><div class=md-toolbar-tools><md-icon>group</md-icon>{{estudiantes.title}}<div flex></div><div><md-button class=md-icon-button ng-click=estudiantes.listarEstudiantes() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon>refresh</md-icon></md-button><md-button class=md-icon-button ng-click=estudiantes.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon>search</md-icon></md-button></div></div></md-toolbar><md-card-content><div class=\"btn-container text-right\" style=\"min-height: 30px\"><md-button class=\"md-raised md-primary\" ng-click=estudiantes.agregarEstudiante($event) aria-label=Add style=\"bottom: 0; right: 0\" ng-if=estudiantes.permission.create><md-icon>add</md-icon>Nuevo estudiante</md-button></div><md-table-container><table md-table md-row-select multiple ng-model=estudiantes.selected md-progress=promise><thead md-head md-order=estudiantes.query.order md-on-reorder=estudiantes.listarEstudiantes><tr md-row><th md-column class=text-center>Acciones</th><th md-column class=text-center><span>Doc. Identidad</span></th><th md-column class=text-center><span>Nombres</span></th><th md-column class=text-center><span>Primer apellido</span></th><th md-column class=text-center><span>Segundo apellido</span></th><th md-column class=text-center><span>Apellido de casada</span></th><th md-column class=text-center><span>Universidad y carrera</span></th><th md-column class=text-center><span>Nota</span></th><!-- <th md-column class=\"text-center\"><span>Autorizado</span></th> --><th md-column class=text-center><span>Preferencia</span></th></tr></thead><tbody md-body><tr md-row md-select=estudiante.id_estudiante md-select-id=id_estudiante md-auto-select ng-repeat=\"estudiante in estudiantes.estudiantes.rows\"><td md-cell><md-button class=md-icon-button aria-label=Editar ng-click=\"estudiantes.editarEstudiante($event, estudiante.id_estudiante)\" ng-if=estudiantes.permission.update><md-tooltip>Editar</md-tooltip><md-icon class=\"md-icon icon-edit\">mode_edit</md-icon></md-button><md-button class=md-icon-button aria-label=Eliminar ng-click=\"estudiantes.eliminarEstudiante($event, estudiante.id_estudiante)\" ng-if=estudiantes.permission.update><md-tooltip>Eliminar</md-tooltip><md-icon class=\"md-icon icon-danger\">delete</md-icon></md-button></td><td md-cell><span><span class=negrita-500>{{estudiante.persona.tipo_documento_identidad.sigla}}</span><br>{{estudiante.persona.documento_identidad}}</span></td><td md-cell><span>{{estudiante.persona.nombres}}</span></td><td md-cell><span>{{estudiante.persona.primer_apellido}}</span></td><td md-cell><span>{{estudiante.persona.segundo_apellido}}</span></td><td md-cell><span>{{estudiante.persona.casada_apellido}}</span></td><td md-cell><span><span class=negrita-500>{{estudiante.carrera.nombre}}</span><br>{{estudiante.universidad.nombre}}</span></td><td md-cell><span>{{estudiante.nota}}</span></td><!-- <td class=\"text-center\" ng-if=\"estudiante.autorizado\" md-cell>\r\n								<span>\r\n									<md-icon class=\"bg-success\">check_circle</md-icon>\r\n								</span>\r\n							</td> --><!-- <td class=\"text-center\" ng-if=\"!estudiante.autorizado\" md-cell>\r\n								<span>\r\n									<md-icon class=\"bg-gray\">check_circle</md-icon>\r\n								</span>\r\n							</td> --><td md-cell class=contenedor-datos><span class=advertencia ng-if=estudiante.caso_especial><md-icon class=md-icon>star</md-icon>{{estudiante.caso_especial}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=estudiantes.query.limit md-total={{estudiantes.estudiantes.count}} md-limit-options=\"[10, 20, 50]\" md-page=estudiantes.query.page md-on-paginate=estudiantes.listarEstudiantes md-boundary-links=estudiantes.options.boundaryLinks md-page-select></md-table-pagination><md-card><form name=formEstudiante ng-submit=\"formEstudiante.$valid && estudiantes.autorizarEstudiantes(event)\" novalidate><help-message mensaje=\"Seleccione la gestión y el período para habilitar a los estudiantes seleccionados.\"></help-message><div class=formulario-datos><div layout=row><md-input-container style=\"margin: 20px 0px\"><label>Gestión</label><md-select ng-model=estudiantes.gestionFiltro ng-change=estudiantes.listarPeriodos(true) required><md-option ng-value=gestion.gestion ng-repeat=\"gestion in estudiantes.gestiones\">{{gestion.gestion}}</md-option></md-select></md-input-container><md-input-container style=\"margin: 20px 0px\"><label>Período</label><md-select ng-model=estudiantes.periodoFiltro required><md-option ng-value=periodo.id_periodo ng-repeat=\"periodo in estudiantes.periodos\">{{periodo.numero}}</md-option></md-select></md-input-container></div><div class=\"btn-container text-right\" style=\"min-height: 30px\"><md-button type=submit class=\"md-raised md-primary\" aria-label=Autorizar style=\"bottom: 0; right: 0\" ng-if=estudiantes.permission.update ng-disabled=\"estudiantes.selected.length == 0 || estudiantes.gestiones.length == 0 || estudiantes.periodos.length == 0\"><md-icon>check_box</md-icon>Enviar a SEDES</md-button></div></div></form></md-card></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/establecimientosSalud/modules.rotaciones.dialog.adicionar.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=\"formly-dialog formly-column-{{column}}\"><form ng-submit=\"form.$valid && guardarEstablecimiento()\" id=data-form name=form novalidate><md-toolbar><div class=md-toolbar-tools><h2>Registro establecimiento de salud</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div style=\"max-width: 400px\"><help-message mensaje=\"Con el fin de evitar registros de establecimientos duplicados, verifique que el establecimiento de salud no exista.\"></help-message></div><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><md-input-container style=\"width: 95%\"><label>Provincia</label><!--<md-select ng-model=\"item.cod_prov\" ng-change=\"cambiarProvincia(item.cod_prov)\" required>--><md-select ng-model=item.prov ng-change=cambiarProvincia(item.prov.cod_prov) required><md-option ng-value=provincia ng-repeat=\"provincia in listaProvincias\">{{provincia.nom_prov}}</md-option></md-select></md-input-container><md-input-container style=\"width: 95%\"><label>Municipio</label><md-select ng-model=item.mun required><md-option ng-value=municipio ng-repeat=\"municipio in listaMunicipios | filter: {cod_prov: varCodProvincia }\">{{municipio.nom_municipio}}</md-option></md-select></md-input-container><md-input-container style=\"width: 95%\"><label>Establecimiento de salud</label><input ng-model=item.nombre_establecimiento capitalize type=text required maxlength=30></md-input-container></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/establecimientosSalud/modules.rotaciones.establecimientosSalud.html","<div class=container ng-cloak><crud-table url=establecimientosSalud.url title-table=establecimientosSalud.title fields=establecimientosSalud.fields formly=establecimientosSalud.formly botones=establecimientosSalud.botones permission=establecimientosSalud.permission ocultar-create=establecimientosSalud.ocultarCreate fks=establecimientosSalud.fks node=true></crud-table></div>");
$templateCache.put("app/modules/rotaciones/gestiones/dialog.CupoEdit.crudTable.html","<md-dialog aria-label=Agregar/Editar ng-cloak><md-toolbar><div class=md-toolbar-tools><h2><md-icon>local_hospital</md-icon>Asignar cupo a establecimiento</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form id=formCupo name=formCupo ng-submit=\"formCupo.$valid && actualizar(cupo)\" novalidate><md-dialog-content><div class=md-dialog-content><md-card-content layout=column><div layout=row><md-input-container><label>Periodo</label><input ng-model=cupo.periodo.numero ng-disabled=true required></md-input-container></div><div layout=row><md-input-container><label>Establecimiento de salud</label><input ng-model=cupo.establecimiento_salud.establecimiento ng-disabled=true required></md-input-container></div><div layout=row><md-input-container><label>Tipo carrera</label><input ng-model=cupo.tipo_carrera.nombre ng-disabled=true required></md-input-container></div><div layout=row><md-input-container><label>Número de cupos</label><input ng-model=cupo.cupos min=0 only-digits required></md-input-container></div></md-card-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/gestiones/modules.rotaciones.dialog.correlativos.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=\"formly-dialog formly-column-{{column}}\"><form ng-submit=\"form.$valid && guardarCorrelativos()\" id=data-form name=form novalidate><md-toolbar><div class=md-toolbar-tools><h2>Correlativos</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><h4 style=\"margin: 0px\">Ingrese los correlativos para los siguientes documentos:</h4><span><br></span><md-input-container class=automatico style=\"width: 95%\"><label>Credencial</label><input ng-model=item.nro_credencial type=text only-digits od-minimo=1 od-cantidad=8 required></md-input-container><md-input-container class=automatico style=\"width: 95%\"><label>Informe técnico</label><input ng-model=item.nro_informe type=text only-digits od-minimo=1 od-cantidad=8 required></md-input-container><md-input-container class=automatico style=\"width: 95%\"><label>Resolución Adm.</label><input ng-model=item.nro_resolucion type=text only-digits od-minimo=1 od-cantidad=8 required></md-input-container></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/gestiones/modules.rotaciones.gestiones.html","<div class=\"container contenedor-datos\" ng-cloak><md-content class=md-padding><div class=formulario-datos><div layout=row><md-input-container><label>Gestión</label><md-select ng-model=gestiones.gestionFiltro ng-change=gestiones.listarPeriodos()><md-option ng-value=gestion.gestion ng-repeat=\"gestion in gestiones.gestiones\">{{gestion.gestion}}</md-option></md-select></md-input-container><md-button class=\"md-icon-button md-icon-button-circle\" ng-click=gestiones.agregarGestion($event) aria-label=Nuevo ng-if=gestiones.permission.create><md-tooltip>Nuevo</md-tooltip><md-icon class=md-icon>add</md-icon></md-button></div></div><md-card style=\"padding: 10px 10px 0\"><div layout-xs=column layout-sm=row layout-gt-sm=row style=\"margin-bottom: 20px\"><label flex><strong>Correlativo credencial: </strong>{{gestiones.correlativos.nro_credencial}}</label><label flex><strong>Correlativo informe: </strong>{{gestiones.correlativos.nro_informe}}</label><label flex><strong>Correlativo resolución: </strong>{{gestiones.correlativos.nro_resolucion}}</label><md-button class=\"md-icon-button md-icon-button-circle\" ng-click=gestiones.editarCorrelativos($event) aria-label=Editar ng-if=gestiones.permission.create><md-tooltip>Editar</md-tooltip><md-icon class=md-icon>create</md-icon></md-button></div></md-card><div layout-xs=column layout-sm=row layout-gt-sm=row style=\"margin-bottom: 20px\"><div ng-repeat=\"periodo in gestiones.periodos\" flex><md-card md-theme=default md-theme-watch style=\"height: 100%\"><md-card-title flex=none><md-card-title-text><span class=md-headline>Período {{periodo.numero}}</span> <span class=md-subhead>del {{periodo.fecha_inicio | date:\'dd/MM/yyyy\'}} al {{periodo.fecha_fin | date:\'dd/MM/yyyy\'}}<md-button class=\"md-icon-button md-icon-button-circle\" ng-click=\"gestiones.editarPeriodo($event, periodo.id_periodo)\" aria-label=Editar ng-if=gestiones.permission.create><md-tooltip>Editar</md-tooltip><md-icon class=\"md-icon md-icon-circle\">create</md-icon></md-button></span></md-card-title-text></md-card-title><md-card-content><span class=md-title>Datos curso<md-button class=\"md-icon-button md-icon-button-circle\" ng-click=\"gestiones.agregarPeriodoSedes($event, periodo.id_periodo, periodo)\" aria-label=Nuevo ng-if=\"!periodo.periodo_sedes[0].id_periodo_sedes && gestiones.permission.create\"><md-tooltip>Nuevo</md-tooltip><md-icon class=md-icon>add</md-icon></md-button><md-button class=\"md-icon-button md-icon-button-circle\" ng-click=\"gestiones.editarPeriodoSedes($event, periodo.periodo_sedes[0].id_periodo_sedes, periodo)\" aria-label=Editar ng-if=\"periodo.periodo_sedes[0].id_periodo_sedes && gestiones.permission.create\"><md-tooltip>Editar</md-tooltip><md-icon class=\"md-icon md-icon-circle\">create</md-icon></md-button></span><div class=contenido-datos ng-if=gestiones.ocultarExamen><p><label>{{gestiones.fechaLimite}}:</label>{{periodo.periodo_sedes[0].fecha_examen | date:\'dd/MM/yyyy\'}}</p><!-- <p>\n                <label>Nota mínima de aprobación:</label> {{periodo.periodo_sedes[0].nota_minima}}\n              </p> --></div><div class=contenido-datos ng-if=!gestiones.ocultarExamen><p><label>Lugar curso:</label>{{periodo.periodo_sedes[0].lugar_curso}}</p><p><label>Fecha curso:</label>{{periodo.periodo_sedes[0].fecha_curso | date:\'dd/MM/yyyy\'}}</p><p><label>Hora curso:</label>{{periodo.periodo_sedes[0].hora_curso}}</p><p><label>Lugar examen:</label>{{periodo.periodo_sedes[0].lugar_examen}}</p><p><label>Fecha examen:</label>{{periodo.periodo_sedes[0].fecha_examen | date:\'dd/MM/yyyy\'}}</p><p><label>Hora examen:</label>{{periodo.periodo_sedes[0].hora_examen}}</p><p><label>Nota mínima de aprobación:</label>{{periodo.periodo_sedes[0].nota_minima}}</p><p style=\"overflow: hidden\"><label>Observación:</label>{{periodo.periodo_sedes[0].observaciones}}</p></div></md-card-content></md-card></div></div><div flex></div><div layout-gt-xs=row layout-xs=column><md-card style=\"width: 100%\" id=cuposEstablecimientos><div ng-show=gestiones.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=gestiones.filter.form ng-submit=gestiones.buscarFiltro()><input type=text class=crud-table-filter id=crud-table-input ng-model=gestiones.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=gestiones.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!gestiones.filter.show><div class=md-toolbar-tools><md-icon class=md-icon style=\"margin-right: 10px\">grid_on</md-icon>{{gestiones.title}}<div flex></div><div><md-button class=md-icon-button ng-click=gestiones.listarCupos() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=gestiones.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><div><div layout-gt-xs=row layout-xs=column><md-input-container style=\"width: 28%\"><label>Período</label><md-select ng-model=gestiones.periodoFiltro ng-change=gestiones.cambiarPeriodo()><md-option ng-value=periodo ng-repeat=\"periodo in gestiones.periodos\">{{periodo.numero}}</md-option></md-select></md-input-container><md-input-container style=\"width: 28%\"><label>Cupos</label><md-select ng-model=gestiones.tipo_cupos ng-change=gestiones.listarCupos()><md-option ng-value=0>Todos</md-option><md-option ng-value=1>Con cupos</md-option><md-option ng-value=-1>Sin cupos</md-option></md-select></md-input-container><md-input-container style=\"width: 28%\"><label>Ámbito</label><md-select ng-model=gestiones.ambito ng-change=gestiones.listarCupos()><md-option ng-value=0>Todos</md-option><md-option ng-value=\"\'R\'\">Rural</md-option><md-option ng-value=\"\'U\'\">Urbano</md-option></md-select></md-input-container><md-button class=\"md-raised md-primary\" ng-click=gestiones.reporte() aira-label=Reporte><md-icon class=\"md-icon md-icon-circle\">description</md-icon>Reporte</md-button></div></div><md-table-container><table md-table md-progress=promise><thead class=tabla-header md-head md-order=gestiones.query.order md-on-reorder=gestiones.listarHabilitados><tr md-row><th md-column class=text-center><span>Código</span></th><th md-column class=text-center><span>Establecimiento</span></th><th md-column class=text-center><span>Municipio</span></th><th md-column class=text-center><span>Red</span></th><th md-column class=text-center><span>Ámbito</span></th><th md-column class=text-center ng-repeat=\"ct in gestiones.carreras\"><span>{{ct.nombre}}</span></th></tr></thead><tbody md-body><tr md-row md-auto-select ng-repeat=\"cupo in gestiones.cupos.rows\"><td md-cell><span>{{cupo.codigo}}</span></td><td md-cell><span>{{cupo.establecimiento}}</span></td><td md-cell><span>{{cupo.nom_municipio}}</span></td><td md-cell><span>{{cupo.red}}</span></td><td md-cell><span>{{cupo.ambito}}</span></td><td md-cell class=text-center ng-repeat=\"c in cupo.cupos\" ng-if=\"cupo.cupos && cupo.cupos.length > 0\" ng-controller=CuposController><md-input-container style=\"width: 100px; height: 25px; margin-top: 5px\"><input md-select-on-focus ng-model=c.cupos min=0 max=100 aria-label=Cupos type=text only-digits od-cantidad=3 required></md-input-container><span style=\"display: inline-block\" ng-if=\"c.cupos_asignados >= 0\" class=c-asignados><md-tooltip>Cupos asignados</md-tooltip><md-icon class=md-icon>person</md-icon>{{c.cupos_asignados}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=gestiones.query.limit md-total={{gestiones.cupos.count}} md-limit-options=\"[10, 20, 50]\" md-page=gestiones.query.page md-page-select md-on-paginate=gestiones.listarCupos md-boundary-links=gestiones.options.boundaryLinks></md-table-pagination></md-card-content></md-card></div></md-content></div>");
$templateCache.put("app/modules/rotaciones/gradosAcademicos/modules.rotaciones.gradosAcademicos.html","<div class=container ng-cloak><crud-table url=gradosAcademicos.url title-table=gradosAcademicos.title fields=gradosAcademicos.fields formly=gradosAcademicos.formly permission=gradosAcademicos.permission fks=gradosAcademicos.fks node=true></crud-table></div>");
$templateCache.put("app/modules/rotaciones/historialFirmados/modules.rotaciones.historialFirmados.html","<vistas></vistas>");
$templateCache.put("app/modules/rotaciones/legalizaciones/dialog.legalizacion.html","<md-dialog aria-label=Legalización ng-cloak><md-toolbar><div class=md-toolbar-tools><h2><md-icon>collections_bookmark</md-icon>Generar legalización</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form id=formLegalizacion name=formLegalizacion ng-submit=\"formLegalizacion.$valid && agregarLegalizacion()\" novalidate><md-dialog-content><div class=md-dialog-content><md-card-content layout=column><div class=formulario-datos style=\"padding: 0 0 20px 0\"><h2>Datos del estudiante</h2><p><label>Gestión:</label>{{habilitacion.periodo.gestion}}</p><p><label>Período:</label>{{habilitacion.periodo.numero}}</p><p><label>Postulante:</label>{{habilitacion.estudiante.persona.nombres}} {{habilitacion.estudiante.persona.primer_apellido}} {{habilitacion.estudiante.persona.segundo_apellido}}</p><p><label>Universidad:</label>{{habilitacion.estudiante.universidad.nombre}}</p><p><label>Carrera:</label>{{habilitacion.estudiante.carrera.nombre}}</p><p ng-if=habilitacion.establecimiento_salud><label>Establecimiento asignado:</label>{{habilitacion.establecimiento_salud.establecimiento}}</p></div><md-input-container style=\"width: 90%\"><label>Código de depósito</label><input ng-model=legalizacion.codigo_deposito only-digits od-cantidad=20 required></md-input-container><md-input-container style=\"width: 90%\"><label>Descripción</label><input ng-model=legalizacion.descripcion type=text></md-input-container></md-card-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/legalizaciones/modules.rotaciones.legalizaciones.html","<div class=container><md-card ng-if=!legalizaciones.idHabilitacion><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>search</md-icon><span>Buscar estudiante</span><div flex></div></div></md-toolbar><md-card-content><form name=form ng-submit=\"form.$valid && legalizaciones.buscar(event)\"><div layout=row class=form-horizontal style=\"margin-top: 20px\"><md-input-container style=\"max-width: 140px\"><label>Tipo</label><md-select ng-model=legalizaciones.tipo required><md-option ng-repeat=\"option in legalizaciones.tipos\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container><md-input-container aria-label=\"Cédula de identidad\" style=\"max-width: 265px\" focus-me=focusInput><label>Cédula de identidad</label><input ng-model=legalizaciones.documentoIdentidad required capitalize></md-input-container><md-button type=submit class=\"md-raised md-primary little-button\"><md-icon>check</md-icon>Generar legalización</md-button><div flex></div></div></form></md-card-content></md-card><div ng-show=legalizaciones.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=legalizaciones.filter.form ng-submit=legalizaciones.buscarFiltro()><input type=text class=crud-table-filter id=crud-table-input ng-model=legalizaciones.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=legalizaciones.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!legalizaciones.filter.show><div class=md-toolbar-tools><md-icon class=icon-edit style=\"margin-right: 10px\">collections_bookmark</md-icon>{{legalizaciones.title}}<div flex></div><div><md-button class=md-icon-button ng-click=legalizaciones.listarLealizaciones() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=legalizaciones.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><md-table-container><table md-table md-progress=promise><thead class=tabla-header md-head md-order=legalizaciones.query.order md-on-reorder=legalizaciones.listarLealizaciones><tr md-row><th md-column class=text-center><span>Resolución</span></th><th md-column class=text-center><span>Documento</span></th><th md-column class=text-center><span>Nombre completo</span></th><th md-column class=text-center><span>Universidad y carrera</span></th><th md-column class=text-center><span>Gestión y período</span></th><th md-column class=text-center><span>Fecha</span></th><th md-column class=text-center><span>Código de depósito</span></th></tr></thead><tbody md-body><tr md-row md-auto-select ng-repeat=\"legalizacion in legalizaciones.legalizaciones.rows\"><td class=text-center md-cell><md-button class=md-icon-button aria-label=\"Mostra resolución administrativa\" ng-click=\"legalizaciones.mostrarResolucion($event, legalizacion.habilitacion.id_habilitacion)\"><md-tooltip>Mostrar resolución administrativa</md-tooltip><md-icon class=\"md-icon icon-other\">insert_drive_file</md-icon></md-button></td><td md-cell><span><span class=negrita-500>{{legalizacion.habilitacion.estudiante.persona.tipo_documento_identidad.sigla}}</span><br>{{legalizacion.habilitacion.estudiante.persona.documento_identidad}}</span></td><td md-cell><span>{{legalizacion.habilitacion.estudiante.persona.primer_apellido}} {{legalizacion.habilitacion.estudiante.persona.segundo_apellido}}, {{legalizacion.habilitacion.estudiante.persona.nombres}}</span></td><td md-cell><span><span class=negrita-500>{{legalizacion.habilitacion.estudiante.carrera.nombre}}</span><br>{{legalizacion.habilitacion.estudiante.universidad.nombre}}</span></td><td md-cell><span>{{legalizacion.habilitacion.periodo.numero}} - {{legalizacion.habilitacion.periodo.gestion}}</span></td><td md-cell><span>{{legalizacion.fecha | date:\'dd/MM/yyyy\'}}</span></td><td md-cell><span>{{legalizacion.codigo_deposito}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=legalizaciones.query.limit md-boundary-links=legalizaciones.options.boundaryLinks md-total={{legalizaciones.estudiantes.count}} md-limit-options=\"[10, 20, 50]\" md-page=legalizaciones.query.page md-on-paginate=legalizaciones.listarLealizaciones md-page-select></md-table-pagination></md-card-content></div>");
$templateCache.put("app/modules/rotaciones/historialEstudiantes/modules.rotaciones.historialEstudiantes.html","<vistas vista=historialEstudiantes.vistaPrincipal></vistas>");
$templateCache.put("app/modules/rotaciones/periodosGestion/modules.rotaciones.dialog.periodosGestion.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=\"formly-dialog formly-column-{{column}}\"><form ng-submit=\"form.$valid && guardarPeriodos()\" id=data-form name=form novalidate><md-toolbar><div class=md-toolbar-tools><h2>Gestión</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><md-input-container class=automatico style=\"width: 95%\"><label>Gestión</label><input ng-model=item.gestion type=number min=2000 required></md-input-container><md-input-container style=\"width: 95%\"><label>SEDES</label><md-select ng-model=item.fid_sedes ng-change=cambiarSedes(item.fid_sedes) ng-disabled=bloquearSedes required><md-option ng-value=sedes1.id_sedes ng-repeat=\"sedes1 in sedes\">{{sedes1.descripcion}}</md-option></md-select></md-input-container><div ng-if=\"periodos && periodos.length == 0\">Seleccione un SEDES para continuar.</div><h4 style=\"margin: 0px\">Rotaciones a generarse:</h4><div ng-repeat=\"(key, periodo) in periodos\"><div><label>Periodo: {{periodo.numero_periodo}}</label></div><div style=\"margin-left: 50px\"><label>Del <span ng-if=\"periodo.dia_inicio < 10\">0</span>{{periodo.dia_inicio}}/<span ng-if=\"periodo.mes_inicio < 10\">0</span>{{periodo.mes_inicio}}/{{item.gestion}}</label><label>al <span ng-if=\"periodo.dia_fin < 10\">0</span>{{periodo.dia_fin}}/<span ng-if=\"periodo.mes_fin < 10\">0</span>{{periodo.mes_fin}}/<span ng-if=\"(periodos.length - 1) == key && gestionNueva != 0\">{{gestionNueva}}</span><span ng-if=\"(periodos.length - 1) != key || gestionNueva == 0\">{{item.gestion}}</span></label></div></div><h4 ng-if=!esconderCorrelativos style=\"margin: 0px\">Ingrese los correlativos para los siguientes documentos:</h4><div layout=row ng-if=!esconderCorrelativos><md-input-container class=automatico style=\"width: 130px\"><label>Credencial</label><input ng-model=correlativos.nro_credencial type=text only-digits od-minimo=1 od-cantidad=8 required></md-input-container><md-input-container class=automatico style=\"width: 130px\"><label>Informe técnico</label><input ng-model=correlativos.nro_informe type=text only-digits od-minimo=1 od-cantidad=8 required></md-input-container><md-input-container class=automatico style=\"width: 130px\"><label>Resolución Adm.</label><input ng-model=correlativos.nro_resolucion type=text only-digits od-minimo=1 od-cantidad=8 required></md-input-container></div></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/periodosGestion/modules.rotaciones.periodosGestion.html","<div class=container ng-cloak><md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-show=periodosGestion.filter.show><div class=md-toolbar-tools><form flex name=periodosGestion.filter.form><input type=text class=crud-table-filter id=input-search ng-model=periodosGestion.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=periodosGestion.getItems()><md-icon>search</md-icon></md-button><md-button class=md-icon-button ng-click=periodosGestion.removeFilter()><md-icon>close</md-icon></md-button></div></md-toolbar><md-toolbar class=md-table-toolbar ng-show=!periodosGestion.filter.show><div class=md-toolbar-tools><md-icon>grid_on</md-icon><span>{{periodosGestion.title}}</span><div flex></div><md-button class=md-icon-button ng-click=periodosGestion.showFilter() ng-if=periodosGestion.permissions.filter><md-tooltip>Filtrar registros</md-tooltip><md-icon>search</md-icon></md-button><md-button class=md-icon-button ng-click=periodosGestion.getItems() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon>refresh</md-icon></md-button><md-button class=\"md-icon-button btn-collapsed\"><md-tooltip>Ocultar/Ver</md-tooltip><md-icon>keyboard_arrow_down</md-icon></md-button></div></md-toolbar><md-card-content><div class=\"btn-container text-right\" style=\"min-height: 30px\" ng-if=\"(!periodosGestion.botones.length || (periodosGestion.botones.length && periodosGestion.botones.length == 0)) && periodosGestion.permissions.create\"><md-button class=\"md-raised md-primary\" ng-click=periodosGestion.add($event) aria-label=Add style=\"bottom: 0; right: 0\"><md-icon>add</md-icon>Agregar gestion</md-button></div><md-table-container><table md-table ng-model=selected md-progress=promise ng-if=periodosGestion.permissions.read><thead md-head md-order=periodosGestion.query.order md-on-reorder=periodosGestion.getItems><tr md-row><th md-column class=text-center1>Gestión</th><th md-column class=text-center1>Número período</th><th md-column class=text-center1>Fecha de inicio</th><th md-column class=text-center1>Fecha de fin</th><th md-column class=text-center1>SEDES</th></tr></thead><tbody md-body class=\"{{periodosGestion.editable ? \'formly-table-editable\' : \'\'}}\"><tr md-row md-select=item ng-repeat=\"item in periodosGestion.items.rows\"><td md-cell><span>{{item.gestion}}</span></td><td md-cell><span>{{item.numero}}</span></td><td md-cell><span>{{item.fecha_inicio}}</span></td><td md-cell><span>{{item.fecha_fin}}</span></td><td md-cell><span>{{item.sedes.descripcion}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=periodosGestion.query.limit md-limit-options=periodosGestion.limitOptions md-page=periodosGestion.query.page md-total={{periodosGestion.items.count}} md-boundary-links=periodosGestion.options.boundaryLinks md-page-select md-on-paginate=periodosGestion.getItems></md-table-pagination></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/postulantes/modules.rotaciones.postulantes.html","<vistas></vistas>");
$templateCache.put("app/modules/rotaciones/preasignaciones/modules.rotaciones.preasignaciones.html","<vistas></vistas>");
$templateCache.put("app/modules/rotaciones/resolucionesAdm/modules.rotaciones.resolucionesAdm.html","<vistas></vistas>");
$templateCache.put("app/modules/rotaciones/rotacionesEdicion/modules.rotaciones.rotacionesEdicion.html","<vistas></vistas>");
$templateCache.put("app/modules/rotaciones/sedes/modules.rotaciones.sedes.html","<div class=container ng-cloak><crud-table url=sedes.url title-table=sedes.title fields=sedes.fields formly=sedes.formly permission=sedes.permission buttons=sedes.buttons archivos=sedes.archivos esconder=sedes.esconder fks=sedes.fks node=true></crud-table></div>");
$templateCache.put("app/modules/rotaciones/sedesUniversitarias/modules.rotaciones.sedesUniversitarias.html","<md-card><div class=formulario-datos><div class=\"btn-container text-right\" style=\"min-height: 30px\"><md-button class=md-raised ng-click=sedesUniversitarias.volverUniversidades($event) aria-label=Volver style=\"bottom: 0; right: 0\"><md-icon>arrow_back</md-icon>Volver a universidades</md-button></div><h2>Datos de la Universidad</h2><p><label>Universidad:</label>{{sedesUniversitarias.universidad.nombre}}</p><p><label>Código:</label>{{sedesUniversitarias.universidad.codigo}}</p><p><label>Resolución:</label>{{sedesUniversitarias.universidad.resolucion}}</p><p ng-if=sedesUniversitarias.universidad.logo><label>Logo:</label><img style=\"width: 100px\" data-ng-src=data:image;base64,{{sedesUniversitarias.universidad.logo}}></p></div><div class=container ng-cloak><crud-table url=sedesUniversitarias.url urldata=sedesUniversitarias.urldata title-table=sedesUniversitarias.title fields=sedesUniversitarias.fields formly=sedesUniversitarias.formly permission=sedesUniversitarias.permission buttons=sedesUniversitarias.buttons fks=sedesUniversitarias.fks node=true></crud-table></div></md-card>");
$templateCache.put("app/modules/rotaciones/tiposCarrera/modules.rotaciones.tiposCarrera.html","<div class=container ng-cloak><crud-table url=tiposCarrera.url title-table=tiposCarrera.title fields=tiposCarrera.fields formly=tiposCarrera.formly permission=tiposCarrera.permission fks=tiposCarrera.fks node=true></crud-table></div>");
$templateCache.put("app/modules/rotaciones/tramitesPasados/modules.rotaciones.tramitesPasados.html","<div class=container ng-cloak><div ng-show=tramitesPasados.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=tramitesPasados.filter.form ng-submit=tramitesPasados.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=tramitesPasados.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=tramitesPasados.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!tramitesPasados.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{tramitesPasados.title}}<div flex></div><div><md-button class=md-icon-button ng-click=tramitesPasados.listarHabilitados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=tramitesPasados.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><div class=acciones-container><div layout-gt-xs=row layout-xs=column><div flex></div><p><md-button class=\"md-raised md-primary\" ng-click=\"tramitesPasados.agregarEstudiante($event, true)\" aria-label=Add ng-if=tramitesPasados.permission.create><md-icon>add</md-icon>Nuevo estudiante</md-button></p></div></div><div flex></div><md-table-container><table md-table md-progress=promise><thead class=tabla-header md-head md-order=tramitesPasados.query.order md-on-reorder=tramitesPasados.listarHabilitados><tr md-row><th md-column class=text-center>Acciones</th><th md-column class=text-center><span>Doc. Identidad</span></th><th md-column class=text-center><span>Nombres</span></th><th md-column class=text-center><span>Primer apellido</span></th><th md-column class=text-center><span>Segundo apellido</span></th><th md-column class=text-center><span>Apellido Casada</span></th><th md-column class=text-center><span>Universidad y carrera</span></th><th md-column class=text-center><span>Rotación</span></th><th md-column class=text-center><span>Establecimiento</span></th><th md-column class=text-center><span>Estado</span></th></tr></thead><tbody md-body><tr md-row md-auto-select ng-repeat=\"habilitado in tramitesPasados.estudiantes.rows\" ng-controller=NotasFilaController><td md-cell><div layout=row><md-button class=md-icon-button aria-label=Editar ng-click=\"tramitesPasados.editarAsignacion($event, habilitado)\" ng-if=\"tramitesPasados.permission.update && (habilitado.estado_habilitacion == \'PREASIGNADO\' || habilitado.estado_habilitacion == \'APROBADO\')\"><md-tooltip>Cambiar establecimiento de salud</md-tooltip><md-icon class=\"md-icon icon-edit\">local_hospital</md-icon></md-button><md-button class=md-icon-button aria-label=\"Mostrar credencial\" ng-click=\"tramitesPasados.generarCredencial($event, habilitado.id_habilitacion)\" ng-if=\"tramitesPasados.permission.update && habilitado.estado_habilitacion == \'ASIGNADO\'\"><md-tooltip>Mostrar credencial</md-tooltip><md-icon class=\"md-icon icon-other\">credit_card</md-icon></md-button><md-button class=md-icon-button aria-label=Editar ng-click=\"tramitesPasados.editarEstudiante($event, habilitado.fid_estudiante)\" ng-if=tramitesPasados.permission.update><md-tooltip>Editar</md-tooltip><md-icon class=\"md-icon icon-edit\">mode_edit</md-icon></md-button><md-button class=md-icon-button aria-label=\"Ver detalle\" ng-click=\"tramitesPasados.verDetalle(event, habilitado.id_habilitacion)\" ng-if=tramitesPasados.permission.update><md-tooltip>Ver detalle</md-tooltip><md-icon class=\"md-icon icon-other\">remove_red_eye</md-icon></md-button></div></td><td md-cell><span><span class=negrita-500>{{habilitado.estudiante.persona.tipo_documento_identidad.sigla}}</span><br>{{habilitado.estudiante.persona.documento_identidad}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.nombres}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.primer_apellido}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.segundo_apellido}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.casada_apellido}}</span></td><td md-cell><span><span class=negrita-500>{{habilitado.estudiante.carrera.nombre}}</span><br>{{habilitado.estudiante.universidad.nombre}}</span></td><td md-cell><span>{{habilitado.periodo.numero}} / {{habilitado.periodo.gestion}}</span></td><td md-cell><span ng-if=habilitado.establecimiento_salud>{{habilitado.establecimiento_salud.establecimiento}}</span> <span ng-if=!habilitado.establecimiento_salud><i>Sin asignar</i></span></td><td md-cell><span style=\"color:{{(habilitado.estado_habilitacion == \'REPROBADO\' || habilitado.estado_habilitacion == \'RECHAZADO\' || habilitado.estado_habilitacion == \'SUSPENDIDA\'  )? \'red\': ( habilitado.estado_habilitacion == \'OBSERVADO\')? \'#F09314\' : \'green\' }}\">{{habilitado.estado_habilitacion}}</span><br><span ng-if=\"habilitado.estado_habilitacion == \'RESOLUCION_FIRMADA_DIRECTOR\'\" class=estado_correo><span ng-if=\"habilitado.estado_correo == \'ENVIADO\'\"><md-icon class=\"md-icon bg-success\">check_circle</md-icon>Enviado </span><span ng-if=\"habilitado.estado_correo == \'ENVIANDO\'\"><md-icon class=md-icon>more_horiz</md-icon>Enviando </span><span ng-if=\"habilitado.estado_correo == \'NO_ENVIADO\'\"><md-icon class=md-icon>cancel</md-icon>Error al enviar</span></span></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=tramitesPasados.query.limit md-boundary-links=tramitesPasados.options.boundaryLinks md-total={{tramitesPasados.estudiantes.count}} md-limit-options=\"[10, 20, 50]\" md-page=tramitesPasados.query.page md-on-paginate=tramitesPasados.listarHabilitados md-page-select></md-table-pagination></md-card-content></div>");
$templateCache.put("app/modules/rotaciones/universidades/modules.rotaciones.universidades.html","<div class=container ng-cloak><crud-table url=universidades.url title-table=universidades.title fields=universidades.fields formly=universidades.formly permission=universidades.permission buttons=universidades.buttons botones=universidades.botones archivos=universidades.archivos fks=universidades.fks node=true></crud-table></div>");
$templateCache.put("app/modules/rotaciones/vistas/modules.rotaciones.vistas.html","<div class=\"container contenedor-vistas\" ng-cloak><div class=header><div layout-gt-xs=row layout-xs=column><div style=\"margin-top: 10px; font-size: 17px\" layout-xs=column layout-sm=row layout-gt-sm=row layout-align-xs=\"center center\" layout-align-sm=\"left center\" layout-align-gt-sm=\"left center\"><strong class=strong style=\"margin: 0px 13px 0 0\">Gestión:</strong><md-input-container style=\"width: 150px\"><md-select ng-model=$ctrl.gestionFiltro ng-change=$ctrl.listarPeriodos(true) aria-label=Gestión required><md-option ng-if=$ctrl.mostrarTodos() ng-value=0>Todos</md-option><md-option ng-if=$ctrl.mostrarGestionesAnteriores(gestion.gestion) ng-value=gestion.gestion ng-repeat=\"gestion in $ctrl.gestiones\">{{gestion.gestion}}</md-option></md-select></md-input-container></div><div flex></div><div layout-xs=column layout-sm=row layout-gt-sm=row layout-align-xs=\"center center\" layout-align-sm=right layout-align-gt-sm=right><ul class=contenedor-periodos layout-gt-xs=row layout-xs=column><li class={{$ctrl.obtenerClasePeriodo(periodo.id_periodo)}} aria-label=\"Ver detalle\" ng-click=$ctrl.cambiarPeriodo(periodo) ng-repeat=\"periodo in $ctrl.periodos\"><a>Rotación {{periodo.numero}}</a></li></ul></div></div><div class=text-center ng-if=\"$ctrl.submenu.length > 1\"><ul class=contenedor-opciones layout-gt-xs=row layout-xs=column><li class={{$ctrl.obtenerAccion(submenu)}} ng-click=$ctrl.cambiarAccion(submenu) ng-repeat=\"submenu in $ctrl.submenu\"><a><md-icon class=md-icon>{{submenu.icon}}</md-icon><p>{{submenu.label}}</p></a></li></ul></div></div><div><rotaciones-habilitados periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-habilitados\'\"></rotaciones-habilitados><rotaciones-en-curso periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-en-curso\'\"></rotaciones-en-curso><rotaciones-notas periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-notas\'\"></rotaciones-notas><rotaciones-lista-reprobados periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-lista-reprobados\'\"></rotaciones-lista-reprobados><rotaciones-asignaciones-establecimientos periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro periodo-objeto=$ctrl.periodoObjeto permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-asignaciones-establecimientos\'\"></rotaciones-asignaciones-establecimientos><rotaciones-lista-credenciales periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-lista-credenciales\'\"></rotaciones-lista-credenciales><rotaciones-firma-credenciales periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-firma-credenciales\'\"></rotaciones-firma-credenciales><rotaciones-credenciales-firmadas periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-credenciales-firmadas\'\"></rotaciones-credenciales-firmadas><rotaciones-firma-resoluciones periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-firma-resoluciones\'\"></rotaciones-firma-resoluciones><rotaciones-generacion-resoluciones periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-generacion-resoluciones\'\"></rotaciones-generacion-resoluciones><rotaciones-resoluciones-firmadas periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-resoluciones-firmadas\'\"></rotaciones-resoluciones-firmadas><rotaciones-lista-monitoreo periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-lista-monitoreo\'\"></rotaciones-lista-monitoreo><rotaciones-tramites-observados periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-tramites-observados\'\"></rotaciones-tramites-observados><rotaciones-estudiantes-enviados periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-estudiantes-enviados\'\"></rotaciones-estudiantes-enviados><rotaciones-requisitos-resoluciones periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-requisitos-resoluciones\'\"></rotaciones-requisitos-resoluciones><rotaciones-asignaciones-estudiantes periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-asignaciones-estudiantes\'\"></rotaciones-asignaciones-estudiantes><rotaciones-informes-firmados periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-informes-firmados\'\"></rotaciones-informes-firmados><rotaciones-aprobar-preasignacion periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-aprobar-preasignacion\'\"></rotaciones-aprobar-preasignacion><rotaciones-edicion periodo-filtro=$ctrl.periodoFiltro gestion-filtro=$ctrl.gestionFiltro permission=$ctrl.permissionSubmenu actualizardatos=$ctrl.actualizardatos ng-if=\"$ctrl.periodoFiltro >= 0 && $ctrl.menuSeleccionado == \'rotaciones-edicion\'\"></rotaciones-edicion></div></div>");
$templateCache.put("app/modules/rotaciones/components/aprobarPreasignacion/modules.rotaciones.components.aprobarPreasignacion.html","<div ng-cloak><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarHabilitados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><form name=formEstudiante ng-submit=\"formEstudiante.$valid && $ctrl.aprobar()\" novalidate><div class=acciones-container><div class=text-right><md-button type=submit class=\"md-raised md-primary\" aria-label=Aprobar style=\"bottom: 0; right: 0\" ng-if=$ctrl.permission.update><md-icon>done</md-icon>Aprobar</md-button></div></div></form><md-card-content><tabla-estudiantes permission=$ctrl.permission gestion-filtro=$ctrl.gestionFiltro periodo-filtro=$ctrl.periodoFiltro actualizardatos=$ctrl.actualizardatos query=$ctrl.query seleccionable=$ctrl.seleccionable estados=$ctrl.estados columnas=$ctrl.columnas buttons=$ctrl.buttons seleccionados=$ctrl.seleccionados etapa=$ctrl.etapa filter=$ctrl.filter listar-habilitados=$ctrl.listarHabilitados show-filter=$ctrl.showFilter remove-filter=$ctrl.removeFilter buscar-estudiante=$ctrl.buscarEstudiante></tabla-estudiantes></md-card-content></div>");
$templateCache.put("app/modules/rotaciones/components/asignacionesEstudiantes/dialog.asignacion.html","<md-dialog aria-label=Agregar/Editar ng-cloak><md-toolbar><div class=md-toolbar-tools><h2><md-icon>local_hospital</md-icon>Asignar establecimiento de salud</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form id=formHabilitacion name=formHabilitacion ng-submit=\"formHabilitacion.$valid && editarAsignacion(habilitacion)\" novalidate><md-dialog-content><div class=md-dialog-content><md-card-content layout=column><help-message mensaje=\"Asigne solamente a personas con preferencia demostrable.\"></help-message><help-message mensaje=\"Se listarán sólo los establecimientos de salud con cupos disponibles.\"></help-message><div class=formulario-datos style=\"padding-top: 0px\"><h2>Datos del estudiante</h2><p><label>Gestión:</label>{{habilitacion.periodo.gestion}}</p><p><label>Período:</label>{{habilitacion.periodo.numero}}</p><p><label>Universitario:</label>{{habilitacion.estudiante.persona.nombres}} {{habilitacion.estudiante.persona.primer_apellido}} {{habilitacion.estudiante.persona.segundo_apellido}}</p><p><label>Universidad:</label>{{habilitacion.estudiante.universidad.nombre}}</p><p><label>Carrera:</label>{{habilitacion.estudiante.carrera.nombre}}</p><p><label>Nota:</label>{{habilitacion.nota}}</p><p ng-if=habilitacion.establecimiento_salud><label>Establecimiento asignado:</label>{{habilitacion.establecimiento_salud.establecimiento}}</p><br><p ng-if=\"habilitacion.asignacion_manual == caso_especial_buena_nota\"><label>Justificación de la preferencia:</label>{{habilitacion.asignacion_manual}}</p><md-input-container style=\"margin: 20px 0px\" ng-if=\"habilitacion.asignacion_manual != caso_especial_buena_nota\"><label>Justificación de la preferencia</label><md-select ng-model=habilitacion.asignacion_manual required><md-option ng-value=caso.nombre ng-repeat=\"caso in casosEspeciales\">{{caso.nombre}}</md-option></md-select></md-input-container><md-input-container style=\"margin-top: 20px\" ng-if=\"habilitacion.asignacion_manual == \'OTROS\'\"><label>Descripción</label><textarea ng-model=habilitacion.asignacion_manual_descripcion capitalize md-select-on-focus required></textarea></md-input-container><p><strong>Asignar nuevo establecimiento de salud:</strong></p><busqueda-establecimiento establecimiento=establecimiento url=urlEst required></busqueda-establecimiento></div></md-card-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/components/asignacionesEstudiantes/dialog.confirmacion.html","<md-dialog aria-label=\"Confirmación de estudiante\" ng-cloak><md-toolbar><div class=md-toolbar-tools><h2><md-icon>camera</md-icon>Asignación aleatoria de establecimienos de salud</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-card-content><div class=messageContainer><p>Los estudiantes de la siguiente lista tienen nota de reprobación, por lo que no serán asignados. Por favor revise las calificaciones y edite si corresponde.</p><p>Después de realizar el sorteo no podrán modificarse. ¿Desea continuar?</p></div><md-table-container><table md-table md-progress=promise><thead class=tabla-header md-head md-order=query.order md-on-reorder=listarHabilitados><tr md-row><th md-column class=text-center><span>Documento.</span></th><th md-column class=text-center><span>Nombre completo</span></th><!-- <th md-column class=\"text-center\"><span>Universidad</span></th> --><th md-column class=text-center><span>Universidad/Carrera</span></th><th md-column class=text-center><span>Nota</span></th><th md-column class=text-center><span>Estado</span></th></tr></thead><tbody md-body><tr md-row md-auto-select ng-repeat=\"habilitado in estudiantes\" ng-controller=NotasFilaController><td md-cell><span>{{habilitado.estudiante.persona.tipo_documento_identidad.sigla}} - {{habilitado.estudiante.persona.documento_identidad}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.nombres}} {{habilitado.estudiante.persona.primer_apellido}} {{habilitado.estudiante.persona.segundo_apellido}}</span></td><!-- <td md-cell><span>{{habilitado.estudiante.universidad.nombre}}</span></td> --><td md-cell><span>{{habilitado.estudiante.universidad.nombre}}<br>{{habilitado.estudiante.carrera.nombre}}</span></td><td md-cell><span><md-input-container ng-if=!habilitado.establecimiento_salud style=\"width: 100px; height: 25px; margin-top: 5px\"><md-icon ng-if=\"habilitado.nota < nota_minima\" class=\"md-icon icon-danger\">cancel</md-icon><md-icon ng-if=\"habilitado.nota >= nota_minima\" class=\"md-icon icon-info\">check_circle</md-icon><input ng-model=habilitado.nota style=\"text-align: center\" min=0 max=100 aria-label=Nota type=text only-digits od-cantidad=3 od-maximo=100></md-input-container></span></td><td md-cell><span>{{habilitado.estado_habilitacion}}</span><br><span ng-if=\"habilitado.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\" class=estado_correo><span ng-if=\"habilitado.estado_correo == \'ENVIADO\'\"><md-icon class=\"md-icon bg-success\">check_circle</md-icon>Enviado </span><span ng-if=\"habilitado.estado_correo == \'ENVIANDO\'\"><md-icon class=md-icon>more_horiz</md-icon>Enviando </span><span ng-if=\"habilitado.estado_correo == \'NO_ENVIADO\'\"><md-icon class=md-icon>cancel</md-icon>Error al enviar </span></span><span ng-if=\"habilitado.estado_habilitacion == \'RESOLUCION_FIRMADA_DIRECTOR\'\" class=estado_correo><span ng-if=\"habilitado.estado_correo == \'ENVIADO\'\"><md-icon class=\"md-icon bg-success\">check_circle</md-icon>Enviado </span><span ng-if=\"habilitado.estado_correo == \'ENVIANDO\'\"><md-icon class=md-icon>more_horiz</md-icon>Enviando </span><span ng-if=\"habilitado.estado_correo == \'NO_ENVIADO\'\"><md-icon class=md-icon>cancel</md-icon>Error al enviar</span></span></td></tr></tbody></table></md-table-container></md-card-content></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button ng-click=asignarEstablecimientos($event) class=\"md-raised md-primary\"><md-icon>check</md-icon>Aceptar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/rotaciones/components/asignacionesEstudiantes/dialog.recordatorio.html","<md-dialog class=recordatorio-asignacion aria-label=Recordatorio ng-cloak><md-toolbar><div class=md-toolbar-tools><h2><md-icon>start</md-icon>Recordatorio</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-card-content><p><!-- <span class=\"span-icono\">\n          <md-icon aria-label=\"Close dialog\">start</md-icon>\n        </span> --> <span>Recuerda realizar la preasignación de los mejores promedios y de los casos especiales (mujer embarazada, mujer con niños dependientes, motivos de salud, persona con discapacidad), una vez aprobados por la Dirección de SEDES podrás proceder con la asignación aleatoria.</span></p><p style=\"padding: 0px 20px 0px\"><md-input-container><md-checkbox ng-model=marcado>Ya se realizó la preasignación de los casos especiales.</md-checkbox></md-input-container></p></md-card-content></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button ng-if=!marcado class=\"md-raised md-primary\" ng-click=mejoresPromedios($event) aria-label=Edit><md-icon>group</md-icon>Mejores promedios</md-button><md-button ng-disabled=!marcado ng-click=aceptar($event) class=\"md-raised md-primary\"><md-icon>check</md-icon>Asignar establecimientos</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/rotaciones/components/asignacionesEstudiantes/dialog.universidad.html","<md-dialog aria-label=\"Agregar universidad\" ng-cloak><form ng-submit=\"form.$valid && guardarUniversidad($event)\" id=data-form name=form novalidate><md-toolbar><div class=md-toolbar-tools><h2>Agregar universidad extranjera</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=close($event)><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding><md-input-container style=\"width: 90%\"><label>Nombre</label><input ng-model=universidad.nombre capitalize required></md-input-container><md-input-container style=\"width: 90%\"><label>Código</label><input ng-model=universidad.codigo capitalize required></md-input-container></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close($event)><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/components/asignacionesEstudiantes/modules.rotaciones.components.asignacionesEstudiantes.html","<div ng-cloak class=contenedor-datos><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarHabilitados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><div class=acciones-container><div layout-gt-xs=row layout-xs=column><p class=\"fechaLimite messageContainer\" ng-if=\"$ctrl.etapa == \'POSTULACIONES\' || $ctrl.registrar\"><strong>Fecha límite de inscripción: </strong>{{$ctrl.fecha_limite| date:\'dd/MM/yyyy\'}}</p><p class=text-right style=\"width: 100%; margin: 0px\"><md-button ng-click=$ctrl.enviarCredenciales($event) type=submit class=\"md-raised md-primary\" aria-label=\"Enviar credenciales al Director\" ng-if=\"$ctrl.permission.update && $ctrl.etapa == \'ASIGNADOS\' && $ctrl.permiso\"><md-icon>insert_drive_file</md-icon>Enviar credenciales al Director</md-button><md-button ng-click=$ctrl.asignarEstablecimientos($event) class=\"md-raised md-primary\" aria-label=\"Asignar establecimientos de salud\" ng-if=\"$ctrl.permission.update && $ctrl.etapa == \'ASIGNACIONES\' && $ctrl.permiso\"><md-icon>camera</md-icon>Asignar establecimientos de salud</md-button><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.agregarEstudiante($event, true)\" aria-label=Add ng-if=\"$ctrl.permission.create && ($ctrl.etapa == \'POSTULACIONES\' || $ctrl.registrar || $ctrl.registroFlotante)\"><md-icon>add</md-icon>Nuevo estudiante</md-button></p><div flex></div></div></div><div class=errorPeriodo ng-if=$ctrl.etapaError><md-icon class=md-icon>cancel</md-icon><span>{{$ctrl.etapaError}}<md-button ng-if=$ctrl.permiso ng-click=$ctrl.registrarPeriodosSedes()>(Registrar)</md-button></span></div><div flex></div><md-table-container><table md-table md-progress=promise><thead class=tabla-header md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.listarHabilitados><tr md-row><th md-column class=text-center>Acciones</th><th md-column class=text-center><span>Doc. Identidad</span></th><th md-column class=text-center><span>Nombres</span></th><th md-column class=text-center><span>Primer apellido</span></th><th md-column class=text-center><span>Segundo apellido</span></th><th md-column class=text-center><span>Apellido de Casada</span></th><th md-column class=text-center><span>Universidad y carrera</span></th><th md-column class=text-center><span>Nota</span></th><th md-column class=text-center ng-if=$ctrl.depositoSedes><span>Depósito</span></th><th md-column class=text-center><span>Establecimiento</span></th><th md-column class=text-center><span>Estado</span></th></tr></thead><tbody md-body><tr md-row md-auto-select ng-repeat=\"habilitado in $ctrl.estudiantes.rows\" ng-controller=NotasFilaController><td md-cell><div layout=row><md-button class=md-icon-button aria-label=Eliminar ng-click=\"$ctrl.eliminarRegistro($event, habilitado)\" ng-if=\"$ctrl.permission.update && (habilitado.estado_habilitacion == \'HABILITADO\' || habilitado.estado_habilitacion == \'APROBADO\') && $ctrl.permiso\"><md-tooltip>Eliminar registro</md-tooltip><md-icon class=\"md-icon icon-danger\">delete</md-icon></md-button><md-button class=md-icon-button aria-label=Editar ng-click=\"$ctrl.editarAsignacion($event, habilitado)\" ng-if=\"$ctrl.permission.update && (habilitado.estado_habilitacion == \'PREASIGNADO\' || habilitado.estado_habilitacion == \'APROBADO\') && $ctrl.permiso\"><md-tooltip>Cambiar establecimiento de salud</md-tooltip><md-icon class=\"md-icon icon-edit\">local_hospital</md-icon></md-button><md-button class=md-icon-button aria-label=\"Mostrar credencial\" ng-click=\"$ctrl.generarCredencial($event, habilitado.id_habilitacion)\" ng-if=\"$ctrl.permission.update && habilitado.estado_habilitacion == \'ASIGNADO\'\"><md-tooltip>Mostrar credencial</md-tooltip><md-icon class=\"md-icon icon-other\">credit_card</md-icon></md-button><md-button class=md-icon-button aria-label=Editar ng-click=\"$ctrl.editarEstudiante($event, habilitado.fid_estudiante)\" ng-if=$ctrl.permission.update><md-tooltip>Editar</md-tooltip><md-icon class=\"md-icon icon-edit\">mode_edit</md-icon></md-button><md-button class=md-icon-button aria-label=\"Ver detalle\" ng-click=\"$ctrl.verDetalle(event, habilitado.id_habilitacion)\" ng-if=\"$ctrl.permission.update && ($ctrl.etapa == \'EN_CURSO\' || $ctrl.verificarMostrarCredencial(habilitado))\"><md-tooltip>Ver detalle</md-tooltip><md-icon class=\"md-icon icon-other\">remove_red_eye</md-icon></md-button></div></td><td md-cell><span><span class=negrita-500>{{habilitado.estudiante.persona.tipo_documento_identidad.sigla}}</span><br>{{habilitado.estudiante.persona.documento_identidad}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.nombres}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.primer_apellido}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.segundo_apellido}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.casada_apellido}}</span></td><td md-cell><span><span class=negrita-500>{{habilitado.estudiante.carrera.nombre}}</span><br>{{habilitado.estudiante.universidad.nombre}} <span class=texto_sede>({{habilitado.estudiante.sede.nombre}})</span></span></td><td md-cell class=text-center><span><md-input-container ng-if=\"!habilitado.establecimiento_salud && habilitado.estado_habilitacion != \'RECHAZADO\'\" style=\"width: 100px; height: 25px; margin-top: 5px\"><div ng-if=\"$ctrl.etapa != \'ASIGNACIONES\'\"><input ng-model=habilitado.nota style=\"color:{{(habilitado.estado_habilitacion == \'REPROBADO\'|| habilitado.estado_habilitacion == \'SUSPENDIDA\' || habilitado.estado_habilitacion == \'RECHAZADO\'  )? \'red\': ( habilitado.estado_habilitacion == \'OBSERVADO\')? \'#F09314\' : \'green\' }}\" min=0 max=100 aria-label=Nota type=text only-digits od-cantidad=3 od-maximo=100 disabled title=\"Aún no puede asignar notas\" ng-if=\"$ctrl.etapa != \'ASIGNACIONES\'\"></div><div ng-if=\"$ctrl.etapa == \'ASIGNACIONES\'\"><input ng-model=habilitado.nota style=\"color:{{(habilitado.estado_habilitacion == \'REPROBADO\'|| habilitado.estado_habilitacion == \'SUSPENDIDA\' || habilitado.estado_habilitacion == \'RECHAZADO\' )? \'red\': ( habilitado.estado_habilitacion == \'OBSERVADO\')? \'#F09314\' : \'green\' }}\" min=0 max=100 aria-label=Nota type=text only-digits od-cantidad=3 od-maximo=100 ng-disabled=habilitado.estudiante.nota ng-if=\"$ctrl.etapa == \'ASIGNACIONES\'\"></div></md-input-container><span ng-if=\"habilitado.establecimiento_salud || habilitado.estado_habilitacion == \'RECHAZADO\'\" style=\"color:{{(habilitado.estado_habilitacion == \'REPROBADO\'|| habilitado.estado_habilitacion == \'SUSPENDIDA\' || habilitado.estado_habilitacion == \'RECHAZADO\' )? \'red\': ( habilitado.estado_habilitacion == \'OBSERVADO\')? \'#F09314\' : \'green\' }}\">{{habilitado.nota}}</span></span></td><td md-cell ng-if=$ctrl.depositoSedes>{{habilitado.estudiante.deposito}}</td><td md-cell><span ng-if=habilitado.establecimiento_salud>{{habilitado.establecimiento_salud.establecimiento}}</span> <span ng-if=!habilitado.establecimiento_salud><i>Sin asignar</i></span><br><span class=advertencia ng-if=habilitado.asignacion_manual><md-icon class=md-icon>star</md-icon>{{habilitado.asignacion_manual}}</span></td><td md-cell><span style=\"color:{{(habilitado.estado_habilitacion == \'REPROBADO\'|| habilitado.estado_habilitacion == \'SUSPENDIDA\' || habilitado.estado_habilitacion == \'RECHAZADO\' )? \'red\': ( habilitado.estado_habilitacion == \'OBSERVADO\')? \'#F09314\' : \'green\' }}\">{{habilitado.estado_habilitacion}}</span><br><span ng-if=\"habilitado.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\" class=estado_correo><span ng-if=\"habilitado.estado_correo == \'ENVIADO\'\"><md-icon class=\"md-icon bg-success\">check_circle</md-icon>Enviado </span><span ng-if=\"habilitado.estado_correo == \'ENVIANDO\'\"><md-icon class=md-icon>more_horiz</md-icon>Enviando </span><span ng-if=\"habilitado.estado_correo == \'NO_ENVIADO\'\"><md-icon class=md-icon>cancel</md-icon>Error al enviar </span></span><span ng-if=\"habilitado.estado_habilitacion == \'RESOLUCION_FIRMADA_DIRECTOR\'\" class=estado_correo><span ng-if=\"habilitado.estado_correo == \'ENVIADO\'\"><md-icon class=\"md-icon bg-success\">check_circle</md-icon>Enviado </span><span ng-if=\"habilitado.estado_correo == \'ENVIANDO\'\"><md-icon class=md-icon>more_horiz</md-icon>Enviando </span><span ng-if=\"habilitado.estado_correo == \'NO_ENVIADO\'\"><md-icon class=md-icon>cancel</md-icon>Error al enviar</span></span></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=$ctrl.query.limit md-boundary-links=$ctrl.options.boundaryLinks md-total={{$ctrl.estudiantes.count}} md-limit-options=\"[10, 20, 50]\" md-page=$ctrl.query.page md-on-paginate=$ctrl.listarHabilitados md-page-select></md-table-pagination></md-card-content></div>");
$templateCache.put("app/modules/rotaciones/components/asignacionesEstudiantes/monitoreo.dialog.html","<md-dialog aria-label=Monitoreo ng-cloak><md-toolbar><div class=md-toolbar-tools><h2><md-icon>person</md-icon>Monitoreo</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form id=formFalta name=formFalta ng-submit=\"formFalta.$valid && guardarFalta(falta)\" novalidate><md-dialog-content><div layout=row><span flex></span><md-button class=\"md-raised md-primary\" ng-click=registrarFalta($event) aria-label=\"Registrar falta\" ng-if=\"habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\"><md-icon>playlist_add</md-icon>Registrar falta</md-button><!-- <md-button class=\"md-raised md-primary\" ng-click=\"listarFaltas($event)\" aria-label=\"Lista de faltas\">\n          <md-icon>menu</md-icon> Mostrar faltas\n        </md-button> --><md-button class=\"md-raised md-primary\" ng-click=observarTramite($event) aria-label=\"Observar trámite\" ng-if=\"habilitacion.estado_habilitacion != \'SUSPENDIDA\' && habilitacion.estado_habilitacion != \'RESOLUCION_FIRMADA_DIRECTOR\'\"><md-icon>do_not_disturb_on</md-icon>Observar trámite</md-button><md-button class=\"md-icon-button icon-back\" ng-click=volverMonitoreo() aria-label=Atrás show-gt-md><md-tooltip>Atrás</md-tooltip><i class=md-icon>arrow_back</i></md-button></div><md-card-header><md-card-header-text><span class=md-title><md-icon class=colorPrimario>person</md-icon>{{habilitacion.estudiante.persona.nombres}} {{habilitacion.estudiante.persona.primer_apellido}} {{habilitacion.estudiante.persona.segundo_apellido}} <span ng-if=\"habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\">(EN CURSO) </span><span ng-if=\"habilitacion.estado_habilitacion != \'CREDENCIAL_FIRMADA\'\">({{habilitacion.estado_habilitacion}})</span></span></md-card-header-text></md-card-header><div layout-gt-xs=row layout-xs=column><md-card style=\"width: 100%\"><md-card-header><md-card-header-text class=text-center><span class=md-title>Datos del estudiante</span></md-card-header-text></md-card-header><md-card-content><div class=formulario-datos><div flex><p><label>Tipo de documento:</label>{{habilitacion.estudiante.persona.tipo_documento_identidad.sigla}}</p><p><label>Número de documento:</label>{{habilitacion.estudiante.persona.documento_identidad}}</p><p><label>Fecha de nacimiento:</label>{{habilitacion.estudiante.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p><p><label>Correo electrónico:</label>{{habilitacion.estudiante.correo_electronico}}</p><p><label>Teléfono de contacto:</label>{{habilitacion.estudiante.telefono}}</p><p><label>Universidad:</label>{{habilitacion.estudiante.universidad.nombre}}</p><p><label>Carrera:</label>{{habilitacion.estudiante.carrera.nombre}}</p><p><label>Nota inducción:</label>{{habilitacion.nota}}</p><p><label>Centro de salud:</label>{{habilitacion.establecimiento_salud.establecimiento}}</p><p><label>Inicio del servicio:</label>{{habilitacion.fecha_inicio | date:\'dd/MM/yyyy\'}}</p><p><label>Fin del servicio:</label>{{habilitacion.fecha_fin | date:\'dd/MM/yyyy\'}}</p><p ng-if=habilitacion.fecha_fin_bloqueo><label>Fecha de finalización de la suspensión:</label>{{habilitacion.fecha_fin_bloqueo | date:\'dd/MM/yyyy\'}}</p><md-divider></md-divider><h4 ng-if=\"faltas && faltas.length > 0\">FALTAS:</h4><ul class=faltas ng-if=\"faltas && faltas.length > 0\"><li ng-repeat=\"(index, falta) in faltas\"><span class=numero>{{index + 1}}</span> <span class=texto>{{falta.descripcion}} ({{falta.tipo_falta.nombre}})</span><md-button class=md-icon-button aria-label=Eliminar ng-click=\"eliminarFalta($even, falta.id_falta)\"><md-tooltip>Eliminar falta</md-tooltip><md-icon class=md-icon>cancel</md-icon></md-button></li></ul><div ng-if=barra.options class=\"text-center progreso\"><ui-knob value=barra.valor options=barra.options></ui-knob></div></div></div></md-card-content></md-card><div flex></div><md-card style=\"width: 100%\"><md-card-content><div layout-gt-xs=row layout-xs=column layout-wrap><div class=contenedorArchivos style=\"width: 100%\"><h3>Documentación generada</h3><div layout=row><div><!-- <h4 style=\"width: 100%;\">Credencial</h4> --> <span><md-icon class=bg-success>check_circle</md-icon></span><md-button ng-click=mostrarCredencial($event)>Credencial</md-button></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=mostrarCredencial($event)><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button></div></div><div layout=row><div><!-- <h4 style=\"width: 100%;\">Credencial</h4> --> <span ng-if=verificarMostrarInforme(habilitacion)><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=!verificarMostrarInforme(habilitacion)><md-icon class=bg-error>cancel</md-icon></span><md-button ng-click=mostrarInformeTecnicoGenerado($event)>Informe técnico legal</md-button></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=mostrarInformeTecnicoGenerado($event) ng-if=verificarMostrarInforme(habilitacion)><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button><p ng-if=!verificarMostrarInforme(habilitacion)>No generado</p></div></div><div layout=row><div><!-- <h4 style=\"width: 100%;\">Credencial</h4> --> <span ng-if=verificarMostrarResolucion(habilitacion)><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=!verificarMostrarResolucion(habilitacion)><md-icon class=bg-error>cancel</md-icon></span><md-button ng-click=mostrarResolucion($event)>Resolución administrativa</md-button></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=mostrarResolucion($event) ng-if=verificarMostrarResolucion(habilitacion)><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button><p ng-if=!verificarMostrarResolucion(habilitacion)>No generado</p></div></div></div><div class=contenedorArchivos style=\"width: 100%\"><h3>Requisitos presentados</h3><div class=archivo-detalle layout=row ng-repeat=\"archivo in archivos\"><div><span ng-if=\"archivo.archivo && archivo.archivo.length == 1\"><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=\"!archivo.archivo || (archivo.archivo && !archivo.archivo.length)\"><md-icon style=\"color: red\">cancel</md-icon></span><!-- <md-button ng-click=\"mostrarInformeTecnicoGenerado($event)\"> --> {{archivo.nombre}}<!-- </md-button> --></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=\"abrirRequisito($event, archivo)\" ng-if=\"archivo.archivo && archivo.archivo.length == 1\"><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button><span ng-if=\"!archivo.archivo || (archivo.archivo && !archivo.archivo.length)\"><strong>{{archivo.metadato_no_cumple}}</strong></span></div></div></div></div></md-card-content></md-card></div><md-toolbar><div class=md-toolbar-tools><md-icon>location_on</md-icon><h2>Localización</h2><span flex></span></div></md-toolbar><md-card-content><div ng-if=mapaEstablecimiento><md-card-header><md-card-header-text><span class=md-title><md-icon class=colorPrimario>local_hospital</md-icon>{{habilitacion.establecimiento_salud.establecimiento}}</span></md-card-header-text></md-card-header><leaflet lf-center=mapaEstablecimiento.ubicacion markers=mapaEstablecimiento.markers legend=mapaEstablecimiento.legend height=500px width=100%></leaflet></div><div ng-if=mapaVacio><span><md-icon class=colorPrimario>location_on</md-icon>{{mapaVacio}}</span></div></md-card-content></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cerrar</md-button><!-- <md-button type=\"submit\" class=\"md-raised md-primary\">\n        <md-icon>check</md-icon> Guardar\n      </md-button> --></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/components/credencialesFirmadas/modules.rotaciones.components.credencialesFirmadas.html","<div class=contenedor-datos ng-cloak><md-card><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarFirmados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><!--<tabla-estudiantes title=\"$ctrl.title\"--><tabla-estudiantes permission=$ctrl.permission gestion-filtro=$ctrl.gestionFiltro periodo-filtro=$ctrl.periodoFiltro query=$ctrl.query seleccionable=$ctrl.seleccionable estados=$ctrl.estados buttons=$ctrl.buttons seleccionados=$ctrl.seleccionados etapa=$ctrl.etapa rezagados=$ctrl.rezagados filter=$ctrl.filter listar-habilitados=$ctrl.listarHabilitados show-filter=$ctrl.showFilter remove-filter=$ctrl.removeFilter buscar-estudiante=$ctrl.buscarEstudiante></tabla-estudiantes></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/components/detalleTramite/editAppcasada.dialog.html","<!-- <md-dialog aria-label=\"Agregar/Editar\" class=\"fullscreen-dialog\"> --><md-dialog aria-label=Agregar/Editar style=\"min-width: 500px; width: 950px\"><form name=formEditar ng-submit=\"formEditar.$valid && guardarEditar()\" novalidate><md-toolbar><div class=md-toolbar-tools><md-icon>person</md-icon><h2></h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><md-card-header><md-card-header-text><span class=md-title>Datos del Estudiante</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-xs=row layout-xs=column><md-card style=\"width: 100%\"><div layout=row><md-card style=\"{{archivoPdf? \'width: 60%;\':\'width: 100%;\' }}\"><md-input-container><label>Nombres</label><input ng-model=personaSegip.nombres required disabled readonly></md-input-container><md-input-container><label>Primer Apellido</label><input ng-model=personaSegip.primer_apellido disabled readonly></md-input-container><md-input-container><label>Segundo Apellido</label><input ng-model=personaSegip.segundo_apellido disabled readonly></md-input-container><md-input-container><label>Apellido Casada</label><input ng-model=persona.apellido_casada maxlength=30 ng-change=cambiaOpciones() style=\"text-transform: uppercase\"></md-input-container><md-input-container><md-autocomplete md-no-cache=ctrl.noCache md-selected-item=persona.nombre_completo md-search-text=persona.nombre_completo_ingresado md-search-text-change=searchTextChange(persona.nombre_completo_ingresado) md-selected-item-change=ctrl.selectedItemChange(item) md-items=\"item in opcionesNombre\" md-item-text=item.nombre md-min-length=0 md-clear-button=true placeholder=\"Seleccione y/o edite el nombre\" required md-input-name=registroCi><md-item-template><span md-highlight-text=titular.nombre_ci md-highlight-flags=^i>{{item.nombre}}</span></md-item-template><md-not-found>Sin lista de sugerencias.</md-not-found></md-autocomplete></md-input-container><md-input-container><md-button ng-click=verReporte() class=\"md-raised md-primary\"><md-icon>search</md-icon>Vista Previa</md-button></md-input-container></md-card><md-card style=\"width: 100%\" ng-if=archivoPdf><iframe ng-src={{archivoPdf}} type=application/pdf style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe></md-card></div><md-dialog-actions layout=row><div class=text-right><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></div></md-dialog-actions></md-card></div></md-card-content></md-dialog-content></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/components/detalleTramite/modules.rotaciones.components.detalleTramite.html","<md-card-header><md-card-header-text><span class=md-title><md-icon class=colorPrimario>person</md-icon>{{$ctrl.habilitacion.estudiante.persona.nombres}} {{$ctrl.habilitacion.estudiante.persona.primer_apellido}} {{$ctrl.habilitacion.estudiante.persona.segundo_apellido}} <span ng-if=\"$ctrl.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\' && $ctrl.barra.valor < 100\">(EN CURSO <span ng-if=\"$ctrl.habilitacion.observacion && $ctrl.habilitacion.observacion.subsanable === false\">- CON OBSERVACIÓN NO SUBSANABLE </span>) </span><span ng-if=\"$ctrl.habilitacion.estado_habilitacion != \'CREDENCIAL_FIRMADA\' || $ctrl.barra.valor >= 100\">({{$ctrl.habilitacion.estado_habilitacion}} <span ng-if=\"$ctrl.habilitacion.observacion && $ctrl.habilitacion.observacion.subsanable === false\">- CON OBSERVACIÓN NO SUBSANABLE </span>) </span><span ng-if=$ctrl.habilitacion.rezagado>- TRÁMITE INICIADO MANUALMENTE</span></span><div style=\"text-align: right\" ng-if=\"$ctrl.habilitacion.estado_habilitacion == \'RESOLUCION_FIRMADA_DIRECTOR\' && $ctrl.currentUserRol == \'ASESOR LEGAL SEDES\'\"><md-button class=\"md-raised md-primary\" ng-click=$ctrl.editarInformacion($event)><md-icon class=bg-success>edit</md-icon>Modificar Resolución Administrativa</md-button></div></md-card-header-text></md-card-header><div layout-gt-xs=row layout-xs=column><md-card style=\"width: 100%\"><md-card-header><md-card-header-text class=text-center><span class=md-title>Datos del estudiante</span></md-card-header-text></md-card-header><md-card-content><div class=formulario-datos><div flex><p><label>Tipo de documento:</label>{{$ctrl.habilitacion.estudiante.persona.tipo_documento_identidad.sigla}}</p><p><label>Número de documento:</label>{{$ctrl.habilitacion.estudiante.persona.documento_identidad}}</p><p><label>Fecha de nacimiento:</label>{{$ctrl.habilitacion.estudiante.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p><p><label>Correo electrónico:</label>{{$ctrl.habilitacion.estudiante.correo_electronico}}</p><p><label>Teléfono de contacto:</label>{{$ctrl.habilitacion.estudiante.telefono}}</p><p><label>Universidad:</label>{{$ctrl.habilitacion.estudiante.universidad.nombre}}</p><p><label>Sede:</label>{{$ctrl.habilitacion.estudiante.sede.nombre}}</p><p><label>Carrera:</label>{{$ctrl.habilitacion.estudiante.carrera.nombre}}</p><p ng-if=!$ctrl.habilitacion.rezagado><label>Nota:</label><span style=\"color:{{($ctrl.habilitacion.estado_habilitacion == \'REPROBADO\' || $ctrl.habilitacion.estado_habilitacion == \'RECHAZADO\') ? \'red\': \'green\' }}\">{{$ctrl.habilitacion.nota}}</span></p><p><label>Centro de salud:</label>{{$ctrl.habilitacion.establecimiento_salud.establecimiento}}</p><p><label>Inicio del servicio:</label>{{$ctrl.habilitacion.fecha_inicio | date:\'dd/MM/yyyy\'}}</p><p><label>Fin del servicio:</label>{{$ctrl.habilitacion.fecha_fin | date:\'dd/MM/yyyy\'}}</p><md-divider ng-show=$ctrl.habilitacion.fecha_inicio_bloqueo></md-divider><p ng-show=$ctrl.habilitacion.fecha_inicio_bloqueo><label>Fecha de inicio de la suspensión:</label>{{$ctrl.habilitacion.fecha_inicio_bloqueo | date:\'dd/MM/yyyy\'}}</p><p ng-show=$ctrl.habilitacion.fecha_fin_bloqueo><label>Fecha de finalización de la suspensión:</label>{{$ctrl.habilitacion.fecha_fin_bloqueo | date:\'dd/MM/yyyy\'}}</p><md-divider></md-divider><h4 ng-if=\"$ctrl.faltas && $ctrl.faltas.length > 0\">FALTAS:</h4><ul class=faltas ng-if=\"$ctrl.faltas && $ctrl.faltas.length > 0\"><li ng-repeat=\"(index, falta) in $ctrl.faltas\"><span class=numero>{{index + 1}}</span> <span class=texto>{{falta.descripcion}} ({{falta.tipo_falta.nombre}})</span><md-button class=md-icon-button aria-label=Eliminar ng-click=\"$ctrl.eliminarFalta($even, falta.id_falta)\" ng-if=\"$ctrl.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\' && $ctrl.eliminarFalta\"><md-tooltip>Eliminar falta</md-tooltip><md-icon class=md-icon>cancel</md-icon></md-button></li></ul><div ng-if=$ctrl.habilitacion.observacion><md-divider></md-divider><p></p><p><label>Estado de la rotación:</label>Trámite Observado<md-icon style=\"color: red\">report_problem</md-icon></p><p><label>Detalle de la observación:</label>{{$ctrl.habilitacion.observacion.detalle}}</p></div><div ng-if=$ctrl.barra.options class=\"text-center progreso\"><ui-knob value=$ctrl.barra.valor options=$ctrl.barra.options></ui-knob></div></div></div></md-card-content></md-card><div flex></div><md-card style=\"width: 100%\"><md-card-content><div layout-gt-xs=row layout-xs=column layout-wrap><div class=contenedorArchivos style=\"width: 95%\"><h3>Documentación generada</h3><div layout=row><div><span ng-if=$ctrl.verificarMostrarCredencial($ctrl.habilitacion)><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=!$ctrl.verificarMostrarCredencial($ctrl.habilitacion)><md-icon class=bg-error>cancel</md-icon></span><span>Credencial</span><p class=verificarFirma ng-if=\"!$ctrl.habilitacion.rezagado && $ctrl.credencialFirmada($ctrl.habilitacion)\"><span><md-icon class=conFirma>check_circle</md-icon></span><span>({{$ctrl.textoConFirma}})</span></p><p class=verificarFirma ng-if=\"!$ctrl.habilitacion.rezagado && !$ctrl.credencialFirmada($ctrl.habilitacion)\"><span><md-icon class=sinFirma>cancel</md-icon></span><span>({{$ctrl.textoSinFirma}})</span></p><p class=verificarFirma ng-if=\"$ctrl.habilitacion.rezagado && $ctrl.credencialFirmada($ctrl.habilitacion)\"><span><md-icon class=sinFirma>assignment</md-icon></span><span>({{$ctrl.textoRezagado}})</span></p></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=$ctrl.mostrarCredencial($event) ng-if=\"!$ctrl.habilitacion.rezagado && $ctrl.verificarMostrarCredencial($ctrl.habilitacion)\"><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button><span ng-if=\"$ctrl.habilitacion.rezagado || !$ctrl.verificarMostrarCredencial($ctrl.habilitacion)\">No generado</span></div></div><div class=docgen layout=row><div><span ng-if=$ctrl.verificarMostrarInforme($ctrl.habilitacion)><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=!$ctrl.verificarMostrarInforme($ctrl.habilitacion)><md-icon class=bg-error>cancel</md-icon></span><span>Informe técnico legal</span><p class=verificarFirma ng-if=\"$ctrl.verificarMostrarInforme($ctrl.habilitacion) && $ctrl.informeFirmado($ctrl.habilitacion)\"><span><md-icon class=conFirma>check_circle</md-icon></span><span>({{$ctrl.textoConFirma}})</span></p><p class=verificarFirma ng-if=\"$ctrl.verificarMostrarInforme($ctrl.habilitacion) && !$ctrl.informeFirmado($ctrl.habilitacion)\"><span><md-icon class=sinFirma>cancel</md-icon></span><span>({{$ctrl.textoSinFirma}})</span></p></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=$ctrl.mostrarInformeTecnicoGenerado($event) ng-if=$ctrl.verificarMostrarInforme($ctrl.habilitacion)><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button><span ng-if=!$ctrl.verificarMostrarInforme($ctrl.habilitacion)>No generado</span></div></div><div class=docgen layout=row><div><!-- <h4 style=\"width: 100%;\">Credencial</h4> --> <span ng-if=$ctrl.verificarMostrarResolucion($ctrl.habilitacion)><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=!$ctrl.verificarMostrarResolucion($ctrl.habilitacion)><md-icon class=bg-error>cancel</md-icon></span><span>Resolución administrativa</span><p class=verificarFirma ng-if=\"$ctrl.verificarMostrarResolucion($ctrl.habilitacion) && $ctrl.resolucionFirmada($ctrl.habilitacion)\"><span><md-icon class=conFirma>check_circle</md-icon></span><span>({{$ctrl.textoConFirma}})</span></p><p class=verificarFirma ng-if=\"$ctrl.verificarMostrarResolucion($ctrl.habilitacion) && !$ctrl.resolucionFirmada($ctrl.habilitacion)\"><span><md-icon class=sinFirma>cancel</md-icon></span><span>({{$ctrl.textoSinFirma}})</span></p></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=\"$ctrl.mostrarResolucion($event, \'RESOLUCION_NORMAL\')\" ng-if=$ctrl.verificarMostrarResolucion($ctrl.habilitacion)><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button><span ng-if=!$ctrl.verificarMostrarResolucion($ctrl.habilitacion)>No generado</span></div></div><div class=docgen layout=row><div><!-- <h4 style=\"width: 100%;\">Credencial</h4> --> <span ng-if=$ctrl.verificarMostrarResolucionApellidoCasada($ctrl.habilitacion)><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=!$ctrl.verificarMostrarResolucionApellidoCasada($ctrl.habilitacion)><md-icon class=bg-error>cancel</md-icon></span><span>Resolución administrativa Apellido de Casada</span><p class=verificarFirma ng-if=\"$ctrl.verificarMostrarResolucionApellidoCasada($ctrl.habilitacion) && $ctrl.resolucionFirmadaApellidoCasada($ctrl.habilitacion)\"><span><md-icon class=conFirma>check_circle</md-icon></span><span>({{$ctrl.textoConFirma}})</span></p><p class=verificarFirma ng-if=\"$ctrl.verificarMostrarResolucionApellidoCasada($ctrl.habilitacion) && !$ctrl.resolucionFirmadaApellidoCasada($ctrl.habilitacion)\"><span><md-icon class=sinFirma>cancel</md-icon></span><span>({{$ctrl.textoSinFirma}})</span></p></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=\"$ctrl.mostrarResolucion($event, \'RESO_CASADA\')\" ng-if=$ctrl.verificarMostrarResolucionApellidoCasada($ctrl.habilitacion)><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button><span ng-if=!$ctrl.verificarMostrarResolucionApellidoCasada($ctrl.habilitacion)>No generado</span></div></div></div><div class=contenedorArchivos style=\"width: 95%\" ng-if=!$ctrl.habilitacion.rezagado><h3>Requisitos presentados</h3><div class=archivo-detalle layout=row ng-repeat=\"archivo in $ctrl.archivos\"><div><span ng-if=\"archivo.archivo && archivo.archivo.length == 1\"><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=\"!archivo.archivo || (archivo.archivo && !archivo.archivo.length)\"><md-icon style=\"color: red\">cancel</md-icon></span><!-- <md-button ng-click=\"$ctrl.mostrarInformeTecnicoGenerado($event)\"> --> {{archivo.nombre}}<!-- </md-button> --></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=\"$ctrl.abrirRequisito($event, archivo)\" ng-if=\"archivo.archivo && archivo.archivo.length == 1 && archivo.tipo_requisito == \'ARCHIVO\'\"><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button><label ng-if=\"archivo.archivo && archivo.archivo.length == 1 && archivo.tipo_requisito != \'ARCHIVO\'\"><strong>{{archivo.archivoTexto}}</strong></label><span ng-if=\"!archivo.archivo || (archivo.archivo && !archivo.archivo.length)\"><strong>{{archivo.metadato_no_cumple}}</strong></span></div></div></div><div class=contenedorArchivos style=\"width: 95%\" ng-if=$ctrl.habilitacion.rezagado><h3>Trámite iniciado manualmente (No se suben requisitos)</h3><div class=formulario-datos style=\"padding: 0px\"><p><label>Código de depósito:</label>{{$ctrl.habilitacion.codigo_deposito}}</p><p><label>Observaciones:</label>{{$ctrl.habilitacion.observaciones}}</p></div></div><div class=contenedorArchivos style=\"width: 95%\" ng-if=$ctrl.habilitacion.apoderado><h3>Datos del apoderado</h3><div class=formulario-datos style=\"padding: 0px\"><p><label>Documento de identidad:</label>{{$ctrl.habilitacion.apoderado.persona.tipo_documento_identidad.sigla}} - {{$ctrl.habilitacion.apoderado.persona.documento_identidad}}</p><p><label>Fecha de nacimiento:</label>{{$ctrl.habilitacion.apoderado.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p><p><label>Nombre completo:</label>{{$ctrl.habilitacion.apoderado.persona.primer_apellido}} {{$ctrl.habilitacion.apoderado.persona.segundo_apellido}}, {{$ctrl.habilitacion.apoderado.persona.nombres}}</p><p><label>Descripción:</label>{{$ctrl.habilitacion.apoderado.descripcion}}</p><div flex></div><div class=text-center><md-button class=md-raised ng-click=\"$ctrl.mostrarPoder($event, $ctrl.habilitacion.apoderado.id_apoderado)\"><md-icon class=bg-success>file_download</md-icon>Ver documento</md-button></div></div></div></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/components/estudiantesEnviados/modules.rotaciones.estudiantesEnviados.html","<div ng-cloak><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarHabilitados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><md-table-container><table md-table md-progress=promise><thead class=tabla-header md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.listarHabilitados><tr md-row><th md-column class=text-center><span>Documentos</span></th><th md-column class=text-center><span>Estado</span></th><th md-column class=text-center><span>Doc. de Identidad</span></th><th md-column class=text-center><span>Nombres</span></th><th md-column class=text-center><span>Primer apellido</span></th><th md-column class=text-center><span>Segundo apellido</span></th><th md-column class=text-center><span>Carrera</span></th><th md-column class=text-center><span>Preferencia</span></th></tr></thead><tbody md-body><tr md-row md-select=habilitado.id_habilitacion md-select-id=id_habilitacion md-auto-select ng-repeat=\"habilitado in $ctrl.estudiantes.rows\"><td md-cell><md-button class=md-icon-button aria-label=\"Generar credencial\" ng-click=\"$ctrl.mostrarCredencial($event, habilitado.id_habilitacion)\" ng-if=$ctrl.verificarMostrarCredencial(habilitado)><md-tooltip>Mostrar credencial</md-tooltip><md-icon class=\"md-icon icon-edit\">credit_card</md-icon></md-button><md-button class=md-icon-button aria-label=\"Mostrar resolución administrativa\" ng-click=\"$ctrl.mostrarResolucion($event, habilitado.id_habilitacion)\" ng-if=$ctrl.verificarMostrarResolucion(habilitado)><md-tooltip>Mostrar resolución administrativa</md-tooltip><md-icon class=\"md-icon icon-other\">insert_drive_file</md-icon></md-button></td><td md-cell><span style=\"color:{{(habilitado.estado_habilitacion == \'REPROBADO\' || habilitado.estado_habilitacion == \'RECHAZADO\' || habilitado.estado_habilitacion == \'SUSPENDIDA\'  )? \'red\': ( habilitado.estado_habilitacion == \'OBSERVADO\')? \'#F09314\' : \'green\' }}\">{{habilitado.estado_habilitacion}}</span></td><td md-cell><span><strong>{{habilitado.estudiante.persona.tipo_documento_identidad.sigla}}</strong><br>{{habilitado.estudiante.persona.documento_identidad}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.nombres}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.primer_apellido}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.segundo_apellido}}</span></td><td md-cell><span>{{habilitado.estudiante.carrera.nombre}}</span></td><td md-cell class=contenedor-datos><span class=advertencia ng-if=habilitado.asignacion_manual><md-icon class=md-icon>star</md-icon>{{habilitado.asignacion_manual}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=$ctrl.query.limit md-total={{$ctrl.estudiantes.count}} md-limit-options=\"[10, 20, 50]\" md-page=$ctrl.query.page md-on-paginate=$ctrl.listarHabilitados md-boundary-links=$ctrl.options.boundaryLinks md-page-select></md-table-pagination></md-card-content></div>");
$templateCache.put("app/modules/rotaciones/components/firmaCredenciales/modules.rotaciones.components.firmaCredenciales.html","<div ng-cloak><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarHabilitados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><form name=formEstudiante ng-submit=\"formEstudiante.$valid && $ctrl.firmarCredenciales()\" novalidate><div class=acciones-container><div class=text-right><md-button type=submit class=\"md-raised md-primary\" aria-label=\"Firmar credencials\" style=\"bottom: 0; right: 0\" ng-if=$ctrl.permission.update><md-icon>border_color</md-icon>Firmar credenciales</md-button></div></div></form><md-card-content><tabla-estudiantes permission=$ctrl.permission gestion-filtro=$ctrl.gestionFiltro periodo-filtro=$ctrl.periodoFiltro actualizardatos=$ctrl.actualizardatos query=$ctrl.query seleccionados=$ctrl.seleccionados seleccionable=$ctrl.seleccionable estados=$ctrl.estados buttons=$ctrl.buttons etapa=$ctrl.etapa filter=$ctrl.filter rezagados=$ctrl.rezagados listar-habilitados=$ctrl.listarHabilitados show-filter=$ctrl.showFilter remove-filter=$ctrl.removeFilter buscar-estudiante=$ctrl.buscarEstudiante></tabla-estudiantes></md-card-content></div>");
$templateCache.put("app/modules/rotaciones/components/firmaResoluciones/modules.rotaciones.components.firmaResoluciones.html","<div ng-cloak><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarHabilitados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><form name=formEstudiante ng-submit=\"formEstudiante.$valid && $ctrl.firmarResoluciones()\" novalidate><div class=acciones-container><div class=text-right><md-button type=submit class=\"md-raised md-primary\" aria-label=\"Firmar resolución\" style=\"bottom: 0; right: 0\" ng-if=$ctrl.permission.update><md-icon>border_color</md-icon>Firmar resoluciones</md-button></div></div></form><md-card-content><tabla-estudiantes permission=$ctrl.permission gestion-filtro=$ctrl.gestionFiltro periodo-filtro=$ctrl.periodoFiltro actualizardatos=$ctrl.actualizardatos query=$ctrl.query seleccionable=$ctrl.seleccionable estados=$ctrl.estados buttons=$ctrl.buttons seleccionados=$ctrl.seleccionados etapa=$ctrl.etapa filter=$ctrl.filter rezagados=$ctrl.rezagados listar-habilitados=$ctrl.listarHabilitados show-filter=$ctrl.showFilter remove-filter=$ctrl.removeFilter buscar-estudiante=$ctrl.buscarEstudiante></tabla-estudiantes></md-card-content></div>");
$templateCache.put("app/modules/rotaciones/components/generacionResoluciones/modules.rotaciones.components.generacionResoluciones.html","<div ng-cloak><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarHabilitados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><form name=formEstudiante ng-submit=\"formEstudiante.$valid && $ctrl.firmarInformes()\" novalidate><div class=acciones-container><div class=text-right><md-button type=submit class=\"md-raised md-primary\" aria-label=\"Generar resoluciones\" style=\"bottom: 0; right: 0\" ng-if=$ctrl.permission.update><md-icon>insert_drive_file</md-icon>Firmar informes técnicos</md-button></div></div></form><md-card-content><tabla-estudiantes permission=$ctrl.permission gestion-filtro=$ctrl.gestionFiltro periodo-filtro=$ctrl.periodoFiltro actualizardatos=$ctrl.actualizardatos query=$ctrl.query seleccionable=$ctrl.seleccionable estados=$ctrl.estados buttons=$ctrl.buttons seleccionados=$ctrl.seleccionados etapa=$ctrl.etapa filter=$ctrl.filter rezagados=$ctrl.rezagados listar-habilitados=$ctrl.listarHabilitados show-filter=$ctrl.showFilter remove-filter=$ctrl.removeFilter buscar-estudiante=$ctrl.buscarEstudiante></tabla-estudiantes></md-card-content></div>");
$templateCache.put("app/modules/rotaciones/components/resolucionesFirmadas/modules.rotaciones.components.resolucionesFirmadas.html","<div class=container ng-cloak><md-card><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarFirmados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><tabla-estudiantes permission=$ctrl.permission gestion-filtro=$ctrl.gestionFiltro periodo-filtro=$ctrl.periodoFiltro actualizardatos=$ctrl.actualizardatos query=$ctrl.query seleccionable=$ctrl.seleccionable estados=$ctrl.estados buttons=$ctrl.buttons seleccionados=$ctrl.seleccionados etapa=$ctrl.etapa filter=$ctrl.filter rezagados=$ctrl.rezagados listar-habilitados=$ctrl.listarHabilitados show-filter=$ctrl.showFilter remove-filter=$ctrl.removeFilter buscar-estudiante=$ctrl.buscarEstudiante></tabla-estudiantes></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/components/rotacionesEdicion/editInfo.dialog.html","<!-- <md-dialog aria-label=\"Agregar/Editar\" class=\"fullscreen-dialog\"> --><md-dialog aria-label=Agregar/Editar style=\"min-width: 500px; width: 700px\"><form name=formEditar ng-submit=\"formEditar.$valid && guardarEditar()\" novalidate><md-toolbar><div class=md-toolbar-tools><md-icon>person</md-icon><h2></h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><md-card-header><md-card-header-text><span class=md-title>Datos del Estudiante</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-xs=row layout-xs=column><md-card style=\"width: 100%\"><div layout=row><md-card style=\"width: 100%\"><md-input-container><label>CI- Documento Nro.</label><input ng-model=estudiante.persona.documento_identidad required readonly></md-input-container><md-input-container><label>Nombres</label><input ng-model=estudiante.persona.nombres required readonly></md-input-container><md-input-container><label>Primer Apellido</label><input ng-model=estudiante.persona.primer_apellido required readonly></md-input-container><md-input-container><label>Segundo Apellido</label><input ng-model=estudiante.persona.segundo_apellido required readonly></md-input-container><md-input-container><label>Establecimiento de Salud</label><input ng-model=habilitacion.establecimiento_salud.establecimiento required readonly></md-input-container><md-input-container ng-if=false><label>Municipio</label><input ng-model=habilitacion.municipio required readonly></md-input-container><md-input-container ng-if=false><label>Red de Salud</label><input ng-model=habilitacion.red_salud required readonly></md-input-container></md-card></div></md-card><md-card style=\"width: 100%\"><div layout=row><md-card><md-input-container><busqueda-sede-universitaria style=\"width: 100%; position: inherit\" id-sede=estudiante.fid_sede sede=sedeSel on-cambiar=cambiarSedeUniversitaria></busqueda-sede-universitaria></md-input-container><md-input-container><label>Carrera</label><md-select name=carrera ng-model=estudiante.fid_carrera required><md-option ng-value=carrera.id_carrera ng-repeat=\"carrera in carreras\">{{carrera.nombre}}</md-option></md-select></md-input-container></md-card></div></md-card></div><md-card><md-dialog-actions layout=row><div class=text-right><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></div></md-dialog-actions></md-card></md-card-content></md-dialog-content></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/components/rotacionesEdicion/modules.rotaciones.components.rotacionesEdicion.html","<div class=contenedor-datos ng-cloak><md-card><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarFirmados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><!--<tabla-estudiantes title=\"$ctrl.title\"--><tabla-estudiantes permission=$ctrl.permission gestion-filtro=$ctrl.gestionFiltro periodo-filtro=$ctrl.periodoFiltro query=$ctrl.query seleccionable=$ctrl.seleccionable estados=$ctrl.estados buttons=$ctrl.buttons seleccionados=$ctrl.seleccionados etapa=$ctrl.etapa rezagados=$ctrl.rezagados filter=$ctrl.filter listar-habilitados=$ctrl.listarHabilitados show-filter=$ctrl.showFilter remove-filter=$ctrl.removeFilter buscar-estudiante=$ctrl.buscarEstudiante></tabla-estudiantes></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/components/tablaEstudiantes/modules.rotaciones.components.tablaEstudiantes.html","<md-table-container class=contenedor-datos><table md-table md-row-select=$ctrl.seleccionable multiple ng-model=$ctrl.seleccionados.selected md-progress=promise><thead class=tabla-header md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.listarHabilitados><tr md-row><th md-column class=text-center>Acciones</th><th md-column class=text-center><span>Doc. Identidad</span></th><th md-column class=text-center><span>Nombres</span></th><th md-column class=text-center><span>Primer apellido</span></th><th md-column class=text-center><span>Segundo apellido</span></th><th md-column class=text-center><span>Apellido de casada</span></th><th md-column class=text-center><span>Universidad y carrera</span></th><th md-column class=text-center><span>Nota</span></th><th ng-if=\"$ctrl.gestionFiltro == 0\" md-column class=text-center><span>Rotación</span></th><th md-column class=text-center><span>Establecimiento</span></th><th md-column class=text-center><span>Estado</span></th><th md-column class=text-center ng-repeat=\"c in $ctrl.columnas\"><span>{{c.label}}</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=habilitado.id_habilitacion md-select-id=id_habilitacion md-auto-select ng-repeat=\"habilitado in $ctrl.estudiantes.rows\"><td md-cell><div layout=row><md-button class=md-icon-button ng-repeat=\"button in $ctrl.buttons\" aria-label=button.tooltip ng-click=\"$ctrl.buttonEvent($event, habilitado, button.onclick)\" ng-if=button.mostrar(habilitado)><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon class=\"md-icon icon-other\" ng-if=\"!button.iconColor || item[\'\' + button.nombreColumnaColor + \'\'] != button.valorColumnaColor\">{{button.icon}}</md-icon><md-icon class=\"md-icon icon-other\" style=\"color: {{button.iconColor}}\" ng-if=\"button.iconColor && item[\'\' + button.nombreColumnaColor + \'\'] == button.valorColumnaColor\">{{button.icon}}</md-icon></md-button></div></td><td md-cell><span><span class=negrita-500>{{habilitado.estudiante.persona.tipo_documento_identidad.sigla}}</span><br>{{habilitado.estudiante.persona.documento_identidad}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.nombres}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.primer_apellido}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.segundo_apellido}}</span></td><td md-cell><span>{{habilitado.estudiante.persona.casada_apellido}}</span></td><td md-cell><span><span class=negrita-500>{{habilitado.estudiante.carrera.nombre}}</span><br>{{habilitado.estudiante.universidad.nombre}}</span></td><td md-cell class=text-center><span><md-input-container ng-if=!habilitado.establecimiento_salud style=\"width: 100px; height: 25px; margin-top: 5px\"><input ng-model=habilitado.nota style=\"color:{{(habilitado.estado_habilitacion == \'REPROBADO\' || habilitado.estado_habilitacion == \'RECHAZADO\' || habilitado.estado_habilitacion == \'SUSPENDIDA\'  )? \'red\': ( habilitado.estado_habilitacion == \'OBSERVADO\')? \'#F09314\' : \'green\' }}\" min=0 max=100 aria-label=Nota type=text only-digits od-cantidad=3 od-maximo=100 ng-disabled=\"$ctrl.etapa != \'ASIGNACIONES\'\"></md-input-container><span ng-if=habilitado.establecimiento_salud style=\"color:{{(habilitado.estado_habilitacion == \'REPROBADO\' || habilitado.estado_habilitacion == \'RECHAZADO\' || habilitado.estado_habilitacion == \'SUSPENDIDA\'  )? \'red\': ( habilitado.estado_habilitacion == \'OBSERVADO\')? \'#F09314\' : \'green\' }}\">{{habilitado.nota}}</span></span></td><td ng-if=\"$ctrl.gestionFiltro == 0\" md-cell><span>{{habilitado.periodo.numero}} / {{habilitado.periodo.gestion}}</span></td><td md-cell><span ng-if=habilitado.establecimiento_salud>{{habilitado.establecimiento_salud.establecimiento}}</span> <span ng-if=!habilitado.establecimiento_salud><i>Sin asignar</i></span><br><span class=advertencia ng-if=habilitado.asignacion_manual><md-icon class=md-icon>star</md-icon>{{habilitado.asignacion_manual}}</span></td><td md-cell><span style=\"color:{{(habilitado.estado_habilitacion == \'REPROBADO\' || habilitado.estado_habilitacion == \'RECHAZADO\' || habilitado.estado_habilitacion == \'SUSPENDIDA\'  )? \'red\': ( habilitado.estado_habilitacion == \'OBSERVADO\')? \'#F09314\' : \'green\' }}\">{{habilitado.estado_habilitacion}} <span class=rezagado-span ng-if=habilitado.rezagado><br>REZAGADO</span></span><br><div ng-if=$ctrl.estadoCorreo><span ng-if=\"habilitado.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\" class=estado_correo><span ng-if=\"habilitado.estado_correo == \'ENVIADO\'\"><md-icon class=\"md-icon bg-success\">check_circle</md-icon>Enviado </span><span ng-if=\"habilitado.estado_correo == \'ENVIANDO\'\"><md-icon class=md-icon>more_horiz</md-icon>Enviando </span><span ng-if=\"habilitado.estado_correo == \'NO_ENVIADO\'\"><md-icon class=md-icon>cancel</md-icon>Error al enviar </span></span><span ng-if=\"habilitado.estado_habilitacion == \'RESOLUCION_FIRMADA_DIRECTOR\'\" class=estado_correo><span ng-if=\"habilitado.estado_correo == \'ENVIADO\'\"><md-icon class=\"md-icon bg-success\">check_circle</md-icon>Enviado </span><span ng-if=\"habilitado.estado_correo == \'ENVIANDO\'\"><md-icon class=md-icon>more_horiz</md-icon>Enviando </span><span ng-if=\"habilitado.estado_correo == \'NO_ENVIADO\'\"><md-icon class=md-icon>cancel</md-icon>Error al enviar</span></span></div></td><td md-cell ng-repeat=\"c in $ctrl.columnas\"><span>{{habilitado[c.nombre]}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=$ctrl.query.limit md-boundary-links=$ctrl.options.boundaryLinks md-total={{$ctrl.estudiantes.count}} md-limit-options=\"[10, 20, 50]\" md-page=$ctrl.query.page md-on-paginate=$ctrl.lista md-page-select></md-table-pagination>");
$templateCache.put("app/modules/rotaciones/components/verificacionEstudiantes/modules.calendario.html","<!-- <md-dialog aria-label=\"Agregar/Editar\" ng-cloak class=\"formly-dialog formly-column-{{column}}\"> --><md-dialog aria-label=Agregar/Editar ng-cloak class=contenedor-verificacion-estudiantes style=\"width: 600px\"><md-toolbar><div class=md-toolbar-tools><md-icon aria-label=\"Calendario de rotaciones\">event</md-icon><h2>Calendario de rotaciones</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=\"text-center rotaciones-gestion\" layout=row ng-if=\"gestiones.length > 0\"><md-button class=md-icon-button ng-click=cambiarGestion(false) id=btn-refresh-crudtable flex ng-disabled=\"gestionActual == 0\"><md-tooltip>Anterior</md-tooltip><md-icon>keyboard_arrow_left</md-icon></md-button><span class=rotaciones-titulo flex>{{gestiones[gestionActual].gestion}}</span><md-button class=md-icon-button ng-click=cambiarGestion(true) id=btn-refresh-crudtable flex ng-disabled=\"gestionActual == (gestiones.length - 1)\"><md-tooltip>Siguiente</md-tooltip><md-icon>keyboard_arrow_right</md-icon></md-button></div><div class=\"rotaciones-gestion buscador buscador-resultado sin-datos\" layout=row ng-if=\"gestiones.length == 0\" style=\"max-width: none\"><div><h3>No se encontraron resultados</h3><div layout=row><div><md-icon class=md-icon>mood_bad</md-icon></div><div class=texto><span>No se encontraron resultados a su búsqueda..</span></div></div></div></div><div ng-repeat=\"periodo in periodos\"><h3>{{periodo.descripcion}}</h3><div class=formulario ng-repeat=\"per in periodo.periodos\"><div layout=row><div><h4 style=\"margin: 0px\">ROTACIÓN {{per.numero}}:</h4></div><span>&nbsp;</span><div>del {{per.fecha_inicio | date:\'dd/MM/yyyy\'}} al {{per.fecha_fin | date:\'dd/MM/yyyy\'}}</div></div></div></div></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/rotaciones/components/verificacionEstudiantes/modules.rotaciones.components.verificacionEstudiantes.html","<div class=contenedor-verificacion-estudiantes><div class=\"buscador buscador-cuerpo\" ng-if=\"(!$ctrl.habilitacion || $ctrl.esconderResultado) && !$ctrl.sinResultado && !$ctrl.enProceso\"><md-toolbar><div class=\"md-toolbar-tools text-left\"><md-icon class=md-icon>search</md-icon><span>&nbsp;Verifica tu trámite</span><div flex></div></div></md-toolbar><div><form name=formEstudiante ng-submit=\"formEstudiante.$valid && $ctrl.buscarEstudiante()\" novalidate><b>&nbsp;</b><md-input-container><label>Tipo de documento</label><md-icon class=md-icon>label</md-icon><md-select ng-model=$ctrl.tipo required style=\"width: 100%\"><md-option ng-repeat=\"option in $ctrl.tipos\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container><p></p><md-input-container ng-if=\"$ctrl.tipo != \'105\'\"><label>Cédula de identidad</label><md-icon class=md-icon>person</md-icon><input ng-model=$ctrl.documento_identidad md-autofocus=true only-digits od-cantidad=20 type=text placeholder=\"Ejemplo: 4521215\" required><div class=hint>Nacional o extranjera (sólo números)</div></md-input-container><md-input-container ng-if=\"$ctrl.tipo == \'105\'\"><label>Número de documento</label><md-icon class=md-icon>person</md-icon><input ng-model=$ctrl.documento_identidad md-autofocus=true type=text placeholder=\"Ejemplo: JK7123131\" required></md-input-container><p></p><div><md-icon class=md-icon>event</md-icon><label class=label-otro>Fecha de nacimiento</label></div><p></p><div layout=row><md-input-container class=small><label>Día</label><input ng-model=$ctrl.dia type=text only-digits od-cantidad=2 od-minimo=1 od-maximo=31 placeholder=31 required></md-input-container><md-input-container class=small><label>Mes</label><input ng-model=$ctrl.mes type=text only-digits od-cantidad=2 od-minimo=1 od-maximo=12 placeholder=12 required></md-input-container><md-input-container class=small><label>Año</label><input ng-model=$ctrl.anio type=text only-digits od-cantidad=4 placeholder=1990 required></md-input-container></div><div class=text-center><md-button type=submit class=\"md-raised md-primary\"><md-icon>search</md-icon>Buscar estudiante</md-button></div><div class=text-center style=\"margin-top: 10px\"><md-button-href class=restablecer ng-click=$ctrl.abrirCalendario()><md-icon aria-label=\"Calendario de rotaciones\">event</md-icon>Calendario de rotaciones</md-button-href></div></form></div></div><div class=\"buscador buscador-resultado\" ng-if=\"$ctrl.habilitacion && !$ctrl.esconderResultado && !$ctrl.sinResultado\"><h4><md-icon class=colorPrimario>person</md-icon>{{$ctrl.habilitacion.estudiante.persona.nombres}} {{$ctrl.habilitacion.estudiante.persona.primer_apellido}} {{$ctrl.habilitacion.estudiante.persona.segundo_apellido}} <span>({{$ctrl.habilitacion.estado_habilitacion}})</span></h4><div class=formulario-datos><div flex><p><label>Tipo de documento:</label>{{$ctrl.habilitacion.estudiante.persona.tipo_documento_identidad.sigla}}</p><p><label>Número de documento:</label>{{$ctrl.habilitacion.estudiante.persona.documento_identidad}}</p><p><label>Fecha de nacimiento:</label>{{$ctrl.habilitacion.estudiante.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p><p><label>Nombres:</label>{{$ctrl.habilitacion.estudiante.persona.nombres}}</p><p><label>Primer apellido:</label>{{$ctrl.habilitacion.estudiante.persona.primer_apellido}}</p><p><label>Segundo apellido:</label>{{$ctrl.habilitacion.estudiante.persona.segundo_apellido}}</p><p><label>Correo electrónico:</label>{{$ctrl.habilitacion.estudiante.correo_electronico}}</p><p><label>Teléfono de contacto:</label>{{$ctrl.habilitacion.estudiante.telefono}}</p><md-divider></md-divider><div ng-repeat=\"hab in $ctrl.habilitaciones\"><p class=rotacion><label>Rotación:</label>{{hab.periodo.numero}} - {{hab.periodo.gestion}}</p><p class=estado><label>Estado el trámite:</label>{{hab.estado_habilitacion}}</p><p><label>Universidad:</label>{{hab.estudiante.universidad.nombre}}</p><p><label>Carrera:</label>{{hab.estudiante.carrera.nombre}}</p><p><label>Nota inducción:</label><span ng-if=hab.nota>{{hab.nota}}</span> <span ng-if=!hab.nota><i>PENDIENTE</i></span></p><p><label>Centro de salud:</label><span ng-if=hab.establecimiento_salud>{{hab.establecimiento_salud.establecimiento}}</span> <span ng-if=\"!hab.establecimiento_salud && hab.reprobado\"><i>Sin asignar por nota de reprobación.</i></span> <span ng-if=\"!hab.establecimiento_salud && !hab.reprobado\"><i>PENDIENTE</i></span></p><p><label>Inicio del servicio:</label>{{hab.fecha_inicio | date:\'dd/MM/yyyy\'}}</p><p><label>Fin del servicio:</label>{{hab.fecha_fin | date:\'dd/MM/yyyy\'}}</p><div style=\"width: 100%\" ng-if=\"hab.credencial && $ctrl.verificarMostrarCredencial(hab)\"><div layout-xs=column layout-gt-xs=row layout-align=\"center center\"><div style=\"margin-top: 15px\"><!-- <h4 style=\"width: 100%;\">Credencial</h4> --> <span><md-icon class=bg-success>check_circle</md-icon></span><span>Credencial emitida</span></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=\"$ctrl.mostrarCredencial(event, hab)\"><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button></div></div></div><div style=\"width: 100%\" ng-if=\"hab.resolucion && $ctrl.verificarMostrarResolucion(hab)\"><div layout-xs=column layout-gt-xs=row layout-align=\"center center\"><div style=\"margin-top: 15px\"><!-- <h4 style=\"width: 100%;\">Credencial</h4> --> <span><md-icon class=bg-success>check_circle</md-icon></span><span>Resolución Administrativa emitida</span></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=\"$ctrl.mostrarResolucion(event, hab)\"><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button></div></div><div layout-xs=column layout-gt-xs=row layout-align=\"center center\"><div style=\"margin-top: 15px\"><!-- <h4 style=\"width: 100%;\">Credencial</h4> --> <span><md-icon class=bg-success>check_circle</md-icon></span><span>Resolución Administrativa Modificatoria emitida</span></div><div flex></div><div class=text-right><md-button class=md-raised ng-click=\"$ctrl.mostrarResolucionModificatoria(event, hab)\"><md-icon class=bg-success>file_download</md-icon>Mostrar</md-button></div></div></div><md-divider></md-divider></div></div></div><div class=text-right><md-button ng-click=$ctrl.volverBuscar()><md-icon class=md-icon>search</md-icon>Nueva búsqueda</md-button></div></div><div class=\"buscador buscador-resultado sin-datos\" ng-if=$ctrl.sinResultado><div><h3>No se encontraron resultados</h3><div layout=row><div><md-icon class=md-icon>mood_bad</md-icon></div><div class=texto><span>No se encontraron resultados a su búsqueda. Verifique el documento de identidad ingresado.</span></div></div></div><div class=text-right><md-button ng-click=$ctrl.volverBuscar(true)><md-icon class=md-icon>search</md-icon>Nueva búsqueda</md-button></div></div><div class=\"buscador buscador-resultado en-proceso\" ng-if=$ctrl.enProceso><div><h3>Su trámite está en proceso.</h3><div layout=row><div><!-- <md-icon class=\"md-icon rotar\">layers</md-icon> --> <img class=\"md-icon rotar\" src=assets/images/tramite.png aria-label=\"Trámite en proceso\"></div><div class=texto><span>Su trámite aún está en proceso.</span></div></div></div><div class=text-right><md-button ng-click=$ctrl.volverBuscar()><md-icon class=md-icon>search</md-icon>Nueva búsqueda</md-button></div></div></div>");
$templateCache.put("app/modules/rotaciones/components/informesFirmados/modules.rotaciones.components.informesFirmados.html","<div class=container ng-cloak><md-card><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarEstudiante()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarFirmados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><tabla-estudiantes permission=$ctrl.permission gestion-filtro=$ctrl.gestionFiltro periodo-filtro=$ctrl.periodoFiltro actualizardatos=$ctrl.actualizardatos query=$ctrl.query seleccionable=$ctrl.seleccionable estados=$ctrl.estados buttons=$ctrl.buttons seleccionados=$ctrl.seleccionados etapa=$ctrl.etapa filter=$ctrl.filter rezagados=$ctrl.rezagados listar-habilitados=$ctrl.listarHabilitados show-filter=$ctrl.showFilter remove-filter=$ctrl.removeFilter buscar-estudiante=$ctrl.buscarEstudiante></tabla-estudiantes></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/credenciales/detalleCredenciales/modules.rotaciones.credenciales.detalleCredenciales.html","<div class=container ng-cloak><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>credit_card</md-icon><span>{{detalleCredenciales.title}}</span><div flex></div></div></md-toolbar><md-card-content><md-card-header><md-card-header-text><span class=md-title><md-icon class=colorPrimario>person</md-icon>{{detalleCredenciales.habilitacion.estudiante.persona.nombres}} {{detalleCredenciales.habilitacion.estudiante.persona.primer_apellido}} {{detalleCredenciales.habilitacion.estudiante.persona.segundo_apellido}}</span></md-card-header-text></md-card-header><div layout-gt-xs=row layout-xs=column><md-card style=\"width: 100%\"><md-card-header><md-card-header-text class=text-center><span class=md-title>Datos del estudiante</span></md-card-header-text></md-card-header><md-card-content><div class=formulario-datos><div flex><p><label>Tipo de documento:</label>{{detalleCredenciales.habilitacion.estudiante.persona.tipo_documento_identidad.sigla}}</p><p><label>Número de documento:</label>{{detalleCredenciales.habilitacion.estudiante.persona.documento_identidad}}</p><p><label>Fecha de nacimiento:</label>{{detalleCredenciales.habilitacion.estudiante.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p><p><label>Nombres:</label>{{detalleCredenciales.habilitacion.estudiante.persona.nombres}}</p><p><label>Primer apellido:</label>{{detalleCredenciales.habilitacion.estudiante.persona.primer_apellido}}</p><p><label>Segundo apellido:</label>{{detalleCredenciales.habilitacion.estudiante.persona.segundo_apellido}}</p><p><label>Correo electrónico:</label>{{detalleCredenciales.habilitacion.estudiante.correo_electronico}}</p><p><label>Teléfono de contacto:</label>{{detalleCredenciales.habilitacion.estudiante.telefono}}</p></div></div></md-card-content></md-card><div flex></div><md-card style=\"width: 100%\"><md-card-header><md-card-header-text class=text-center><span class=md-title>Datos académicos</span></md-card-header-text></md-card-header><md-card-content><div class=formulario-datos layout-gt-xs=row layout-xs=column><div flex><p><label>Universidad:</label>{{detalleCredenciales.habilitacion.estudiante.universidad.nombre}}</p><p><label>Carrera:</label>{{detalleCredenciales.habilitacion.estudiante.carrera.nombre}}</p><p><label>Nota:</label>{{detalleCredenciales.habilitacion.nota}}</p><p><label>Establecimiento de salud asignado:</label>{{detalleCredenciales.habilitacion.establecimiento_salud.establecimiento}}</p><p><label>Fecha de inicio del servicio:</label>{{detalleCredenciales.habilitacion.fecha_inicio | date:\'dd/MM/yyyy\'}}</p><p><label>Fecha de finalización del servicio:</label>{{detalleCredenciales.habilitacion.fecha_fin | date:\'dd/MM/yyyy\'}}</p></div></div></md-card-content></md-card></div><md-toolbar><div class=md-toolbar-tools><h2>Credencial generada</h2><span flex></span></div></md-toolbar><md-dialog-content><md-card-header><md-card-header-text><span class=md-title>Credencial</span></md-card-header-text></md-card-header><!-- <iframe src=\"{{detalleCredenciales.habilitacion.credencial}}\" style=\"width:100%; height:600px; border: none;\" id=\"iframe-pdf-crud\"></iframe> --><div class=formulario-datos ng-if=!detalleCredenciales.habilitacion.credencial><p>Se descargará la credencial.</p></div><div layout-gt-xs=row layout-xs=column><iframe ng-if=detalleCredenciales.habilitacion.credencial ng-src={{detalleCredenciales.formatearUrl(detalleCredenciales.habilitacion.credencial)}} style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe><div><md-card-header><md-card-header-text><span class=md-title>Firmas del documento</span></md-card-header-text></md-card-header><div class=formulario-datos><p ng-if=detalleCredenciales.firmasMensaje>{{detalleCredenciales.firmasMensaje}}</p><div ng-repeat=\"firma in detalleCredenciales.firmas\"><md-card style=\"font-size: 12px; padding: 10px; max-width: 250px\" layout=row><div style=\"margin-right: 5px\"><span style=text-left><md-icon class=colorPrimario>border_color</md-icon></span></div><div><!-- <span ng-bind-html=\"detalleCredenciales.formatearHtml(firma)\"></span> --><div><b>Nombre: </b>{{firma.nombreComunSubject}}</div><div><b>Fecha firma:</b> {{firma.fechaFirma}}</div></div></md-card></div></div></div></div></md-dialog-content></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/credenciales/verificacionCredencial/modules.rotaciones.credenciales.verificacionCredencial.html","<div class=container ng-cloak><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>credit_card</md-icon><span>{{verificacionCredencial.title}}</span><div flex></div></div></md-toolbar><md-card-content ng-if=!verificacionCredencial.habilitacion><div class=formulario-datos><p>No se ha encontrado la información solicitada o el enlace es incorrecto, por favor verifique nuevamente.</p></div></md-card-content><md-card-content ng-if=verificacionCredencial.habilitacion><md-card-header><md-card-header-text><span class=md-title><md-icon class=colorPrimario>person</md-icon>{{verificacionCredencial.habilitacion.estudiante.persona.nombres}} {{verificacionCredencial.habilitacion.estudiante.persona.primer_apellido}} {{verificacionCredencial.habilitacion.estudiante.persona.segundo_apellido}}</span></md-card-header-text></md-card-header><div layout-gt-xs=row layout-xs=column><md-card style=\"width: 100%\"><md-card-header><md-card-header-text class=text-center><span class=md-title>Datos del estudiante</span></md-card-header-text></md-card-header><md-card-content><div class=formulario-datos><div flex><p><label>Tipo de documento:</label>{{verificacionCredencial.habilitacion.estudiante.persona.tipo_documento_identidad.sigla}}</p><p><label>Número de documento:</label>{{verificacionCredencial.habilitacion.estudiante.persona.documento_identidad}}</p><p><label>Fecha de nacimiento:</label>{{verificacionCredencial.habilitacion.estudiante.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p><p><label>Nombres:</label>{{verificacionCredencial.habilitacion.estudiante.persona.nombres}}</p><p><label>Primer apellido:</label>{{verificacionCredencial.habilitacion.estudiante.persona.primer_apellido}}</p><p><label>Segundo apellido:</label>{{verificacionCredencial.habilitacion.estudiante.persona.segundo_apellido}}</p><p><label>Correo electrónico:</label>{{verificacionCredencial.habilitacion.estudiante.correo_electronico}}</p><p><label>Teléfono de contacto:</label>{{verificacionCredencial.habilitacion.estudiante.telefono}}</p></div></div></md-card-content></md-card><div flex></div><md-card style=\"width: 100%\"><md-card-header><md-card-header-text class=text-center><span class=md-title>Datos académicos</span></md-card-header-text></md-card-header><md-card-content><div class=formulario-datos layout-gt-xs=row layout-xs=column><div flex><p><label>Universidad:</label>{{verificacionCredencial.habilitacion.estudiante.universidad.nombre}}</p><p><label>Carrera:</label>{{verificacionCredencial.habilitacion.estudiante.carrera.nombre}}</p><p><label>Nota:</label>{{verificacionCredencial.habilitacion.nota}}</p><p><label>Establecimiento:</label>{{verificacionCredencial.habilitacion.establecimiento_salud.establecimiento}}</p><p><label>Fecha de inicio:</label>{{verificacionCredencial.habilitacion.fecha_inicio | date:\'dd/MM/yyyy\'}}</p><p><label>Fecha de finalización:</label>{{verificacionCredencial.habilitacion.fecha_fin | date:\'dd/MM/yyyy\'}}</p><p><label>Estado de la credencial:</label>{{verificacionCredencial.habilitacion.estado_habilitacion}}</p><p ng-if=verificacionCredencial.habilitacion.vencido><label style=\"color: red\">VENCIDA</label></p></div></div></md-card-content></md-card></div><md-toolbar><div class=md-toolbar-tools><h2>Credencial generada</h2><span flex></span></div></md-toolbar><md-dialog-content ng-if=\"verificacionCredencial.habilitacion.credencial !== false\"><div class=formulario-datos><!-- <iframe src=\"{{verificacionCredencial.habilitacion.credencial}}\" style=\"width:100%; height:600px; border: none;\" id=\"iframe-pdf-crud\"></iframe> --><iframe ng-src={{verificacionCredencial.formatearUrl(verificacionCredencial.habilitacion.credencial)}} style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe></div></md-dialog-content><md-dialog-content ng-if=\"verificacionCredencial.habilitacion.credencial === false\"><div class=formulario-datos><p>No se ha encontrado ninguna Credencial asociada a este estudante.</p></div></md-dialog-content></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/monitoreo/detalleMonitoreo/create.dialog.html","<!-- <md-dialog aria-label=\"Agregar/Editar\" class=\"fullscreen-dialog\"> --><md-dialog aria-label=Agregar/Editar style=\"width: 900px\"><md-toolbar><div class=md-toolbar-tools><md-icon>perm_identity</md-icon><h2>Registro del apoderado</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><div style=\"padding: 0px 16px\"><!-- TODO: buscar donde se realiza --><cedula-identidad persona=apoderado.persona></cedula-identidad></div><form name=formApoderado ng-submit=\"formApoderado.$valid && guardarApoderado()\" novalidate><md-dialog-content class=contenedor-usuarios style=\"padding: 0px 20px\"><!-- <h4>Datos de la persona</h4> --><div layout-gt-xs=row layout-xs=column style=\"margin-top: 10px\"><!-- <md-input-container class=\"automatico\">\n          <label>Nombre(s)</label>\n          <input ng-model=\"apoderado.persona.nombres\" required ng-readonly=\"true\" ng-disabled=\"true\" capitalize class=\"input-automatico\">\n        </md-input-container>\n        <md-input-container class=\"automatico\">\n          <label>Primer apellido</label>\n          <input ng-model=\"apoderado.persona.primer_apellido\" ng-readonly=\"true\" ng-disabled=\"true\" capitalize class=\"input-automatico\">\n        </md-input-container>\n        <md-input-container class=\"automatico\">\n          <label>Segundo apellido</label>\n          <input ng-model=\"apoderado.persona.segundo_apellido\" required ng-readonly=\"true\" ng-disabled=\"true\" capitalize class=\"input-automatico\">\n        </md-input-container> --> <input ng-model=apoderado.persona.id_persona type=hidden></div><h4>Datos de documento</h4><div layout-gt-xs=row layout-xs=column><md-input-container><label>Descripción</label><!-- <input ng-model=\"apoderado.descripcion\" type=\"text\" rows=\"3\"> --><textarea ng-model=apoderado.descripcion md-select-on-focus required></textarea></md-input-container></div><div layout-gt-xs=row layout-xs=column><div><md-input-container style=\"width: 85%\"><label>Documento</label><br></md-input-container><lf-ng-md-file-input lf-files=archivo aria-label=\"Subir archivo\" lf-placeholder=\"Subir archivo\" lf-browse-label=Buscar lf-remove-label=Limpiar accept=.pdf,image/* lf-required></lf-ng-md-file-input><div ng-messages=formApoderado.archivo.$error style=color:red><div ng-message=required>This is required.</div><div ng-message=maxcount>Too many files.</div><div ng-message=filesize>File size too large.</div><div ng-message=totalsize>Total size too large.</div><div ng-message=mimetype>Mimetype error.</div></div><!-- <p>Documento</p>\n          <lf-ng-md-file-input lf-files=\"archivo\" aria-label=\"Subir archivo\" lf-placeholder=\"Subir archivo\" lf-browse-label=\"Buscar\"\n          lf-remove-label=\"Eliminar\" accept=\".pdf,image/*\" required>\n          </lf-ng-md-file-input> --></div></div></md-dialog-content><md-dialog-actions layout=row><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.monitoreo.crud.html","<md-dialog aria-label=Agregar/Editar ng-cloak><md-toolbar><div class=md-toolbar-tools><h2><md-icon>playlist_add</md-icon>Agregar falta</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form id=formFalta name=formFalta ng-submit=\"formFalta.$valid && guardarFalta(falta)\" novalidate><div style=\"max-width: 350px; margin-left: 12px\"><help-message mensaje=\"El registro de faltas puede incurrir en la suspensión de la presente habilitación.\"></help-message></div><md-dialog-content><div class=md-dialog-content><md-card-content layout=column><md-input-container><label class=strong>Tipo de falta</label><md-select ng-model=falta.fid_tipo_falta required><md-option ng-value=tipo.id_parametro ng-repeat=\"tipo in tipos_faltas\">{{tipo.nombre}}</md-option></md-select></md-input-container><div ng-if=falta.fid_tipo_falta style=\"max-width: 350px\"><help-message mensaje={{obtenerDescripcionFalta(falta.fid_tipo_falta)}}></help-message></div><md-input-container style=\"margin-top: 30px\"><label class=strong>Cantidad de períodos a suspender</label><input type=text ng-model=falta.nro_periodos only-digits od-maximo=4 required></md-input-container><md-input-container><label>Observaciones</label><textarea ng-model=falta.descripcion></textarea></md-input-container></md-card-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.monitoreo.lista.html","<md-dialog aria-label=Listar ng-cloak><form id=data-form name=form ng-submit=lista()><md-toolbar><div class=md-toolbar-tools><h2><md-icon>list</md-icon>Lista de faltas</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column><table class=\"table table-hovered table-striped margin-0\"><thead><tr><th>Acciones</th><th>Tipo de falta</th><th>Descripción</th></tr></thead><tbody ng-repeat=\"falta in faltas\"><tr><td><md-button class=md-icon-button aria-label=Editar ng-click=eliminarFalta(falta.id_falta)><md-tooltip>Eliminar falta</md-tooltip><md-icon class=md-icon>cancel</md-icon></md-button></td><td>{{falta.tipo_falta.nombre}}</td><td>{{falta.descripcion}}</td></tr></tbody></table></md-content></div><p class=formulario-datos ng-if=\"!faltas || (faltas && faltas.length == 0)\"><md-icon>check</md-icon>El estudiante no cuenta con faltas en la rotación actual.</p></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>close</md-icon>Cerrar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.observacion.crud.html","<md-dialog aria-label=Agregar/Editar ng-cloak><md-toolbar><div class=md-toolbar-tools><h2><md-icon>do_not_disturb_on</md-icon>Observar trámite</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form id=formObservacion name=formObservacion ng-submit=\"formObservacion.$valid && guardarObservacion(observacion)\" novalidate><div style=\"max-width: 450px; margin-left: 12px\"><help-message ng-if=!anterior mensaje=\"Si observa el trámite, se derivará al técnico de la sub-unidad correspondiente para su revisión y se desviará del flujo normal hasta que sea corregido. Para subsanar la observacioń, el usuario técnico correspondiente debe aprobar la conclusión del SSSRO del estudiante, subsanar la observación, e ingresar a la bandeja de Resoluciones Administrativas, buscar el C.I. y enviar el informe técnico al asesor legal\"></help-message><help-message ng-if=anterior mensaje=\"Se registrarán el siguiente mensaje en el Informe Técnico Legal.\"></help-message></div><md-dialog-content><div class=md-dialog-content><md-card-content layout=column><md-input-container><label>Descripción de la observación</label><textarea ng-model=observacion.detalle required></textarea></md-input-container><md-input-container class=small ng-if=!anterior><md-checkbox ng-model=observacion.definitiva>Suspensión definitiva</md-checkbox></md-input-container></md-card-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.pdf.html","<md-dialog aria-label=Imprimir ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"width: 960px\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><iframe src={{formatearUrlPdf(data)}} style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe><!--<ng-pdf template-url=\"app/modules/rotaciones/monitoreo/detalleMonitoreo/pdf.html\" scale=\"page-fit\"></ng-pdf>--></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/rotaciones/monitoreo/detalleMonitoreo/dialog.req.html","<md-dialog aria-label=Imprimir ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"width: 960px\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"text-align: center\"><div style=\"width:100%; height:600px\"><img src={{formatearUrl(data)}}></div></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/rotaciones/monitoreo/detalleMonitoreo/modules.rotaciones.monitoreo.detalleMonitoreo.html","<div class=\"container container-monitoreo\" ng-cloak><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>person</md-icon><span>{{detalleMonitoreo.title}}</span><div flex></div></div></md-toolbar><md-card-content><div layout=row><span flex></span><md-button class=\"md-raised md-primary\" ng-click=detalleMonitoreo.registrarFalta($event) aria-label=\"Registrar falta\" ng-if=\"detalleMonitoreo.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\"><md-icon>playlist_add</md-icon>Registrar falta</md-button><md-button class=\"md-raised md-primary\" ng-click=detalleMonitoreo.observarTramite($event) aria-label=\"Observar trámite\" ng-if=\"detalleMonitoreo.mostrarObservarTramite(detalleMonitoreo.habilitacion) && detalleMonitoreo.habilitacion.estado_habilitacion != \'SUSPENDIDA\' && detalleMonitoreo.habilitacion.estado_habilitacion != \'RESOLUCION_FIRMADA_DIRECTOR\'\"><md-icon>do_not_disturb_on</md-icon>Observar trámite</md-button><md-button class=\"md-icon-button icon-back\" ng-click=detalleMonitoreo.volverMonitoreo() aria-label=Atrás show-gt-md><md-tooltip>Atrás</md-tooltip><i class=md-icon>arrow_back</i></md-button></div><detalle-tramite ng-if=detalleMonitoreo.habilitacion habilitacion=detalleMonitoreo.habilitacion permission=detalleMonitoreo.permission archivos=detalleMonitoreo.archivos faltas=detalleMonitoreo.faltas eliminar-falta=detalleMonitoreo.eliminarFalta id-habilitacion=detalleMonitoreo.idHabilitacion></detalle-tramite></md-card-content></md-card><md-card><md-toolbar><div class=md-toolbar-tools><md-icon>location_on</md-icon><h2>Localización</h2><span flex></span></div></md-toolbar><md-card-content><div ng-if=detalleMonitoreo.mapaEstablecimiento><md-card-header><md-card-header-text><span class=md-title><md-icon class=colorPrimario>local_hospital</md-icon>{{detalleMonitoreo.habilitacion.establecimiento_salud.establecimiento}}</span></md-card-header-text></md-card-header><leaflet lf-center=detalleMonitoreo.mapaEstablecimiento.ubicacion markers=detalleMonitoreo.mapaEstablecimiento.markers legend=detalleMonitoreo.mapaEstablecimiento.legend height=500px width=100%></leaflet></div><div ng-if=detalleMonitoreo.mapaVacio><span><md-icon class=colorPrimario>location_on</md-icon>{{detalleMonitoreo.mapaVacio}}</span></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/monitoreo/detalleMonitoreo/pdf.html","<style>.pdf-controls {\n    background: #eee none repeat scroll 0 0;\n    display: block;\n    padding: 1em;\n    width: 100%;\n  }</style><nav class=pdf-controls><button ng-click=goPrevious()>&lt;</button> <button ng-click=goNext()>&gt;</button> <button ng-click=zoomIn()>+</button> <button ng-click=fit()>100%</button> <button ng-click=zoomOut()>-</button> <button ng-click=rotate()>90</button> <span>Página: </span><input type=text min=1 ng-model=pageNum> <span>/ {{pageCount}}</span></nav><canvas id=pdf-canvas></canvas>");
$templateCache.put("app/modules/rotaciones/observados/detalleObservados/modules.rotaciones.observados.detalleObservados.html","<div class=\"container container-monitoreo\" ng-cloak><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>credit_card</md-icon><span>{{detalleObservados.habilitacion.estudiante.persona.nombres}} {{detalleObservados.habilitacion.estudiante.persona.primer_apellido}} {{detalleObservados.habilitacion.estudiante.persona.segundo_apellido}}</span><div flex></div></div></md-toolbar><md-card-content><div layout=row><span flex></span><md-button class=\"md-raised md-primary\" ng-click=detalleObservados.subsanarObservacion($event) aria-label=\"Subsanar trámite\" ng-if=\"detalleObservados.habilitacion.observacion && detalleObservados.habilitacion.observacion.subsanable\"><md-icon>check</md-icon>Subsanar observación</md-button></div><detalle-tramite ng-if=detalleObservados.habilitacion habilitacion=detalleObservados.habilitacion permission=detalleObservados.permission archivos=detalleObservados.archivos faltas=detalleObservados.faltas eliminar-falta=detalleObservados.eliminarFalta id-habilitacion=detalleObservados.idHabilitacion></detalle-tramite><md-card><md-card-header><md-card-header-text class=text-center><span class=md-title>Documentación presentada</span></md-card-header-text></md-card-header><div layout-gt-xs=row layout-xs=column layout-wrap><div flex=30 class=contenedorArchivos ng-repeat=\"archivo in detalleObservados.archivos\" ng-controller=ArchivosFilaController><div><p>{{archivo.descripcion}}</p><lf-ng-md-file-input lf-files=archivo.files aria-label=\"Subir archivo\" lf-placeholder=\"Subir archivo\" lf-browse-label=Buscar lf-remove-label=Eliminar accept=.pdf,image/* ng-if=\"detalleObservados.habilitacion.observacion && detalleObservados.habilitacion.observacion.subsanable && archivo.tipo_requisito == \'ARCHIVO\'\"></lf-ng-md-file-input><md-input-container ng-if=\"archivo.tipo_requisito == \'NUMERICO\' && detalleObservados.habilitacion.observacion && detalleObservados.habilitacion.observacion.subsanable\" style=\"margin: 10px 0 0 0\"><label>Código</label><input ng-model=archivo.archivoTexto required only-digits od-cantidad=20></md-input-container><md-input-container ng-if=\"archivo.tipo_requisito == \'TEXTO\' && detalleObservados.habilitacion.observacion && detalleObservados.habilitacion.observacion.subsanable\" style=\"margin: 10px 0 0 0\"><label>Código</label><input ng-model=archivo.archivoTexto required></md-input-container><div layout=row class=nombreArchivo ng-if=\"archivo.archivo && archivo.archivo.length == 1\"><span style=\"padding: 15px 0 0 5px\"><md-icon class=bg-success>check_circle</md-icon>{{archivo.metadato_cumple}}</span><div flex></div><label ng-if=\"archivo.tipo_requisito != \'ARCHIVO\' && !detalleObservados.habilitacion.observacion\" style=\"padding: 15px 0 0 5px\"><strong>{{archivo.archivoTexto}}</strong></label><md-button class=md-raised ng-click=\"detalleObservados.abrirRequisito($event, archivo)\" ng-if=\"archivo.tipo_requisito == \'ARCHIVO\'\"><md-icon class=md-icon>file_download</md-icon>Mostrar</md-button></div><div class=nombreArchivo ng-if=\"!archivo.archivo || (archivo.archivo && !archivo.archivo.length)\"><span><md-icon style=\"color: red\">cancel</md-icon>{{archivo.metadato_no_cumple}}</span></div></div></div></div></md-card></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/observados/tramitesObservados/modules.rotaciones.observados.tramitesObservados.html","<div ng-cloak><div ng-show=$ctrl.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=$ctrl.filter.form ng-submit=$ctrl.buscarFiltro()><input type=text class=crud-table-filter id=crud-table-input ng-model=$ctrl.query.filter placeholder=\"Escriba su búsqueda aquí...\"></form><md-button class=md-icon-button ng-click=$ctrl.removeFilter()><md-icon>close</md-icon></md-button></div></div><div ng-show=!$ctrl.filter.show><div class=md-toolbar-tools><md-icon style=\"margin-right: 10px\">group</md-icon>{{$ctrl.title}}<div flex></div><div><md-button class=md-icon-button ng-click=$ctrl.listarAsignados() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon style=\"color: #2E3B0B\">refresh</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.showFilter()><md-tooltip>Filtrar registros</md-tooltip><md-icon style=\"color: #2E3B0B\">search</md-icon></md-button></div></div></div><md-card-content><tabla-estudiantes permission=$ctrl.permission gestion-filtro=$ctrl.gestionFiltro periodo-filtro=$ctrl.periodoFiltro actualizardatos=$ctrl.actualizardatos query=$ctrl.query seleccionable=$ctrl.seleccionable estados=$ctrl.estados buttons=$ctrl.buttons seleccionados=$ctrl.seleccionados etapa=$ctrl.etapa filter=$ctrl.filter rezagados=$ctrl.rezagados listar-habilitados=$ctrl.listarHabilitados show-filter=$ctrl.showFilter remove-filter=$ctrl.removeFilter buscar-estudiante=$ctrl.buscarEstudiante></tabla-estudiantes></md-card-content></div>");
$templateCache.put("app/modules/rotaciones/monitoreo/monitoreo/modules.rotaciones.monitoreo.monitoreo.html","<vistas></vistas>");
$templateCache.put("app/modules/rotaciones/reportes/reporteEstudiantes/modules.rotaciones.reportes.reporteEstudiantes.html","<div style=margin:20px><md-card style=\"width: 100%\"><div><div class=md-toolbar-tools><md-icon class=md-icon style=\"margin-right: 10px\">grid_on</md-icon>Reporte de Estudiantes<div flex></div></div></div><md-card-content><div><md-card-content><md-input-container style=\"width: 80%\"><label>SEDES</label><md-select ng-model=reporteEstudiantes.id_sedes ng-change=reporteEstudiantes.cambiandoSedes() ng-disabled=\"reporteEstudiantes.sedes.length == 1\" required><md-option ng-value=0 ng-if=\"reporteEstudiantes.sedes.length != 1\">Todos</md-option><md-option ng-value=sedes.id_sedes ng-repeat=\"sedes in reporteEstudiantes.sedes\">{{sedes.descripcion}}</md-option></md-select></md-input-container><div>&nbsp;</div><md-input-container style=\"width: 80%\"><label>Gestión</label><md-select ng-model=reporteEstudiantes.gestion ng-change=reporteEstudiantes.cambiandoGestion() required><md-option ng-value=gestion.gestion ng-repeat=\"gestion in reporteEstudiantes.gestiones\">{{gestion.gestion}}</md-option></md-select></md-input-container><div>&nbsp;</div><md-input-container style=\"width: 80%\" ng-if=\"reporteEstudiantes.id_sedes != 0\"><label>Periodo</label><md-select ng-model=reporteEstudiantes.periodo ng-change=reporteEstudiantes.cambiandoPeriodo() required><md-option ng-value=0 ng-if=\"reporteEstudiantes.periodos.length > 0\">Todos</md-option><md-option ng-value=per ng-repeat=\"per in reporteEstudiantes.periodos\">{{per.numero}}</md-option></md-select></md-input-container><md-input-container style=\"width: 80%\" ng-if=\"reporteEstudiantes.id_sedes == 0\"><label>Periodo</label><md-select ng-model=reporteEstudiantes.periodo ng-change=reporteEstudiantes.cambiandoPeriodoGenerico() required><md-option ng-value=0 ng-if=\"reporteEstudiantes.periodosGenericos.length > 0\">Todos</md-option><md-option ng-value=per ng-repeat=\"per in reporteEstudiantes.periodosGenericos\">{{per.numero}}</md-option></md-select></md-input-container><div>&nbsp;</div><md-input-container style=\"width: 80%\" ng-if=\"reporteEstudiantes.id_sedes != 0\"><label>Red</label><md-select ng-model=reporteEstudiantes.cod_area ng-change=reporteEstudiantes.cambiandoRed() required><md-option ng-value=0>Todos</md-option><md-option ng-value=red.cod_area ng-repeat=\"red in reporteEstudiantes.redes\">{{red.red}}</md-option></md-select></md-input-container><div ng-if=\"reporteEstudiantes.id_sedes != 0\">&nbsp;</div><md-input-container style=\"width: 80%\" ng-if=\"reporteEstudiantes.id_sedes != 0\"><label>Municipio</label><md-select ng-model=reporteEstudiantes.cod_muni ng-change=reporteEstudiantes.cambiandoMunicipio() required><md-option ng-value=0>Todos</md-option><md-option ng-value=municipio.cod_muni ng-repeat=\"municipio in reporteEstudiantes.municipios\">{{municipio.nom_municipio}}</md-option></md-select></md-input-container><div ng-if=\"reporteEstudiantes.id_sedes != 0\">&nbsp;</div><md-input-container style=\"width: 80%\" ng-if=\"reporteEstudiantes.id_sedes != 0\"><label>Establecimiento de salud</label><md-select ng-model=reporteEstudiantes.id_establecimiento_salud required><md-option ng-value=0>Todos</md-option><md-option ng-value=establecimiento.id_establecimiento_salud ng-repeat=\"establecimiento in reporteEstudiantes.establecimientos\">{{establecimiento.establecimiento}}</md-option></md-select></md-input-container><div ng-if=\"reporteEstudiantes.id_sedes != 0\">&nbsp;</div><md-input-container style=\"width: 80%\"><label>Universidad</label><md-select ng-model=reporteEstudiantes.id_universidad required><md-option ng-value=0>Todas</md-option><md-option ng-value=universidad.id_universidad ng-repeat=\"universidad in reporteEstudiantes.universidades\">{{universidad.nombre}}</md-option></md-select></md-input-container><div>&nbsp;</div><md-input-container style=\"width: 80%\"><label>Carrera</label><md-select ng-model=reporteEstudiantes.id_tipo_carrera required><md-option ng-value=0 ng-if=\"reporteEstudiantes.carreras.length > 0\">Todas</md-option><md-option ng-value=carrera.id_tipo_carrera ng-repeat=\"carrera in reporteEstudiantes.carreras\">{{carrera.nombre}}</md-option></md-select></md-input-container><div>&nbsp;</div><md-input-container style=\"width: 80%\"><label>Estado</label><md-select ng-model=reporteEstudiantes.estado_habilitacion required><md-option ng-value=\"\'\'\">Todos</md-option><md-option ng-value=estado ng-repeat=\"estado in reporteEstudiantes.estados\">{{estado}}</md-option></md-select></md-input-container><md-input-container class=small><md-checkbox ng-model=reporteEstudiantes.casos_especiales>Mostrar sólo casos especiales.<md-tooltip>Estudiantes que fueron asignados con algún tipo de preferencia a un establecimiento de salud.</md-tooltip></md-checkbox></md-input-container><div><md-button class=\"md-raised md-primary\" ng-click=reporteEstudiantes.reporte() aria-label=Reporte><md-icon>description</md-icon>Obtener Reporte</md-button></div></md-card-content></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/resoluciones/detalleResoluciones/dialog.pdf.html","<!-- <md-dialog class=\"fullscreen-dialog\" aria-label=\"Documento\" ng-cloak class=\"formly-dialog formly-column-{{column}}\"> --><md-dialog aria-label=Documento ng-cloak style=\"width: 80%\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><p ng-if=!data.documento>Se descargará el documento.</p><div layout-gt-xs=row layout-xs=column><iframe ng-if=data.documento src={{formatearUrlPdf(data.documento)}} style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe><div class=formulario-datos><md-card-header><md-card-header-text><span class=md-title>Firmas del documento</span></md-card-header-text></md-card-header><div><p ng-if=data.firmasMensaje>{{data.firmasMensaje}}</p><div ng-repeat=\"firma in data.firmas\"><md-card style=\"font-size: 12px; padding: 10px; max-width: 250px\" layout=row><div style=\"margin-right: 5px\"><span style=text-left><md-icon class=colorPrimario>border_color</md-icon></span></div><div><!-- <span ng-bind-html=\"formatearHtml(firma)\"></span> --><div><b>Nombre: </b>{{firma.nombreComunSubject}}</div><div><b>Fecha firma:</b> {{firma.fechaFirma}}</div></div></md-card></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/rotaciones/resoluciones/detalleResoluciones/modules.rotaciones.resoluciones.detalleResoluciones.html","<div class=\"container container-monitoreo\" ng-cloak><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>credit_card</md-icon><span>{{detalleResoluciones.habilitacion.estudiante.persona.nombres}} {{detalleResoluciones.habilitacion.estudiante.persona.primer_apellido}} {{detalleResoluciones.habilitacion.estudiante.persona.segundo_apellido}}</span><div flex></div></div></md-toolbar><md-card-content><div layout=row><span flex></span><md-button class=\"md-raised md-primary\" ng-click=detalleResoluciones.observarTramite($event) aria-label=\"Observar trámite\" ng-if=\"detalleResoluciones.habilitacion.estado_habilitacion != \'RESOLUCION_FIRMADA_DIRECTOR\' && !detalleResoluciones.habilitacion.observacion\"><md-icon>do_not_disturb_on</md-icon>Observar trámite</md-button></div><detalle-tramite ng-if=detalleResoluciones.habilitacion habilitacion=detalleResoluciones.habilitacion permission=detalleResoluciones.permission archivos=detalleResoluciones.archivos faltas=detalleResoluciones.faltas eliminar-falta=detalleResoluciones.eliminarFalta id-habilitacion=detalleResoluciones.idHabilitacion></detalle-tramite></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/reportes/reporteCupos/modules.rotaciones.reportes.reporteCupos.html","<div style=margin:20px><md-card style=\"width: 100%\"><div><div class=md-toolbar-tools><md-icon class=md-icon style=\"margin-right: 10px\">grid_on</md-icon>Reporte de establecimientos<div flex></div></div></div><md-card-content><div><md-card-content><md-input-container style=\"width: 80%\"><label>SEDES</label><md-select ng-model=reporteCupos.id_sedes ng-change=reporteCupos.cambiandoSedes() ng-disabled=\"reporteCupos.sedes.length == 1\" required><md-option ng-value=0 ng-if=\"reporteCupos.sedes.length != 1\">Todos</md-option><md-option ng-value=sedes.id_sedes ng-repeat=\"sedes in reporteCupos.sedes\">{{sedes.descripcion}}</md-option></md-select></md-input-container><div>&nbsp;</div><md-input-container style=\"width: 80%\"><label>Gestión</label><md-select ng-model=reporteCupos.gestion ng-change=reporteCupos.cambiandoGestion() required><md-option ng-value=gestion.gestion ng-repeat=\"gestion in reporteCupos.gestiones\">{{gestion.gestion}}</md-option></md-select></md-input-container><div>&nbsp;</div><md-input-container style=\"width: 80%\" ng-if=\"reporteCupos.id_sedes != 0\"><label>Periodo</label><md-select ng-model=reporteCupos.periodo ng-change=reporteCupos.cambiandoPeriodo() required><md-option ng-value=per ng-repeat=\"per in reporteCupos.periodos\">{{per.numero}}</md-option></md-select></md-input-container><md-input-container style=\"width: 80%\" ng-if=\"reporteCupos.id_sedes == 0\"><label>Periodo</label><md-select ng-model=reporteCupos.periodo ng-change=reporteCupos.cambiandoPeriodoGenerico() required><md-option ng-value=per ng-repeat=\"per in reporteCupos.periodosGenericos\">{{per.numero}}</md-option></md-select></md-input-container><div>&nbsp;</div><md-input-container style=\"width: 80%\" ng-if=\"reporteCupos.id_sedes != 0\"><label>Red</label><md-select ng-model=reporteCupos.cod_area ng-change=reporteCupos.cambiandoRed() required><md-option ng-value=0>Todos</md-option><md-option ng-value=red.cod_area ng-repeat=\"red in reporteCupos.redes\">{{red.red}}</md-option></md-select></md-input-container><div ng-if=\"reporteCupos.id_sedes != 0\">&nbsp;</div><md-input-container style=\"width: 80%\" ng-if=\"reporteCupos.id_sedes != 0\"><label>Municipio</label><md-select ng-model=reporteCupos.cod_muni ng-change=reporteCupos.cambiandoMunicipio() required><md-option ng-value=0>Todos</md-option><md-option ng-value=municipio.cod_muni ng-repeat=\"municipio in reporteCupos.municipios\">{{municipio.nom_municipio}}</md-option></md-select></md-input-container><div ng-if=\"reporteCupos.id_sedes != 0\">&nbsp;</div><md-input-container style=\"width: 80%\"><label>Ámbito</label><md-select ng-model=reporteCupos.ambito ng-change=gestiones.listarCupos()><md-option ng-value=0>Todos</md-option><md-option ng-value=\"\'R\'\">Rural</md-option><md-option ng-value=\"\'U\'\">Urbano</md-option></md-select></md-input-container><div>&nbsp;</div><md-input-container style=\"width: 80%\"><label>Cupos</label><md-select ng-model=reporteCupos.tipo_cupos><md-option ng-value=0>Todos</md-option><md-option ng-value=1>Con cupos</md-option><md-option ng-value=-1>Sin cupos</md-option></md-select></md-input-container><div>&nbsp;</div><div><md-button class=\"md-raised md-primary\" ng-click=reporteCupos.reporte() aria-label=Reporte><md-icon>description</md-icon>Obtener Reporte</md-button></div></md-card-content></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/resoluciones/requisitosResoluciones/modules.rotaciones.resoluciones.requisitosResoluciones.html","<div class=\"container container-monitoreo\" ng-cloak><md-card ng-if=!requisitosResoluciones.idHabilitacion><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>search</md-icon><span>Buscar estudiante</span><div flex></div></div></md-toolbar><md-card-content><form name=form ng-submit=\"form.$valid && requisitosResoluciones.buscar()\"><div layout=row class=form-horizontal style=\"margin-top: 20px\"><md-input-container style=\"max-width: 140px\"><label>Tipo</label><md-select ng-model=requisitosResoluciones.tipo required><md-option ng-repeat=\"option in requisitosResoluciones.tipos\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container><md-input-container aria-label=\"Cédula de identidad\" style=\"max-width: 265px\" focus-me=focusInput><label>Documento de identidad</label><input ng-model=requisitosResoluciones.documentoIdentidad required capitalize></md-input-container><md-button type=submit class=\"md-raised md-primary little-button\"><md-icon>check</md-icon>Buscar</md-button><div flex></div></div></form><div ng-repeat=\"enc in requisitosResoluciones.encontrados\"><div ng-repeat=\"hab1 in enc.habilitacion\"><md-button ng-click=requisitosResoluciones.verDetalleInscripcion(hab1.id_habilitacion) style=\"text-align: left\"><div layout=row><p style=\"margin: 0\"><strong>{{enc.persona.nombres}} {{enc.persona.primer_apellido}} {{enc.persona.segundo_apellido}}</strong><br>{{hab1.periodo.numero}} - {{hab1.periodo.gestion}}<br>{{hab1.fecha_inicio | date:\'dd/MM/yyyy\'}} - {{hab1.fecha_fin | date:\'dd/MM/yyyy\'}}</p></div></md-button></div></div></md-card-content></md-card><md-card ng-if=requisitosResoluciones.idHabilitacion><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>folder_shared</md-icon><span>{{requisitosResoluciones.title}}</span><div flex></div></div></md-toolbar><md-card-content><div layout=row><span flex></span><md-button class=\"md-raised md-primary\" ng-click=requisitosResoluciones.registrarApoderado($event) aria-label=\"Registrar apoderado\" ng-if=\"requisitosResoluciones.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\' && !requisitosResoluciones.habilitacion.observacion\"><md-icon>person</md-icon>Registrar apoderado</md-button><md-button class=\"md-raised md-primary\" ng-click=requisitosResoluciones.observarTramite($event) aria-label=\"Observar trámite\" ng-if=\"requisitosResoluciones.mostrarObservarTramite(requisitosResoluciones.habilitacion) && requisitosResoluciones.habilitacion.estado_habilitacion != \'SUSPENDIDA\' && requisitosResoluciones.habilitacion.estado_habilitacion != \'RESOLUCION_FIRMADA_DIRECTOR\' && !requisitosResoluciones.habilitacion.observacion\"><md-icon>do_not_disturb_on</md-icon>Observar trámite</md-button><md-button ng-click=requisitosResoluciones.volverBuscar()><md-icon class=md-icon>search</md-icon>Nueva búsqueda</md-button></div><detalle-tramite ng-if=requisitosResoluciones.habilitacion habilitacion=requisitosResoluciones.habilitacion permission=requisitosResoluciones.permission archivos=requisitosResoluciones.archivos faltas=requisitosResoluciones.faltas id-habilitacion=requisitosResoluciones.idHabilitacion></detalle-tramite><div><md-card ng-if=\"!requisitosResoluciones.habilitacion.observacion && !requisitosResoluciones.habilitacion.rezagado\"><md-card-header><md-card-header-text class=text-center><span class=md-title>Subir documentación del estudiante</span></md-card-header-text></md-card-header><div flex></div><form name=formAsesor ng-submit=\"formAsesor.$valid && requisitosResoluciones.enviarAsesor($event)\" novalidate ng-if=\"requisitosResoluciones.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\' && !requisitosResoluciones.habilitacion.observacion\"><div style=\"text-align: right\"><md-button ng-click=requisitosResoluciones.mostrarInformeTecnico($event)><md-icon>insert_drive_file</md-icon>Ver Informe Técnico Legal</md-button><md-button class=\"md-icon-button md-icon-button-circle\" ng-click=\"requisitosResoluciones.observarTramite($event, true)\" aria-label=Editar><md-tooltip>Agregar descripción</md-tooltip><md-icon class=\"md-icon md-icon-circle\">mode_edit</md-icon></md-button><md-button type=submit class=\"md-raised md-primary\" aria-label=\"Enviar al asesor legal\"><md-icon>mail</md-icon>Enviar al Asesor Legal</md-button></div></form><div style=\"padding: 10px 20px\" ng-if=\"requisitosResoluciones.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\"><h4 ng-if=\"requisitosResoluciones.notas && requisitosResoluciones.notas.length > 0\">OBSERVACIONES DEL INFORME TÉCNICO LEGAL:</h4><ul class=faltas ng-if=\"requisitosResoluciones.notas && requisitosResoluciones.notas.length > 0\"><li ng-repeat=\"(index, nota) in requisitosResoluciones.notas\"><span class=numero>{{index + 1}}</span> <span class=texto>{{nota.detalle}}</span><md-button class=md-icon-button aria-label=Eliminar ng-click=requisitosResoluciones.eliminarNota(nota.id_observacion) ng-if=\"requisitosResoluciones.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\"><md-tooltip>Eliminar observación</md-tooltip><md-icon class=md-icon>cancel</md-icon></md-button></li></ul></div><div layout-gt-xs=row layout-xs=column layout-wrap><div flex=30 class=contenedorArchivos ng-repeat=\"archivo in requisitosResoluciones.archivos\" ng-controller=ArchivosFilaController><div><p>{{archivo.descripcion}}</p><lf-ng-md-file-input lf-files=archivo.files aria-label=\"Subir archivo\" lf-placeholder=\"Subir archivo\" lf-browse-label=Buscar lf-remove-label=Eliminar accept=.pdf,image/* ng-if=\"requisitosResoluciones.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\' && archivo.tipo_requisito == \'ARCHIVO\'\"></lf-ng-md-file-input><md-input-container ng-if=\"archivo.tipo_requisito == \'NUMERICO\' && requisitosResoluciones.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\" style=\"margin: 10px 0 0 0\"><label>Código</label><input ng-model=archivo.archivoTexto required only-digits od-cantidad=20></md-input-container><md-input-container ng-if=\"archivo.tipo_requisito == \'TEXTO\' && requisitosResoluciones.habilitacion.estado_habilitacion == \'CREDENCIAL_FIRMADA\'\" style=\"margin: 10px 0 0 0\"><label>Código</label><input ng-model=archivo.archivoTexto required></md-input-container><div layout=row class=nombreArchivo ng-if=\"archivo.archivo && archivo.archivo.length == 1\"><span style=\"padding: 15px 0 0 5px\"><md-icon class=bg-success>check_circle</md-icon>{{archivo.metadato_cumple}}</span><div flex></div><label ng-if=\"archivo.tipo_requisito != \'ARCHIVO\' && requisitosResoluciones.habilitacion.estado_habilitacion != \'CREDENCIAL_FIRMADA\'\" style=\"padding: 15px 0 0 5px\"><strong>{{archivo.archivoTexto}}</strong></label><md-button class=md-raised ng-click=\"requisitosResoluciones.abrirRequisito($event, archivo)\" ng-if=\"archivo.tipo_requisito == \'ARCHIVO\'\"><md-icon class=md-icon>file_download</md-icon>Mostrar</md-button></div><div class=nombreArchivo ng-if=\"!archivo.archivo || (archivo.archivo && !archivo.archivo.length)\"><span><md-icon style=\"color: red\">cancel</md-icon>{{archivo.metadato_no_cumple}}</span></div></div></div></div></md-card></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/resoluciones/verificacionResolucion/modules.rotaciones.resoluciones.verificacionResolucion.html","<div class=container ng-cloak><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>credit_card</md-icon><span>{{verificacionResolucion.title}}</span><div flex></div></div></md-toolbar><md-card-content ng-if=!verificacionResolucion.habilitacion><div class=formulario-datos><p>No se ha encontrado la información solicitada o el enlace es incorrecto, por favor verifique nuevamente.</p></div></md-card-content><md-card-content ng-if=verificacionResolucion.habilitacion><md-card-header><md-card-header-text><span class=md-title><md-icon class=colorPrimario>person</md-icon>{{verificacionResolucion.habilitacion.estudiante.persona.nombres}} {{verificacionResolucion.habilitacion.estudiante.persona.primer_apellido}} {{verificacionResolucion.habilitacion.estudiante.persona.segundo_apellido}}</span></md-card-header-text></md-card-header><div layout-gt-xs=row layout-xs=column><md-card style=\"width: 100%\"><md-card-header><md-card-header-text class=text-center><span class=md-title>Datos del estudiante</span></md-card-header-text></md-card-header><md-card-content><div class=formulario-datos><div flex><p><label>Tipo de documento:</label>{{verificacionResolucion.habilitacion.estudiante.persona.tipo_documento_identidad.sigla}}</p><p><label>Número de documento:</label>{{verificacionResolucion.habilitacion.estudiante.persona.documento_identidad}}</p><p><label>Fecha de nacimiento:</label>{{verificacionResolucion.habilitacion.estudiante.persona.fecha_nacimiento | date:\'dd/MM/yyyy\'}}</p><p><label>Nombres:</label>{{verificacionResolucion.habilitacion.estudiante.persona.nombres}}</p><p><label>Primer apellido:</label>{{verificacionResolucion.habilitacion.estudiante.persona.primer_apellido}}</p><p><label>Segundo apellido:</label>{{verificacionResolucion.habilitacion.estudiante.persona.segundo_apellido}}</p><p><label>Correo electrónico:</label>{{verificacionResolucion.habilitacion.estudiante.correo_electronico}}</p><p><label>Teléfono de contacto:</label>{{verificacionResolucion.habilitacion.estudiante.telefono}}</p></div></div></md-card-content></md-card><div flex></div><md-card style=\"width: 100%\"><md-card-header><md-card-header-text class=text-center><span class=md-title>Datos académicos</span></md-card-header-text></md-card-header><md-card-content><div class=formulario-datos layout-gt-xs=row layout-xs=column><div flex><p><label>Universidad:</label>{{verificacionResolucion.habilitacion.estudiante.universidad.nombre}}</p><p><label>Carrera:</label>{{verificacionResolucion.habilitacion.estudiante.carrera.nombre}}</p><p><label>Nota:</label>{{verificacionResolucion.habilitacion.nota}}</p><p><label>Establecimiento de salud asignado:</label>{{verificacionResolucion.habilitacion.establecimiento_salud.establecimiento}}</p><p><label>Fecha de inicio del servicio:</label>{{verificacionResolucion.habilitacion.fecha_inicio | date:\'dd/MM/yyyy\'}}</p><p><label>Fecha de finalización del servicio:</label>{{verificacionResolucion.habilitacion.fecha_fin | date:\'dd/MM/yyyy\'}}</p><p ng-if=\"verificacionResolucion.habilitacion.estado_habilitacion == \'RESOLUCION_FIRMADA_DIRECTOR\'\"><label>Estado del trámite:</label>El estudiante cuenta con una Resolución Administrativa válida.</p><p ng-if=\"verificacionResolucion.habilitacion.estado_habilitacion != \'RESOLUCION_FIRMADA_DIRECTOR\'\"><label>Estado de la resolución administrativa:</label>{{verificacionResolucion.habilitacion.estado_habilitacion}}</p></div></div></md-card-content></md-card></div><md-toolbar><div class=md-toolbar-tools><h2>Resolución Administrativa</h2><span flex></span></div></md-toolbar><md-dialog-content ng-if=\"verificacionResolucion.habilitacion.resolucion !== false\"><div class=formulario-datos><!-- <iframe src=\"{{verificacionResolucion.habilitacion.resolucion}}\" style=\"width:100%; height:600px; border: none;\" id=\"iframe-pdf-crud\"></iframe> --><iframe ng-src={{verificacionResolucion.formatearUrl(verificacionResolucion.habilitacion.resolucion)}} style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe></div></md-dialog-content><md-dialog-content ng-if=\"verificacionResolucion.habilitacion.resolucion === false\"><div class=formulario-datos><p>No se ha encontrado ninguna Resolución Administrativa asociada a este estudiante.</p></div></md-dialog-content></md-card-content></md-card></div>");
$templateCache.put("app/modules/rotaciones/sedes/sedesDetalle/editRequisito.dialog.html","<!-- <md-dialog aria-label=\"Agregar/Editar\" class=\"fullscreen-dialog\"> --><md-dialog aria-label=Agregar/Editar style=\"max-width: 500px\"><form name=formRequisito ng-submit=\"formRequisito.$valid && guardarRequisito()\" novalidate><md-toolbar><div class=md-toolbar-tools><md-icon>insert_drive_file</md-icon><h2>Registro requisito</h2><span flex></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><div layout=row><md-card><md-card-header><md-card-header-text><span class=md-title>Datos requisito</span></md-card-header-text></md-card-header><md-card-content><md-input-container><label>Nombre</label><input ng-model=requisito.nombre required></md-input-container><md-input-container><label>Descripción</label><input ng-model=requisito.descripcion required></md-input-container><md-input-container><label>Formato del requisito</label><md-select ng-model=requisito.tipo_requisito required style=\"margin: 0 0 30px 0\"><md-option ng-value=tipo_req ng-repeat=\"tipo_req in tiposRequisitos\">{{tipo_req}}</md-option></md-select></md-input-container><md-input-container><md-tooltip md-direction=top>Esta etiqueta aparecerá cuando se carguen los requisitos del interno que haya conluido el SSSRO para verificar si cumple o no.</md-tooltip><label>Requisito cumple</label><input ng-model=requisito.metadato_cumple required></md-input-container><md-input-container><md-tooltip md-direction=top>Esta etiqueta aparecerá cuando se carguen los requisitos del interno que haya conluido el SSSRO para verificar si cumple o no.</md-tooltip><label>Requisito no cumple</label><input ng-model=requisito.metadato_no_cumple required></md-input-container></md-card-content></md-card></div></md-dialog-content><md-dialog-actions layout=row><div class=text-right><md-button class=md-raised ng-click=close()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/rotaciones/sedes/sedesDetalle/modules.rotaciones.sedes.sedesDetalle.html","<div class=\"container container-monitoreo\" ng-cloak><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>credit_card</md-icon><span>{{sedesDetalle.title}}</span><div flex></div></div></md-toolbar><md-card-content><md-card-header><md-card-header-text><span class=md-title><md-icon class=colorPrimario>credit_card</md-icon>{{sedesDetalle.sedes.descripcion}}</span></md-card-header-text></md-card-header><div layout-gt-xs=row layout-xs=column><md-card style=\"width: 100%\"><md-card-content><span class=md-title>Imágenes<md-button class=\"md-icon-button md-icon-button-circle\" ng-click=\"sedesDetalle.editarImagenes($event, sedesDetalle.sedes.id_sedes)\" aria-label=Editar ng-if=sedesDetalle.permission.update><md-tooltip>Editar</md-tooltip><md-icon class=md-icon>create</md-icon></md-button></span><div class=contenido-datos><span><label>Logo:</label><image alt=\"Debe subir el logo\" style=\"width: 100px\" data-ng-src=data:image;base64,{{sedesDetalle.sedes.logo.data}}></span><span><label>Escudo:</label><image alt=\"Debe subir el escudo\" style=\"width: 100px\" data-ng-src=data:image;base64,{{sedesDetalle.sedes.escudo.data}}></span><span><label>Fondo credencial:</label><image alt=\"Debe subir el fondo de credencial\" style=\"width: 100px\" data-ng-src=data:image;base64,{{sedesDetalle.sedes.fondo.data}}></span><span><label>Fondo resolución:</label><image alt=\"Debe subir el fondo de resolución\" style=\"width: 100px\" data-ng-src=data:image;base64,{{sedesDetalle.sedes.fondo_resolucion.data}}></span></div><br><br><div layout-gt-xs=row><div flex-xs flex-gt-xs=50 layout=column><span class=md-title>Datos autoridades<md-button class=\"md-icon-button md-icon-button-circle\" ng-click=sedesDetalle.agregarDatosSedes($event) aria-label=Nuevo ng-if=sedesDetalle.permission.create><md-tooltip>Nuevo</md-tooltip><md-icon class=md-icon>add</md-icon></md-button><md-button class=\"md-icon-button md-icon-button-circle\" ng-click=\"sedesDetalle.editarDatosSedes($event, sedesDetalle.datosSedes.id_par_sedes)\" aria-label=Editar ng-if=\"sedesDetalle.datosSedes.id_par_sedes && sedesDetalle.permission.update\"><md-tooltip>Editar</md-tooltip><md-icon class=md-icon>create</md-icon></md-button></span><div class=contenido-datos><div flex><p><label>Cargo técnico:</label>{{sedesDetalle.datosSedes.cargo_tecnico}}</p><p><label>Nombre técnico:</label>{{sedesDetalle.datosSedes.nombre_tecnico}}</p><p><label>Cargo asesor:</label>{{sedesDetalle.datosSedes.cargo_asesor}}</p><p><label>Nombre asesor:</label>{{sedesDetalle.datosSedes.nombre_asesor}}</p><p><label>Cargo director:</label>{{sedesDetalle.datosSedes.cargo_director}}</p><p><label>Nombre director:</label>{{sedesDetalle.datosSedes.nombre_director}}</p></div></div></div><div flex-xs flex-gt-xs=50 layout=column><span class=md-title>Datos SEDES<md-button class=\"md-icon-button md-icon-button-circle\" ng-click=\"sedesDetalle.editarCorreo($event, sedesDetalle.sedes.id_sedes)\" aria-label=Editar ng-if=sedesDetalle.permission.update><md-tooltip>Editar</md-tooltip><md-icon class=md-icon>create</md-icon></md-button></span><div class=contenido-datos><!-- <p>\r\n                                      <label>Host (SMTP):</label> {{sedesDetalle.sedes.correo_host}}\r\n                                    </p>\r\n                                    <p>\r\n                                      <label>Puerto:</label> {{sedesDetalle.sedes.correo_puerto}}\r\n                                    </p> --><p><label>Correo:</label>{{sedesDetalle.sedes.correo}}</p><p><label>Habilitar nota para Universidades:</label><span ng-if=sedesDetalle.sedes.tipo><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=!sedesDetalle.sedes.tipo><md-icon class=bg-gray>cancel</md-icon></span></p><p><label>Habilitar depósito para Universidades:</label><span ng-if=sedesDetalle.sedes.deposito><md-icon class=bg-success>check_circle</md-icon></span><span ng-if=!sedesDetalle.sedes.deposito><md-icon class=bg-gray>cancel</md-icon></span></p><p><label>Cantidad mejores promedios:</label>{{sedesDetalle.sedes.cantidad_promedios}}</p><p><label>Gestión de inicio:</label>{{sedesDetalle.sedes.gestion_inicio}}</p><p><label>Invitación*:</label><span ng-show=!sedesDetalle.mostrarEditor><md-button class=\"md-icon-button md-icon-button-circle\" ng-click=\"sedesDetalle.editarInvitacion($event, sedesDetalle.sedes.id_sedes)\"><md-icon class=md-icon>language</md-icon></md-button></span></p></div><div><md-card><div ng-show=sedesDetalle.mostrarEditor><textarea id=editorMsj autofocus></textarea></div><div ng-show=sedesDetalle.mostrarEditor layout=row layout-align=\"center center\"><md-button ng-click=sedesDetalle.cancelarEdicion() class=md-raised><md-icon>cancel</md-icon>Cancelar</md-button><md-button ng-click=\"sedesDetalle.guardarInvitacion($event, sedesDetalle.sedes.id_sedes)\" class=\"md-raised md-primary\"><md-icon>check</md-icon>Guardar</md-button></div></md-card></div><span class=md-title>Inicio Documentos<md-button class=\"md-icon-button md-icon-button-circle\" ng-click=\"sedesDetalle.editarCite($event, sedesDetalle.sedes.id_sedes)\" aria-label=Editar ng-if=sedesDetalle.permission.update><md-tooltip>Editar</md-tooltip><md-icon class=md-icon>create</md-icon></md-button></span><div class=contenido-datos><p><label>Cite:</label>{{sedesDetalle.sedes.cite}}</p></div></div></div><br><span class=md-title>Requisitos<md-button class=\"md-icon-button md-icon-button-circle\" ng-click=sedesDetalle.agregarRequisito($event) aria-label=Nuevo ng-if=sedesDetalle.permission.create><md-tooltip>Nuevo</md-tooltip><md-icon class=md-icon>add</md-icon></md-button></span><div class=formulario-datos><md-table-container><table md-table ng-model=$ctrl.selected md-progress=promise><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.listarHabilitados><tr md-row><th md-column class=text-center>Acciones</th><th md-column class=text-center><span>Nombre</span></th><th md-column class=text-center><span>Formato del requisito</span></th><th md-column class=text-center><span>Requisito cumple</span></th><th md-column class=text-center><span>Requisito no cumple</span></th><th md-column class=text-center><span>Estado</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"requisito in sedesDetalle.requisitos\" ng-controller=NotasFilaController><td md-cell><!-- <md-button class=\"md-icon-button\" aria-label=\"Editar\" ng-click=\"vm.edit($event, item)\"> --><md-button class=md-icon-button aria-label=Editar ng-click=\"sedesDetalle.editarRequisito($event, requisito.id_par_archivo)\" ng-if=sedesDetalle.permission.update><md-tooltip>Editar</md-tooltip><md-icon class=\"md-icon icon-edit\">mode_edit</md-icon></md-button></td><td md-cell><span>{{requisito.nombre}}</span></td><td md-cell><span>{{requisito.tipo_requisito}}</span></td><td md-cell><span>{{requisito.metadato_cumple}}</span></td><td md-cell><span>{{requisito.metadato_no_cumple}}</span></td><td md-cell><md-input-container ng-click=\"sedesDetalle.activarRequisito($event, requisito.id_par_archivo, requisito.estado, requisito.fid_sedes)\" ng-if=sedesDetalle.permission.update><md-switch ng-model=requisito.estado aria-label=\"Switch 2\" ng-true-value=\"\'ACTIVO\'\" ng-false-value=\"\'INACTIVO\'\" style=\"color: {{requisito.estado==\'ACTIVO\'?\'#FF5722\':\'#212121\'}}\" class=md-warn>{{ requisito.estado}}</md-switch></md-input-container></td></tr></tbody></table></md-table-container></div></md-card-content></md-card><div flex></div></div></md-card-content></md-card></div>");}]);